/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mimzad ERP API
 * Core and Shared Event Backbone API for Mimzad ERP
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BackflushSuggestionResult,
  BomFamily,
  BomItem,
  BomOperationAllocation,
  BomRevision,
  CapacityCheckRun,
  CatalogFamily,
  CatalogFamilyCreate,
  CatalogRevision,
  CatalogRevisionCreate,
  CustomFieldDefinition,
  CustomFieldMedia,
  CustomFieldValue,
  DowntimeReasonCode,
  DowntimeRecord,
  FormFamily,
  FormInstance,
  FormInstanceDraft,
  FormRevision,
  HoldOrderRequest,
  HoldReasonCode,
  InspectionRecord,
  InventoryLot,
  LabelPrintSettings,
  LeaveRequest,
  LeaveType,
  Listing,
  ListingCreate,
  ListingPrice,
  Location,
  LotCurrentReleaseStatus,
  LotLookupResponse,
  Machine,
  MasterScheduleFamily,
  MasterScheduleLine,
  MasterScheduleRevision,
  MaterialBalanceResult,
  MaterialConsumptionRecord,
  MaterialFamily,
  MaterialRevision,
  MrpRun,
  OperationMaterialSource,
  OperatorRosterAssignment,
  OperatorShiftOverride,
  OperatorStationAssignment,
  OperatorStationRotationSlot,
  OrderExchange,
  OrderExchangeCreate,
  Organization,
  OrganizationCreate,
  OrganizationInvitation,
  OvertimeRecord,
  PaginatedBomFamilyList,
  PaginatedBomItemList,
  PaginatedBomOperationAllocationList,
  PaginatedBomRevisionList,
  PaginatedCapacityCheckRunList,
  PaginatedCatalogFamilyList,
  PaginatedCatalogRevisionList,
  PaginatedCustomFieldDefinitionList,
  PaginatedCustomFieldValueList,
  PaginatedDowntimeReasonCodeList,
  PaginatedDowntimeRecordList,
  PaginatedFormFamilyList,
  PaginatedFormInstanceDraftList,
  PaginatedFormInstanceList,
  PaginatedFormRevisionList,
  PaginatedHoldReasonCodeList,
  PaginatedInspectionRecordList,
  PaginatedInventoryLotList,
  PaginatedLabelPrintSettingsList,
  PaginatedLeaveRequestList,
  PaginatedLeaveTypeList,
  PaginatedListingList,
  PaginatedListingPriceList,
  PaginatedLocationList,
  PaginatedMachineList,
  PaginatedMasterScheduleFamilyList,
  PaginatedMasterScheduleLineList,
  PaginatedMasterScheduleRevisionList,
  PaginatedMaterialConsumptionRecordList,
  PaginatedMaterialFamilyList,
  PaginatedMaterialRevisionList,
  PaginatedMrpRunList,
  PaginatedOperationMaterialSourceList,
  PaginatedOperatorRosterAssignmentList,
  PaginatedOperatorShiftOverrideList,
  PaginatedOperatorStationAssignmentList,
  PaginatedOperatorStationRotationSlotList,
  PaginatedOrderExchangeList,
  PaginatedOrganizationInvitationList,
  PaginatedOrganizationList,
  PaginatedOrganizationMembershipList,
  PaginatedOvertimeRecordList,
  PaginatedPendingLotAllocationList,
  PaginatedPlanningPeriodList,
  PaginatedPrintFormatFamilyList,
  PaginatedPrintFormatRevisionList,
  PaginatedProductionLineList,
  PaginatedProductionOrderList,
  PaginatedQualityCheckFamilyList,
  PaginatedQualityCheckRevisionList,
  PaginatedReportDefinitionList,
  PaginatedRosterDayList,
  PaginatedRosterList,
  PaginatedRoutingFamilyList,
  PaginatedRoutingOperationDependencyList,
  PaginatedRoutingOperationJoinTypeList,
  PaginatedRoutingOperationList,
  PaginatedRoutingRevisionList,
  PaginatedScrapReasonCodeList,
  PaginatedScrapRecordList,
  PaginatedSerialUnitList,
  PaginatedSerialUnitLotLinkList,
  PaginatedShiftBoundaryOverrideList,
  PaginatedShiftSwapRequestList,
  PaginatedShiftTemplateList,
  PaginatedStationAssignmentOverrideList,
  PaginatedStockTransactionList,
  PaginatedStoreFamilyList,
  PaginatedStoreList,
  PaginatedStoreRevisionList,
  PaginatedTenantListList,
  PaginatedUnitOfMeasureList,
  PaginatedUserList,
  PaginatedWarehouseList,
  PaginatedWorkCenterCapacityProfileList,
  PaginatedWorkCenterList,
  PaginatedWorkCenterLotFeedSessionList,
  PaginatedWorkInstructionFamilyList,
  PaginatedWorkInstructionRevisionList,
  PaginatedWorkOrderList,
  PaginatedWorkOrderShortageHoldList,
  PaginatedWorkflowFamilyList,
  PaginatedWorkflowInstanceList,
  PaginatedWorkflowRevisionList,
  PatchedBomFamily,
  PatchedBomItem,
  PatchedBomRevision,
  PatchedCustomFieldDefinition,
  PatchedDowntimeReasonCode,
  PatchedFormFamily,
  PatchedFormInstanceDraft,
  PatchedFormRevision,
  PatchedHoldReasonCode,
  PatchedLabelPrintSettings,
  PatchedLeaveRequest,
  PatchedLeaveType,
  PatchedLocation,
  PatchedMachine,
  PatchedMasterScheduleFamily,
  PatchedMasterScheduleLine,
  PatchedMasterScheduleRevision,
  PatchedMaterialFamily,
  PatchedMaterialRevision,
  PatchedOperatorRosterAssignment,
  PatchedOperatorStationAssignment,
  PatchedOperatorStationRotationSlot,
  PatchedOrganization,
  PatchedPlanningPeriod,
  PatchedPrintFormatFamily,
  PatchedPrintFormatRevision,
  PatchedProductionLine,
  PatchedProductionOrder,
  PatchedQualityCheckFamily,
  PatchedQualityCheckRevision,
  PatchedReportDefinition,
  PatchedRoster,
  PatchedRosterDay,
  PatchedRoutingFamily,
  PatchedRoutingOperation,
  PatchedRoutingOperationDependency,
  PatchedRoutingOperationJoinType,
  PatchedRoutingRevision,
  PatchedScrapReasonCode,
  PatchedShiftBoundaryOverride,
  PatchedShiftSwapRequest,
  PatchedShiftTemplate,
  PatchedTenantDetail,
  PatchedUnitOfMeasure,
  PatchedUser,
  PatchedWarehouse,
  PatchedWorkCenter,
  PatchedWorkCenterCapacityProfile,
  PatchedWorkInstructionFamily,
  PatchedWorkInstructionRevision,
  PatchedWorkOrder,
  PatchedWorkflowFamily,
  PatchedWorkflowInstance,
  PatchedWorkflowRevision,
  PauseWorkOrderRequest,
  PendingLotAllocation,
  PlanningPeriod,
  PrintFormatFamily,
  PrintFormatRevision,
  ProductionLine,
  ProductionOrder,
  QcApproval,
  QualityCheckFamily,
  QualityCheckRevision,
  QualityCheckSubmitApproval,
  ReleaseDecisionCreate,
  ReleaseDecisionOutput,
  ReportDefinition,
  ReportSourceField,
  Resume,
  Roster,
  RosterDay,
  RoutingFamily,
  RoutingOperation,
  RoutingOperationDependency,
  RoutingOperationJoinType,
  RoutingRevision,
  ScrapReasonCode,
  ScrapRecord,
  SerialUnit,
  SerialUnitLinkComponent,
  SerialUnitLotLink,
  ShiftBoundaryOverride,
  ShiftSwapRequest,
  ShiftTemplate,
  StartWorkOrderRequest,
  StationAssignmentOverride,
  StockOnHand,
  StockTransaction,
  Store,
  StoreCreate,
  StoreFamily,
  StoreFamilyCreate,
  StoreRevision,
  StoreRevisionCreate,
  SwitchProductRequest,
  TenantCreate,
  TenantDetail,
  UnifiedConsumptionActionInput,
  UnifiedConsumptionLineResult,
  UnitOfMeasure,
  User,
  V1CustomFieldDefinitionsListParams,
  V1CustomFieldValuesListParams,
  V1FormsFormFamiliesListParams,
  V1FormsFormInstanceDraftsListParams,
  V1FormsFormInstancesListParams,
  V1FormsFormRevisionsListParams,
  V1InspectionsListParams,
  V1InventoryLabelPrintSettingsListParams,
  V1InventoryLocationsListParams,
  V1InventoryLotsListParams,
  V1InventoryLotsLookupRetrieveParams,
  V1InventoryLotsRangeRetrieveParams,
  V1InventoryMaterialRevisionsListParams,
  V1InventoryMaterialsImportBatchesRetrieve200,
  V1InventoryMaterialsImportCommitCreate200,
  V1InventoryMaterialsImportCommitCreate202,
  V1InventoryMaterialsImportCommitCreateBodyOne,
  V1InventoryMaterialsImportCommitCreateBodyThree,
  V1InventoryMaterialsImportCommitCreateBodyTwo,
  V1InventoryMaterialsImportDetectHeadersCreate200,
  V1InventoryMaterialsImportDetectHeadersCreateBody,
  V1InventoryMaterialsImportValidateCreate200,
  V1InventoryMaterialsImportValidateCreate202,
  V1InventoryMaterialsImportValidateCreateBodyOne,
  V1InventoryMaterialsImportValidateCreateBodyThree,
  V1InventoryMaterialsImportValidateCreateBodyTwo,
  V1InventoryMaterialsListParams,
  V1InventoryPendingLotAllocationsListParams,
  V1InventoryStockOnHandRetrieveParams,
  V1InventoryStockReceiptsImportBatchesRetrieve200,
  V1InventoryStockReceiptsImportCommitCreate200,
  V1InventoryStockReceiptsImportCommitCreate202,
  V1InventoryStockReceiptsImportCommitCreateBodyOne,
  V1InventoryStockReceiptsImportCommitCreateBodyThree,
  V1InventoryStockReceiptsImportCommitCreateBodyTwo,
  V1InventoryStockReceiptsImportDetectHeadersCreate200,
  V1InventoryStockReceiptsImportDetectHeadersCreateBody,
  V1InventoryStockReceiptsImportValidateCreate200,
  V1InventoryStockReceiptsImportValidateCreate202,
  V1InventoryStockReceiptsImportValidateCreateBodyOne,
  V1InventoryStockReceiptsImportValidateCreateBodyThree,
  V1InventoryStockReceiptsImportValidateCreateBodyTwo,
  V1InventoryStockTransactionsListParams,
  V1InventoryUomListParams,
  V1InventoryWarehousesListParams,
  V1MarketplaceCatalogFamiliesListParams,
  V1MarketplaceCatalogRevisionsListParams,
  V1MarketplaceListingPricesListParams,
  V1MarketplaceListingsListParams,
  V1MarketplaceOrdersListParams,
  V1MarketplaceStoreFamiliesListParams,
  V1MarketplaceStoreRevisionsListParams,
  V1MarketplaceStoresListParams,
  V1OrganizationsChildrenCreateParams,
  V1OrganizationsChildrenListParams,
  V1OrganizationsInvitationsCreateParams,
  V1OrganizationsInvitationsListParams,
  V1OrganizationsListParams,
  V1OrganizationsMembershipsCreateParams,
  V1OrganizationsMembershipsListParams,
  V1PlanningCapacityChecksListParams,
  V1PlanningCapacityProfilesListParams,
  V1PlanningMasterScheduleLinesListParams,
  V1PlanningMasterScheduleRevisionsListParams,
  V1PlanningMasterSchedulesListParams,
  V1PlanningMrpRunsListParams,
  V1PlanningPeriodsListParams,
  V1PrintingPrintFormatFamiliesListParams,
  V1PrintingPrintFormatRevisionsListParams,
  V1ProductionBomFamiliesListParams,
  V1ProductionBomItemsListParams,
  V1ProductionBomOperationAllocationsListParams,
  V1ProductionBomRevisionsListParams,
  V1ProductionHoldReasonCodesListParams,
  V1ProductionLotFeedSessionsListParams,
  V1ProductionMachinesListParams,
  V1ProductionMaterialBalancesListParams,
  V1ProductionMaterialConsumptionRecordsListParams,
  V1ProductionOperationMaterialSourcesListParams,
  V1ProductionProductionLinesListParams,
  V1ProductionProductionOrdersListParams,
  V1ProductionRoutingFamiliesListParams,
  V1ProductionRoutingOperationDependenciesListParams,
  V1ProductionRoutingOperationsJoinTypeListParams,
  V1ProductionRoutingOperationsListParams,
  V1ProductionRoutingRevisionsListParams,
  V1ProductionRoutingWorkInstructionFamiliesListParams,
  V1ProductionRoutingWorkInstructionRevisionsListParams,
  V1ProductionScrapReasonCodesListParams,
  V1ProductionScrapRecordsListParams,
  V1ProductionSerialUnitLotLinksListParams,
  V1ProductionSerialUnitsListParams,
  V1ProductionShopfloorDowntimeReasonCodesListParams,
  V1ProductionShopfloorDowntimeRecordsListParams,
  V1ProductionShopfloorLeaveRequestsListParams,
  V1ProductionShopfloorLeaveTypesListParams,
  V1ProductionShopfloorOperatorRosterAssignmentsListParams,
  V1ProductionShopfloorOperatorShiftOverridesListParams,
  V1ProductionShopfloorOvertimeRecordsListParams,
  V1ProductionShopfloorRosterDaysListParams,
  V1ProductionShopfloorRostersListParams,
  V1ProductionShopfloorShiftBoundaryOverridesListParams,
  V1ProductionShopfloorShiftSwapRequestsListParams,
  V1ProductionShopfloorShiftTemplatesListParams,
  V1ProductionShopfloorWorkInstructionsForLineRetrieveParams,
  V1ProductionShortageHoldsListParams,
  V1ProductionStationAssignmentOperatorStationAssignmentsListParams,
  V1ProductionStationAssignmentOperatorStationRotationSlotsListParams,
  V1ProductionStationAssignmentStationAssignmentOverridesListParams,
  V1ProductionUnifiedConsumptionActionBackflushSuggestionsListParams,
  V1ProductionWorkCentersListParams,
  V1ProductionWorkOrdersListParams,
  V1QualityCheckFamiliesListParams,
  V1QualityCheckRevisionsListParams,
  V1ReportingDefinitionsExecuteCreateParams,
  V1ReportingDefinitionsListParams,
  V1TenantsListParams,
  V1UsersListParams,
  V1WorkflowFamiliesListParams,
  V1WorkflowInstancesListParams,
  V1WorkflowRevisionsListParams,
  Warehouse,
  WorkCenter,
  WorkCenterCapacityProfile,
  WorkCenterLotFeedSession,
  WorkInstructionFamily,
  WorkInstructionRevision,
  WorkOrder,
  WorkOrderShortageHold,
  WorkOrderShortageHoldCreate,
  WorkflowFamily,
  WorkflowFamilyUnlockBody,
  WorkflowInstance,
  WorkflowInstanceCreate,
  WorkflowRejectBody,
  WorkflowRevision
} from '.././models';

import { customAxiosInstance } from '../../client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;





/**
 * ADR-095 Rule CF-02/CF-06: CRUD for CustomFieldDefinition.
Tenant-scoped: tenant_id injected from request context.
No DELETE — ADR-046 Hard Delete Prohibited; use deactivate/activate.
 * @summary List custom field definitions for active tenant
 */
export const v1CustomFieldDefinitionsList = (
    params?: V1CustomFieldDefinitionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedCustomFieldDefinitionList>(
      {url: `/api/v1/custom-field-definitions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1CustomFieldDefinitionsListQueryKey = (params?: V1CustomFieldDefinitionsListParams,) => {
    return [
    `/api/v1/custom-field-definitions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1CustomFieldDefinitionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError = unknown>(params?: V1CustomFieldDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CustomFieldDefinitionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>> = ({ signal }) => v1CustomFieldDefinitionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1CustomFieldDefinitionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>>
export type V1CustomFieldDefinitionsListQueryError = unknown


export function useV1CustomFieldDefinitionsList<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError = unknown>(
 params: undefined |  V1CustomFieldDefinitionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldDefinitionsList<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError = unknown>(
 params?: V1CustomFieldDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldDefinitionsList<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError = unknown>(
 params?: V1CustomFieldDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List custom field definitions for active tenant
 */

export function useV1CustomFieldDefinitionsList<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError = unknown>(
 params?: V1CustomFieldDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1CustomFieldDefinitionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-095 Rule CF-02/CF-06: CRUD for CustomFieldDefinition.
Tenant-scoped: tenant_id injected from request context.
No DELETE — ADR-046 Hard Delete Prohibited; use deactivate/activate.
 * @summary Create a custom field definition
 */
export const v1CustomFieldDefinitionsCreate = (
    customFieldDefinition: NonReadonly<CustomFieldDefinition>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CustomFieldDefinition>(
      {url: `/api/v1/custom-field-definitions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customFieldDefinition, signal
    },
      );
    }
  


export const getV1CustomFieldDefinitionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsCreate>>, TError,{data: NonReadonly<CustomFieldDefinition>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsCreate>>, TError,{data: NonReadonly<CustomFieldDefinition>}, TContext> => {

const mutationKey = ['v1CustomFieldDefinitionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CustomFieldDefinitionsCreate>>, {data: NonReadonly<CustomFieldDefinition>}> = (props) => {
          const {data} = props ?? {};

          return  v1CustomFieldDefinitionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1CustomFieldDefinitionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldDefinitionsCreate>>>
    export type V1CustomFieldDefinitionsCreateMutationBody = NonReadonly<CustomFieldDefinition>
    export type V1CustomFieldDefinitionsCreateMutationError = unknown

    /**
 * @summary Create a custom field definition
 */
export const useV1CustomFieldDefinitionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsCreate>>, TError,{data: NonReadonly<CustomFieldDefinition>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CustomFieldDefinitionsCreate>>,
        TError,
        {data: NonReadonly<CustomFieldDefinition>},
        TContext
      > => {

      const mutationOptions = getV1CustomFieldDefinitionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-095 Rule CF-02/CF-06: CRUD for CustomFieldDefinition.
Tenant-scoped: tenant_id injected from request context.
No DELETE — ADR-046 Hard Delete Prohibited; use deactivate/activate.
 * @summary Retrieve a custom field definition
 */
export const v1CustomFieldDefinitionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CustomFieldDefinition>(
      {url: `/api/v1/custom-field-definitions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1CustomFieldDefinitionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/custom-field-definitions/${id}/`
    ] as const;
    }

    
export const getV1CustomFieldDefinitionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CustomFieldDefinitionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>> = ({ signal }) => v1CustomFieldDefinitionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1CustomFieldDefinitionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>>
export type V1CustomFieldDefinitionsRetrieveQueryError = unknown


export function useV1CustomFieldDefinitionsRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldDefinitionsRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldDefinitionsRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a custom field definition
 */

export function useV1CustomFieldDefinitionsRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1CustomFieldDefinitionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-095 Rule CF-02/CF-06: CRUD for CustomFieldDefinition.
Tenant-scoped: tenant_id injected from request context.
No DELETE — ADR-046 Hard Delete Prohibited; use deactivate/activate.
 */
export const v1CustomFieldDefinitionsUpdate = (
    id: string,
    customFieldDefinition: NonReadonly<CustomFieldDefinition>,
 ) => {
      
      
      return customAxiosInstance<CustomFieldDefinition>(
      {url: `/api/v1/custom-field-definitions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customFieldDefinition
    },
      );
    }
  


export const getV1CustomFieldDefinitionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsUpdate>>, TError,{id: string;data: NonReadonly<CustomFieldDefinition>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsUpdate>>, TError,{id: string;data: NonReadonly<CustomFieldDefinition>}, TContext> => {

const mutationKey = ['v1CustomFieldDefinitionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CustomFieldDefinitionsUpdate>>, {id: string;data: NonReadonly<CustomFieldDefinition>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1CustomFieldDefinitionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1CustomFieldDefinitionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldDefinitionsUpdate>>>
    export type V1CustomFieldDefinitionsUpdateMutationBody = NonReadonly<CustomFieldDefinition>
    export type V1CustomFieldDefinitionsUpdateMutationError = unknown

    export const useV1CustomFieldDefinitionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsUpdate>>, TError,{id: string;data: NonReadonly<CustomFieldDefinition>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CustomFieldDefinitionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<CustomFieldDefinition>},
        TContext
      > => {

      const mutationOptions = getV1CustomFieldDefinitionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-095 Rule CF-02/CF-06: CRUD for CustomFieldDefinition.
Tenant-scoped: tenant_id injected from request context.
No DELETE — ADR-046 Hard Delete Prohibited; use deactivate/activate.
 */
export const v1CustomFieldDefinitionsPartialUpdate = (
    id: string,
    patchedCustomFieldDefinition: NonReadonly<PatchedCustomFieldDefinition>,
 ) => {
      
      
      return customAxiosInstance<CustomFieldDefinition>(
      {url: `/api/v1/custom-field-definitions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedCustomFieldDefinition
    },
      );
    }
  


export const getV1CustomFieldDefinitionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedCustomFieldDefinition>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedCustomFieldDefinition>}, TContext> => {

const mutationKey = ['v1CustomFieldDefinitionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CustomFieldDefinitionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedCustomFieldDefinition>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1CustomFieldDefinitionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1CustomFieldDefinitionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldDefinitionsPartialUpdate>>>
    export type V1CustomFieldDefinitionsPartialUpdateMutationBody = NonReadonly<PatchedCustomFieldDefinition>
    export type V1CustomFieldDefinitionsPartialUpdateMutationError = unknown

    export const useV1CustomFieldDefinitionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedCustomFieldDefinition>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CustomFieldDefinitionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedCustomFieldDefinition>},
        TContext
      > => {

      const mutationOptions = getV1CustomFieldDefinitionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-095 Rule CF-02/CF-06: CRUD for CustomFieldDefinition.
Tenant-scoped: tenant_id injected from request context.
No DELETE — ADR-046 Hard Delete Prohibited; use deactivate/activate.
 * @summary Reactivate a previously-deactivated custom field definition
 */
export const v1CustomFieldDefinitionsActivateCreate = (
    id: string,
    customFieldDefinition: NonReadonly<CustomFieldDefinition>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CustomFieldDefinition>(
      {url: `/api/v1/custom-field-definitions/${id}/activate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customFieldDefinition, signal
    },
      );
    }
  


export const getV1CustomFieldDefinitionsActivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsActivateCreate>>, TError,{id: string;data: NonReadonly<CustomFieldDefinition>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsActivateCreate>>, TError,{id: string;data: NonReadonly<CustomFieldDefinition>}, TContext> => {

const mutationKey = ['v1CustomFieldDefinitionsActivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CustomFieldDefinitionsActivateCreate>>, {id: string;data: NonReadonly<CustomFieldDefinition>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1CustomFieldDefinitionsActivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1CustomFieldDefinitionsActivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldDefinitionsActivateCreate>>>
    export type V1CustomFieldDefinitionsActivateCreateMutationBody = NonReadonly<CustomFieldDefinition>
    export type V1CustomFieldDefinitionsActivateCreateMutationError = unknown

    /**
 * @summary Reactivate a previously-deactivated custom field definition
 */
export const useV1CustomFieldDefinitionsActivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsActivateCreate>>, TError,{id: string;data: NonReadonly<CustomFieldDefinition>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CustomFieldDefinitionsActivateCreate>>,
        TError,
        {id: string;data: NonReadonly<CustomFieldDefinition>},
        TContext
      > => {

      const mutationOptions = getV1CustomFieldDefinitionsActivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-095 Rule CF-02/CF-06: CRUD for CustomFieldDefinition.
Tenant-scoped: tenant_id injected from request context.
No DELETE — ADR-046 Hard Delete Prohibited; use deactivate/activate.
 * @summary Deactivate a custom field definition (soft, never deleted)
 */
export const v1CustomFieldDefinitionsDeactivateCreate = (
    id: string,
    customFieldDefinition: NonReadonly<CustomFieldDefinition>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CustomFieldDefinition>(
      {url: `/api/v1/custom-field-definitions/${id}/deactivate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customFieldDefinition, signal
    },
      );
    }
  


export const getV1CustomFieldDefinitionsDeactivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsDeactivateCreate>>, TError,{id: string;data: NonReadonly<CustomFieldDefinition>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsDeactivateCreate>>, TError,{id: string;data: NonReadonly<CustomFieldDefinition>}, TContext> => {

const mutationKey = ['v1CustomFieldDefinitionsDeactivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CustomFieldDefinitionsDeactivateCreate>>, {id: string;data: NonReadonly<CustomFieldDefinition>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1CustomFieldDefinitionsDeactivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1CustomFieldDefinitionsDeactivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldDefinitionsDeactivateCreate>>>
    export type V1CustomFieldDefinitionsDeactivateCreateMutationBody = NonReadonly<CustomFieldDefinition>
    export type V1CustomFieldDefinitionsDeactivateCreateMutationError = unknown

    /**
 * @summary Deactivate a custom field definition (soft, never deleted)
 */
export const useV1CustomFieldDefinitionsDeactivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsDeactivateCreate>>, TError,{id: string;data: NonReadonly<CustomFieldDefinition>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CustomFieldDefinitionsDeactivateCreate>>,
        TError,
        {id: string;data: NonReadonly<CustomFieldDefinition>},
        TContext
      > => {

      const mutationOptions = getV1CustomFieldDefinitionsDeactivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-009 (closes ADR-095 OQ-CF-01): exposes the
shared.entity_search custom-fieldable registry so the frontend
stops hardcoding a model list that has no backend validation
behind it. Returns bare "app_label.model" keys — labels are a
frontend/UX concern, kept out of the backend registry on purpose
(see AM-009 Rule AM-009-03).
 * @summary List entity-type keys that are valid Custom Fields targets (AM-009)
 */
export const v1CustomFieldDefinitionsTargetTypesRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CustomFieldDefinition>(
      {url: `/api/v1/custom-field-definitions/target-types/`, method: 'GET', signal
    },
      );
    }
  



export const getV1CustomFieldDefinitionsTargetTypesRetrieveQueryKey = () => {
    return [
    `/api/v1/custom-field-definitions/target-types/`
    ] as const;
    }

    
export const getV1CustomFieldDefinitionsTargetTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CustomFieldDefinitionsTargetTypesRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>> = ({ signal }) => v1CustomFieldDefinitionsTargetTypesRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1CustomFieldDefinitionsTargetTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>>
export type V1CustomFieldDefinitionsTargetTypesRetrieveQueryError = unknown


export function useV1CustomFieldDefinitionsTargetTypesRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldDefinitionsTargetTypesRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldDefinitionsTargetTypesRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List entity-type keys that are valid Custom Fields targets (AM-009)
 */

export function useV1CustomFieldDefinitionsTargetTypesRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldDefinitionsTargetTypesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1CustomFieldDefinitionsTargetTypesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-095 Rule CF-07: Media upload/download endpoint enforcing tenant isolation.
 * @summary Upload a file or image for custom fields
 */
export const v1CustomFieldMediaCreate = (
    customFieldMedia: NonReadonly<CustomFieldMedia>,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();

      return customAxiosInstance<CustomFieldMedia>(
      {url: `/api/v1/custom-field-media/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getV1CustomFieldMediaCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldMediaCreate>>, TError,{data: NonReadonly<CustomFieldMedia>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldMediaCreate>>, TError,{data: NonReadonly<CustomFieldMedia>}, TContext> => {

const mutationKey = ['v1CustomFieldMediaCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CustomFieldMediaCreate>>, {data: NonReadonly<CustomFieldMedia>}> = (props) => {
          const {data} = props ?? {};

          return  v1CustomFieldMediaCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1CustomFieldMediaCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldMediaCreate>>>
    export type V1CustomFieldMediaCreateMutationBody = NonReadonly<CustomFieldMedia>
    export type V1CustomFieldMediaCreateMutationError = unknown

    /**
 * @summary Upload a file or image for custom fields
 */
export const useV1CustomFieldMediaCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldMediaCreate>>, TError,{data: NonReadonly<CustomFieldMedia>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CustomFieldMediaCreate>>,
        TError,
        {data: NonReadonly<CustomFieldMedia>},
        TContext
      > => {

      const mutationOptions = getV1CustomFieldMediaCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-095 Rule CF-07: Media upload/download endpoint enforcing tenant isolation.
 * @summary Download a custom field media file securely
 */
export const v1CustomFieldMediaDownloadRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CustomFieldMedia>(
      {url: `/api/v1/custom-field-media/${id}/download/`, method: 'GET', signal
    },
      );
    }
  



export const getV1CustomFieldMediaDownloadRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/custom-field-media/${id}/download/`
    ] as const;
    }

    
export const getV1CustomFieldMediaDownloadRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CustomFieldMediaDownloadRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>> = ({ signal }) => v1CustomFieldMediaDownloadRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1CustomFieldMediaDownloadRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>>
export type V1CustomFieldMediaDownloadRetrieveQueryError = unknown


export function useV1CustomFieldMediaDownloadRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldMediaDownloadRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldMediaDownloadRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Download a custom field media file securely
 */

export function useV1CustomFieldMediaDownloadRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldMediaDownloadRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1CustomFieldMediaDownloadRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-095 Rule CF-05: read-only for individual rows (list/retrieve).
All writes go through `set-values` (CustomFieldService.set_values), never
a bare POST/PATCH on a single row — so type validation against the
definition, and the "all required fields present" check, can never be
bypassed by hitting a raw create/update endpoint (same class of bug
AM-007 found and fixed in apps.quality).
 * @summary List custom field values (filter by target)
 */
export const v1CustomFieldValuesList = (
    params?: V1CustomFieldValuesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedCustomFieldValueList>(
      {url: `/api/v1/custom-field-values/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1CustomFieldValuesListQueryKey = (params?: V1CustomFieldValuesListParams,) => {
    return [
    `/api/v1/custom-field-values/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1CustomFieldValuesListQueryOptions = <TData = Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError = unknown>(params?: V1CustomFieldValuesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CustomFieldValuesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CustomFieldValuesList>>> = ({ signal }) => v1CustomFieldValuesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1CustomFieldValuesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldValuesList>>>
export type V1CustomFieldValuesListQueryError = unknown


export function useV1CustomFieldValuesList<TData = Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError = unknown>(
 params: undefined |  V1CustomFieldValuesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldValuesList>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldValuesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldValuesList<TData = Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError = unknown>(
 params?: V1CustomFieldValuesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldValuesList>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldValuesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldValuesList<TData = Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError = unknown>(
 params?: V1CustomFieldValuesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List custom field values (filter by target)
 */

export function useV1CustomFieldValuesList<TData = Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError = unknown>(
 params?: V1CustomFieldValuesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1CustomFieldValuesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-095 Rule CF-05: read-only for individual rows (list/retrieve).
All writes go through `set-values` (CustomFieldService.set_values), never
a bare POST/PATCH on a single row — so type validation against the
definition, and the "all required fields present" check, can never be
bypassed by hitting a raw create/update endpoint (same class of bug
AM-007 found and fixed in apps.quality).
 * @summary Retrieve a single custom field value row
 */
export const v1CustomFieldValuesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CustomFieldValue>(
      {url: `/api/v1/custom-field-values/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1CustomFieldValuesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/custom-field-values/${id}/`
    ] as const;
    }

    
export const getV1CustomFieldValuesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CustomFieldValuesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>> = ({ signal }) => v1CustomFieldValuesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1CustomFieldValuesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>>
export type V1CustomFieldValuesRetrieveQueryError = unknown


export function useV1CustomFieldValuesRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldValuesRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldValuesRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a single custom field value row
 */

export function useV1CustomFieldValuesRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1CustomFieldValuesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-095 Rule CF-05: read-only for individual rows (list/retrieve).
All writes go through `set-values` (CustomFieldService.set_values), never
a bare POST/PATCH on a single row — so type validation against the
definition, and the "all required fields present" check, can never be
bypassed by hitting a raw create/update endpoint (same class of bug
AM-007 found and fixed in apps.quality).
 * @summary Get active field schema + current values for one target instance
 */
export const v1CustomFieldValuesForTargetRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CustomFieldValue>(
      {url: `/api/v1/custom-field-values/for-target/`, method: 'GET', signal
    },
      );
    }
  



export const getV1CustomFieldValuesForTargetRetrieveQueryKey = () => {
    return [
    `/api/v1/custom-field-values/for-target/`
    ] as const;
    }

    
export const getV1CustomFieldValuesForTargetRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1CustomFieldValuesForTargetRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>> = ({ signal }) => v1CustomFieldValuesForTargetRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1CustomFieldValuesForTargetRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>>
export type V1CustomFieldValuesForTargetRetrieveQueryError = unknown


export function useV1CustomFieldValuesForTargetRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldValuesForTargetRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1CustomFieldValuesForTargetRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get active field schema + current values for one target instance
 */

export function useV1CustomFieldValuesForTargetRetrieve<TData = Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1CustomFieldValuesForTargetRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1CustomFieldValuesForTargetRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-095 Rule CF-05: read-only for individual rows (list/retrieve).
All writes go through `set-values` (CustomFieldService.set_values), never
a bare POST/PATCH on a single row — so type validation against the
definition, and the "all required fields present" check, can never be
bypassed by hitting a raw create/update endpoint (same class of bug
AM-007 found and fixed in apps.quality).
 * @summary Bulk upsert values for one target entity instance
 */
export const v1CustomFieldValuesSetValuesCreate = (
    customFieldValue: NonReadonly<CustomFieldValue>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CustomFieldValue>(
      {url: `/api/v1/custom-field-values/set-values/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customFieldValue, signal
    },
      );
    }
  


export const getV1CustomFieldValuesSetValuesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldValuesSetValuesCreate>>, TError,{data: NonReadonly<CustomFieldValue>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldValuesSetValuesCreate>>, TError,{data: NonReadonly<CustomFieldValue>}, TContext> => {

const mutationKey = ['v1CustomFieldValuesSetValuesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1CustomFieldValuesSetValuesCreate>>, {data: NonReadonly<CustomFieldValue>}> = (props) => {
          const {data} = props ?? {};

          return  v1CustomFieldValuesSetValuesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1CustomFieldValuesSetValuesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1CustomFieldValuesSetValuesCreate>>>
    export type V1CustomFieldValuesSetValuesCreateMutationBody = NonReadonly<CustomFieldValue>
    export type V1CustomFieldValuesSetValuesCreateMutationError = unknown

    /**
 * @summary Bulk upsert values for one target entity instance
 */
export const useV1CustomFieldValuesSetValuesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1CustomFieldValuesSetValuesCreate>>, TError,{data: NonReadonly<CustomFieldValue>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1CustomFieldValuesSetValuesCreate>>,
        TError,
        {data: NonReadonly<CustomFieldValue>},
        TContext
      > => {

      const mutationOptions = getV1CustomFieldValuesSetValuesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormFamiliesList = (
    params?: V1FormsFormFamiliesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedFormFamilyList>(
      {url: `/api/v1/forms/form-families/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1FormsFormFamiliesListQueryKey = (params?: V1FormsFormFamiliesListParams,) => {
    return [
    `/api/v1/forms/form-families/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1FormsFormFamiliesListQueryOptions = <TData = Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError = unknown>(params?: V1FormsFormFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1FormsFormFamiliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1FormsFormFamiliesList>>> = ({ signal }) => v1FormsFormFamiliesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1FormsFormFamiliesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormFamiliesList>>>
export type V1FormsFormFamiliesListQueryError = unknown


export function useV1FormsFormFamiliesList<TData = Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError = unknown>(
 params: undefined |  V1FormsFormFamiliesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormFamiliesList<TData = Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError = unknown>(
 params?: V1FormsFormFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormFamiliesList<TData = Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError = unknown>(
 params?: V1FormsFormFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1FormsFormFamiliesList<TData = Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError = unknown>(
 params?: V1FormsFormFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1FormsFormFamiliesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormFamiliesCreate = (
    formFamily: NonReadonly<FormFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormFamily>(
      {url: `/api/v1/forms/form-families/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formFamily, signal
    },
      );
    }
  


export const getV1FormsFormFamiliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesCreate>>, TError,{data: NonReadonly<FormFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesCreate>>, TError,{data: NonReadonly<FormFamily>}, TContext> => {

const mutationKey = ['v1FormsFormFamiliesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormFamiliesCreate>>, {data: NonReadonly<FormFamily>}> = (props) => {
          const {data} = props ?? {};

          return  v1FormsFormFamiliesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormFamiliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormFamiliesCreate>>>
    export type V1FormsFormFamiliesCreateMutationBody = NonReadonly<FormFamily>
    export type V1FormsFormFamiliesCreateMutationError = unknown

    export const useV1FormsFormFamiliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesCreate>>, TError,{data: NonReadonly<FormFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormFamiliesCreate>>,
        TError,
        {data: NonReadonly<FormFamily>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormFamiliesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormFamiliesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormFamily>(
      {url: `/api/v1/forms/form-families/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1FormsFormFamiliesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/forms/form-families/${id}/`
    ] as const;
    }

    
export const getV1FormsFormFamiliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1FormsFormFamiliesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>> = ({ signal }) => v1FormsFormFamiliesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1FormsFormFamiliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>>
export type V1FormsFormFamiliesRetrieveQueryError = unknown


export function useV1FormsFormFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1FormsFormFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1FormsFormFamiliesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormFamiliesUpdate = (
    id: string,
    formFamily: NonReadonly<FormFamily>,
 ) => {
      
      
      return customAxiosInstance<FormFamily>(
      {url: `/api/v1/forms/form-families/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: formFamily
    },
      );
    }
  


export const getV1FormsFormFamiliesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesUpdate>>, TError,{id: string;data: NonReadonly<FormFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesUpdate>>, TError,{id: string;data: NonReadonly<FormFamily>}, TContext> => {

const mutationKey = ['v1FormsFormFamiliesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormFamiliesUpdate>>, {id: string;data: NonReadonly<FormFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1FormsFormFamiliesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormFamiliesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormFamiliesUpdate>>>
    export type V1FormsFormFamiliesUpdateMutationBody = NonReadonly<FormFamily>
    export type V1FormsFormFamiliesUpdateMutationError = unknown

    export const useV1FormsFormFamiliesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesUpdate>>, TError,{id: string;data: NonReadonly<FormFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormFamiliesUpdate>>,
        TError,
        {id: string;data: NonReadonly<FormFamily>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormFamiliesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormFamiliesPartialUpdate = (
    id: string,
    patchedFormFamily: NonReadonly<PatchedFormFamily>,
 ) => {
      
      
      return customAxiosInstance<FormFamily>(
      {url: `/api/v1/forms/form-families/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedFormFamily
    },
      );
    }
  


export const getV1FormsFormFamiliesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedFormFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedFormFamily>}, TContext> => {

const mutationKey = ['v1FormsFormFamiliesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormFamiliesPartialUpdate>>, {id: string;data: NonReadonly<PatchedFormFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1FormsFormFamiliesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormFamiliesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormFamiliesPartialUpdate>>>
    export type V1FormsFormFamiliesPartialUpdateMutationBody = NonReadonly<PatchedFormFamily>
    export type V1FormsFormFamiliesPartialUpdateMutationError = unknown

    export const useV1FormsFormFamiliesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedFormFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormFamiliesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedFormFamily>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormFamiliesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormFamiliesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/forms/form-families/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1FormsFormFamiliesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1FormsFormFamiliesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormFamiliesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1FormsFormFamiliesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormFamiliesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormFamiliesDestroy>>>
    
    export type V1FormsFormFamiliesDestroyMutationError = unknown

    export const useV1FormsFormFamiliesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormFamiliesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormFamiliesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1FormsFormFamiliesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstanceDraftsList = (
    params?: V1FormsFormInstanceDraftsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedFormInstanceDraftList>(
      {url: `/api/v1/forms/form-instance-drafts/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1FormsFormInstanceDraftsListQueryKey = (params?: V1FormsFormInstanceDraftsListParams,) => {
    return [
    `/api/v1/forms/form-instance-drafts/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1FormsFormInstanceDraftsListQueryOptions = <TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError = unknown>(params?: V1FormsFormInstanceDraftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1FormsFormInstanceDraftsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>> = ({ signal }) => v1FormsFormInstanceDraftsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1FormsFormInstanceDraftsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>>
export type V1FormsFormInstanceDraftsListQueryError = unknown


export function useV1FormsFormInstanceDraftsList<TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError = unknown>(
 params: undefined |  V1FormsFormInstanceDraftsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormInstanceDraftsList<TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError = unknown>(
 params?: V1FormsFormInstanceDraftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormInstanceDraftsList<TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError = unknown>(
 params?: V1FormsFormInstanceDraftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1FormsFormInstanceDraftsList<TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError = unknown>(
 params?: V1FormsFormInstanceDraftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1FormsFormInstanceDraftsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstanceDraftsCreate = (
    formInstanceDraft: NonReadonly<FormInstanceDraft>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormInstanceDraft>(
      {url: `/api/v1/forms/form-instance-drafts/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formInstanceDraft, signal
    },
      );
    }
  


export const getV1FormsFormInstanceDraftsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsCreate>>, TError,{data: NonReadonly<FormInstanceDraft>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsCreate>>, TError,{data: NonReadonly<FormInstanceDraft>}, TContext> => {

const mutationKey = ['v1FormsFormInstanceDraftsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsCreate>>, {data: NonReadonly<FormInstanceDraft>}> = (props) => {
          const {data} = props ?? {};

          return  v1FormsFormInstanceDraftsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormInstanceDraftsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsCreate>>>
    export type V1FormsFormInstanceDraftsCreateMutationBody = NonReadonly<FormInstanceDraft>
    export type V1FormsFormInstanceDraftsCreateMutationError = unknown

    export const useV1FormsFormInstanceDraftsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsCreate>>, TError,{data: NonReadonly<FormInstanceDraft>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormInstanceDraftsCreate>>,
        TError,
        {data: NonReadonly<FormInstanceDraft>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormInstanceDraftsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstanceDraftsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormInstanceDraft>(
      {url: `/api/v1/forms/form-instance-drafts/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1FormsFormInstanceDraftsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/forms/form-instance-drafts/${id}/`
    ] as const;
    }

    
export const getV1FormsFormInstanceDraftsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1FormsFormInstanceDraftsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>> = ({ signal }) => v1FormsFormInstanceDraftsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1FormsFormInstanceDraftsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>>
export type V1FormsFormInstanceDraftsRetrieveQueryError = unknown


export function useV1FormsFormInstanceDraftsRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormInstanceDraftsRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormInstanceDraftsRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1FormsFormInstanceDraftsRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1FormsFormInstanceDraftsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstanceDraftsUpdate = (
    id: string,
    formInstanceDraft: NonReadonly<FormInstanceDraft>,
 ) => {
      
      
      return customAxiosInstance<FormInstanceDraft>(
      {url: `/api/v1/forms/form-instance-drafts/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: formInstanceDraft
    },
      );
    }
  


export const getV1FormsFormInstanceDraftsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsUpdate>>, TError,{id: string;data: NonReadonly<FormInstanceDraft>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsUpdate>>, TError,{id: string;data: NonReadonly<FormInstanceDraft>}, TContext> => {

const mutationKey = ['v1FormsFormInstanceDraftsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsUpdate>>, {id: string;data: NonReadonly<FormInstanceDraft>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1FormsFormInstanceDraftsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormInstanceDraftsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsUpdate>>>
    export type V1FormsFormInstanceDraftsUpdateMutationBody = NonReadonly<FormInstanceDraft>
    export type V1FormsFormInstanceDraftsUpdateMutationError = unknown

    export const useV1FormsFormInstanceDraftsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsUpdate>>, TError,{id: string;data: NonReadonly<FormInstanceDraft>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormInstanceDraftsUpdate>>,
        TError,
        {id: string;data: NonReadonly<FormInstanceDraft>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormInstanceDraftsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstanceDraftsPartialUpdate = (
    id: string,
    patchedFormInstanceDraft: NonReadonly<PatchedFormInstanceDraft>,
 ) => {
      
      
      return customAxiosInstance<FormInstanceDraft>(
      {url: `/api/v1/forms/form-instance-drafts/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedFormInstanceDraft
    },
      );
    }
  


export const getV1FormsFormInstanceDraftsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedFormInstanceDraft>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedFormInstanceDraft>}, TContext> => {

const mutationKey = ['v1FormsFormInstanceDraftsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsPartialUpdate>>, {id: string;data: NonReadonly<PatchedFormInstanceDraft>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1FormsFormInstanceDraftsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormInstanceDraftsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsPartialUpdate>>>
    export type V1FormsFormInstanceDraftsPartialUpdateMutationBody = NonReadonly<PatchedFormInstanceDraft>
    export type V1FormsFormInstanceDraftsPartialUpdateMutationError = unknown

    export const useV1FormsFormInstanceDraftsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedFormInstanceDraft>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormInstanceDraftsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedFormInstanceDraft>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormInstanceDraftsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstanceDraftsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/forms/form-instance-drafts/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1FormsFormInstanceDraftsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1FormsFormInstanceDraftsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1FormsFormInstanceDraftsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormInstanceDraftsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsDestroy>>>
    
    export type V1FormsFormInstanceDraftsDestroyMutationError = unknown

    export const useV1FormsFormInstanceDraftsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormInstanceDraftsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1FormsFormInstanceDraftsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstanceDraftsSubmitCreate = (
    id: string,
    formInstanceDraft: NonReadonly<FormInstanceDraft>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormInstanceDraft>(
      {url: `/api/v1/forms/form-instance-drafts/${id}/submit/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formInstanceDraft, signal
    },
      );
    }
  


export const getV1FormsFormInstanceDraftsSubmitCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsSubmitCreate>>, TError,{id: string;data: NonReadonly<FormInstanceDraft>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsSubmitCreate>>, TError,{id: string;data: NonReadonly<FormInstanceDraft>}, TContext> => {

const mutationKey = ['v1FormsFormInstanceDraftsSubmitCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsSubmitCreate>>, {id: string;data: NonReadonly<FormInstanceDraft>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1FormsFormInstanceDraftsSubmitCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormInstanceDraftsSubmitCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsSubmitCreate>>>
    export type V1FormsFormInstanceDraftsSubmitCreateMutationBody = NonReadonly<FormInstanceDraft>
    export type V1FormsFormInstanceDraftsSubmitCreateMutationError = unknown

    export const useV1FormsFormInstanceDraftsSubmitCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstanceDraftsSubmitCreate>>, TError,{id: string;data: NonReadonly<FormInstanceDraft>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormInstanceDraftsSubmitCreate>>,
        TError,
        {id: string;data: NonReadonly<FormInstanceDraft>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormInstanceDraftsSubmitCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstancesList = (
    params?: V1FormsFormInstancesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedFormInstanceList>(
      {url: `/api/v1/forms/form-instances/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1FormsFormInstancesListQueryKey = (params?: V1FormsFormInstancesListParams,) => {
    return [
    `/api/v1/forms/form-instances/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1FormsFormInstancesListQueryOptions = <TData = Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError = unknown>(params?: V1FormsFormInstancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1FormsFormInstancesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1FormsFormInstancesList>>> = ({ signal }) => v1FormsFormInstancesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1FormsFormInstancesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstancesList>>>
export type V1FormsFormInstancesListQueryError = unknown


export function useV1FormsFormInstancesList<TData = Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError = unknown>(
 params: undefined |  V1FormsFormInstancesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormInstancesList>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormInstancesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormInstancesList<TData = Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError = unknown>(
 params?: V1FormsFormInstancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormInstancesList>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormInstancesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormInstancesList<TData = Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError = unknown>(
 params?: V1FormsFormInstancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1FormsFormInstancesList<TData = Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError = unknown>(
 params?: V1FormsFormInstancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1FormsFormInstancesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstancesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormInstance>(
      {url: `/api/v1/forms/form-instances/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1FormsFormInstancesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/forms/form-instances/${id}/`
    ] as const;
    }

    
export const getV1FormsFormInstancesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1FormsFormInstancesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>> = ({ signal }) => v1FormsFormInstancesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1FormsFormInstancesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>>
export type V1FormsFormInstancesRetrieveQueryError = unknown


export function useV1FormsFormInstancesRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormInstancesRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormInstancesRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1FormsFormInstancesRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormInstancesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1FormsFormInstancesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1FormsFormInstancesCorrectCreate = (
    id: string,
    formInstance: NonReadonly<FormInstance>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormInstance>(
      {url: `/api/v1/forms/form-instances/${id}/correct/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formInstance, signal
    },
      );
    }
  


export const getV1FormsFormInstancesCorrectCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstancesCorrectCreate>>, TError,{id: string;data: NonReadonly<FormInstance>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstancesCorrectCreate>>, TError,{id: string;data: NonReadonly<FormInstance>}, TContext> => {

const mutationKey = ['v1FormsFormInstancesCorrectCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormInstancesCorrectCreate>>, {id: string;data: NonReadonly<FormInstance>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1FormsFormInstancesCorrectCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormInstancesCorrectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormInstancesCorrectCreate>>>
    export type V1FormsFormInstancesCorrectCreateMutationBody = NonReadonly<FormInstance>
    export type V1FormsFormInstancesCorrectCreateMutationError = unknown

    export const useV1FormsFormInstancesCorrectCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormInstancesCorrectCreate>>, TError,{id: string;data: NonReadonly<FormInstance>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormInstancesCorrectCreate>>,
        TError,
        {id: string;data: NonReadonly<FormInstance>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormInstancesCorrectCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1FormsFormRevisionsList = (
    params?: V1FormsFormRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedFormRevisionList>(
      {url: `/api/v1/forms/form-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1FormsFormRevisionsListQueryKey = (params?: V1FormsFormRevisionsListParams,) => {
    return [
    `/api/v1/forms/form-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1FormsFormRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError = unknown>(params?: V1FormsFormRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1FormsFormRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1FormsFormRevisionsList>>> = ({ signal }) => v1FormsFormRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1FormsFormRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormRevisionsList>>>
export type V1FormsFormRevisionsListQueryError = unknown


export function useV1FormsFormRevisionsList<TData = Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError = unknown>(
 params: undefined |  V1FormsFormRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormRevisionsList<TData = Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError = unknown>(
 params?: V1FormsFormRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormRevisionsList<TData = Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError = unknown>(
 params?: V1FormsFormRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1FormsFormRevisionsList<TData = Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError = unknown>(
 params?: V1FormsFormRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1FormsFormRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1FormsFormRevisionsCreate = (
    formRevision: NonReadonly<FormRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormRevision>(
      {url: `/api/v1/forms/form-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formRevision, signal
    },
      );
    }
  


export const getV1FormsFormRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsCreate>>, TError,{data: NonReadonly<FormRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsCreate>>, TError,{data: NonReadonly<FormRevision>}, TContext> => {

const mutationKey = ['v1FormsFormRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormRevisionsCreate>>, {data: NonReadonly<FormRevision>}> = (props) => {
          const {data} = props ?? {};

          return  v1FormsFormRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormRevisionsCreate>>>
    export type V1FormsFormRevisionsCreateMutationBody = NonReadonly<FormRevision>
    export type V1FormsFormRevisionsCreateMutationError = unknown

    export const useV1FormsFormRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsCreate>>, TError,{data: NonReadonly<FormRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormRevisionsCreate>>,
        TError,
        {data: NonReadonly<FormRevision>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1FormsFormRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormRevision>(
      {url: `/api/v1/forms/form-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1FormsFormRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/forms/form-revisions/${id}/`
    ] as const;
    }

    
export const getV1FormsFormRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1FormsFormRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>> = ({ signal }) => v1FormsFormRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1FormsFormRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>>
export type V1FormsFormRevisionsRetrieveQueryError = unknown


export function useV1FormsFormRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1FormsFormRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1FormsFormRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1FormsFormRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1FormsFormRevisionsUpdate = (
    id: string,
    formRevision: NonReadonly<FormRevision>,
 ) => {
      
      
      return customAxiosInstance<FormRevision>(
      {url: `/api/v1/forms/form-revisions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: formRevision
    },
      );
    }
  


export const getV1FormsFormRevisionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsUpdate>>, TError,{id: string;data: NonReadonly<FormRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsUpdate>>, TError,{id: string;data: NonReadonly<FormRevision>}, TContext> => {

const mutationKey = ['v1FormsFormRevisionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormRevisionsUpdate>>, {id: string;data: NonReadonly<FormRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1FormsFormRevisionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormRevisionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormRevisionsUpdate>>>
    export type V1FormsFormRevisionsUpdateMutationBody = NonReadonly<FormRevision>
    export type V1FormsFormRevisionsUpdateMutationError = unknown

    export const useV1FormsFormRevisionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsUpdate>>, TError,{id: string;data: NonReadonly<FormRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormRevisionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<FormRevision>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormRevisionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1FormsFormRevisionsPartialUpdate = (
    id: string,
    patchedFormRevision: NonReadonly<PatchedFormRevision>,
 ) => {
      
      
      return customAxiosInstance<FormRevision>(
      {url: `/api/v1/forms/form-revisions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedFormRevision
    },
      );
    }
  


export const getV1FormsFormRevisionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedFormRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedFormRevision>}, TContext> => {

const mutationKey = ['v1FormsFormRevisionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormRevisionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedFormRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1FormsFormRevisionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormRevisionsPartialUpdate>>>
    export type V1FormsFormRevisionsPartialUpdateMutationBody = NonReadonly<PatchedFormRevision>
    export type V1FormsFormRevisionsPartialUpdateMutationError = unknown

    export const useV1FormsFormRevisionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedFormRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormRevisionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedFormRevision>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormRevisionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1FormsFormRevisionsPublishCreate = (
    id: string,
    formRevision: NonReadonly<FormRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<FormRevision>(
      {url: `/api/v1/forms/form-revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formRevision, signal
    },
      );
    }
  


export const getV1FormsFormRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<FormRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<FormRevision>}, TContext> => {

const mutationKey = ['v1FormsFormRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1FormsFormRevisionsPublishCreate>>, {id: string;data: NonReadonly<FormRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1FormsFormRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1FormsFormRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1FormsFormRevisionsPublishCreate>>>
    export type V1FormsFormRevisionsPublishCreateMutationBody = NonReadonly<FormRevision>
    export type V1FormsFormRevisionsPublishCreateMutationError = unknown

    export const useV1FormsFormRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1FormsFormRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<FormRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1FormsFormRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<FormRevision>},
        TContext
      > => {

      const mutationOptions = getV1FormsFormRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * دریافت ایمیل و رمزعبور و بازگرداندن JWT.
 */
export const v1IdentityLoginCreate = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/identity/login/`, method: 'POST', signal
    },
      );
    }
  


export const getV1IdentityLoginCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1IdentityLoginCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1IdentityLoginCreate>>, TError,void, TContext> => {

const mutationKey = ['v1IdentityLoginCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1IdentityLoginCreate>>, void> = () => {
          

          return  v1IdentityLoginCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1IdentityLoginCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1IdentityLoginCreate>>>
    
    export type V1IdentityLoginCreateMutationError = unknown

    export const useV1IdentityLoginCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1IdentityLoginCreate>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1IdentityLoginCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getV1IdentityLoginCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * باطل کردن Refresh Token.
 */
export const v1IdentityLogoutCreate = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/identity/logout/`, method: 'POST', signal
    },
      );
    }
  


export const getV1IdentityLogoutCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1IdentityLogoutCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1IdentityLogoutCreate>>, TError,void, TContext> => {

const mutationKey = ['v1IdentityLogoutCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1IdentityLogoutCreate>>, void> = () => {
          

          return  v1IdentityLogoutCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1IdentityLogoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1IdentityLogoutCreate>>>
    
    export type V1IdentityLogoutCreateMutationError = unknown

    export const useV1IdentityLogoutCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1IdentityLogoutCreate>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1IdentityLogoutCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getV1IdentityLogoutCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * باطل کردن تمام نشست‌های کاربر احراز هویت‌شده.

PFR-24 security fix: این endpoint نیاز به JWT معتبر دارد.
کاربر از request.user (که توسط JWTAuthentication populate می‌شود)
شناسایی می‌شود — نه از email ارسال‌شده در body.

باگ قبلی: هر کسی با داشتن ایمیل یک کاربر می‌توانست بدون احراز هویت
تمام session‌هایش را terminate کند (DoS unauthenticated).
این باگ حالا بسته شد — `IsAuthenticated` الزامی است.
 */
export const v1IdentityLogoutAllCreate = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/identity/logout/all/`, method: 'POST', signal
    },
      );
    }
  


export const getV1IdentityLogoutAllCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1IdentityLogoutAllCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1IdentityLogoutAllCreate>>, TError,void, TContext> => {

const mutationKey = ['v1IdentityLogoutAllCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1IdentityLogoutAllCreate>>, void> = () => {
          

          return  v1IdentityLogoutAllCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1IdentityLogoutAllCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1IdentityLogoutAllCreate>>>
    
    export type V1IdentityLogoutAllCreateMutationError = unknown

    export const useV1IdentityLogoutAllCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1IdentityLogoutAllCreate>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1IdentityLogoutAllCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getV1IdentityLogoutAllCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * اطلاعات کاربر لاگین‌شده.
 */
export const v1IdentityMeRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/identity/me/`, method: 'GET', signal
    },
      );
    }
  



export const getV1IdentityMeRetrieveQueryKey = () => {
    return [
    `/api/v1/identity/me/`
    ] as const;
    }

    
export const getV1IdentityMeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1IdentityMeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1IdentityMeRetrieve>>> = ({ signal }) => v1IdentityMeRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1IdentityMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1IdentityMeRetrieve>>>
export type V1IdentityMeRetrieveQueryError = unknown


export function useV1IdentityMeRetrieve<TData = Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1IdentityMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1IdentityMeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1IdentityMeRetrieve<TData = Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1IdentityMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1IdentityMeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1IdentityMeRetrieve<TData = Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1IdentityMeRetrieve<TData = Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1IdentityMeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1IdentityMeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * صدور access_token جدید از روی refresh_token معتبر.
 */
export const v1IdentityRefreshCreate = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/identity/refresh/`, method: 'POST', signal
    },
      );
    }
  


export const getV1IdentityRefreshCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1IdentityRefreshCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1IdentityRefreshCreate>>, TError,void, TContext> => {

const mutationKey = ['v1IdentityRefreshCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1IdentityRefreshCreate>>, void> = () => {
          

          return  v1IdentityRefreshCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1IdentityRefreshCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1IdentityRefreshCreate>>>
    
    export type V1IdentityRefreshCreateMutationError = unknown

    export const useV1IdentityRefreshCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1IdentityRefreshCreate>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1IdentityRefreshCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getV1IdentityRefreshCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-056 Rule QM-03: InspectionRecords are append-only. Unchanged by
AM-008 — append-only was never in scope for this Amendment's
edit/activate request, and shouldn't be: an inspection result is a
historical fact, not a document with a lifecycle.
 * @summary List inspection records (read-only)
 */
export const v1InspectionsList = (
    params?: V1InspectionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedInspectionRecordList>(
      {url: `/api/v1/inspections/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InspectionsListQueryKey = (params?: V1InspectionsListParams,) => {
    return [
    `/api/v1/inspections/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InspectionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1InspectionsList>>, TError = unknown>(params?: V1InspectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InspectionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InspectionsList>>> = ({ signal }) => v1InspectionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InspectionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InspectionsList>>>
export type V1InspectionsListQueryError = unknown


export function useV1InspectionsList<TData = Awaited<ReturnType<typeof v1InspectionsList>>, TError = unknown>(
 params: undefined |  V1InspectionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InspectionsList>>,
          TError,
          Awaited<ReturnType<typeof v1InspectionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InspectionsList<TData = Awaited<ReturnType<typeof v1InspectionsList>>, TError = unknown>(
 params?: V1InspectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InspectionsList>>,
          TError,
          Awaited<ReturnType<typeof v1InspectionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InspectionsList<TData = Awaited<ReturnType<typeof v1InspectionsList>>, TError = unknown>(
 params?: V1InspectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List inspection records (read-only)
 */

export function useV1InspectionsList<TData = Awaited<ReturnType<typeof v1InspectionsList>>, TError = unknown>(
 params?: V1InspectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InspectionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-056 Rule QM-03: InspectionRecords are append-only. Unchanged by
AM-008 — append-only was never in scope for this Amendment's
edit/activate request, and shouldn't be: an inspection result is a
historical fact, not a document with a lifecycle.
 * @summary Record a new inspection
 */
export const v1InspectionsCreate = (
    inspectionRecord: NonReadonly<InspectionRecord>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<InspectionRecord>(
      {url: `/api/v1/inspections/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inspectionRecord, signal
    },
      );
    }
  


export const getV1InspectionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InspectionsCreate>>, TError,{data: NonReadonly<InspectionRecord>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InspectionsCreate>>, TError,{data: NonReadonly<InspectionRecord>}, TContext> => {

const mutationKey = ['v1InspectionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InspectionsCreate>>, {data: NonReadonly<InspectionRecord>}> = (props) => {
          const {data} = props ?? {};

          return  v1InspectionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InspectionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InspectionsCreate>>>
    export type V1InspectionsCreateMutationBody = NonReadonly<InspectionRecord>
    export type V1InspectionsCreateMutationError = unknown

    /**
 * @summary Record a new inspection
 */
export const useV1InspectionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InspectionsCreate>>, TError,{data: NonReadonly<InspectionRecord>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InspectionsCreate>>,
        TError,
        {data: NonReadonly<InspectionRecord>},
        TContext
      > => {

      const mutationOptions = getV1InspectionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-056 Rule QM-03: InspectionRecords are append-only. Unchanged by
AM-008 — append-only was never in scope for this Amendment's
edit/activate request, and shouldn't be: an inspection result is a
historical fact, not a document with a lifecycle.
 */
export const v1InspectionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<InspectionRecord>(
      {url: `/api/v1/inspections/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InspectionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inspections/${id}/`
    ] as const;
    }

    
export const getV1InspectionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InspectionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InspectionsRetrieve>>> = ({ signal }) => v1InspectionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InspectionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InspectionsRetrieve>>>
export type V1InspectionsRetrieveQueryError = unknown


export function useV1InspectionsRetrieve<TData = Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InspectionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InspectionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InspectionsRetrieve<TData = Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InspectionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InspectionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InspectionsRetrieve<TData = Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InspectionsRetrieve<TData = Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InspectionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InspectionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-099 Rule LBL-05b.
یک رکورد به‌ازای هر (tenant, template_kind) — یکتایی توسط DB constraint تضمین می‌شود.
 */
export const v1InventoryLabelPrintSettingsList = (
    params?: V1InventoryLabelPrintSettingsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedLabelPrintSettingsList>(
      {url: `/api/v1/inventory/label-print-settings/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryLabelPrintSettingsListQueryKey = (params?: V1InventoryLabelPrintSettingsListParams,) => {
    return [
    `/api/v1/inventory/label-print-settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryLabelPrintSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError = unknown>(params?: V1InventoryLabelPrintSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLabelPrintSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>> = ({ signal }) => v1InventoryLabelPrintSettingsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLabelPrintSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>>
export type V1InventoryLabelPrintSettingsListQueryError = unknown


export function useV1InventoryLabelPrintSettingsList<TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError = unknown>(
 params: undefined |  V1InventoryLabelPrintSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLabelPrintSettingsList<TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError = unknown>(
 params?: V1InventoryLabelPrintSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLabelPrintSettingsList<TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError = unknown>(
 params?: V1InventoryLabelPrintSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryLabelPrintSettingsList<TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError = unknown>(
 params?: V1InventoryLabelPrintSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLabelPrintSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-099 Rule LBL-05b.
یک رکورد به‌ازای هر (tenant, template_kind) — یکتایی توسط DB constraint تضمین می‌شود.
 */
export const v1InventoryLabelPrintSettingsCreate = (
    labelPrintSettings: NonReadonly<LabelPrintSettings>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LabelPrintSettings>(
      {url: `/api/v1/inventory/label-print-settings/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: labelPrintSettings, signal
    },
      );
    }
  


export const getV1InventoryLabelPrintSettingsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsCreate>>, TError,{data: NonReadonly<LabelPrintSettings>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsCreate>>, TError,{data: NonReadonly<LabelPrintSettings>}, TContext> => {

const mutationKey = ['v1InventoryLabelPrintSettingsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsCreate>>, {data: NonReadonly<LabelPrintSettings>}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryLabelPrintSettingsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLabelPrintSettingsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsCreate>>>
    export type V1InventoryLabelPrintSettingsCreateMutationBody = NonReadonly<LabelPrintSettings>
    export type V1InventoryLabelPrintSettingsCreateMutationError = unknown

    export const useV1InventoryLabelPrintSettingsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsCreate>>, TError,{data: NonReadonly<LabelPrintSettings>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsCreate>>,
        TError,
        {data: NonReadonly<LabelPrintSettings>},
        TContext
      > => {

      const mutationOptions = getV1InventoryLabelPrintSettingsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-099 Rule LBL-05b.
یک رکورد به‌ازای هر (tenant, template_kind) — یکتایی توسط DB constraint تضمین می‌شود.
 */
export const v1InventoryLabelPrintSettingsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LabelPrintSettings>(
      {url: `/api/v1/inventory/label-print-settings/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryLabelPrintSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/label-print-settings/${id}/`
    ] as const;
    }

    
export const getV1InventoryLabelPrintSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLabelPrintSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>> = ({ signal }) => v1InventoryLabelPrintSettingsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLabelPrintSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>>
export type V1InventoryLabelPrintSettingsRetrieveQueryError = unknown


export function useV1InventoryLabelPrintSettingsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLabelPrintSettingsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLabelPrintSettingsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryLabelPrintSettingsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLabelPrintSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-099 Rule LBL-05b.
یک رکورد به‌ازای هر (tenant, template_kind) — یکتایی توسط DB constraint تضمین می‌شود.
 */
export const v1InventoryLabelPrintSettingsUpdate = (
    id: string,
    labelPrintSettings: NonReadonly<LabelPrintSettings>,
 ) => {
      
      
      return customAxiosInstance<LabelPrintSettings>(
      {url: `/api/v1/inventory/label-print-settings/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: labelPrintSettings
    },
      );
    }
  


export const getV1InventoryLabelPrintSettingsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsUpdate>>, TError,{id: string;data: NonReadonly<LabelPrintSettings>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsUpdate>>, TError,{id: string;data: NonReadonly<LabelPrintSettings>}, TContext> => {

const mutationKey = ['v1InventoryLabelPrintSettingsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsUpdate>>, {id: string;data: NonReadonly<LabelPrintSettings>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryLabelPrintSettingsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLabelPrintSettingsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsUpdate>>>
    export type V1InventoryLabelPrintSettingsUpdateMutationBody = NonReadonly<LabelPrintSettings>
    export type V1InventoryLabelPrintSettingsUpdateMutationError = unknown

    export const useV1InventoryLabelPrintSettingsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsUpdate>>, TError,{id: string;data: NonReadonly<LabelPrintSettings>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsUpdate>>,
        TError,
        {id: string;data: NonReadonly<LabelPrintSettings>},
        TContext
      > => {

      const mutationOptions = getV1InventoryLabelPrintSettingsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-099 Rule LBL-05b.
یک رکورد به‌ازای هر (tenant, template_kind) — یکتایی توسط DB constraint تضمین می‌شود.
 */
export const v1InventoryLabelPrintSettingsPartialUpdate = (
    id: string,
    patchedLabelPrintSettings: NonReadonly<PatchedLabelPrintSettings>,
 ) => {
      
      
      return customAxiosInstance<LabelPrintSettings>(
      {url: `/api/v1/inventory/label-print-settings/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedLabelPrintSettings
    },
      );
    }
  


export const getV1InventoryLabelPrintSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLabelPrintSettings>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLabelPrintSettings>}, TContext> => {

const mutationKey = ['v1InventoryLabelPrintSettingsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsPartialUpdate>>, {id: string;data: NonReadonly<PatchedLabelPrintSettings>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryLabelPrintSettingsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLabelPrintSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsPartialUpdate>>>
    export type V1InventoryLabelPrintSettingsPartialUpdateMutationBody = NonReadonly<PatchedLabelPrintSettings>
    export type V1InventoryLabelPrintSettingsPartialUpdateMutationError = unknown

    export const useV1InventoryLabelPrintSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLabelPrintSettings>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedLabelPrintSettings>},
        TContext
      > => {

      const mutationOptions = getV1InventoryLabelPrintSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-099 Rule LBL-05b.
یک رکورد به‌ازای هر (tenant, template_kind) — یکتایی توسط DB constraint تضمین می‌شود.
 */
export const v1InventoryLabelPrintSettingsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/inventory/label-print-settings/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1InventoryLabelPrintSettingsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1InventoryLabelPrintSettingsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1InventoryLabelPrintSettingsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLabelPrintSettingsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsDestroy>>>
    
    export type V1InventoryLabelPrintSettingsDestroyMutationError = unknown

    export const useV1InventoryLabelPrintSettingsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLabelPrintSettingsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1InventoryLabelPrintSettingsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List locations
 */
export const v1InventoryLocationsList = (
    params?: V1InventoryLocationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedLocationList>(
      {url: `/api/v1/inventory/locations/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryLocationsListQueryKey = (params?: V1InventoryLocationsListParams,) => {
    return [
    `/api/v1/inventory/locations/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryLocationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError = unknown>(params?: V1InventoryLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLocationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLocationsList>>> = ({ signal }) => v1InventoryLocationsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLocationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLocationsList>>>
export type V1InventoryLocationsListQueryError = unknown


export function useV1InventoryLocationsList<TData = Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError = unknown>(
 params: undefined |  V1InventoryLocationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLocationsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLocationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLocationsList<TData = Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError = unknown>(
 params?: V1InventoryLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLocationsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLocationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLocationsList<TData = Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError = unknown>(
 params?: V1InventoryLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List locations
 */

export function useV1InventoryLocationsList<TData = Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError = unknown>(
 params?: V1InventoryLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLocationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a new location
 */
export const v1InventoryLocationsCreate = (
    location: NonReadonly<Location>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Location>(
      {url: `/api/v1/inventory/locations/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: location, signal
    },
      );
    }
  


export const getV1InventoryLocationsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsCreate>>, TError,{data: NonReadonly<Location>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsCreate>>, TError,{data: NonReadonly<Location>}, TContext> => {

const mutationKey = ['v1InventoryLocationsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLocationsCreate>>, {data: NonReadonly<Location>}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryLocationsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLocationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLocationsCreate>>>
    export type V1InventoryLocationsCreateMutationBody = NonReadonly<Location>
    export type V1InventoryLocationsCreateMutationError = unknown

    /**
 * @summary Create a new location
 */
export const useV1InventoryLocationsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsCreate>>, TError,{data: NonReadonly<Location>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLocationsCreate>>,
        TError,
        {data: NonReadonly<Location>},
        TContext
      > => {

      const mutationOptions = getV1InventoryLocationsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a location
 */
export const v1InventoryLocationsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Location>(
      {url: `/api/v1/inventory/locations/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryLocationsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/locations/${id}/`
    ] as const;
    }

    
export const getV1InventoryLocationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLocationsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>> = ({ signal }) => v1InventoryLocationsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLocationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>>
export type V1InventoryLocationsRetrieveQueryError = unknown


export function useV1InventoryLocationsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLocationsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLocationsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a location
 */

export function useV1InventoryLocationsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLocationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLocationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1InventoryLocationsUpdate = (
    id: string,
    location: NonReadonly<Location>,
 ) => {
      
      
      return customAxiosInstance<Location>(
      {url: `/api/v1/inventory/locations/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: location
    },
      );
    }
  


export const getV1InventoryLocationsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsUpdate>>, TError,{id: string;data: NonReadonly<Location>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsUpdate>>, TError,{id: string;data: NonReadonly<Location>}, TContext> => {

const mutationKey = ['v1InventoryLocationsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLocationsUpdate>>, {id: string;data: NonReadonly<Location>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryLocationsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLocationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLocationsUpdate>>>
    export type V1InventoryLocationsUpdateMutationBody = NonReadonly<Location>
    export type V1InventoryLocationsUpdateMutationError = unknown

    export const useV1InventoryLocationsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsUpdate>>, TError,{id: string;data: NonReadonly<Location>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLocationsUpdate>>,
        TError,
        {id: string;data: NonReadonly<Location>},
        TContext
      > => {

      const mutationOptions = getV1InventoryLocationsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1InventoryLocationsPartialUpdate = (
    id: string,
    patchedLocation: NonReadonly<PatchedLocation>,
 ) => {
      
      
      return customAxiosInstance<Location>(
      {url: `/api/v1/inventory/locations/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedLocation
    },
      );
    }
  


export const getV1InventoryLocationsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLocation>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLocation>}, TContext> => {

const mutationKey = ['v1InventoryLocationsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLocationsPartialUpdate>>, {id: string;data: NonReadonly<PatchedLocation>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryLocationsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLocationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLocationsPartialUpdate>>>
    export type V1InventoryLocationsPartialUpdateMutationBody = NonReadonly<PatchedLocation>
    export type V1InventoryLocationsPartialUpdateMutationError = unknown

    export const useV1InventoryLocationsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLocation>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLocationsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedLocation>},
        TContext
      > => {

      const mutationOptions = getV1InventoryLocationsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1InventoryLocationsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/inventory/locations/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1InventoryLocationsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1InventoryLocationsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLocationsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1InventoryLocationsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLocationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLocationsDestroy>>>
    
    export type V1InventoryLocationsDestroyMutationError = unknown

    export const useV1InventoryLocationsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLocationsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLocationsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1InventoryLocationsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-075 Rule DU-04: InventoryLot — Trace Entity.
update و delete مجاز نیستند.
adjust: برای override ضریب تبدیل توسط QC.
record-status: برای ثبت ردپایی تغییر وضعیت پالت (AM-056).
 */
export const v1InventoryLotsList = (
    params?: V1InventoryLotsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedInventoryLotList>(
      {url: `/api/v1/inventory/lots/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryLotsListQueryKey = (params?: V1InventoryLotsListParams,) => {
    return [
    `/api/v1/inventory/lots/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryLotsListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLotsList>>, TError = unknown>(params?: V1InventoryLotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLotsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLotsList>>> = ({ signal }) => v1InventoryLotsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLotsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLotsList>>>
export type V1InventoryLotsListQueryError = unknown


export function useV1InventoryLotsList<TData = Awaited<ReturnType<typeof v1InventoryLotsList>>, TError = unknown>(
 params: undefined |  V1InventoryLotsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsList<TData = Awaited<ReturnType<typeof v1InventoryLotsList>>, TError = unknown>(
 params?: V1InventoryLotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsList<TData = Awaited<ReturnType<typeof v1InventoryLotsList>>, TError = unknown>(
 params?: V1InventoryLotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryLotsList<TData = Awaited<ReturnType<typeof v1InventoryLotsList>>, TError = unknown>(
 params?: V1InventoryLotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLotsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-075 Rule DU-04: InventoryLot — Trace Entity.
update و delete مجاز نیستند.
adjust: برای override ضریب تبدیل توسط QC.
record-status: برای ثبت ردپایی تغییر وضعیت پالت (AM-056).
 */
export const v1InventoryLotsCreate = (
    inventoryLot: NonReadonly<InventoryLot>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<InventoryLot>(
      {url: `/api/v1/inventory/lots/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inventoryLot, signal
    },
      );
    }
  


export const getV1InventoryLotsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLotsCreate>>, TError,{data: NonReadonly<InventoryLot>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLotsCreate>>, TError,{data: NonReadonly<InventoryLot>}, TContext> => {

const mutationKey = ['v1InventoryLotsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLotsCreate>>, {data: NonReadonly<InventoryLot>}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryLotsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLotsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLotsCreate>>>
    export type V1InventoryLotsCreateMutationBody = NonReadonly<InventoryLot>
    export type V1InventoryLotsCreateMutationError = unknown

    export const useV1InventoryLotsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLotsCreate>>, TError,{data: NonReadonly<InventoryLot>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLotsCreate>>,
        TError,
        {data: NonReadonly<InventoryLot>},
        TContext
      > => {

      const mutationOptions = getV1InventoryLotsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-104 Rule SN-11 — GET /api/v1/inventory/lots/{id}/affected-units/
سناریوی Recall: همهٔ واحدهایی که مستقیم یا از طریق Genealogy از این
پالت آمده‌اند.
 */
export const v1InventoryLotsAffectedUnitsRetrieve = (
    lotId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/inventory/lots/${lotId}/affected-units/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryLotsAffectedUnitsRetrieveQueryKey = (lotId?: string,) => {
    return [
    `/api/v1/inventory/lots/${lotId}/affected-units/`
    ] as const;
    }

    
export const getV1InventoryLotsAffectedUnitsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError = unknown>(lotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLotsAffectedUnitsRetrieveQueryKey(lotId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>> = ({ signal }) => v1InventoryLotsAffectedUnitsRetrieve(lotId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(lotId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLotsAffectedUnitsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>>
export type V1InventoryLotsAffectedUnitsRetrieveQueryError = unknown


export function useV1InventoryLotsAffectedUnitsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError = unknown>(
 lotId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsAffectedUnitsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError = unknown>(
 lotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsAffectedUnitsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError = unknown>(
 lotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryLotsAffectedUnitsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError = unknown>(
 lotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsAffectedUnitsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLotsAffectedUnitsRetrieveQueryOptions(lotId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-075 Rule DU-04: InventoryLot — Trace Entity.
update و delete مجاز نیستند.
adjust: برای override ضریب تبدیل توسط QC.
record-status: برای ثبت ردپایی تغییر وضعیت پالت (AM-056).
 */
export const v1InventoryLotsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<InventoryLot>(
      {url: `/api/v1/inventory/lots/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryLotsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/lots/${id}/`
    ] as const;
    }

    
export const getV1InventoryLotsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLotsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>> = ({ signal }) => v1InventoryLotsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLotsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>>
export type V1InventoryLotsRetrieveQueryError = unknown


export function useV1InventoryLotsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryLotsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLotsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-075 Rule DU-05: Override ضریب تبدیل Lot.
فقط inventory.manage مجاز است.
 */
export const v1InventoryLotsAdjustConversionCreate = (
    id: string,
    inventoryLot: NonReadonly<InventoryLot>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<InventoryLot>(
      {url: `/api/v1/inventory/lots/${id}/adjust-conversion/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inventoryLot, signal
    },
      );
    }
  


export const getV1InventoryLotsAdjustConversionCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLotsAdjustConversionCreate>>, TError,{id: string;data: NonReadonly<InventoryLot>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLotsAdjustConversionCreate>>, TError,{id: string;data: NonReadonly<InventoryLot>}, TContext> => {

const mutationKey = ['v1InventoryLotsAdjustConversionCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLotsAdjustConversionCreate>>, {id: string;data: NonReadonly<InventoryLot>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryLotsAdjustConversionCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLotsAdjustConversionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLotsAdjustConversionCreate>>>
    export type V1InventoryLotsAdjustConversionCreateMutationBody = NonReadonly<InventoryLot>
    export type V1InventoryLotsAdjustConversionCreateMutationError = unknown

    export const useV1InventoryLotsAdjustConversionCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLotsAdjustConversionCreate>>, TError,{id: string;data: NonReadonly<InventoryLot>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLotsAdjustConversionCreate>>,
        TError,
        {id: string;data: NonReadonly<InventoryLot>},
        TContext
      > => {

      const mutationOptions = getV1InventoryLotsAdjustConversionCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-056: ثبت رکورد تغییر وضعیت پالت (Append-Only).
نیازمند دسترسی inventory.manage.
 */
export const v1InventoryLotsRecordStatusCreate = (
    id: string,
    inventoryLot: NonReadonly<InventoryLot>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<InventoryLot>(
      {url: `/api/v1/inventory/lots/${id}/record-status/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inventoryLot, signal
    },
      );
    }
  


export const getV1InventoryLotsRecordStatusCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLotsRecordStatusCreate>>, TError,{id: string;data: NonReadonly<InventoryLot>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLotsRecordStatusCreate>>, TError,{id: string;data: NonReadonly<InventoryLot>}, TContext> => {

const mutationKey = ['v1InventoryLotsRecordStatusCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryLotsRecordStatusCreate>>, {id: string;data: NonReadonly<InventoryLot>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryLotsRecordStatusCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryLotsRecordStatusCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLotsRecordStatusCreate>>>
    export type V1InventoryLotsRecordStatusCreateMutationBody = NonReadonly<InventoryLot>
    export type V1InventoryLotsRecordStatusCreateMutationError = unknown

    export const useV1InventoryLotsRecordStatusCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryLotsRecordStatusCreate>>, TError,{id: string;data: NonReadonly<InventoryLot>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryLotsRecordStatusCreate>>,
        TError,
        {id: string;data: NonReadonly<InventoryLot>},
        TContext
      > => {

      const mutationOptions = getV1InventoryLotsRecordStatusCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-056: مشاهده تاریخچه رکوردهای وضعیت پالت.
نیازمند دسترسی inventory.view.
 */
export const v1InventoryLotsStatusRecordsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<InventoryLot>(
      {url: `/api/v1/inventory/lots/${id}/status-records/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryLotsStatusRecordsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/lots/${id}/status-records/`
    ] as const;
    }

    
export const getV1InventoryLotsStatusRecordsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLotsStatusRecordsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>> = ({ signal }) => v1InventoryLotsStatusRecordsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLotsStatusRecordsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>>
export type V1InventoryLotsStatusRecordsRetrieveQueryError = unknown


export function useV1InventoryLotsStatusRecordsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsStatusRecordsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsStatusRecordsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryLotsStatusRecordsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsStatusRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLotsStatusRecordsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-099 Rule LBL-04 + AM-037: استعلام پالت با شمارهٔ دقیق.
 * @summary Lookup an inventory lot by exact lot number
 */
export const v1InventoryLotsLookupRetrieve = (
    params: V1InventoryLotsLookupRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LotLookupResponse>(
      {url: `/api/v1/inventory/lots/lookup/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryLotsLookupRetrieveQueryKey = (params?: V1InventoryLotsLookupRetrieveParams,) => {
    return [
    `/api/v1/inventory/lots/lookup/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryLotsLookupRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError = unknown>(params: V1InventoryLotsLookupRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLotsLookupRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>> = ({ signal }) => v1InventoryLotsLookupRetrieve(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLotsLookupRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>>
export type V1InventoryLotsLookupRetrieveQueryError = unknown


export function useV1InventoryLotsLookupRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError = unknown>(
 params: V1InventoryLotsLookupRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsLookupRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError = unknown>(
 params: V1InventoryLotsLookupRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsLookupRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError = unknown>(
 params: V1InventoryLotsLookupRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Lookup an inventory lot by exact lot number
 */

export function useV1InventoryLotsLookupRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError = unknown>(
 params: V1InventoryLotsLookupRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsLookupRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLotsLookupRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-099 Rule LBL-04b: استعلام بازهٔ پالت‌ها برای چاپ گروهی.
 * @summary Lookup a contiguous range of lots by material code and Jalali date
 */
export const v1InventoryLotsRangeRetrieve = (
    params: V1InventoryLotsRangeRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/inventory/lots/range/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryLotsRangeRetrieveQueryKey = (params?: V1InventoryLotsRangeRetrieveParams,) => {
    return [
    `/api/v1/inventory/lots/range/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryLotsRangeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError = unknown>(params: V1InventoryLotsRangeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryLotsRangeRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>> = ({ signal }) => v1InventoryLotsRangeRetrieve(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryLotsRangeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>>
export type V1InventoryLotsRangeRetrieveQueryError = unknown


export function useV1InventoryLotsRangeRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError = unknown>(
 params: V1InventoryLotsRangeRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsRangeRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError = unknown>(
 params: V1InventoryLotsRangeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryLotsRangeRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError = unknown>(
 params: V1InventoryLotsRangeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Lookup a contiguous range of lots by material code and Jalali date
 */

export function useV1InventoryLotsRangeRetrieve<TData = Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError = unknown>(
 params: V1InventoryLotsRangeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryLotsRangeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryLotsRangeRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary List material revisions
 */
export const v1InventoryMaterialRevisionsList = (
    params?: V1InventoryMaterialRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedMaterialRevisionList>(
      {url: `/api/v1/inventory/material-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryMaterialRevisionsListQueryKey = (params?: V1InventoryMaterialRevisionsListParams,) => {
    return [
    `/api/v1/inventory/material-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryMaterialRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError = unknown>(params?: V1InventoryMaterialRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryMaterialRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>> = ({ signal }) => v1InventoryMaterialRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryMaterialRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>>
export type V1InventoryMaterialRevisionsListQueryError = unknown


export function useV1InventoryMaterialRevisionsList<TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError = unknown>(
 params: undefined |  V1InventoryMaterialRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialRevisionsList<TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError = unknown>(
 params?: V1InventoryMaterialRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialRevisionsList<TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError = unknown>(
 params?: V1InventoryMaterialRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List material revisions
 */

export function useV1InventoryMaterialRevisionsList<TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError = unknown>(
 params?: V1InventoryMaterialRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryMaterialRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Create a new draft revision
 */
export const v1InventoryMaterialRevisionsCreate = (
    materialRevision: NonReadonly<MaterialRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialRevision>(
      {url: `/api/v1/inventory/material-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: materialRevision, signal
    },
      );
    }
  


export const getV1InventoryMaterialRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsCreate>>, TError,{data: NonReadonly<MaterialRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsCreate>>, TError,{data: NonReadonly<MaterialRevision>}, TContext> => {

const mutationKey = ['v1InventoryMaterialRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsCreate>>, {data: NonReadonly<MaterialRevision>}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryMaterialRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsCreate>>>
    export type V1InventoryMaterialRevisionsCreateMutationBody = NonReadonly<MaterialRevision>
    export type V1InventoryMaterialRevisionsCreateMutationError = unknown

    /**
 * @summary Create a new draft revision
 */
export const useV1InventoryMaterialRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsCreate>>, TError,{data: NonReadonly<MaterialRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialRevisionsCreate>>,
        TError,
        {data: NonReadonly<MaterialRevision>},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Retrieve a material revision
 */
export const v1InventoryMaterialRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialRevision>(
      {url: `/api/v1/inventory/material-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryMaterialRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/material-revisions/${id}/`
    ] as const;
    }

    
export const getV1InventoryMaterialRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryMaterialRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>> = ({ signal }) => v1InventoryMaterialRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryMaterialRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>>
export type V1InventoryMaterialRevisionsRetrieveQueryError = unknown


export function useV1InventoryMaterialRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a material revision
 */

export function useV1InventoryMaterialRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryMaterialRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1InventoryMaterialRevisionsUpdate = (
    id: string,
    materialRevision: NonReadonly<MaterialRevision>,
 ) => {
      
      
      return customAxiosInstance<MaterialRevision>(
      {url: `/api/v1/inventory/material-revisions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: materialRevision
    },
      );
    }
  


export const getV1InventoryMaterialRevisionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsUpdate>>, TError,{id: string;data: NonReadonly<MaterialRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsUpdate>>, TError,{id: string;data: NonReadonly<MaterialRevision>}, TContext> => {

const mutationKey = ['v1InventoryMaterialRevisionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsUpdate>>, {id: string;data: NonReadonly<MaterialRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryMaterialRevisionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialRevisionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsUpdate>>>
    export type V1InventoryMaterialRevisionsUpdateMutationBody = NonReadonly<MaterialRevision>
    export type V1InventoryMaterialRevisionsUpdateMutationError = unknown

    export const useV1InventoryMaterialRevisionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsUpdate>>, TError,{id: string;data: NonReadonly<MaterialRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialRevisionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<MaterialRevision>},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialRevisionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1InventoryMaterialRevisionsPartialUpdate = (
    id: string,
    patchedMaterialRevision: NonReadonly<PatchedMaterialRevision>,
 ) => {
      
      
      return customAxiosInstance<MaterialRevision>(
      {url: `/api/v1/inventory/material-revisions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMaterialRevision
    },
      );
    }
  


export const getV1InventoryMaterialRevisionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMaterialRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMaterialRevision>}, TContext> => {

const mutationKey = ['v1InventoryMaterialRevisionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedMaterialRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryMaterialRevisionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPartialUpdate>>>
    export type V1InventoryMaterialRevisionsPartialUpdateMutationBody = NonReadonly<PatchedMaterialRevision>
    export type V1InventoryMaterialRevisionsPartialUpdateMutationError = unknown

    export const useV1InventoryMaterialRevisionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMaterialRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedMaterialRevision>},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialRevisionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1InventoryMaterialRevisionsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/inventory/material-revisions/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1InventoryMaterialRevisionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1InventoryMaterialRevisionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1InventoryMaterialRevisionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialRevisionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsDestroy>>>
    
    export type V1InventoryMaterialRevisionsDestroyMutationError = unknown

    export const useV1InventoryMaterialRevisionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialRevisionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialRevisionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Publish a material revision (immutable afterward)
 */
export const v1InventoryMaterialRevisionsPublishCreate = (
    id: string,
    materialRevision: NonReadonly<MaterialRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialRevision>(
      {url: `/api/v1/inventory/material-revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: materialRevision, signal
    },
      );
    }
  


export const getV1InventoryMaterialRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<MaterialRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<MaterialRevision>}, TContext> => {

const mutationKey = ['v1InventoryMaterialRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPublishCreate>>, {id: string;data: NonReadonly<MaterialRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryMaterialRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPublishCreate>>>
    export type V1InventoryMaterialRevisionsPublishCreateMutationBody = NonReadonly<MaterialRevision>
    export type V1InventoryMaterialRevisionsPublishCreateMutationError = unknown

    /**
 * @summary Publish a material revision (immutable afterward)
 */
export const useV1InventoryMaterialRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<MaterialRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<MaterialRevision>},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List materials for active tenant
 */
export const v1InventoryMaterialsList = (
    params?: V1InventoryMaterialsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedMaterialFamilyList>(
      {url: `/api/v1/inventory/materials/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryMaterialsListQueryKey = (params?: V1InventoryMaterialsListParams,) => {
    return [
    `/api/v1/inventory/materials/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryMaterialsListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError = unknown>(params?: V1InventoryMaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryMaterialsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryMaterialsList>>> = ({ signal }) => v1InventoryMaterialsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryMaterialsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsList>>>
export type V1InventoryMaterialsListQueryError = unknown


export function useV1InventoryMaterialsList<TData = Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError = unknown>(
 params: undefined |  V1InventoryMaterialsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialsList<TData = Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError = unknown>(
 params?: V1InventoryMaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialsList<TData = Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError = unknown>(
 params?: V1InventoryMaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List materials for active tenant
 */

export function useV1InventoryMaterialsList<TData = Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError = unknown>(
 params?: V1InventoryMaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryMaterialsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a new material family
 */
export const v1InventoryMaterialsCreate = (
    materialFamily: NonReadonly<MaterialFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialFamily>(
      {url: `/api/v1/inventory/materials/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: materialFamily, signal
    },
      );
    }
  


export const getV1InventoryMaterialsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsCreate>>, TError,{data: NonReadonly<MaterialFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsCreate>>, TError,{data: NonReadonly<MaterialFamily>}, TContext> => {

const mutationKey = ['v1InventoryMaterialsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialsCreate>>, {data: NonReadonly<MaterialFamily>}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryMaterialsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsCreate>>>
    export type V1InventoryMaterialsCreateMutationBody = NonReadonly<MaterialFamily>
    export type V1InventoryMaterialsCreateMutationError = unknown

    /**
 * @summary Create a new material family
 */
export const useV1InventoryMaterialsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsCreate>>, TError,{data: NonReadonly<MaterialFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialsCreate>>,
        TError,
        {data: NonReadonly<MaterialFamily>},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a material by ID
 */
export const v1InventoryMaterialsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialFamily>(
      {url: `/api/v1/inventory/materials/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryMaterialsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/materials/${id}/`
    ] as const;
    }

    
export const getV1InventoryMaterialsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryMaterialsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>> = ({ signal }) => v1InventoryMaterialsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryMaterialsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>>
export type V1InventoryMaterialsRetrieveQueryError = unknown


export function useV1InventoryMaterialsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a material by ID
 */

export function useV1InventoryMaterialsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryMaterialsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1InventoryMaterialsUpdate = (
    id: string,
    materialFamily: NonReadonly<MaterialFamily>,
 ) => {
      
      
      return customAxiosInstance<MaterialFamily>(
      {url: `/api/v1/inventory/materials/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: materialFamily
    },
      );
    }
  


export const getV1InventoryMaterialsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsUpdate>>, TError,{id: string;data: NonReadonly<MaterialFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsUpdate>>, TError,{id: string;data: NonReadonly<MaterialFamily>}, TContext> => {

const mutationKey = ['v1InventoryMaterialsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialsUpdate>>, {id: string;data: NonReadonly<MaterialFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryMaterialsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsUpdate>>>
    export type V1InventoryMaterialsUpdateMutationBody = NonReadonly<MaterialFamily>
    export type V1InventoryMaterialsUpdateMutationError = unknown

    export const useV1InventoryMaterialsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsUpdate>>, TError,{id: string;data: NonReadonly<MaterialFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialsUpdate>>,
        TError,
        {id: string;data: NonReadonly<MaterialFamily>},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1InventoryMaterialsPartialUpdate = (
    id: string,
    patchedMaterialFamily: NonReadonly<PatchedMaterialFamily>,
 ) => {
      
      
      return customAxiosInstance<MaterialFamily>(
      {url: `/api/v1/inventory/materials/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMaterialFamily
    },
      );
    }
  


export const getV1InventoryMaterialsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMaterialFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMaterialFamily>}, TContext> => {

const mutationKey = ['v1InventoryMaterialsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialsPartialUpdate>>, {id: string;data: NonReadonly<PatchedMaterialFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryMaterialsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsPartialUpdate>>>
    export type V1InventoryMaterialsPartialUpdateMutationBody = NonReadonly<PatchedMaterialFamily>
    export type V1InventoryMaterialsPartialUpdateMutationError = unknown

    export const useV1InventoryMaterialsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMaterialFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedMaterialFamily>},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Activate a material family
 */
export const v1InventoryMaterialsActivateCreate = (
    id: string,
    materialFamily: NonReadonly<MaterialFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialFamily>(
      {url: `/api/v1/inventory/materials/${id}/activate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: materialFamily, signal
    },
      );
    }
  


export const getV1InventoryMaterialsActivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsActivateCreate>>, TError,{id: string;data: NonReadonly<MaterialFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsActivateCreate>>, TError,{id: string;data: NonReadonly<MaterialFamily>}, TContext> => {

const mutationKey = ['v1InventoryMaterialsActivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialsActivateCreate>>, {id: string;data: NonReadonly<MaterialFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryMaterialsActivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialsActivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsActivateCreate>>>
    export type V1InventoryMaterialsActivateCreateMutationBody = NonReadonly<MaterialFamily>
    export type V1InventoryMaterialsActivateCreateMutationError = unknown

    /**
 * @summary Activate a material family
 */
export const useV1InventoryMaterialsActivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsActivateCreate>>, TError,{id: string;data: NonReadonly<MaterialFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialsActivateCreate>>,
        TError,
        {id: string;data: NonReadonly<MaterialFamily>},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialsActivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Deactivate a material family
 */
export const v1InventoryMaterialsDeactivateCreate = (
    id: string,
    materialFamily: NonReadonly<MaterialFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialFamily>(
      {url: `/api/v1/inventory/materials/${id}/deactivate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: materialFamily, signal
    },
      );
    }
  


export const getV1InventoryMaterialsDeactivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsDeactivateCreate>>, TError,{id: string;data: NonReadonly<MaterialFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsDeactivateCreate>>, TError,{id: string;data: NonReadonly<MaterialFamily>}, TContext> => {

const mutationKey = ['v1InventoryMaterialsDeactivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialsDeactivateCreate>>, {id: string;data: NonReadonly<MaterialFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryMaterialsDeactivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialsDeactivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsDeactivateCreate>>>
    export type V1InventoryMaterialsDeactivateCreateMutationBody = NonReadonly<MaterialFamily>
    export type V1InventoryMaterialsDeactivateCreateMutationError = unknown

    /**
 * @summary Deactivate a material family
 */
export const useV1InventoryMaterialsDeactivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsDeactivateCreate>>, TError,{id: string;data: NonReadonly<MaterialFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialsDeactivateCreate>>,
        TError,
        {id: string;data: NonReadonly<MaterialFamily>},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialsDeactivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary دریافت وضعیت و گزارش یک بچ پردازشی
 */
export const v1InventoryMaterialsImportBatchesRetrieve = (
    batchId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<V1InventoryMaterialsImportBatchesRetrieve200>(
      {url: `/api/v1/inventory/materials/import/batches/${batchId}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryMaterialsImportBatchesRetrieveQueryKey = (batchId?: string,) => {
    return [
    `/api/v1/inventory/materials/import/batches/${batchId}/`
    ] as const;
    }

    
export const getV1InventoryMaterialsImportBatchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError = unknown>(batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryMaterialsImportBatchesRetrieveQueryKey(batchId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>> = ({ signal }) => v1InventoryMaterialsImportBatchesRetrieve(batchId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(batchId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryMaterialsImportBatchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>>
export type V1InventoryMaterialsImportBatchesRetrieveQueryError = unknown


export function useV1InventoryMaterialsImportBatchesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError = unknown>(
 batchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialsImportBatchesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError = unknown>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialsImportBatchesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError = unknown>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary دریافت وضعیت و گزارش یک بچ پردازشی
 */

export function useV1InventoryMaterialsImportBatchesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError = unknown>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportBatchesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryMaterialsImportBatchesRetrieveQueryOptions(batchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary ثبت نهایی ردیفهای معتبر در دیتابیس
 */
export const v1InventoryMaterialsImportCommitCreate = (
    v1InventoryMaterialsImportCommitCreateBody: V1InventoryMaterialsImportCommitCreateBodyOne | V1InventoryMaterialsImportCommitCreateBodyTwo | V1InventoryMaterialsImportCommitCreateBodyThree,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<V1InventoryMaterialsImportCommitCreate200 | V1InventoryMaterialsImportCommitCreate202>(
      {url: `/api/v1/inventory/materials/import/commit/`, method: 'POST',
      data: v1InventoryMaterialsImportCommitCreateBody, signal
    },
      );
    }
  


export const getV1InventoryMaterialsImportCommitCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportCommitCreate>>, TError,{data: V1InventoryMaterialsImportCommitCreateBodyOne | V1InventoryMaterialsImportCommitCreateBodyTwo | V1InventoryMaterialsImportCommitCreateBodyThree}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportCommitCreate>>, TError,{data: V1InventoryMaterialsImportCommitCreateBodyOne | V1InventoryMaterialsImportCommitCreateBodyTwo | V1InventoryMaterialsImportCommitCreateBodyThree}, TContext> => {

const mutationKey = ['v1InventoryMaterialsImportCommitCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialsImportCommitCreate>>, {data: V1InventoryMaterialsImportCommitCreateBodyOne | V1InventoryMaterialsImportCommitCreateBodyTwo | V1InventoryMaterialsImportCommitCreateBodyThree}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryMaterialsImportCommitCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialsImportCommitCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsImportCommitCreate>>>
    export type V1InventoryMaterialsImportCommitCreateMutationBody = V1InventoryMaterialsImportCommitCreateBodyOne | V1InventoryMaterialsImportCommitCreateBodyTwo | V1InventoryMaterialsImportCommitCreateBodyThree
    export type V1InventoryMaterialsImportCommitCreateMutationError = unknown

    /**
 * @summary ثبت نهایی ردیفهای معتبر در دیتابیس
 */
export const useV1InventoryMaterialsImportCommitCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportCommitCreate>>, TError,{data: V1InventoryMaterialsImportCommitCreateBodyOne | V1InventoryMaterialsImportCommitCreateBodyTwo | V1InventoryMaterialsImportCommitCreateBodyThree}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialsImportCommitCreate>>,
        TError,
        {data: V1InventoryMaterialsImportCommitCreateBodyOne | V1InventoryMaterialsImportCommitCreateBodyTwo | V1InventoryMaterialsImportCommitCreateBodyThree},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialsImportCommitCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary آپلود فایل و تشخیص هدرهای موجود + فیلدهای موردنیاز پلتفرم
 */
export const v1InventoryMaterialsImportDetectHeadersCreate = (
    v1InventoryMaterialsImportDetectHeadersCreateBody: V1InventoryMaterialsImportDetectHeadersCreateBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(v1InventoryMaterialsImportDetectHeadersCreateBody.file !== undefined) {
 formData.append(`file`, v1InventoryMaterialsImportDetectHeadersCreateBody.file)
 }

      return customAxiosInstance<V1InventoryMaterialsImportDetectHeadersCreate200>(
      {url: `/api/v1/inventory/materials/import/detect-headers/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getV1InventoryMaterialsImportDetectHeadersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportDetectHeadersCreate>>, TError,{data: V1InventoryMaterialsImportDetectHeadersCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportDetectHeadersCreate>>, TError,{data: V1InventoryMaterialsImportDetectHeadersCreateBody}, TContext> => {

const mutationKey = ['v1InventoryMaterialsImportDetectHeadersCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialsImportDetectHeadersCreate>>, {data: V1InventoryMaterialsImportDetectHeadersCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryMaterialsImportDetectHeadersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialsImportDetectHeadersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsImportDetectHeadersCreate>>>
    export type V1InventoryMaterialsImportDetectHeadersCreateMutationBody = V1InventoryMaterialsImportDetectHeadersCreateBody
    export type V1InventoryMaterialsImportDetectHeadersCreateMutationError = unknown

    /**
 * @summary آپلود فایل و تشخیص هدرهای موجود + فیلدهای موردنیاز پلتفرم
 */
export const useV1InventoryMaterialsImportDetectHeadersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportDetectHeadersCreate>>, TError,{data: V1InventoryMaterialsImportDetectHeadersCreateBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialsImportDetectHeadersCreate>>,
        TError,
        {data: V1InventoryMaterialsImportDetectHeadersCreateBody},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialsImportDetectHeadersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary دانلود فایل نمونهی Import
 */
export const v1InventoryMaterialsImportTemplateRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Blob>(
      {url: `/api/v1/inventory/materials/import/template/`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  



export const getV1InventoryMaterialsImportTemplateRetrieveQueryKey = () => {
    return [
    `/api/v1/inventory/materials/import/template/`
    ] as const;
    }

    
export const getV1InventoryMaterialsImportTemplateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryMaterialsImportTemplateRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>> = ({ signal }) => v1InventoryMaterialsImportTemplateRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryMaterialsImportTemplateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>>
export type V1InventoryMaterialsImportTemplateRetrieveQueryError = unknown


export function useV1InventoryMaterialsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryMaterialsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary دانلود فایل نمونهی Import
 */

export function useV1InventoryMaterialsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportTemplateRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryMaterialsImportTemplateRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary اعتبارسنجی فایل آپلود شده با نگاشت ستونها
 */
export const v1InventoryMaterialsImportValidateCreate = (
    v1InventoryMaterialsImportValidateCreateBody: V1InventoryMaterialsImportValidateCreateBodyOne | V1InventoryMaterialsImportValidateCreateBodyTwo | V1InventoryMaterialsImportValidateCreateBodyThree,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<V1InventoryMaterialsImportValidateCreate200 | V1InventoryMaterialsImportValidateCreate202>(
      {url: `/api/v1/inventory/materials/import/validate/`, method: 'POST',
      data: v1InventoryMaterialsImportValidateCreateBody, signal
    },
      );
    }
  


export const getV1InventoryMaterialsImportValidateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportValidateCreate>>, TError,{data: V1InventoryMaterialsImportValidateCreateBodyOne | V1InventoryMaterialsImportValidateCreateBodyTwo | V1InventoryMaterialsImportValidateCreateBodyThree}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportValidateCreate>>, TError,{data: V1InventoryMaterialsImportValidateCreateBodyOne | V1InventoryMaterialsImportValidateCreateBodyTwo | V1InventoryMaterialsImportValidateCreateBodyThree}, TContext> => {

const mutationKey = ['v1InventoryMaterialsImportValidateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryMaterialsImportValidateCreate>>, {data: V1InventoryMaterialsImportValidateCreateBodyOne | V1InventoryMaterialsImportValidateCreateBodyTwo | V1InventoryMaterialsImportValidateCreateBodyThree}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryMaterialsImportValidateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryMaterialsImportValidateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryMaterialsImportValidateCreate>>>
    export type V1InventoryMaterialsImportValidateCreateMutationBody = V1InventoryMaterialsImportValidateCreateBodyOne | V1InventoryMaterialsImportValidateCreateBodyTwo | V1InventoryMaterialsImportValidateCreateBodyThree
    export type V1InventoryMaterialsImportValidateCreateMutationError = unknown

    /**
 * @summary اعتبارسنجی فایل آپلود شده با نگاشت ستونها
 */
export const useV1InventoryMaterialsImportValidateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryMaterialsImportValidateCreate>>, TError,{data: V1InventoryMaterialsImportValidateCreateBodyOne | V1InventoryMaterialsImportValidateCreateBodyTwo | V1InventoryMaterialsImportValidateCreateBodyThree}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryMaterialsImportValidateCreate>>,
        TError,
        {data: V1InventoryMaterialsImportValidateCreateBodyOne | V1InventoryMaterialsImportValidateCreateBodyTwo | V1InventoryMaterialsImportValidateCreateBodyThree},
        TContext
      > => {

      const mutationOptions = getV1InventoryMaterialsImportValidateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-044: فقط خواندنی به‌جز اکشن allocate — این رکوردها را خودِ
StockService.post_issue/post_transfer می‌سازد، نه این ViewSet.
 */
export const v1InventoryPendingLotAllocationsList = (
    params?: V1InventoryPendingLotAllocationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedPendingLotAllocationList>(
      {url: `/api/v1/inventory/pending-lot-allocations/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryPendingLotAllocationsListQueryKey = (params?: V1InventoryPendingLotAllocationsListParams,) => {
    return [
    `/api/v1/inventory/pending-lot-allocations/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryPendingLotAllocationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError = unknown>(params?: V1InventoryPendingLotAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryPendingLotAllocationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>> = ({ signal }) => v1InventoryPendingLotAllocationsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryPendingLotAllocationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>>
export type V1InventoryPendingLotAllocationsListQueryError = unknown


export function useV1InventoryPendingLotAllocationsList<TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError = unknown>(
 params: undefined |  V1InventoryPendingLotAllocationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryPendingLotAllocationsList<TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError = unknown>(
 params?: V1InventoryPendingLotAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryPendingLotAllocationsList<TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError = unknown>(
 params?: V1InventoryPendingLotAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryPendingLotAllocationsList<TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError = unknown>(
 params?: V1InventoryPendingLotAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryPendingLotAllocationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-044: فقط خواندنی به‌جز اکشن allocate — این رکوردها را خودِ
StockService.post_issue/post_transfer می‌سازد، نه این ViewSet.
 */
export const v1InventoryPendingLotAllocationsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PendingLotAllocation>(
      {url: `/api/v1/inventory/pending-lot-allocations/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryPendingLotAllocationsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/pending-lot-allocations/${id}/`
    ] as const;
    }

    
export const getV1InventoryPendingLotAllocationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryPendingLotAllocationsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>> = ({ signal }) => v1InventoryPendingLotAllocationsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryPendingLotAllocationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>>
export type V1InventoryPendingLotAllocationsRetrieveQueryError = unknown


export function useV1InventoryPendingLotAllocationsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryPendingLotAllocationsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryPendingLotAllocationsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryPendingLotAllocationsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryPendingLotAllocationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Rule PLA-03. فقط inventory.manage — اکشن سفارشی، پس باید در
DEFAULT_ACTION_PERMISSION_SUFFIX (shared/backbone/api/permissions.py)
نگاشت شود، وگرنه طبق تجربهٔ تکراری این پروژه (AM-018/AM-025/AM-017)
بدون مجوز برای هر کاربر احرازهویت‌شده باز می‌ماند. این نگاشت باید
صراحتاً به "manage" اشاره کند، نه "view".
 */
export const v1InventoryPendingLotAllocationsAllocateCreate = (
    id: string,
    pendingLotAllocation: NonReadonly<PendingLotAllocation>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PendingLotAllocation>(
      {url: `/api/v1/inventory/pending-lot-allocations/${id}/allocate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pendingLotAllocation, signal
    },
      );
    }
  


export const getV1InventoryPendingLotAllocationsAllocateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsAllocateCreate>>, TError,{id: string;data: NonReadonly<PendingLotAllocation>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsAllocateCreate>>, TError,{id: string;data: NonReadonly<PendingLotAllocation>}, TContext> => {

const mutationKey = ['v1InventoryPendingLotAllocationsAllocateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsAllocateCreate>>, {id: string;data: NonReadonly<PendingLotAllocation>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryPendingLotAllocationsAllocateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryPendingLotAllocationsAllocateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsAllocateCreate>>>
    export type V1InventoryPendingLotAllocationsAllocateCreateMutationBody = NonReadonly<PendingLotAllocation>
    export type V1InventoryPendingLotAllocationsAllocateCreateMutationError = unknown

    export const useV1InventoryPendingLotAllocationsAllocateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsAllocateCreate>>, TError,{id: string;data: NonReadonly<PendingLotAllocation>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsAllocateCreate>>,
        TError,
        {id: string;data: NonReadonly<PendingLotAllocation>},
        TContext
      > => {

      const mutationOptions = getV1InventoryPendingLotAllocationsAllocateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-044 §2.4 اصلاحیه. باید محدودتر از allocate باشد (فقط مدیر
انبار) — طبق یادداشت services_am044.py، تصمیم دقیق سطح پرمیشن
هنوز باز است؛ فعلاً همان permission_domain این ViewSet اعمال
می‌شود.
 */
export const v1InventoryPendingLotAllocationsMarkUntraceableCreate = (
    id: string,
    pendingLotAllocation: NonReadonly<PendingLotAllocation>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PendingLotAllocation>(
      {url: `/api/v1/inventory/pending-lot-allocations/${id}/mark-untraceable/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pendingLotAllocation, signal
    },
      );
    }
  


export const getV1InventoryPendingLotAllocationsMarkUntraceableCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsMarkUntraceableCreate>>, TError,{id: string;data: NonReadonly<PendingLotAllocation>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsMarkUntraceableCreate>>, TError,{id: string;data: NonReadonly<PendingLotAllocation>}, TContext> => {

const mutationKey = ['v1InventoryPendingLotAllocationsMarkUntraceableCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsMarkUntraceableCreate>>, {id: string;data: NonReadonly<PendingLotAllocation>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryPendingLotAllocationsMarkUntraceableCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryPendingLotAllocationsMarkUntraceableCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsMarkUntraceableCreate>>>
    export type V1InventoryPendingLotAllocationsMarkUntraceableCreateMutationBody = NonReadonly<PendingLotAllocation>
    export type V1InventoryPendingLotAllocationsMarkUntraceableCreateMutationError = unknown

    export const useV1InventoryPendingLotAllocationsMarkUntraceableCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsMarkUntraceableCreate>>, TError,{id: string;data: NonReadonly<PendingLotAllocation>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryPendingLotAllocationsMarkUntraceableCreate>>,
        TError,
        {id: string;data: NonReadonly<PendingLotAllocation>},
        TContext
      > => {

      const mutationOptions = getV1InventoryPendingLotAllocationsMarkUntraceableCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary دریافت وضعیت و گزارش یک بچ پردازشی
 */
export const v1InventoryStockReceiptsImportBatchesRetrieve = (
    batchId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<V1InventoryStockReceiptsImportBatchesRetrieve200>(
      {url: `/api/v1/inventory/stock-receipts/import/batches/${batchId}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryStockReceiptsImportBatchesRetrieveQueryKey = (batchId?: string,) => {
    return [
    `/api/v1/inventory/stock-receipts/import/batches/${batchId}/`
    ] as const;
    }

    
export const getV1InventoryStockReceiptsImportBatchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError = unknown>(batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryStockReceiptsImportBatchesRetrieveQueryKey(batchId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>> = ({ signal }) => v1InventoryStockReceiptsImportBatchesRetrieve(batchId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(batchId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryStockReceiptsImportBatchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>>
export type V1InventoryStockReceiptsImportBatchesRetrieveQueryError = unknown


export function useV1InventoryStockReceiptsImportBatchesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError = unknown>(
 batchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockReceiptsImportBatchesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError = unknown>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockReceiptsImportBatchesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError = unknown>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary دریافت وضعیت و گزارش یک بچ پردازشی
 */

export function useV1InventoryStockReceiptsImportBatchesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError = unknown>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportBatchesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryStockReceiptsImportBatchesRetrieveQueryOptions(batchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary ثبت نهایی ردیفهای معتبر در دیتابیس
 */
export const v1InventoryStockReceiptsImportCommitCreate = (
    v1InventoryStockReceiptsImportCommitCreateBody: V1InventoryStockReceiptsImportCommitCreateBodyOne | V1InventoryStockReceiptsImportCommitCreateBodyTwo | V1InventoryStockReceiptsImportCommitCreateBodyThree,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<V1InventoryStockReceiptsImportCommitCreate200 | V1InventoryStockReceiptsImportCommitCreate202>(
      {url: `/api/v1/inventory/stock-receipts/import/commit/`, method: 'POST',
      data: v1InventoryStockReceiptsImportCommitCreateBody, signal
    },
      );
    }
  


export const getV1InventoryStockReceiptsImportCommitCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportCommitCreate>>, TError,{data: V1InventoryStockReceiptsImportCommitCreateBodyOne | V1InventoryStockReceiptsImportCommitCreateBodyTwo | V1InventoryStockReceiptsImportCommitCreateBodyThree}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportCommitCreate>>, TError,{data: V1InventoryStockReceiptsImportCommitCreateBodyOne | V1InventoryStockReceiptsImportCommitCreateBodyTwo | V1InventoryStockReceiptsImportCommitCreateBodyThree}, TContext> => {

const mutationKey = ['v1InventoryStockReceiptsImportCommitCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportCommitCreate>>, {data: V1InventoryStockReceiptsImportCommitCreateBodyOne | V1InventoryStockReceiptsImportCommitCreateBodyTwo | V1InventoryStockReceiptsImportCommitCreateBodyThree}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryStockReceiptsImportCommitCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryStockReceiptsImportCommitCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportCommitCreate>>>
    export type V1InventoryStockReceiptsImportCommitCreateMutationBody = V1InventoryStockReceiptsImportCommitCreateBodyOne | V1InventoryStockReceiptsImportCommitCreateBodyTwo | V1InventoryStockReceiptsImportCommitCreateBodyThree
    export type V1InventoryStockReceiptsImportCommitCreateMutationError = unknown

    /**
 * @summary ثبت نهایی ردیفهای معتبر در دیتابیس
 */
export const useV1InventoryStockReceiptsImportCommitCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportCommitCreate>>, TError,{data: V1InventoryStockReceiptsImportCommitCreateBodyOne | V1InventoryStockReceiptsImportCommitCreateBodyTwo | V1InventoryStockReceiptsImportCommitCreateBodyThree}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryStockReceiptsImportCommitCreate>>,
        TError,
        {data: V1InventoryStockReceiptsImportCommitCreateBodyOne | V1InventoryStockReceiptsImportCommitCreateBodyTwo | V1InventoryStockReceiptsImportCommitCreateBodyThree},
        TContext
      > => {

      const mutationOptions = getV1InventoryStockReceiptsImportCommitCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary آپلود فایل و تشخیص هدرهای موجود + فیلدهای موردنیاز پلتفرم
 */
export const v1InventoryStockReceiptsImportDetectHeadersCreate = (
    v1InventoryStockReceiptsImportDetectHeadersCreateBody: V1InventoryStockReceiptsImportDetectHeadersCreateBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(v1InventoryStockReceiptsImportDetectHeadersCreateBody.file !== undefined) {
 formData.append(`file`, v1InventoryStockReceiptsImportDetectHeadersCreateBody.file)
 }

      return customAxiosInstance<V1InventoryStockReceiptsImportDetectHeadersCreate200>(
      {url: `/api/v1/inventory/stock-receipts/import/detect-headers/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getV1InventoryStockReceiptsImportDetectHeadersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportDetectHeadersCreate>>, TError,{data: V1InventoryStockReceiptsImportDetectHeadersCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportDetectHeadersCreate>>, TError,{data: V1InventoryStockReceiptsImportDetectHeadersCreateBody}, TContext> => {

const mutationKey = ['v1InventoryStockReceiptsImportDetectHeadersCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportDetectHeadersCreate>>, {data: V1InventoryStockReceiptsImportDetectHeadersCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryStockReceiptsImportDetectHeadersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryStockReceiptsImportDetectHeadersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportDetectHeadersCreate>>>
    export type V1InventoryStockReceiptsImportDetectHeadersCreateMutationBody = V1InventoryStockReceiptsImportDetectHeadersCreateBody
    export type V1InventoryStockReceiptsImportDetectHeadersCreateMutationError = unknown

    /**
 * @summary آپلود فایل و تشخیص هدرهای موجود + فیلدهای موردنیاز پلتفرم
 */
export const useV1InventoryStockReceiptsImportDetectHeadersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportDetectHeadersCreate>>, TError,{data: V1InventoryStockReceiptsImportDetectHeadersCreateBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryStockReceiptsImportDetectHeadersCreate>>,
        TError,
        {data: V1InventoryStockReceiptsImportDetectHeadersCreateBody},
        TContext
      > => {

      const mutationOptions = getV1InventoryStockReceiptsImportDetectHeadersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary دانلود فایل نمونهی Import
 */
export const v1InventoryStockReceiptsImportTemplateRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Blob>(
      {url: `/api/v1/inventory/stock-receipts/import/template/`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  



export const getV1InventoryStockReceiptsImportTemplateRetrieveQueryKey = () => {
    return [
    `/api/v1/inventory/stock-receipts/import/template/`
    ] as const;
    }

    
export const getV1InventoryStockReceiptsImportTemplateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryStockReceiptsImportTemplateRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>> = ({ signal }) => v1InventoryStockReceiptsImportTemplateRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryStockReceiptsImportTemplateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>>
export type V1InventoryStockReceiptsImportTemplateRetrieveQueryError = unknown


export function useV1InventoryStockReceiptsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockReceiptsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockReceiptsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary دانلود فایل نمونهی Import
 */

export function useV1InventoryStockReceiptsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportTemplateRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryStockReceiptsImportTemplateRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * هر ViewSet/endpoint دومینی (Material، Stock Receipt، ...) یک subclass
از این چهار View میسازد و فقط ``import_config_class`` را ست میکند.
 * @summary اعتبارسنجی فایل آپلود شده با نگاشت ستونها
 */
export const v1InventoryStockReceiptsImportValidateCreate = (
    v1InventoryStockReceiptsImportValidateCreateBody: V1InventoryStockReceiptsImportValidateCreateBodyOne | V1InventoryStockReceiptsImportValidateCreateBodyTwo | V1InventoryStockReceiptsImportValidateCreateBodyThree,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<V1InventoryStockReceiptsImportValidateCreate200 | V1InventoryStockReceiptsImportValidateCreate202>(
      {url: `/api/v1/inventory/stock-receipts/import/validate/`, method: 'POST',
      data: v1InventoryStockReceiptsImportValidateCreateBody, signal
    },
      );
    }
  


export const getV1InventoryStockReceiptsImportValidateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportValidateCreate>>, TError,{data: V1InventoryStockReceiptsImportValidateCreateBodyOne | V1InventoryStockReceiptsImportValidateCreateBodyTwo | V1InventoryStockReceiptsImportValidateCreateBodyThree}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportValidateCreate>>, TError,{data: V1InventoryStockReceiptsImportValidateCreateBodyOne | V1InventoryStockReceiptsImportValidateCreateBodyTwo | V1InventoryStockReceiptsImportValidateCreateBodyThree}, TContext> => {

const mutationKey = ['v1InventoryStockReceiptsImportValidateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportValidateCreate>>, {data: V1InventoryStockReceiptsImportValidateCreateBodyOne | V1InventoryStockReceiptsImportValidateCreateBodyTwo | V1InventoryStockReceiptsImportValidateCreateBodyThree}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryStockReceiptsImportValidateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryStockReceiptsImportValidateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportValidateCreate>>>
    export type V1InventoryStockReceiptsImportValidateCreateMutationBody = V1InventoryStockReceiptsImportValidateCreateBodyOne | V1InventoryStockReceiptsImportValidateCreateBodyTwo | V1InventoryStockReceiptsImportValidateCreateBodyThree
    export type V1InventoryStockReceiptsImportValidateCreateMutationError = unknown

    /**
 * @summary اعتبارسنجی فایل آپلود شده با نگاشت ستونها
 */
export const useV1InventoryStockReceiptsImportValidateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockReceiptsImportValidateCreate>>, TError,{data: V1InventoryStockReceiptsImportValidateCreateBodyOne | V1InventoryStockReceiptsImportValidateCreateBodyTwo | V1InventoryStockReceiptsImportValidateCreateBodyThree}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryStockReceiptsImportValidateCreate>>,
        TError,
        {data: V1InventoryStockReceiptsImportValidateCreateBodyOne | V1InventoryStockReceiptsImportValidateCreateBodyTwo | V1InventoryStockReceiptsImportValidateCreateBodyThree},
        TContext
      > => {

      const mutationOptions = getV1InventoryStockReceiptsImportValidateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Read + Create only. Update/Delete forbidden by model (ADR-054).
 * @summary List stock transactions (append-only ledger)
 */
export const v1InventoryStockTransactionsList = (
    params?: V1InventoryStockTransactionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedStockTransactionList>(
      {url: `/api/v1/inventory/stock-transactions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryStockTransactionsListQueryKey = (params?: V1InventoryStockTransactionsListParams,) => {
    return [
    `/api/v1/inventory/stock-transactions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryStockTransactionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError = unknown>(params?: V1InventoryStockTransactionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryStockTransactionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>> = ({ signal }) => v1InventoryStockTransactionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryStockTransactionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>>
export type V1InventoryStockTransactionsListQueryError = unknown


export function useV1InventoryStockTransactionsList<TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError = unknown>(
 params: undefined |  V1InventoryStockTransactionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockTransactionsList<TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError = unknown>(
 params?: V1InventoryStockTransactionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockTransactionsList<TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError = unknown>(
 params?: V1InventoryStockTransactionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List stock transactions (append-only ledger)
 */

export function useV1InventoryStockTransactionsList<TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError = unknown>(
 params?: V1InventoryStockTransactionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryStockTransactionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Read + Create only. Update/Delete forbidden by model (ADR-054).
 * @summary Post a receipt, issue or opening-balance transaction
 */
export const v1InventoryStockTransactionsCreate = (
    stockTransaction: NonReadonly<StockTransaction>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StockTransaction>(
      {url: `/api/v1/inventory/stock-transactions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stockTransaction, signal
    },
      );
    }
  


export const getV1InventoryStockTransactionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsCreate>>, TError,{data: NonReadonly<StockTransaction>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsCreate>>, TError,{data: NonReadonly<StockTransaction>}, TContext> => {

const mutationKey = ['v1InventoryStockTransactionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryStockTransactionsCreate>>, {data: NonReadonly<StockTransaction>}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryStockTransactionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryStockTransactionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockTransactionsCreate>>>
    export type V1InventoryStockTransactionsCreateMutationBody = NonReadonly<StockTransaction>
    export type V1InventoryStockTransactionsCreateMutationError = unknown

    /**
 * @summary Post a receipt, issue or opening-balance transaction
 */
export const useV1InventoryStockTransactionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsCreate>>, TError,{data: NonReadonly<StockTransaction>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryStockTransactionsCreate>>,
        TError,
        {data: NonReadonly<StockTransaction>},
        TContext
      > => {

      const mutationOptions = getV1InventoryStockTransactionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Read + Create only. Update/Delete forbidden by model (ADR-054).
 * @summary Retrieve a stock transaction
 */
export const v1InventoryStockTransactionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StockTransaction>(
      {url: `/api/v1/inventory/stock-transactions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryStockTransactionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/stock-transactions/${id}/`
    ] as const;
    }

    
export const getV1InventoryStockTransactionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryStockTransactionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>> = ({ signal }) => v1InventoryStockTransactionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryStockTransactionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>>
export type V1InventoryStockTransactionsRetrieveQueryError = unknown


export function useV1InventoryStockTransactionsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockTransactionsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockTransactionsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a stock transaction
 */

export function useV1InventoryStockTransactionsRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryStockTransactionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Read + Create only. Update/Delete forbidden by model (ADR-054).
 * @summary Post a transfer between two warehouses
 */
export const v1InventoryStockTransactionsTransferCreate = (
    stockTransaction: NonReadonly<StockTransaction>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StockTransaction>(
      {url: `/api/v1/inventory/stock-transactions/transfer/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stockTransaction, signal
    },
      );
    }
  


export const getV1InventoryStockTransactionsTransferCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsTransferCreate>>, TError,{data: NonReadonly<StockTransaction>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsTransferCreate>>, TError,{data: NonReadonly<StockTransaction>}, TContext> => {

const mutationKey = ['v1InventoryStockTransactionsTransferCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryStockTransactionsTransferCreate>>, {data: NonReadonly<StockTransaction>}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryStockTransactionsTransferCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryStockTransactionsTransferCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockTransactionsTransferCreate>>>
    export type V1InventoryStockTransactionsTransferCreateMutationBody = NonReadonly<StockTransaction>
    export type V1InventoryStockTransactionsTransferCreateMutationError = unknown

    /**
 * @summary Post a transfer between two warehouses
 */
export const useV1InventoryStockTransactionsTransferCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryStockTransactionsTransferCreate>>, TError,{data: NonReadonly<StockTransaction>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryStockTransactionsTransferCreate>>,
        TError,
        {data: NonReadonly<StockTransaction>},
        TContext
      > => {

      const mutationOptions = getV1InventoryStockTransactionsTransferCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List all on-hand stock balances across all materials and warehouses
 */
export const v1InventoryStockBalancesList = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StockOnHand[]>(
      {url: `/api/v1/inventory/stock/balances/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryStockBalancesListQueryKey = () => {
    return [
    `/api/v1/inventory/stock/balances/`
    ] as const;
    }

    
export const getV1InventoryStockBalancesListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryStockBalancesListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryStockBalancesList>>> = ({ signal }) => v1InventoryStockBalancesList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryStockBalancesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockBalancesList>>>
export type V1InventoryStockBalancesListQueryError = unknown


export function useV1InventoryStockBalancesList<TData = Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockBalancesList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockBalancesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockBalancesList<TData = Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockBalancesList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockBalancesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockBalancesList<TData = Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all on-hand stock balances across all materials and warehouses
 */

export function useV1InventoryStockBalancesList<TData = Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockBalancesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryStockBalancesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Get current on-hand stock balance for a material at a warehouse
 */
export const v1InventoryStockOnHandRetrieve = (
    params: V1InventoryStockOnHandRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/inventory/stock/on-hand/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryStockOnHandRetrieveQueryKey = (params?: V1InventoryStockOnHandRetrieveParams,) => {
    return [
    `/api/v1/inventory/stock/on-hand/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryStockOnHandRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError = unknown>(params: V1InventoryStockOnHandRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryStockOnHandRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>> = ({ signal }) => v1InventoryStockOnHandRetrieve(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryStockOnHandRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>>
export type V1InventoryStockOnHandRetrieveQueryError = unknown


export function useV1InventoryStockOnHandRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError = unknown>(
 params: V1InventoryStockOnHandRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockOnHandRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError = unknown>(
 params: V1InventoryStockOnHandRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryStockOnHandRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError = unknown>(
 params: V1InventoryStockOnHandRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get current on-hand stock balance for a material at a warehouse
 */

export function useV1InventoryStockOnHandRetrieve<TData = Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError = unknown>(
 params: V1InventoryStockOnHandRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryStockOnHandRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryStockOnHandRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-075 Rule DU-01: UOM Master CRUD.
list/retrieve: inventory.view
create/update: inventory.manage
delete: مجاز نیست — is_active=False به جای حذف
 */
export const v1InventoryUomList = (
    params?: V1InventoryUomListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedUnitOfMeasureList>(
      {url: `/api/v1/inventory/uom/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryUomListQueryKey = (params?: V1InventoryUomListParams,) => {
    return [
    `/api/v1/inventory/uom/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryUomListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryUomList>>, TError = unknown>(params?: V1InventoryUomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryUomListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryUomList>>> = ({ signal }) => v1InventoryUomList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryUomListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryUomList>>>
export type V1InventoryUomListQueryError = unknown


export function useV1InventoryUomList<TData = Awaited<ReturnType<typeof v1InventoryUomList>>, TError = unknown>(
 params: undefined |  V1InventoryUomListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryUomList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryUomList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryUomList<TData = Awaited<ReturnType<typeof v1InventoryUomList>>, TError = unknown>(
 params?: V1InventoryUomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryUomList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryUomList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryUomList<TData = Awaited<ReturnType<typeof v1InventoryUomList>>, TError = unknown>(
 params?: V1InventoryUomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryUomList<TData = Awaited<ReturnType<typeof v1InventoryUomList>>, TError = unknown>(
 params?: V1InventoryUomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryUomListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-075 Rule DU-01: UOM Master CRUD.
list/retrieve: inventory.view
create/update: inventory.manage
delete: مجاز نیست — is_active=False به جای حذف
 */
export const v1InventoryUomCreate = (
    unitOfMeasure: NonReadonly<UnitOfMeasure>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<UnitOfMeasure>(
      {url: `/api/v1/inventory/uom/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unitOfMeasure, signal
    },
      );
    }
  


export const getV1InventoryUomCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryUomCreate>>, TError,{data: NonReadonly<UnitOfMeasure>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryUomCreate>>, TError,{data: NonReadonly<UnitOfMeasure>}, TContext> => {

const mutationKey = ['v1InventoryUomCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryUomCreate>>, {data: NonReadonly<UnitOfMeasure>}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryUomCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryUomCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryUomCreate>>>
    export type V1InventoryUomCreateMutationBody = NonReadonly<UnitOfMeasure>
    export type V1InventoryUomCreateMutationError = unknown

    export const useV1InventoryUomCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryUomCreate>>, TError,{data: NonReadonly<UnitOfMeasure>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryUomCreate>>,
        TError,
        {data: NonReadonly<UnitOfMeasure>},
        TContext
      > => {

      const mutationOptions = getV1InventoryUomCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-075 Rule DU-01: UOM Master CRUD.
list/retrieve: inventory.view
create/update: inventory.manage
delete: مجاز نیست — is_active=False به جای حذف
 */
export const v1InventoryUomRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<UnitOfMeasure>(
      {url: `/api/v1/inventory/uom/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryUomRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/uom/${id}/`
    ] as const;
    }

    
export const getV1InventoryUomRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryUomRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryUomRetrieve>>> = ({ signal }) => v1InventoryUomRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryUomRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryUomRetrieve>>>
export type V1InventoryUomRetrieveQueryError = unknown


export function useV1InventoryUomRetrieve<TData = Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryUomRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryUomRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryUomRetrieve<TData = Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryUomRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryUomRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryUomRetrieve<TData = Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1InventoryUomRetrieve<TData = Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryUomRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryUomRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-075 Rule DU-01: UOM Master CRUD.
list/retrieve: inventory.view
create/update: inventory.manage
delete: مجاز نیست — is_active=False به جای حذف
 */
export const v1InventoryUomUpdate = (
    id: string,
    unitOfMeasure: NonReadonly<UnitOfMeasure>,
 ) => {
      
      
      return customAxiosInstance<UnitOfMeasure>(
      {url: `/api/v1/inventory/uom/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: unitOfMeasure
    },
      );
    }
  


export const getV1InventoryUomUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryUomUpdate>>, TError,{id: string;data: NonReadonly<UnitOfMeasure>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryUomUpdate>>, TError,{id: string;data: NonReadonly<UnitOfMeasure>}, TContext> => {

const mutationKey = ['v1InventoryUomUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryUomUpdate>>, {id: string;data: NonReadonly<UnitOfMeasure>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryUomUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryUomUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryUomUpdate>>>
    export type V1InventoryUomUpdateMutationBody = NonReadonly<UnitOfMeasure>
    export type V1InventoryUomUpdateMutationError = unknown

    export const useV1InventoryUomUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryUomUpdate>>, TError,{id: string;data: NonReadonly<UnitOfMeasure>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryUomUpdate>>,
        TError,
        {id: string;data: NonReadonly<UnitOfMeasure>},
        TContext
      > => {

      const mutationOptions = getV1InventoryUomUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-075 Rule DU-01: UOM Master CRUD.
list/retrieve: inventory.view
create/update: inventory.manage
delete: مجاز نیست — is_active=False به جای حذف
 */
export const v1InventoryUomPartialUpdate = (
    id: string,
    patchedUnitOfMeasure: NonReadonly<PatchedUnitOfMeasure>,
 ) => {
      
      
      return customAxiosInstance<UnitOfMeasure>(
      {url: `/api/v1/inventory/uom/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedUnitOfMeasure
    },
      );
    }
  


export const getV1InventoryUomPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryUomPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedUnitOfMeasure>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryUomPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedUnitOfMeasure>}, TContext> => {

const mutationKey = ['v1InventoryUomPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryUomPartialUpdate>>, {id: string;data: NonReadonly<PatchedUnitOfMeasure>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryUomPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryUomPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryUomPartialUpdate>>>
    export type V1InventoryUomPartialUpdateMutationBody = NonReadonly<PatchedUnitOfMeasure>
    export type V1InventoryUomPartialUpdateMutationError = unknown

    export const useV1InventoryUomPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryUomPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedUnitOfMeasure>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryUomPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedUnitOfMeasure>},
        TContext
      > => {

      const mutationOptions = getV1InventoryUomPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List warehouses
 */
export const v1InventoryWarehousesList = (
    params?: V1InventoryWarehousesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWarehouseList>(
      {url: `/api/v1/inventory/warehouses/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1InventoryWarehousesListQueryKey = (params?: V1InventoryWarehousesListParams,) => {
    return [
    `/api/v1/inventory/warehouses/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1InventoryWarehousesListQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError = unknown>(params?: V1InventoryWarehousesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryWarehousesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryWarehousesList>>> = ({ signal }) => v1InventoryWarehousesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryWarehousesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryWarehousesList>>>
export type V1InventoryWarehousesListQueryError = unknown


export function useV1InventoryWarehousesList<TData = Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError = unknown>(
 params: undefined |  V1InventoryWarehousesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryWarehousesList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryWarehousesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryWarehousesList<TData = Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError = unknown>(
 params?: V1InventoryWarehousesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryWarehousesList>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryWarehousesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryWarehousesList<TData = Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError = unknown>(
 params?: V1InventoryWarehousesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List warehouses
 */

export function useV1InventoryWarehousesList<TData = Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError = unknown>(
 params?: V1InventoryWarehousesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryWarehousesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a new warehouse
 */
export const v1InventoryWarehousesCreate = (
    warehouse: NonReadonly<Warehouse>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Warehouse>(
      {url: `/api/v1/inventory/warehouses/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: warehouse, signal
    },
      );
    }
  


export const getV1InventoryWarehousesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesCreate>>, TError,{data: NonReadonly<Warehouse>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesCreate>>, TError,{data: NonReadonly<Warehouse>}, TContext> => {

const mutationKey = ['v1InventoryWarehousesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryWarehousesCreate>>, {data: NonReadonly<Warehouse>}> = (props) => {
          const {data} = props ?? {};

          return  v1InventoryWarehousesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryWarehousesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryWarehousesCreate>>>
    export type V1InventoryWarehousesCreateMutationBody = NonReadonly<Warehouse>
    export type V1InventoryWarehousesCreateMutationError = unknown

    /**
 * @summary Create a new warehouse
 */
export const useV1InventoryWarehousesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesCreate>>, TError,{data: NonReadonly<Warehouse>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryWarehousesCreate>>,
        TError,
        {data: NonReadonly<Warehouse>},
        TContext
      > => {

      const mutationOptions = getV1InventoryWarehousesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a warehouse
 */
export const v1InventoryWarehousesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Warehouse>(
      {url: `/api/v1/inventory/warehouses/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1InventoryWarehousesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inventory/warehouses/${id}/`
    ] as const;
    }

    
export const getV1InventoryWarehousesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1InventoryWarehousesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>> = ({ signal }) => v1InventoryWarehousesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1InventoryWarehousesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>>
export type V1InventoryWarehousesRetrieveQueryError = unknown


export function useV1InventoryWarehousesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryWarehousesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1InventoryWarehousesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a warehouse
 */

export function useV1InventoryWarehousesRetrieve<TData = Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1InventoryWarehousesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1InventoryWarehousesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1InventoryWarehousesUpdate = (
    id: string,
    warehouse: NonReadonly<Warehouse>,
 ) => {
      
      
      return customAxiosInstance<Warehouse>(
      {url: `/api/v1/inventory/warehouses/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: warehouse
    },
      );
    }
  


export const getV1InventoryWarehousesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesUpdate>>, TError,{id: string;data: NonReadonly<Warehouse>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesUpdate>>, TError,{id: string;data: NonReadonly<Warehouse>}, TContext> => {

const mutationKey = ['v1InventoryWarehousesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryWarehousesUpdate>>, {id: string;data: NonReadonly<Warehouse>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryWarehousesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryWarehousesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryWarehousesUpdate>>>
    export type V1InventoryWarehousesUpdateMutationBody = NonReadonly<Warehouse>
    export type V1InventoryWarehousesUpdateMutationError = unknown

    export const useV1InventoryWarehousesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesUpdate>>, TError,{id: string;data: NonReadonly<Warehouse>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryWarehousesUpdate>>,
        TError,
        {id: string;data: NonReadonly<Warehouse>},
        TContext
      > => {

      const mutationOptions = getV1InventoryWarehousesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1InventoryWarehousesPartialUpdate = (
    id: string,
    patchedWarehouse: NonReadonly<PatchedWarehouse>,
 ) => {
      
      
      return customAxiosInstance<Warehouse>(
      {url: `/api/v1/inventory/warehouses/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWarehouse
    },
      );
    }
  


export const getV1InventoryWarehousesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWarehouse>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWarehouse>}, TContext> => {

const mutationKey = ['v1InventoryWarehousesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryWarehousesPartialUpdate>>, {id: string;data: NonReadonly<PatchedWarehouse>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1InventoryWarehousesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryWarehousesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryWarehousesPartialUpdate>>>
    export type V1InventoryWarehousesPartialUpdateMutationBody = NonReadonly<PatchedWarehouse>
    export type V1InventoryWarehousesPartialUpdateMutationError = unknown

    export const useV1InventoryWarehousesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWarehouse>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryWarehousesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedWarehouse>},
        TContext
      > => {

      const mutationOptions = getV1InventoryWarehousesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1InventoryWarehousesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/inventory/warehouses/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1InventoryWarehousesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1InventoryWarehousesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1InventoryWarehousesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1InventoryWarehousesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1InventoryWarehousesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1InventoryWarehousesDestroy>>>
    
    export type V1InventoryWarehousesDestroyMutationError = unknown

    export const useV1InventoryWarehousesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1InventoryWarehousesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1InventoryWarehousesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1InventoryWarehousesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary List catalog families
 */
export const v1MarketplaceCatalogFamiliesList = (
    params?: V1MarketplaceCatalogFamiliesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedCatalogFamilyList>(
      {url: `/api/v1/marketplace/catalog-families/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1MarketplaceCatalogFamiliesListQueryKey = (params?: V1MarketplaceCatalogFamiliesListParams,) => {
    return [
    `/api/v1/marketplace/catalog-families/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1MarketplaceCatalogFamiliesListQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError = unknown>(params?: V1MarketplaceCatalogFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceCatalogFamiliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>> = ({ signal }) => v1MarketplaceCatalogFamiliesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceCatalogFamiliesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>>
export type V1MarketplaceCatalogFamiliesListQueryError = unknown


export function useV1MarketplaceCatalogFamiliesList<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError = unknown>(
 params: undefined |  V1MarketplaceCatalogFamiliesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceCatalogFamiliesList<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError = unknown>(
 params?: V1MarketplaceCatalogFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceCatalogFamiliesList<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError = unknown>(
 params?: V1MarketplaceCatalogFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List catalog families
 */

export function useV1MarketplaceCatalogFamiliesList<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError = unknown>(
 params?: V1MarketplaceCatalogFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceCatalogFamiliesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Create a catalog family (one public product page)
 */
export const v1MarketplaceCatalogFamiliesCreate = (
    catalogFamilyCreate: CatalogFamilyCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CatalogFamilyCreate>(
      {url: `/api/v1/marketplace/catalog-families/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: catalogFamilyCreate, signal
    },
      );
    }
  


export const getV1MarketplaceCatalogFamiliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesCreate>>, TError,{data: CatalogFamilyCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesCreate>>, TError,{data: CatalogFamilyCreate}, TContext> => {

const mutationKey = ['v1MarketplaceCatalogFamiliesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesCreate>>, {data: CatalogFamilyCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1MarketplaceCatalogFamiliesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceCatalogFamiliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesCreate>>>
    export type V1MarketplaceCatalogFamiliesCreateMutationBody = CatalogFamilyCreate
    export type V1MarketplaceCatalogFamiliesCreateMutationError = unknown

    /**
 * @summary Create a catalog family (one public product page)
 */
export const useV1MarketplaceCatalogFamiliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesCreate>>, TError,{data: CatalogFamilyCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesCreate>>,
        TError,
        {data: CatalogFamilyCreate},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceCatalogFamiliesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Retrieve a catalog family
 */
export const v1MarketplaceCatalogFamiliesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CatalogFamily>(
      {url: `/api/v1/marketplace/catalog-families/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1MarketplaceCatalogFamiliesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketplace/catalog-families/${id}/`
    ] as const;
    }

    
export const getV1MarketplaceCatalogFamiliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceCatalogFamiliesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>> = ({ signal }) => v1MarketplaceCatalogFamiliesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceCatalogFamiliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>>
export type V1MarketplaceCatalogFamiliesRetrieveQueryError = unknown


export function useV1MarketplaceCatalogFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceCatalogFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceCatalogFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a catalog family
 */

export function useV1MarketplaceCatalogFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceCatalogFamiliesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary List catalog revisions
 */
export const v1MarketplaceCatalogRevisionsList = (
    params?: V1MarketplaceCatalogRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedCatalogRevisionList>(
      {url: `/api/v1/marketplace/catalog-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1MarketplaceCatalogRevisionsListQueryKey = (params?: V1MarketplaceCatalogRevisionsListParams,) => {
    return [
    `/api/v1/marketplace/catalog-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1MarketplaceCatalogRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError = unknown>(params?: V1MarketplaceCatalogRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceCatalogRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>> = ({ signal }) => v1MarketplaceCatalogRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceCatalogRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>>
export type V1MarketplaceCatalogRevisionsListQueryError = unknown


export function useV1MarketplaceCatalogRevisionsList<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError = unknown>(
 params: undefined |  V1MarketplaceCatalogRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceCatalogRevisionsList<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError = unknown>(
 params?: V1MarketplaceCatalogRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceCatalogRevisionsList<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError = unknown>(
 params?: V1MarketplaceCatalogRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List catalog revisions
 */

export function useV1MarketplaceCatalogRevisionsList<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError = unknown>(
 params?: V1MarketplaceCatalogRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceCatalogRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Create a new draft CatalogRevision
 */
export const v1MarketplaceCatalogRevisionsCreate = (
    catalogRevisionCreate: CatalogRevisionCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CatalogRevisionCreate>(
      {url: `/api/v1/marketplace/catalog-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: catalogRevisionCreate, signal
    },
      );
    }
  


export const getV1MarketplaceCatalogRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsCreate>>, TError,{data: CatalogRevisionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsCreate>>, TError,{data: CatalogRevisionCreate}, TContext> => {

const mutationKey = ['v1MarketplaceCatalogRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsCreate>>, {data: CatalogRevisionCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1MarketplaceCatalogRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceCatalogRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsCreate>>>
    export type V1MarketplaceCatalogRevisionsCreateMutationBody = CatalogRevisionCreate
    export type V1MarketplaceCatalogRevisionsCreateMutationError = unknown

    /**
 * @summary Create a new draft CatalogRevision
 */
export const useV1MarketplaceCatalogRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsCreate>>, TError,{data: CatalogRevisionCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsCreate>>,
        TError,
        {data: CatalogRevisionCreate},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceCatalogRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Retrieve a catalog revision
 */
export const v1MarketplaceCatalogRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CatalogRevision>(
      {url: `/api/v1/marketplace/catalog-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1MarketplaceCatalogRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketplace/catalog-revisions/${id}/`
    ] as const;
    }

    
export const getV1MarketplaceCatalogRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceCatalogRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>> = ({ signal }) => v1MarketplaceCatalogRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceCatalogRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>>
export type V1MarketplaceCatalogRevisionsRetrieveQueryError = unknown


export function useV1MarketplaceCatalogRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceCatalogRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceCatalogRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a catalog revision
 */

export function useV1MarketplaceCatalogRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceCatalogRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Publish a draft CatalogRevision (supersedes the prior published one)
 */
export const v1MarketplaceCatalogRevisionsPublishCreate = (
    id: string,
    catalogRevision: NonReadonly<CatalogRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CatalogRevision>(
      {url: `/api/v1/marketplace/catalog-revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: catalogRevision, signal
    },
      );
    }
  


export const getV1MarketplaceCatalogRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<CatalogRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<CatalogRevision>}, TContext> => {

const mutationKey = ['v1MarketplaceCatalogRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsPublishCreate>>, {id: string;data: NonReadonly<CatalogRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1MarketplaceCatalogRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceCatalogRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsPublishCreate>>>
    export type V1MarketplaceCatalogRevisionsPublishCreateMutationBody = NonReadonly<CatalogRevision>
    export type V1MarketplaceCatalogRevisionsPublishCreateMutationError = unknown

    /**
 * @summary Publish a draft CatalogRevision (supersedes the prior published one)
 */
export const useV1MarketplaceCatalogRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<CatalogRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceCatalogRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<CatalogRevision>},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceCatalogRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rule MIS-05: creating a new price atomically closes out whichever
price on the same Listing currently has valid_until=None, via
ListingPrice.close_out() — never edited/deleted directly.
 * @summary List price history for a listing
 */
export const v1MarketplaceListingPricesList = (
    params?: V1MarketplaceListingPricesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedListingPriceList>(
      {url: `/api/v1/marketplace/listing-prices/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1MarketplaceListingPricesListQueryKey = (params?: V1MarketplaceListingPricesListParams,) => {
    return [
    `/api/v1/marketplace/listing-prices/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1MarketplaceListingPricesListQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError = unknown>(params?: V1MarketplaceListingPricesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceListingPricesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>> = ({ signal }) => v1MarketplaceListingPricesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceListingPricesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>>
export type V1MarketplaceListingPricesListQueryError = unknown


export function useV1MarketplaceListingPricesList<TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError = unknown>(
 params: undefined |  V1MarketplaceListingPricesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceListingPricesList<TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError = unknown>(
 params?: V1MarketplaceListingPricesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceListingPricesList<TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError = unknown>(
 params?: V1MarketplaceListingPricesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List price history for a listing
 */

export function useV1MarketplaceListingPricesList<TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError = unknown>(
 params?: V1MarketplaceListingPricesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceListingPricesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Rule MIS-05: creating a new price atomically closes out whichever
price on the same Listing currently has valid_until=None, via
ListingPrice.close_out() — never edited/deleted directly.
 * @summary Set a new active price (closes out the previous one)
 */
export const v1MarketplaceListingPricesCreate = (
    listingPrice: NonReadonly<ListingPrice>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ListingPrice>(
      {url: `/api/v1/marketplace/listing-prices/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listingPrice, signal
    },
      );
    }
  


export const getV1MarketplaceListingPricesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesCreate>>, TError,{data: NonReadonly<ListingPrice>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesCreate>>, TError,{data: NonReadonly<ListingPrice>}, TContext> => {

const mutationKey = ['v1MarketplaceListingPricesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceListingPricesCreate>>, {data: NonReadonly<ListingPrice>}> = (props) => {
          const {data} = props ?? {};

          return  v1MarketplaceListingPricesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceListingPricesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceListingPricesCreate>>>
    export type V1MarketplaceListingPricesCreateMutationBody = NonReadonly<ListingPrice>
    export type V1MarketplaceListingPricesCreateMutationError = unknown

    /**
 * @summary Set a new active price (closes out the previous one)
 */
export const useV1MarketplaceListingPricesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesCreate>>, TError,{data: NonReadonly<ListingPrice>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceListingPricesCreate>>,
        TError,
        {data: NonReadonly<ListingPrice>},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceListingPricesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rule MIS-05: creating a new price atomically closes out whichever
price on the same Listing currently has valid_until=None, via
ListingPrice.close_out() — never edited/deleted directly.
 */
export const v1MarketplaceListingPricesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ListingPrice>(
      {url: `/api/v1/marketplace/listing-prices/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1MarketplaceListingPricesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketplace/listing-prices/${id}/`
    ] as const;
    }

    
export const getV1MarketplaceListingPricesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceListingPricesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>> = ({ signal }) => v1MarketplaceListingPricesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceListingPricesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>>
export type V1MarketplaceListingPricesRetrieveQueryError = unknown


export function useV1MarketplaceListingPricesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceListingPricesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceListingPricesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1MarketplaceListingPricesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingPricesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceListingPricesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary List marketplace listings for active tenant
 */
export const v1MarketplaceListingsList = (
    params?: V1MarketplaceListingsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedListingList>(
      {url: `/api/v1/marketplace/listings/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1MarketplaceListingsListQueryKey = (params?: V1MarketplaceListingsListParams,) => {
    return [
    `/api/v1/marketplace/listings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1MarketplaceListingsListQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError = unknown>(params?: V1MarketplaceListingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceListingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceListingsList>>> = ({ signal }) => v1MarketplaceListingsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceListingsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceListingsList>>>
export type V1MarketplaceListingsListQueryError = unknown


export function useV1MarketplaceListingsList<TData = Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError = unknown>(
 params: undefined |  V1MarketplaceListingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceListingsList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceListingsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceListingsList<TData = Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError = unknown>(
 params?: V1MarketplaceListingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceListingsList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceListingsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceListingsList<TData = Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError = unknown>(
 params?: V1MarketplaceListingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List marketplace listings for active tenant
 */

export function useV1MarketplaceListingsList<TData = Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError = unknown>(
 params?: V1MarketplaceListingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceListingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Create a listing (a published CatalogRevision pinned to a published StoreRevision)
 */
export const v1MarketplaceListingsCreate = (
    listingCreate: ListingCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ListingCreate>(
      {url: `/api/v1/marketplace/listings/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listingCreate, signal
    },
      );
    }
  


export const getV1MarketplaceListingsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceListingsCreate>>, TError,{data: ListingCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceListingsCreate>>, TError,{data: ListingCreate}, TContext> => {

const mutationKey = ['v1MarketplaceListingsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceListingsCreate>>, {data: ListingCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1MarketplaceListingsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceListingsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceListingsCreate>>>
    export type V1MarketplaceListingsCreateMutationBody = ListingCreate
    export type V1MarketplaceListingsCreateMutationError = unknown

    /**
 * @summary Create a listing (a published CatalogRevision pinned to a published StoreRevision)
 */
export const useV1MarketplaceListingsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceListingsCreate>>, TError,{data: ListingCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceListingsCreate>>,
        TError,
        {data: ListingCreate},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceListingsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Retrieve a listing
 */
export const v1MarketplaceListingsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Listing>(
      {url: `/api/v1/marketplace/listings/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1MarketplaceListingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketplace/listings/${id}/`
    ] as const;
    }

    
export const getV1MarketplaceListingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceListingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>> = ({ signal }) => v1MarketplaceListingsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceListingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>>
export type V1MarketplaceListingsRetrieveQueryError = unknown


export function useV1MarketplaceListingsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceListingsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceListingsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a listing
 */

export function useV1MarketplaceListingsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceListingsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceListingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Deactivate a listing (append-mostly — is_active only)
 */
export const v1MarketplaceListingsDeactivateCreate = (
    id: string,
    listing: NonReadonly<Listing>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Listing>(
      {url: `/api/v1/marketplace/listings/${id}/deactivate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listing, signal
    },
      );
    }
  


export const getV1MarketplaceListingsDeactivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceListingsDeactivateCreate>>, TError,{id: string;data: NonReadonly<Listing>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceListingsDeactivateCreate>>, TError,{id: string;data: NonReadonly<Listing>}, TContext> => {

const mutationKey = ['v1MarketplaceListingsDeactivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceListingsDeactivateCreate>>, {id: string;data: NonReadonly<Listing>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1MarketplaceListingsDeactivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceListingsDeactivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceListingsDeactivateCreate>>>
    export type V1MarketplaceListingsDeactivateCreateMutationBody = NonReadonly<Listing>
    export type V1MarketplaceListingsDeactivateCreateMutationError = unknown

    /**
 * @summary Deactivate a listing (append-mostly — is_active only)
 */
export const useV1MarketplaceListingsDeactivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceListingsDeactivateCreate>>, TError,{id: string;data: NonReadonly<Listing>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceListingsDeactivateCreate>>,
        TError,
        {id: string;data: NonReadonly<Listing>},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceListingsDeactivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-069 Rule MIS-02: all state transitions go through
OrderExchangeService — this ViewSet never calls
OrderExchange.save() directly, only list/retrieve/create plus the
accept/reject actions below.

AM-010 Rule MIS-08: accept/reject are gated by IsPermitted via
DEFAULT_ACTION_PERMISSION_SUFFIX["accept"/"reject"] = "manage" —
prior to this AM they were reachable by any authenticated user.
 * @summary List orders for active tenant
 */
export const v1MarketplaceOrdersList = (
    params?: V1MarketplaceOrdersListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOrderExchangeList>(
      {url: `/api/v1/marketplace/orders/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1MarketplaceOrdersListQueryKey = (params?: V1MarketplaceOrdersListParams,) => {
    return [
    `/api/v1/marketplace/orders/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1MarketplaceOrdersListQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError = unknown>(params?: V1MarketplaceOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceOrdersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceOrdersList>>> = ({ signal }) => v1MarketplaceOrdersList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceOrdersListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceOrdersList>>>
export type V1MarketplaceOrdersListQueryError = unknown


export function useV1MarketplaceOrdersList<TData = Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError = unknown>(
 params: undefined |  V1MarketplaceOrdersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceOrdersList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceOrdersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceOrdersList<TData = Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError = unknown>(
 params?: V1MarketplaceOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceOrdersList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceOrdersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceOrdersList<TData = Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError = unknown>(
 params?: V1MarketplaceOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List orders for active tenant
 */

export function useV1MarketplaceOrdersList<TData = Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError = unknown>(
 params?: V1MarketplaceOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceOrdersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-069 Rule MIS-02: all state transitions go through
OrderExchangeService — this ViewSet never calls
OrderExchange.save() directly, only list/retrieve/create plus the
accept/reject actions below.

AM-010 Rule MIS-08: accept/reject are gated by IsPermitted via
DEFAULT_ACTION_PERMISSION_SUFFIX["accept"/"reject"] = "manage" —
prior to this AM they were reachable by any authenticated user.
 * @summary Create (place) a new order against a listing
 */
export const v1MarketplaceOrdersCreate = (
    orderExchangeCreate: OrderExchangeCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OrderExchangeCreate>(
      {url: `/api/v1/marketplace/orders/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orderExchangeCreate, signal
    },
      );
    }
  


export const getV1MarketplaceOrdersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersCreate>>, TError,{data: OrderExchangeCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersCreate>>, TError,{data: OrderExchangeCreate}, TContext> => {

const mutationKey = ['v1MarketplaceOrdersCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceOrdersCreate>>, {data: OrderExchangeCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1MarketplaceOrdersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceOrdersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceOrdersCreate>>>
    export type V1MarketplaceOrdersCreateMutationBody = OrderExchangeCreate
    export type V1MarketplaceOrdersCreateMutationError = unknown

    /**
 * @summary Create (place) a new order against a listing
 */
export const useV1MarketplaceOrdersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersCreate>>, TError,{data: OrderExchangeCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceOrdersCreate>>,
        TError,
        {data: OrderExchangeCreate},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceOrdersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-069 Rule MIS-02: all state transitions go through
OrderExchangeService — this ViewSet never calls
OrderExchange.save() directly, only list/retrieve/create plus the
accept/reject actions below.

AM-010 Rule MIS-08: accept/reject are gated by IsPermitted via
DEFAULT_ACTION_PERMISSION_SUFFIX["accept"/"reject"] = "manage" —
prior to this AM they were reachable by any authenticated user.
 * @summary Retrieve an order
 */
export const v1MarketplaceOrdersRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OrderExchange>(
      {url: `/api/v1/marketplace/orders/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1MarketplaceOrdersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketplace/orders/${id}/`
    ] as const;
    }

    
export const getV1MarketplaceOrdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceOrdersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>> = ({ signal }) => v1MarketplaceOrdersRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceOrdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>>
export type V1MarketplaceOrdersRetrieveQueryError = unknown


export function useV1MarketplaceOrdersRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceOrdersRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceOrdersRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve an order
 */

export function useV1MarketplaceOrdersRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceOrdersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-069 Rule MIS-02: all state transitions go through
OrderExchangeService — this ViewSet never calls
OrderExchange.save() directly, only list/retrieve/create plus the
accept/reject actions below.

AM-010 Rule MIS-08: accept/reject are gated by IsPermitted via
DEFAULT_ACTION_PERMISSION_SUFFIX["accept"/"reject"] = "manage" —
prior to this AM they were reachable by any authenticated user.
 * @summary Seller accepts the order and declares fulfillment_type
 */
export const v1MarketplaceOrdersAcceptCreate = (
    id: string,
    orderExchange: NonReadonly<OrderExchange>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OrderExchange>(
      {url: `/api/v1/marketplace/orders/${id}/accept/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orderExchange, signal
    },
      );
    }
  


export const getV1MarketplaceOrdersAcceptCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersAcceptCreate>>, TError,{id: string;data: NonReadonly<OrderExchange>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersAcceptCreate>>, TError,{id: string;data: NonReadonly<OrderExchange>}, TContext> => {

const mutationKey = ['v1MarketplaceOrdersAcceptCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceOrdersAcceptCreate>>, {id: string;data: NonReadonly<OrderExchange>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1MarketplaceOrdersAcceptCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceOrdersAcceptCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceOrdersAcceptCreate>>>
    export type V1MarketplaceOrdersAcceptCreateMutationBody = NonReadonly<OrderExchange>
    export type V1MarketplaceOrdersAcceptCreateMutationError = unknown

    /**
 * @summary Seller accepts the order and declares fulfillment_type
 */
export const useV1MarketplaceOrdersAcceptCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersAcceptCreate>>, TError,{id: string;data: NonReadonly<OrderExchange>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceOrdersAcceptCreate>>,
        TError,
        {id: string;data: NonReadonly<OrderExchange>},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceOrdersAcceptCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-069 Rule MIS-02: all state transitions go through
OrderExchangeService — this ViewSet never calls
OrderExchange.save() directly, only list/retrieve/create plus the
accept/reject actions below.

AM-010 Rule MIS-08: accept/reject are gated by IsPermitted via
DEFAULT_ACTION_PERMISSION_SUFFIX["accept"/"reject"] = "manage" —
prior to this AM they were reachable by any authenticated user.
 * @summary Seller rejects the order
 */
export const v1MarketplaceOrdersRejectCreate = (
    id: string,
    orderExchange: NonReadonly<OrderExchange>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OrderExchange>(
      {url: `/api/v1/marketplace/orders/${id}/reject/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orderExchange, signal
    },
      );
    }
  


export const getV1MarketplaceOrdersRejectCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersRejectCreate>>, TError,{id: string;data: NonReadonly<OrderExchange>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersRejectCreate>>, TError,{id: string;data: NonReadonly<OrderExchange>}, TContext> => {

const mutationKey = ['v1MarketplaceOrdersRejectCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceOrdersRejectCreate>>, {id: string;data: NonReadonly<OrderExchange>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1MarketplaceOrdersRejectCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceOrdersRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceOrdersRejectCreate>>>
    export type V1MarketplaceOrdersRejectCreateMutationBody = NonReadonly<OrderExchange>
    export type V1MarketplaceOrdersRejectCreateMutationError = unknown

    /**
 * @summary Seller rejects the order
 */
export const useV1MarketplaceOrdersRejectCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceOrdersRejectCreate>>, TError,{id: string;data: NonReadonly<OrderExchange>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceOrdersRejectCreate>>,
        TError,
        {id: string;data: NonReadonly<OrderExchange>},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceOrdersRejectCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary List store settings families
 */
export const v1MarketplaceStoreFamiliesList = (
    params?: V1MarketplaceStoreFamiliesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedStoreFamilyList>(
      {url: `/api/v1/marketplace/store-families/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1MarketplaceStoreFamiliesListQueryKey = (params?: V1MarketplaceStoreFamiliesListParams,) => {
    return [
    `/api/v1/marketplace/store-families/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1MarketplaceStoreFamiliesListQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError = unknown>(params?: V1MarketplaceStoreFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceStoreFamiliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>> = ({ signal }) => v1MarketplaceStoreFamiliesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceStoreFamiliesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>>
export type V1MarketplaceStoreFamiliesListQueryError = unknown


export function useV1MarketplaceStoreFamiliesList<TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError = unknown>(
 params: undefined |  V1MarketplaceStoreFamiliesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoreFamiliesList<TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError = unknown>(
 params?: V1MarketplaceStoreFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoreFamiliesList<TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError = unknown>(
 params?: V1MarketplaceStoreFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List store settings families
 */

export function useV1MarketplaceStoreFamiliesList<TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError = unknown>(
 params?: V1MarketplaceStoreFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceStoreFamiliesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Create the settings timeline for a Store (1:1)
 */
export const v1MarketplaceStoreFamiliesCreate = (
    storeFamilyCreate: StoreFamilyCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StoreFamilyCreate>(
      {url: `/api/v1/marketplace/store-families/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: storeFamilyCreate, signal
    },
      );
    }
  


export const getV1MarketplaceStoreFamiliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesCreate>>, TError,{data: StoreFamilyCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesCreate>>, TError,{data: StoreFamilyCreate}, TContext> => {

const mutationKey = ['v1MarketplaceStoreFamiliesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesCreate>>, {data: StoreFamilyCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1MarketplaceStoreFamiliesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceStoreFamiliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesCreate>>>
    export type V1MarketplaceStoreFamiliesCreateMutationBody = StoreFamilyCreate
    export type V1MarketplaceStoreFamiliesCreateMutationError = unknown

    /**
 * @summary Create the settings timeline for a Store (1:1)
 */
export const useV1MarketplaceStoreFamiliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesCreate>>, TError,{data: StoreFamilyCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesCreate>>,
        TError,
        {data: StoreFamilyCreate},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceStoreFamiliesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Retrieve a store family
 */
export const v1MarketplaceStoreFamiliesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StoreFamily>(
      {url: `/api/v1/marketplace/store-families/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1MarketplaceStoreFamiliesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketplace/store-families/${id}/`
    ] as const;
    }

    
export const getV1MarketplaceStoreFamiliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceStoreFamiliesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>> = ({ signal }) => v1MarketplaceStoreFamiliesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceStoreFamiliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>>
export type V1MarketplaceStoreFamiliesRetrieveQueryError = unknown


export function useV1MarketplaceStoreFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoreFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoreFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a store family
 */

export function useV1MarketplaceStoreFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceStoreFamiliesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-010 Rule STC-02: create always produces a draft (revision_no =
max(existing for family) + 1). `publish` mirrors ListingPrice's
close_out pattern: the revision being published becomes PUBLISHED,
and whichever sibling revision on the same family was PUBLISHED
becomes SUPERSEDED — both inside one atomic transaction.
 * @summary List store revisions
 */
export const v1MarketplaceStoreRevisionsList = (
    params?: V1MarketplaceStoreRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedStoreRevisionList>(
      {url: `/api/v1/marketplace/store-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1MarketplaceStoreRevisionsListQueryKey = (params?: V1MarketplaceStoreRevisionsListParams,) => {
    return [
    `/api/v1/marketplace/store-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1MarketplaceStoreRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError = unknown>(params?: V1MarketplaceStoreRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceStoreRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>> = ({ signal }) => v1MarketplaceStoreRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceStoreRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>>
export type V1MarketplaceStoreRevisionsListQueryError = unknown


export function useV1MarketplaceStoreRevisionsList<TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError = unknown>(
 params: undefined |  V1MarketplaceStoreRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoreRevisionsList<TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError = unknown>(
 params?: V1MarketplaceStoreRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoreRevisionsList<TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError = unknown>(
 params?: V1MarketplaceStoreRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List store revisions
 */

export function useV1MarketplaceStoreRevisionsList<TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError = unknown>(
 params?: V1MarketplaceStoreRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceStoreRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-010 Rule STC-02: create always produces a draft (revision_no =
max(existing for family) + 1). `publish` mirrors ListingPrice's
close_out pattern: the revision being published becomes PUBLISHED,
and whichever sibling revision on the same family was PUBLISHED
becomes SUPERSEDED — both inside one atomic transaction.
 * @summary Create a new draft StoreRevision
 */
export const v1MarketplaceStoreRevisionsCreate = (
    storeRevisionCreate: StoreRevisionCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StoreRevisionCreate>(
      {url: `/api/v1/marketplace/store-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: storeRevisionCreate, signal
    },
      );
    }
  


export const getV1MarketplaceStoreRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsCreate>>, TError,{data: StoreRevisionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsCreate>>, TError,{data: StoreRevisionCreate}, TContext> => {

const mutationKey = ['v1MarketplaceStoreRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsCreate>>, {data: StoreRevisionCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1MarketplaceStoreRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceStoreRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsCreate>>>
    export type V1MarketplaceStoreRevisionsCreateMutationBody = StoreRevisionCreate
    export type V1MarketplaceStoreRevisionsCreateMutationError = unknown

    /**
 * @summary Create a new draft StoreRevision
 */
export const useV1MarketplaceStoreRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsCreate>>, TError,{data: StoreRevisionCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsCreate>>,
        TError,
        {data: StoreRevisionCreate},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceStoreRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-010 Rule STC-02: create always produces a draft (revision_no =
max(existing for family) + 1). `publish` mirrors ListingPrice's
close_out pattern: the revision being published becomes PUBLISHED,
and whichever sibling revision on the same family was PUBLISHED
becomes SUPERSEDED — both inside one atomic transaction.
 * @summary Retrieve a store revision
 */
export const v1MarketplaceStoreRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StoreRevision>(
      {url: `/api/v1/marketplace/store-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1MarketplaceStoreRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketplace/store-revisions/${id}/`
    ] as const;
    }

    
export const getV1MarketplaceStoreRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceStoreRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>> = ({ signal }) => v1MarketplaceStoreRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceStoreRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>>
export type V1MarketplaceStoreRevisionsRetrieveQueryError = unknown


export function useV1MarketplaceStoreRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoreRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoreRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a store revision
 */

export function useV1MarketplaceStoreRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceStoreRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-010 Rule STC-02: create always produces a draft (revision_no =
max(existing for family) + 1). `publish` mirrors ListingPrice's
close_out pattern: the revision being published becomes PUBLISHED,
and whichever sibling revision on the same family was PUBLISHED
becomes SUPERSEDED — both inside one atomic transaction.
 * @summary Publish a draft StoreRevision (supersedes the prior published one)
 */
export const v1MarketplaceStoreRevisionsPublishCreate = (
    id: string,
    storeRevision: NonReadonly<StoreRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StoreRevision>(
      {url: `/api/v1/marketplace/store-revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: storeRevision, signal
    },
      );
    }
  


export const getV1MarketplaceStoreRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<StoreRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<StoreRevision>}, TContext> => {

const mutationKey = ['v1MarketplaceStoreRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsPublishCreate>>, {id: string;data: NonReadonly<StoreRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1MarketplaceStoreRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceStoreRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsPublishCreate>>>
    export type V1MarketplaceStoreRevisionsPublishCreateMutationBody = NonReadonly<StoreRevision>
    export type V1MarketplaceStoreRevisionsPublishCreateMutationError = unknown

    /**
 * @summary Publish a draft StoreRevision (supersedes the prior published one)
 */
export const useV1MarketplaceStoreRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<StoreRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceStoreRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<StoreRevision>},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceStoreRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary List stores for active tenant
 */
export const v1MarketplaceStoresList = (
    params?: V1MarketplaceStoresListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedStoreList>(
      {url: `/api/v1/marketplace/stores/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1MarketplaceStoresListQueryKey = (params?: V1MarketplaceStoresListParams,) => {
    return [
    `/api/v1/marketplace/stores/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1MarketplaceStoresListQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError = unknown>(params?: V1MarketplaceStoresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceStoresListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceStoresList>>> = ({ signal }) => v1MarketplaceStoresList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceStoresListQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoresList>>>
export type V1MarketplaceStoresListQueryError = unknown


export function useV1MarketplaceStoresList<TData = Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError = unknown>(
 params: undefined |  V1MarketplaceStoresListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoresList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoresList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoresList<TData = Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError = unknown>(
 params?: V1MarketplaceStoresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoresList>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoresList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoresList<TData = Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError = unknown>(
 params?: V1MarketplaceStoresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List stores for active tenant
 */

export function useV1MarketplaceStoresList<TData = Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError = unknown>(
 params?: V1MarketplaceStoresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceStoresListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Create a store (Trace Entity root)
 */
export const v1MarketplaceStoresCreate = (
    storeCreate: StoreCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StoreCreate>(
      {url: `/api/v1/marketplace/stores/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: storeCreate, signal
    },
      );
    }
  


export const getV1MarketplaceStoresCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoresCreate>>, TError,{data: StoreCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoresCreate>>, TError,{data: StoreCreate}, TContext> => {

const mutationKey = ['v1MarketplaceStoresCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceStoresCreate>>, {data: StoreCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1MarketplaceStoresCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceStoresCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoresCreate>>>
    export type V1MarketplaceStoresCreateMutationBody = StoreCreate
    export type V1MarketplaceStoresCreateMutationError = unknown

    /**
 * @summary Create a store (Trace Entity root)
 */
export const useV1MarketplaceStoresCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoresCreate>>, TError,{data: StoreCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceStoresCreate>>,
        TError,
        {data: StoreCreate},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceStoresCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Retrieve a store
 */
export const v1MarketplaceStoresRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Store>(
      {url: `/api/v1/marketplace/stores/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1MarketplaceStoresRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketplace/stores/${id}/`
    ] as const;
    }

    
export const getV1MarketplaceStoresRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MarketplaceStoresRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>> = ({ signal }) => v1MarketplaceStoresRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1MarketplaceStoresRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>>
export type V1MarketplaceStoresRetrieveQueryError = unknown


export function useV1MarketplaceStoresRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoresRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1MarketplaceStoresRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a store
 */

export function useV1MarketplaceStoresRetrieve<TData = Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MarketplaceStoresRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1MarketplaceStoresRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Marketplace ViewSets.
Local copy per ADR-058 domain isolation / ADR-067 Rule WF-01 —
no cross-domain imports (mirrors apps.quality.api.mixins,
apps.workflow.api.mixins).
 * @summary Deactivate a store (append-mostly — is_active only)
 */
export const v1MarketplaceStoresDeactivateCreate = (
    id: string,
    store: NonReadonly<Store>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Store>(
      {url: `/api/v1/marketplace/stores/${id}/deactivate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: store, signal
    },
      );
    }
  


export const getV1MarketplaceStoresDeactivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoresDeactivateCreate>>, TError,{id: string;data: NonReadonly<Store>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoresDeactivateCreate>>, TError,{id: string;data: NonReadonly<Store>}, TContext> => {

const mutationKey = ['v1MarketplaceStoresDeactivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceStoresDeactivateCreate>>, {id: string;data: NonReadonly<Store>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1MarketplaceStoresDeactivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceStoresDeactivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceStoresDeactivateCreate>>>
    export type V1MarketplaceStoresDeactivateCreateMutationBody = NonReadonly<Store>
    export type V1MarketplaceStoresDeactivateCreateMutationError = unknown

    /**
 * @summary Deactivate a store (append-mostly — is_active only)
 */
export const useV1MarketplaceStoresDeactivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceStoresDeactivateCreate>>, TError,{id: string;data: NonReadonly<Store>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceStoresDeactivateCreate>>,
        TError,
        {id: string;data: NonReadonly<Store>},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceStoresDeactivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-069 Rule MIS-04 §3: inbound webhook endpoint.

Pattern:
1. Parse connector_revision_id from URL.
2. Persist the raw delivery (append-only, 202 returned immediately).
3. Queue HMAC verification as an async Celery task
   (verify_webhook_delivery_task) — never blocks the response.

Authentication is intentionally set to AllowAny because webhook
payloads arrive from external systems that do not hold a user JWT.
Authenticity is instead verified via HMAC signature (MIS-07).
 */
export const v1MarketplaceWebhooksReceiveCreate = (
    connectorRevisionId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/marketplace/webhooks/receive/${connectorRevisionId}/`, method: 'POST', signal
    },
      );
    }
  


export const getV1MarketplaceWebhooksReceiveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceWebhooksReceiveCreate>>, TError,{connectorRevisionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceWebhooksReceiveCreate>>, TError,{connectorRevisionId: string}, TContext> => {

const mutationKey = ['v1MarketplaceWebhooksReceiveCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MarketplaceWebhooksReceiveCreate>>, {connectorRevisionId: string}> = (props) => {
          const {connectorRevisionId} = props ?? {};

          return  v1MarketplaceWebhooksReceiveCreate(connectorRevisionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1MarketplaceWebhooksReceiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MarketplaceWebhooksReceiveCreate>>>
    
    export type V1MarketplaceWebhooksReceiveCreateMutationError = unknown

    export const useV1MarketplaceWebhooksReceiveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MarketplaceWebhooksReceiveCreate>>, TError,{connectorRevisionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MarketplaceWebhooksReceiveCreate>>,
        TError,
        {connectorRevisionId: string},
        TContext
      > => {

      const mutationOptions = getV1MarketplaceWebhooksReceiveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 */
export const v1OrganizationsList = (
    params?: V1OrganizationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOrganizationList>(
      {url: `/api/v1/organizations/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1OrganizationsListQueryKey = (params?: V1OrganizationsListParams,) => {
    return [
    `/api/v1/organizations/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1OrganizationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1OrganizationsList>>, TError = unknown>(params?: V1OrganizationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1OrganizationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1OrganizationsList>>> = ({ signal }) => v1OrganizationsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1OrganizationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsList>>>
export type V1OrganizationsListQueryError = unknown


export function useV1OrganizationsList<TData = Awaited<ReturnType<typeof v1OrganizationsList>>, TError = unknown>(
 params: undefined |  V1OrganizationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsList>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsList<TData = Awaited<ReturnType<typeof v1OrganizationsList>>, TError = unknown>(
 params?: V1OrganizationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsList>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsList<TData = Awaited<ReturnType<typeof v1OrganizationsList>>, TError = unknown>(
 params?: V1OrganizationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1OrganizationsList<TData = Awaited<ReturnType<typeof v1OrganizationsList>>, TError = unknown>(
 params?: V1OrganizationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1OrganizationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary Create a new organization
 */
export const v1OrganizationsCreate = (
    organizationCreate: NonReadonly<OrganizationCreate>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Organization>(
      {url: `/api/v1/organizations/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organizationCreate, signal
    },
      );
    }
  


export const getV1OrganizationsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsCreate>>, TError,{data: NonReadonly<OrganizationCreate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsCreate>>, TError,{data: NonReadonly<OrganizationCreate>}, TContext> => {

const mutationKey = ['v1OrganizationsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsCreate>>, {data: NonReadonly<OrganizationCreate>}> = (props) => {
          const {data} = props ?? {};

          return  v1OrganizationsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsCreate>>>
    export type V1OrganizationsCreateMutationBody = NonReadonly<OrganizationCreate>
    export type V1OrganizationsCreateMutationError = unknown

    /**
 * @summary Create a new organization
 */
export const useV1OrganizationsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsCreate>>, TError,{data: NonReadonly<OrganizationCreate>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsCreate>>,
        TError,
        {data: NonReadonly<OrganizationCreate>},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 */
export const v1OrganizationsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Organization>(
      {url: `/api/v1/organizations/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1OrganizationsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/organizations/${id}/`
    ] as const;
    }

    
export const getV1OrganizationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1OrganizationsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1OrganizationsRetrieve>>> = ({ signal }) => v1OrganizationsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1OrganizationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsRetrieve>>>
export type V1OrganizationsRetrieveQueryError = unknown


export function useV1OrganizationsRetrieve<TData = Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsRetrieve<TData = Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsRetrieve<TData = Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1OrganizationsRetrieve<TData = Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1OrganizationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary Partially update an organization (PATCH-only)
 */
export const v1OrganizationsPartialUpdate = (
    id: string,
    patchedOrganization: NonReadonly<PatchedOrganization>,
 ) => {
      
      
      return customAxiosInstance<Organization>(
      {url: `/api/v1/organizations/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedOrganization
    },
      );
    }
  


export const getV1OrganizationsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOrganization>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOrganization>}, TContext> => {

const mutationKey = ['v1OrganizationsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsPartialUpdate>>, {id: string;data: NonReadonly<PatchedOrganization>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1OrganizationsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsPartialUpdate>>>
    export type V1OrganizationsPartialUpdateMutationBody = NonReadonly<PatchedOrganization>
    export type V1OrganizationsPartialUpdateMutationError = unknown

    /**
 * @summary Partially update an organization (PATCH-only)
 */
export const useV1OrganizationsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOrganization>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedOrganization>},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary Archive an organization
 */
export const v1OrganizationsArchiveCreate = (
    id: string,
    organization: NonReadonly<Organization>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Organization>(
      {url: `/api/v1/organizations/${id}/archive/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organization, signal
    },
      );
    }
  


export const getV1OrganizationsArchiveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsArchiveCreate>>, TError,{id: string;data: NonReadonly<Organization>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsArchiveCreate>>, TError,{id: string;data: NonReadonly<Organization>}, TContext> => {

const mutationKey = ['v1OrganizationsArchiveCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsArchiveCreate>>, {id: string;data: NonReadonly<Organization>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1OrganizationsArchiveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsArchiveCreate>>>
    export type V1OrganizationsArchiveCreateMutationBody = NonReadonly<Organization>
    export type V1OrganizationsArchiveCreateMutationError = unknown

    /**
 * @summary Archive an organization
 */
export const useV1OrganizationsArchiveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsArchiveCreate>>, TError,{id: string;data: NonReadonly<Organization>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsArchiveCreate>>,
        TError,
        {id: string;data: NonReadonly<Organization>},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsArchiveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary List or Add children for organization hierarchy
 */
export const v1OrganizationsChildrenList = (
    id: string,
    params?: V1OrganizationsChildrenListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOrganizationList>(
      {url: `/api/v1/organizations/${id}/children/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1OrganizationsChildrenListQueryKey = (id?: string,
    params?: V1OrganizationsChildrenListParams,) => {
    return [
    `/api/v1/organizations/${id}/children/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1OrganizationsChildrenListQueryOptions = <TData = Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError = unknown>(id: string,
    params?: V1OrganizationsChildrenListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1OrganizationsChildrenListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1OrganizationsChildrenList>>> = ({ signal }) => v1OrganizationsChildrenList(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1OrganizationsChildrenListQueryResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsChildrenList>>>
export type V1OrganizationsChildrenListQueryError = unknown


export function useV1OrganizationsChildrenList<TData = Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError = unknown>(
 id: string,
    params: undefined |  V1OrganizationsChildrenListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsChildrenList>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsChildrenList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsChildrenList<TData = Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError = unknown>(
 id: string,
    params?: V1OrganizationsChildrenListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsChildrenList>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsChildrenList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsChildrenList<TData = Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError = unknown>(
 id: string,
    params?: V1OrganizationsChildrenListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List or Add children for organization hierarchy
 */

export function useV1OrganizationsChildrenList<TData = Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError = unknown>(
 id: string,
    params?: V1OrganizationsChildrenListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1OrganizationsChildrenListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary List or Add children for organization hierarchy
 */
export const v1OrganizationsChildrenCreate = (
    id: string,
    organization: NonReadonly<Organization>,
    params?: V1OrganizationsChildrenCreateParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOrganizationList>(
      {url: `/api/v1/organizations/${id}/children/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organization,
        params, signal
    },
      );
    }
  


export const getV1OrganizationsChildrenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenCreate>>, TError,{id: string;data: NonReadonly<Organization>;params?: V1OrganizationsChildrenCreateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenCreate>>, TError,{id: string;data: NonReadonly<Organization>;params?: V1OrganizationsChildrenCreateParams}, TContext> => {

const mutationKey = ['v1OrganizationsChildrenCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsChildrenCreate>>, {id: string;data: NonReadonly<Organization>;params?: V1OrganizationsChildrenCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  v1OrganizationsChildrenCreate(id,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsChildrenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsChildrenCreate>>>
    export type V1OrganizationsChildrenCreateMutationBody = NonReadonly<Organization>
    export type V1OrganizationsChildrenCreateMutationError = unknown

    /**
 * @summary List or Add children for organization hierarchy
 */
export const useV1OrganizationsChildrenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenCreate>>, TError,{id: string;data: NonReadonly<Organization>;params?: V1OrganizationsChildrenCreateParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsChildrenCreate>>,
        TError,
        {id: string;data: NonReadonly<Organization>;params?: V1OrganizationsChildrenCreateParams},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsChildrenCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary Remove child from organization hierarchy
 */
export const v1OrganizationsChildrenDestroy = (
    id: string,
    childId: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/organizations/${id}/children/${childId}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1OrganizationsChildrenDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenDestroy>>, TError,{id: string;childId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenDestroy>>, TError,{id: string;childId: string}, TContext> => {

const mutationKey = ['v1OrganizationsChildrenDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsChildrenDestroy>>, {id: string;childId: string}> = (props) => {
          const {id,childId} = props ?? {};

          return  v1OrganizationsChildrenDestroy(id,childId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsChildrenDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsChildrenDestroy>>>
    
    export type V1OrganizationsChildrenDestroyMutationError = unknown

    /**
 * @summary Remove child from organization hierarchy
 */
export const useV1OrganizationsChildrenDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsChildrenDestroy>>, TError,{id: string;childId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsChildrenDestroy>>,
        TError,
        {id: string;childId: string},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsChildrenDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary List or Send invitations for organization
 */
export const v1OrganizationsInvitationsList = (
    id: string,
    params?: V1OrganizationsInvitationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOrganizationInvitationList>(
      {url: `/api/v1/organizations/${id}/invitations/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1OrganizationsInvitationsListQueryKey = (id?: string,
    params?: V1OrganizationsInvitationsListParams,) => {
    return [
    `/api/v1/organizations/${id}/invitations/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1OrganizationsInvitationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError = unknown>(id: string,
    params?: V1OrganizationsInvitationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1OrganizationsInvitationsListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>> = ({ signal }) => v1OrganizationsInvitationsList(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1OrganizationsInvitationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>>
export type V1OrganizationsInvitationsListQueryError = unknown


export function useV1OrganizationsInvitationsList<TData = Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError = unknown>(
 id: string,
    params: undefined |  V1OrganizationsInvitationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsInvitationsList<TData = Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError = unknown>(
 id: string,
    params?: V1OrganizationsInvitationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsInvitationsList<TData = Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError = unknown>(
 id: string,
    params?: V1OrganizationsInvitationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List or Send invitations for organization
 */

export function useV1OrganizationsInvitationsList<TData = Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError = unknown>(
 id: string,
    params?: V1OrganizationsInvitationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1OrganizationsInvitationsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary List or Send invitations for organization
 */
export const v1OrganizationsInvitationsCreate = (
    id: string,
    organization: NonReadonly<Organization>,
    params?: V1OrganizationsInvitationsCreateParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOrganizationInvitationList>(
      {url: `/api/v1/organizations/${id}/invitations/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organization,
        params, signal
    },
      );
    }
  


export const getV1OrganizationsInvitationsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsCreate>>, TError,{id: string;data: NonReadonly<Organization>;params?: V1OrganizationsInvitationsCreateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsCreate>>, TError,{id: string;data: NonReadonly<Organization>;params?: V1OrganizationsInvitationsCreateParams}, TContext> => {

const mutationKey = ['v1OrganizationsInvitationsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsInvitationsCreate>>, {id: string;data: NonReadonly<Organization>;params?: V1OrganizationsInvitationsCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  v1OrganizationsInvitationsCreate(id,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsInvitationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsInvitationsCreate>>>
    export type V1OrganizationsInvitationsCreateMutationBody = NonReadonly<Organization>
    export type V1OrganizationsInvitationsCreateMutationError = unknown

    /**
 * @summary List or Send invitations for organization
 */
export const useV1OrganizationsInvitationsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsCreate>>, TError,{id: string;data: NonReadonly<Organization>;params?: V1OrganizationsInvitationsCreateParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsInvitationsCreate>>,
        TError,
        {id: string;data: NonReadonly<Organization>;params?: V1OrganizationsInvitationsCreateParams},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsInvitationsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-025 Addendum §INV-02: identity comes ONLY from request.user.email.
No request-body email is read or compared — eliminates the previous
self-report/spoof surface entirely (rather than checking-then-ignoring
a body value, the body is never consulted).
 * @summary Accept an organization invitation
 */
export const v1OrganizationsInvitationsAcceptCreate = (
    id: string,
    invitationId: string,
    organization: NonReadonly<Organization>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OrganizationInvitation>(
      {url: `/api/v1/organizations/${id}/invitations/${invitationId}/accept/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organization, signal
    },
      );
    }
  


export const getV1OrganizationsInvitationsAcceptCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsAcceptCreate>>, TError,{id: string;invitationId: string;data: NonReadonly<Organization>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsAcceptCreate>>, TError,{id: string;invitationId: string;data: NonReadonly<Organization>}, TContext> => {

const mutationKey = ['v1OrganizationsInvitationsAcceptCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsInvitationsAcceptCreate>>, {id: string;invitationId: string;data: NonReadonly<Organization>}> = (props) => {
          const {id,invitationId,data} = props ?? {};

          return  v1OrganizationsInvitationsAcceptCreate(id,invitationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsInvitationsAcceptCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsInvitationsAcceptCreate>>>
    export type V1OrganizationsInvitationsAcceptCreateMutationBody = NonReadonly<Organization>
    export type V1OrganizationsInvitationsAcceptCreateMutationError = unknown

    /**
 * @summary Accept an organization invitation
 */
export const useV1OrganizationsInvitationsAcceptCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsAcceptCreate>>, TError,{id: string;invitationId: string;data: NonReadonly<Organization>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsInvitationsAcceptCreate>>,
        TError,
        {id: string;invitationId: string;data: NonReadonly<Organization>},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsInvitationsAcceptCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-025 Addendum §INV-02 — same identity rule as accept_invitation.
 * @summary Reject an organization invitation
 */
export const v1OrganizationsInvitationsRejectCreate = (
    id: string,
    invitationId: string,
    organization: NonReadonly<Organization>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OrganizationInvitation>(
      {url: `/api/v1/organizations/${id}/invitations/${invitationId}/reject/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organization, signal
    },
      );
    }
  


export const getV1OrganizationsInvitationsRejectCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsRejectCreate>>, TError,{id: string;invitationId: string;data: NonReadonly<Organization>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsRejectCreate>>, TError,{id: string;invitationId: string;data: NonReadonly<Organization>}, TContext> => {

const mutationKey = ['v1OrganizationsInvitationsRejectCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsInvitationsRejectCreate>>, {id: string;invitationId: string;data: NonReadonly<Organization>}> = (props) => {
          const {id,invitationId,data} = props ?? {};

          return  v1OrganizationsInvitationsRejectCreate(id,invitationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsInvitationsRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsInvitationsRejectCreate>>>
    export type V1OrganizationsInvitationsRejectCreateMutationBody = NonReadonly<Organization>
    export type V1OrganizationsInvitationsRejectCreateMutationError = unknown

    /**
 * @summary Reject an organization invitation
 */
export const useV1OrganizationsInvitationsRejectCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsInvitationsRejectCreate>>, TError,{id: string;invitationId: string;data: NonReadonly<Organization>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsInvitationsRejectCreate>>,
        TError,
        {id: string;invitationId: string;data: NonReadonly<Organization>},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsInvitationsRejectCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary List or Add memberships for organization
 */
export const v1OrganizationsMembershipsList = (
    id: string,
    params?: V1OrganizationsMembershipsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOrganizationMembershipList>(
      {url: `/api/v1/organizations/${id}/memberships/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1OrganizationsMembershipsListQueryKey = (id?: string,
    params?: V1OrganizationsMembershipsListParams,) => {
    return [
    `/api/v1/organizations/${id}/memberships/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1OrganizationsMembershipsListQueryOptions = <TData = Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError = unknown>(id: string,
    params?: V1OrganizationsMembershipsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1OrganizationsMembershipsListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>> = ({ signal }) => v1OrganizationsMembershipsList(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1OrganizationsMembershipsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>>
export type V1OrganizationsMembershipsListQueryError = unknown


export function useV1OrganizationsMembershipsList<TData = Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError = unknown>(
 id: string,
    params: undefined |  V1OrganizationsMembershipsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsMembershipsList<TData = Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError = unknown>(
 id: string,
    params?: V1OrganizationsMembershipsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>,
          TError,
          Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1OrganizationsMembershipsList<TData = Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError = unknown>(
 id: string,
    params?: V1OrganizationsMembershipsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List or Add memberships for organization
 */

export function useV1OrganizationsMembershipsList<TData = Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError = unknown>(
 id: string,
    params?: V1OrganizationsMembershipsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1OrganizationsMembershipsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary List or Add memberships for organization
 */
export const v1OrganizationsMembershipsCreate = (
    id: string,
    organization: NonReadonly<Organization>,
    params?: V1OrganizationsMembershipsCreateParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOrganizationMembershipList>(
      {url: `/api/v1/organizations/${id}/memberships/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organization,
        params, signal
    },
      );
    }
  


export const getV1OrganizationsMembershipsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsCreate>>, TError,{id: string;data: NonReadonly<Organization>;params?: V1OrganizationsMembershipsCreateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsCreate>>, TError,{id: string;data: NonReadonly<Organization>;params?: V1OrganizationsMembershipsCreateParams}, TContext> => {

const mutationKey = ['v1OrganizationsMembershipsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsMembershipsCreate>>, {id: string;data: NonReadonly<Organization>;params?: V1OrganizationsMembershipsCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  v1OrganizationsMembershipsCreate(id,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsMembershipsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsMembershipsCreate>>>
    export type V1OrganizationsMembershipsCreateMutationBody = NonReadonly<Organization>
    export type V1OrganizationsMembershipsCreateMutationError = unknown

    /**
 * @summary List or Add memberships for organization
 */
export const useV1OrganizationsMembershipsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsCreate>>, TError,{id: string;data: NonReadonly<Organization>;params?: V1OrganizationsMembershipsCreateParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsMembershipsCreate>>,
        TError,
        {id: string;data: NonReadonly<Organization>;params?: V1OrganizationsMembershipsCreateParams},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsMembershipsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Organization management, scoped by active Tenant context.

AM-025 Addendum: thin view — every business rule (tenant membership
validation, archived-organization matrix, update field policy, hierarchy
cycle/archive checks) lives in OrganizationService. This view only
parses input, calls the service, and translates results/exceptions.
 * @summary Remove member from organization
 */
export const v1OrganizationsMembershipsDestroy = (
    id: string,
    userId: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/organizations/${id}/memberships/${userId}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1OrganizationsMembershipsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsDestroy>>, TError,{id: string;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsDestroy>>, TError,{id: string;userId: string}, TContext> => {

const mutationKey = ['v1OrganizationsMembershipsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1OrganizationsMembershipsDestroy>>, {id: string;userId: string}> = (props) => {
          const {id,userId} = props ?? {};

          return  v1OrganizationsMembershipsDestroy(id,userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1OrganizationsMembershipsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1OrganizationsMembershipsDestroy>>>
    
    export type V1OrganizationsMembershipsDestroyMutationError = unknown

    /**
 * @summary Remove member from organization
 */
export const useV1OrganizationsMembershipsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1OrganizationsMembershipsDestroy>>, TError,{id: string;userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1OrganizationsMembershipsDestroy>>,
        TError,
        {id: string;userId: string},
        TContext
      > => {

      const mutationOptions = getV1OrganizationsMembershipsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-097 Rule CAP-01: read-only، مثل MrpRunViewSet. رکوردها فقط از
طریق اکشن run تولید می‌شوند.

(پیش از ADR-097 این docstring به‌اشتباه "ADR-095 Rule CAP-05" را ارجاع
می‌داد — ADR-095 واقعی Custom Fields Framework است.)

ADR-097 Rule CAP-03: اکشن `run` اکنون تحت permission_domain="planning"
+ suffix "manage" محافظت می‌شود (رجوع shared/backbone/api/permissions.py،
DEFAULT_ACTION_PERMISSION_SUFFIX["run"]). پیش از این ADR این اکشن بدون
هیچ چک مجوزی برای هر کاربر احراز-هویت‌شده در دسترس بود.
 */
export const v1PlanningCapacityChecksList = (
    params?: V1PlanningCapacityChecksListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedCapacityCheckRunList>(
      {url: `/api/v1/planning/capacity-checks/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1PlanningCapacityChecksListQueryKey = (params?: V1PlanningCapacityChecksListParams,) => {
    return [
    `/api/v1/planning/capacity-checks/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1PlanningCapacityChecksListQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError = unknown>(params?: V1PlanningCapacityChecksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningCapacityChecksListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>> = ({ signal }) => v1PlanningCapacityChecksList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningCapacityChecksListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>>
export type V1PlanningCapacityChecksListQueryError = unknown


export function useV1PlanningCapacityChecksList<TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError = unknown>(
 params: undefined |  V1PlanningCapacityChecksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningCapacityChecksList<TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError = unknown>(
 params?: V1PlanningCapacityChecksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningCapacityChecksList<TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError = unknown>(
 params?: V1PlanningCapacityChecksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningCapacityChecksList<TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError = unknown>(
 params?: V1PlanningCapacityChecksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningCapacityChecksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-097 Rule CAP-01: read-only، مثل MrpRunViewSet. رکوردها فقط از
طریق اکشن run تولید می‌شوند.

(پیش از ADR-097 این docstring به‌اشتباه "ADR-095 Rule CAP-05" را ارجاع
می‌داد — ADR-095 واقعی Custom Fields Framework است.)

ADR-097 Rule CAP-03: اکشن `run` اکنون تحت permission_domain="planning"
+ suffix "manage" محافظت می‌شود (رجوع shared/backbone/api/permissions.py،
DEFAULT_ACTION_PERMISSION_SUFFIX["run"]). پیش از این ADR این اکشن بدون
هیچ چک مجوزی برای هر کاربر احراز-هویت‌شده در دسترس بود.
 */
export const v1PlanningCapacityChecksRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CapacityCheckRun>(
      {url: `/api/v1/planning/capacity-checks/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PlanningCapacityChecksRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/planning/capacity-checks/${id}/`
    ] as const;
    }

    
export const getV1PlanningCapacityChecksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningCapacityChecksRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>> = ({ signal }) => v1PlanningCapacityChecksRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningCapacityChecksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>>
export type V1PlanningCapacityChecksRetrieveQueryError = unknown


export function useV1PlanningCapacityChecksRetrieve<TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningCapacityChecksRetrieve<TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningCapacityChecksRetrieve<TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningCapacityChecksRetrieve<TData = Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningCapacityChecksRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-097 Rule CAP-01: read-only، مثل MrpRunViewSet. رکوردها فقط از
طریق اکشن run تولید می‌شوند.

(پیش از ADR-097 این docstring به‌اشتباه "ADR-095 Rule CAP-05" را ارجاع
می‌داد — ADR-095 واقعی Custom Fields Framework است.)

ADR-097 Rule CAP-03: اکشن `run` اکنون تحت permission_domain="planning"
+ suffix "manage" محافظت می‌شود (رجوع shared/backbone/api/permissions.py،
DEFAULT_ACTION_PERMISSION_SUFFIX["run"]). پیش از این ADR این اکشن بدون
هیچ چک مجوزی برای هر کاربر احراز-هویت‌شده در دسترس بود.
 */
export const v1PlanningCapacityChecksRunCreate = (
    capacityCheckRun: NonReadonly<CapacityCheckRun>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CapacityCheckRun>(
      {url: `/api/v1/planning/capacity-checks/run/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: capacityCheckRun, signal
    },
      );
    }
  


export const getV1PlanningCapacityChecksRunCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksRunCreate>>, TError,{data: NonReadonly<CapacityCheckRun>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksRunCreate>>, TError,{data: NonReadonly<CapacityCheckRun>}, TContext> => {

const mutationKey = ['v1PlanningCapacityChecksRunCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningCapacityChecksRunCreate>>, {data: NonReadonly<CapacityCheckRun>}> = (props) => {
          const {data} = props ?? {};

          return  v1PlanningCapacityChecksRunCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningCapacityChecksRunCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningCapacityChecksRunCreate>>>
    export type V1PlanningCapacityChecksRunCreateMutationBody = NonReadonly<CapacityCheckRun>
    export type V1PlanningCapacityChecksRunCreateMutationError = unknown

    export const useV1PlanningCapacityChecksRunCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityChecksRunCreate>>, TError,{data: NonReadonly<CapacityCheckRun>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningCapacityChecksRunCreate>>,
        TError,
        {data: NonReadonly<CapacityCheckRun>},
        TContext
      > => {

      const mutationOptions = getV1PlanningCapacityChecksRunCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-097 Rule CAP-04: Config Entity ساده (بدون Family/Revision — مشابه
الگوی UnitOfMeasure) برای تعریف ظرفیت هر WorkCenter. پیش از این ADR
هیچ API‌ای برای این مدل وجود نداشت و تنها راه تعریف ظرفیت، دستکاری
مستقیم ORM بود.
 */
export const v1PlanningCapacityProfilesList = (
    params?: V1PlanningCapacityProfilesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkCenterCapacityProfileList>(
      {url: `/api/v1/planning/capacity-profiles/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1PlanningCapacityProfilesListQueryKey = (params?: V1PlanningCapacityProfilesListParams,) => {
    return [
    `/api/v1/planning/capacity-profiles/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1PlanningCapacityProfilesListQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError = unknown>(params?: V1PlanningCapacityProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningCapacityProfilesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>> = ({ signal }) => v1PlanningCapacityProfilesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningCapacityProfilesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>>
export type V1PlanningCapacityProfilesListQueryError = unknown


export function useV1PlanningCapacityProfilesList<TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError = unknown>(
 params: undefined |  V1PlanningCapacityProfilesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningCapacityProfilesList<TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError = unknown>(
 params?: V1PlanningCapacityProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningCapacityProfilesList<TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError = unknown>(
 params?: V1PlanningCapacityProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningCapacityProfilesList<TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError = unknown>(
 params?: V1PlanningCapacityProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningCapacityProfilesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-097 Rule CAP-04: Config Entity ساده (بدون Family/Revision — مشابه
الگوی UnitOfMeasure) برای تعریف ظرفیت هر WorkCenter. پیش از این ADR
هیچ API‌ای برای این مدل وجود نداشت و تنها راه تعریف ظرفیت، دستکاری
مستقیم ORM بود.
 */
export const v1PlanningCapacityProfilesCreate = (
    workCenterCapacityProfile: NonReadonly<WorkCenterCapacityProfile>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkCenterCapacityProfile>(
      {url: `/api/v1/planning/capacity-profiles/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workCenterCapacityProfile, signal
    },
      );
    }
  


export const getV1PlanningCapacityProfilesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesCreate>>, TError,{data: NonReadonly<WorkCenterCapacityProfile>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesCreate>>, TError,{data: NonReadonly<WorkCenterCapacityProfile>}, TContext> => {

const mutationKey = ['v1PlanningCapacityProfilesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningCapacityProfilesCreate>>, {data: NonReadonly<WorkCenterCapacityProfile>}> = (props) => {
          const {data} = props ?? {};

          return  v1PlanningCapacityProfilesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningCapacityProfilesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningCapacityProfilesCreate>>>
    export type V1PlanningCapacityProfilesCreateMutationBody = NonReadonly<WorkCenterCapacityProfile>
    export type V1PlanningCapacityProfilesCreateMutationError = unknown

    export const useV1PlanningCapacityProfilesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesCreate>>, TError,{data: NonReadonly<WorkCenterCapacityProfile>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningCapacityProfilesCreate>>,
        TError,
        {data: NonReadonly<WorkCenterCapacityProfile>},
        TContext
      > => {

      const mutationOptions = getV1PlanningCapacityProfilesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-097 Rule CAP-04: Config Entity ساده (بدون Family/Revision — مشابه
الگوی UnitOfMeasure) برای تعریف ظرفیت هر WorkCenter. پیش از این ADR
هیچ API‌ای برای این مدل وجود نداشت و تنها راه تعریف ظرفیت، دستکاری
مستقیم ORM بود.
 */
export const v1PlanningCapacityProfilesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkCenterCapacityProfile>(
      {url: `/api/v1/planning/capacity-profiles/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PlanningCapacityProfilesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/planning/capacity-profiles/${id}/`
    ] as const;
    }

    
export const getV1PlanningCapacityProfilesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningCapacityProfilesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>> = ({ signal }) => v1PlanningCapacityProfilesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningCapacityProfilesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>>
export type V1PlanningCapacityProfilesRetrieveQueryError = unknown


export function useV1PlanningCapacityProfilesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningCapacityProfilesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningCapacityProfilesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningCapacityProfilesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningCapacityProfilesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-097 Rule CAP-04: Config Entity ساده (بدون Family/Revision — مشابه
الگوی UnitOfMeasure) برای تعریف ظرفیت هر WorkCenter. پیش از این ADR
هیچ API‌ای برای این مدل وجود نداشت و تنها راه تعریف ظرفیت، دستکاری
مستقیم ORM بود.
 */
export const v1PlanningCapacityProfilesUpdate = (
    id: string,
    workCenterCapacityProfile: NonReadonly<WorkCenterCapacityProfile>,
 ) => {
      
      
      return customAxiosInstance<WorkCenterCapacityProfile>(
      {url: `/api/v1/planning/capacity-profiles/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workCenterCapacityProfile
    },
      );
    }
  


export const getV1PlanningCapacityProfilesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesUpdate>>, TError,{id: string;data: NonReadonly<WorkCenterCapacityProfile>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesUpdate>>, TError,{id: string;data: NonReadonly<WorkCenterCapacityProfile>}, TContext> => {

const mutationKey = ['v1PlanningCapacityProfilesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningCapacityProfilesUpdate>>, {id: string;data: NonReadonly<WorkCenterCapacityProfile>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningCapacityProfilesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningCapacityProfilesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningCapacityProfilesUpdate>>>
    export type V1PlanningCapacityProfilesUpdateMutationBody = NonReadonly<WorkCenterCapacityProfile>
    export type V1PlanningCapacityProfilesUpdateMutationError = unknown

    export const useV1PlanningCapacityProfilesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesUpdate>>, TError,{id: string;data: NonReadonly<WorkCenterCapacityProfile>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningCapacityProfilesUpdate>>,
        TError,
        {id: string;data: NonReadonly<WorkCenterCapacityProfile>},
        TContext
      > => {

      const mutationOptions = getV1PlanningCapacityProfilesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-097 Rule CAP-04: Config Entity ساده (بدون Family/Revision — مشابه
الگوی UnitOfMeasure) برای تعریف ظرفیت هر WorkCenter. پیش از این ADR
هیچ API‌ای برای این مدل وجود نداشت و تنها راه تعریف ظرفیت، دستکاری
مستقیم ORM بود.
 */
export const v1PlanningCapacityProfilesPartialUpdate = (
    id: string,
    patchedWorkCenterCapacityProfile: NonReadonly<PatchedWorkCenterCapacityProfile>,
 ) => {
      
      
      return customAxiosInstance<WorkCenterCapacityProfile>(
      {url: `/api/v1/planning/capacity-profiles/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWorkCenterCapacityProfile
    },
      );
    }
  


export const getV1PlanningCapacityProfilesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkCenterCapacityProfile>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkCenterCapacityProfile>}, TContext> => {

const mutationKey = ['v1PlanningCapacityProfilesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningCapacityProfilesPartialUpdate>>, {id: string;data: NonReadonly<PatchedWorkCenterCapacityProfile>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningCapacityProfilesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningCapacityProfilesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningCapacityProfilesPartialUpdate>>>
    export type V1PlanningCapacityProfilesPartialUpdateMutationBody = NonReadonly<PatchedWorkCenterCapacityProfile>
    export type V1PlanningCapacityProfilesPartialUpdateMutationError = unknown

    export const useV1PlanningCapacityProfilesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkCenterCapacityProfile>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningCapacityProfilesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedWorkCenterCapacityProfile>},
        TContext
      > => {

      const mutationOptions = getV1PlanningCapacityProfilesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-097 Rule CAP-04: Config Entity ساده (بدون Family/Revision — مشابه
الگوی UnitOfMeasure) برای تعریف ظرفیت هر WorkCenter. پیش از این ADR
هیچ API‌ای برای این مدل وجود نداشت و تنها راه تعریف ظرفیت، دستکاری
مستقیم ORM بود.
 */
export const v1PlanningCapacityProfilesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/planning/capacity-profiles/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1PlanningCapacityProfilesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PlanningCapacityProfilesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningCapacityProfilesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PlanningCapacityProfilesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningCapacityProfilesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningCapacityProfilesDestroy>>>
    
    export type V1PlanningCapacityProfilesDestroyMutationError = unknown

    export const useV1PlanningCapacityProfilesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningCapacityProfilesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningCapacityProfilesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1PlanningCapacityProfilesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleLinesList = (
    params?: V1PlanningMasterScheduleLinesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedMasterScheduleLineList>(
      {url: `/api/v1/planning/master-schedule-lines/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1PlanningMasterScheduleLinesListQueryKey = (params?: V1PlanningMasterScheduleLinesListParams,) => {
    return [
    `/api/v1/planning/master-schedule-lines/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1PlanningMasterScheduleLinesListQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError = unknown>(params?: V1PlanningMasterScheduleLinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningMasterScheduleLinesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>> = ({ signal }) => v1PlanningMasterScheduleLinesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningMasterScheduleLinesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>>
export type V1PlanningMasterScheduleLinesListQueryError = unknown


export function useV1PlanningMasterScheduleLinesList<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError = unknown>(
 params: undefined |  V1PlanningMasterScheduleLinesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterScheduleLinesList<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError = unknown>(
 params?: V1PlanningMasterScheduleLinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterScheduleLinesList<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError = unknown>(
 params?: V1PlanningMasterScheduleLinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningMasterScheduleLinesList<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError = unknown>(
 params?: V1PlanningMasterScheduleLinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningMasterScheduleLinesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleLinesCreate = (
    masterScheduleLine: NonReadonly<MasterScheduleLine>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MasterScheduleLine>(
      {url: `/api/v1/planning/master-schedule-lines/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: masterScheduleLine, signal
    },
      );
    }
  


export const getV1PlanningMasterScheduleLinesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesCreate>>, TError,{data: NonReadonly<MasterScheduleLine>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesCreate>>, TError,{data: NonReadonly<MasterScheduleLine>}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleLinesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesCreate>>, {data: NonReadonly<MasterScheduleLine>}> = (props) => {
          const {data} = props ?? {};

          return  v1PlanningMasterScheduleLinesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleLinesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesCreate>>>
    export type V1PlanningMasterScheduleLinesCreateMutationBody = NonReadonly<MasterScheduleLine>
    export type V1PlanningMasterScheduleLinesCreateMutationError = unknown

    export const useV1PlanningMasterScheduleLinesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesCreate>>, TError,{data: NonReadonly<MasterScheduleLine>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesCreate>>,
        TError,
        {data: NonReadonly<MasterScheduleLine>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleLinesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleLinesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MasterScheduleLine>(
      {url: `/api/v1/planning/master-schedule-lines/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PlanningMasterScheduleLinesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/planning/master-schedule-lines/${id}/`
    ] as const;
    }

    
export const getV1PlanningMasterScheduleLinesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningMasterScheduleLinesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>> = ({ signal }) => v1PlanningMasterScheduleLinesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningMasterScheduleLinesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>>
export type V1PlanningMasterScheduleLinesRetrieveQueryError = unknown


export function useV1PlanningMasterScheduleLinesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterScheduleLinesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterScheduleLinesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningMasterScheduleLinesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningMasterScheduleLinesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleLinesUpdate = (
    id: string,
    masterScheduleLine: NonReadonly<MasterScheduleLine>,
 ) => {
      
      
      return customAxiosInstance<MasterScheduleLine>(
      {url: `/api/v1/planning/master-schedule-lines/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: masterScheduleLine
    },
      );
    }
  


export const getV1PlanningMasterScheduleLinesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesUpdate>>, TError,{id: string;data: NonReadonly<MasterScheduleLine>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesUpdate>>, TError,{id: string;data: NonReadonly<MasterScheduleLine>}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleLinesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesUpdate>>, {id: string;data: NonReadonly<MasterScheduleLine>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningMasterScheduleLinesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleLinesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesUpdate>>>
    export type V1PlanningMasterScheduleLinesUpdateMutationBody = NonReadonly<MasterScheduleLine>
    export type V1PlanningMasterScheduleLinesUpdateMutationError = unknown

    export const useV1PlanningMasterScheduleLinesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesUpdate>>, TError,{id: string;data: NonReadonly<MasterScheduleLine>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesUpdate>>,
        TError,
        {id: string;data: NonReadonly<MasterScheduleLine>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleLinesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleLinesPartialUpdate = (
    id: string,
    patchedMasterScheduleLine: NonReadonly<PatchedMasterScheduleLine>,
 ) => {
      
      
      return customAxiosInstance<MasterScheduleLine>(
      {url: `/api/v1/planning/master-schedule-lines/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMasterScheduleLine
    },
      );
    }
  


export const getV1PlanningMasterScheduleLinesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMasterScheduleLine>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMasterScheduleLine>}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleLinesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesPartialUpdate>>, {id: string;data: NonReadonly<PatchedMasterScheduleLine>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningMasterScheduleLinesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleLinesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesPartialUpdate>>>
    export type V1PlanningMasterScheduleLinesPartialUpdateMutationBody = NonReadonly<PatchedMasterScheduleLine>
    export type V1PlanningMasterScheduleLinesPartialUpdateMutationError = unknown

    export const useV1PlanningMasterScheduleLinesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMasterScheduleLine>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedMasterScheduleLine>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleLinesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleLinesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/planning/master-schedule-lines/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1PlanningMasterScheduleLinesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleLinesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PlanningMasterScheduleLinesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleLinesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesDestroy>>>
    
    export type V1PlanningMasterScheduleLinesDestroyMutationError = unknown

    export const useV1PlanningMasterScheduleLinesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleLinesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleLinesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleRevisionsList = (
    params?: V1PlanningMasterScheduleRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedMasterScheduleRevisionList>(
      {url: `/api/v1/planning/master-schedule-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1PlanningMasterScheduleRevisionsListQueryKey = (params?: V1PlanningMasterScheduleRevisionsListParams,) => {
    return [
    `/api/v1/planning/master-schedule-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1PlanningMasterScheduleRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError = unknown>(params?: V1PlanningMasterScheduleRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningMasterScheduleRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>> = ({ signal }) => v1PlanningMasterScheduleRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningMasterScheduleRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>>
export type V1PlanningMasterScheduleRevisionsListQueryError = unknown


export function useV1PlanningMasterScheduleRevisionsList<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError = unknown>(
 params: undefined |  V1PlanningMasterScheduleRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterScheduleRevisionsList<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError = unknown>(
 params?: V1PlanningMasterScheduleRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterScheduleRevisionsList<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError = unknown>(
 params?: V1PlanningMasterScheduleRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningMasterScheduleRevisionsList<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError = unknown>(
 params?: V1PlanningMasterScheduleRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningMasterScheduleRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleRevisionsCreate = (
    masterScheduleRevision: NonReadonly<MasterScheduleRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MasterScheduleRevision>(
      {url: `/api/v1/planning/master-schedule-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: masterScheduleRevision, signal
    },
      );
    }
  


export const getV1PlanningMasterScheduleRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsCreate>>, TError,{data: NonReadonly<MasterScheduleRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsCreate>>, TError,{data: NonReadonly<MasterScheduleRevision>}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsCreate>>, {data: NonReadonly<MasterScheduleRevision>}> = (props) => {
          const {data} = props ?? {};

          return  v1PlanningMasterScheduleRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsCreate>>>
    export type V1PlanningMasterScheduleRevisionsCreateMutationBody = NonReadonly<MasterScheduleRevision>
    export type V1PlanningMasterScheduleRevisionsCreateMutationError = unknown

    export const useV1PlanningMasterScheduleRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsCreate>>, TError,{data: NonReadonly<MasterScheduleRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsCreate>>,
        TError,
        {data: NonReadonly<MasterScheduleRevision>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MasterScheduleRevision>(
      {url: `/api/v1/planning/master-schedule-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PlanningMasterScheduleRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/planning/master-schedule-revisions/${id}/`
    ] as const;
    }

    
export const getV1PlanningMasterScheduleRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningMasterScheduleRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>> = ({ signal }) => v1PlanningMasterScheduleRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningMasterScheduleRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>>
export type V1PlanningMasterScheduleRevisionsRetrieveQueryError = unknown


export function useV1PlanningMasterScheduleRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterScheduleRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterScheduleRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningMasterScheduleRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningMasterScheduleRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleRevisionsUpdate = (
    id: string,
    masterScheduleRevision: NonReadonly<MasterScheduleRevision>,
 ) => {
      
      
      return customAxiosInstance<MasterScheduleRevision>(
      {url: `/api/v1/planning/master-schedule-revisions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: masterScheduleRevision
    },
      );
    }
  


export const getV1PlanningMasterScheduleRevisionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsUpdate>>, TError,{id: string;data: NonReadonly<MasterScheduleRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsUpdate>>, TError,{id: string;data: NonReadonly<MasterScheduleRevision>}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleRevisionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsUpdate>>, {id: string;data: NonReadonly<MasterScheduleRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningMasterScheduleRevisionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleRevisionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsUpdate>>>
    export type V1PlanningMasterScheduleRevisionsUpdateMutationBody = NonReadonly<MasterScheduleRevision>
    export type V1PlanningMasterScheduleRevisionsUpdateMutationError = unknown

    export const useV1PlanningMasterScheduleRevisionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsUpdate>>, TError,{id: string;data: NonReadonly<MasterScheduleRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<MasterScheduleRevision>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleRevisionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleRevisionsPartialUpdate = (
    id: string,
    patchedMasterScheduleRevision: NonReadonly<PatchedMasterScheduleRevision>,
 ) => {
      
      
      return customAxiosInstance<MasterScheduleRevision>(
      {url: `/api/v1/planning/master-schedule-revisions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMasterScheduleRevision
    },
      );
    }
  


export const getV1PlanningMasterScheduleRevisionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMasterScheduleRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMasterScheduleRevision>}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleRevisionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedMasterScheduleRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningMasterScheduleRevisionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPartialUpdate>>>
    export type V1PlanningMasterScheduleRevisionsPartialUpdateMutationBody = NonReadonly<PatchedMasterScheduleRevision>
    export type V1PlanningMasterScheduleRevisionsPartialUpdateMutationError = unknown

    export const useV1PlanningMasterScheduleRevisionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMasterScheduleRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedMasterScheduleRevision>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleRevisionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleRevisionsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/planning/master-schedule-revisions/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1PlanningMasterScheduleRevisionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleRevisionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PlanningMasterScheduleRevisionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleRevisionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsDestroy>>>
    
    export type V1PlanningMasterScheduleRevisionsDestroyMutationError = unknown

    export const useV1PlanningMasterScheduleRevisionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleRevisionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleRevisionsPublishCreate = (
    id: string,
    masterScheduleRevision: NonReadonly<MasterScheduleRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MasterScheduleRevision>(
      {url: `/api/v1/planning/master-schedule-revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: masterScheduleRevision, signal
    },
      );
    }
  


export const getV1PlanningMasterScheduleRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<MasterScheduleRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<MasterScheduleRevision>}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPublishCreate>>, {id: string;data: NonReadonly<MasterScheduleRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningMasterScheduleRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPublishCreate>>>
    export type V1PlanningMasterScheduleRevisionsPublishCreateMutationBody = NonReadonly<MasterScheduleRevision>
    export type V1PlanningMasterScheduleRevisionsPublishCreateMutationError = unknown

    export const useV1PlanningMasterScheduleRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<MasterScheduleRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<MasterScheduleRevision>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PlanningMasterScheduleRevisionsRunMrpCreate = (
    id: string,
    masterScheduleRevision: NonReadonly<MasterScheduleRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MasterScheduleRevision>(
      {url: `/api/v1/planning/master-schedule-revisions/${id}/run-mrp/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: masterScheduleRevision, signal
    },
      );
    }
  


export const getV1PlanningMasterScheduleRevisionsRunMrpCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRunMrpCreate>>, TError,{id: string;data: NonReadonly<MasterScheduleRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRunMrpCreate>>, TError,{id: string;data: NonReadonly<MasterScheduleRevision>}, TContext> => {

const mutationKey = ['v1PlanningMasterScheduleRevisionsRunMrpCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRunMrpCreate>>, {id: string;data: NonReadonly<MasterScheduleRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningMasterScheduleRevisionsRunMrpCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterScheduleRevisionsRunMrpCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRunMrpCreate>>>
    export type V1PlanningMasterScheduleRevisionsRunMrpCreateMutationBody = NonReadonly<MasterScheduleRevision>
    export type V1PlanningMasterScheduleRevisionsRunMrpCreateMutationError = unknown

    export const useV1PlanningMasterScheduleRevisionsRunMrpCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRunMrpCreate>>, TError,{id: string;data: NonReadonly<MasterScheduleRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterScheduleRevisionsRunMrpCreate>>,
        TError,
        {id: string;data: NonReadonly<MasterScheduleRevision>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterScheduleRevisionsRunMrpCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningMasterSchedulesList = (
    params?: V1PlanningMasterSchedulesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedMasterScheduleFamilyList>(
      {url: `/api/v1/planning/master-schedules/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1PlanningMasterSchedulesListQueryKey = (params?: V1PlanningMasterSchedulesListParams,) => {
    return [
    `/api/v1/planning/master-schedules/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1PlanningMasterSchedulesListQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError = unknown>(params?: V1PlanningMasterSchedulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningMasterSchedulesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>> = ({ signal }) => v1PlanningMasterSchedulesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningMasterSchedulesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>>
export type V1PlanningMasterSchedulesListQueryError = unknown


export function useV1PlanningMasterSchedulesList<TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError = unknown>(
 params: undefined |  V1PlanningMasterSchedulesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterSchedulesList<TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError = unknown>(
 params?: V1PlanningMasterSchedulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterSchedulesList<TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError = unknown>(
 params?: V1PlanningMasterSchedulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningMasterSchedulesList<TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError = unknown>(
 params?: V1PlanningMasterSchedulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningMasterSchedulesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningMasterSchedulesCreate = (
    masterScheduleFamily: NonReadonly<MasterScheduleFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MasterScheduleFamily>(
      {url: `/api/v1/planning/master-schedules/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: masterScheduleFamily, signal
    },
      );
    }
  


export const getV1PlanningMasterSchedulesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesCreate>>, TError,{data: NonReadonly<MasterScheduleFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesCreate>>, TError,{data: NonReadonly<MasterScheduleFamily>}, TContext> => {

const mutationKey = ['v1PlanningMasterSchedulesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterSchedulesCreate>>, {data: NonReadonly<MasterScheduleFamily>}> = (props) => {
          const {data} = props ?? {};

          return  v1PlanningMasterSchedulesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterSchedulesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterSchedulesCreate>>>
    export type V1PlanningMasterSchedulesCreateMutationBody = NonReadonly<MasterScheduleFamily>
    export type V1PlanningMasterSchedulesCreateMutationError = unknown

    export const useV1PlanningMasterSchedulesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesCreate>>, TError,{data: NonReadonly<MasterScheduleFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterSchedulesCreate>>,
        TError,
        {data: NonReadonly<MasterScheduleFamily>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterSchedulesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningMasterSchedulesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MasterScheduleFamily>(
      {url: `/api/v1/planning/master-schedules/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PlanningMasterSchedulesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/planning/master-schedules/${id}/`
    ] as const;
    }

    
export const getV1PlanningMasterSchedulesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningMasterSchedulesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>> = ({ signal }) => v1PlanningMasterSchedulesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningMasterSchedulesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>>
export type V1PlanningMasterSchedulesRetrieveQueryError = unknown


export function useV1PlanningMasterSchedulesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterSchedulesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMasterSchedulesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningMasterSchedulesRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningMasterSchedulesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningMasterSchedulesUpdate = (
    id: string,
    masterScheduleFamily: NonReadonly<MasterScheduleFamily>,
 ) => {
      
      
      return customAxiosInstance<MasterScheduleFamily>(
      {url: `/api/v1/planning/master-schedules/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: masterScheduleFamily
    },
      );
    }
  


export const getV1PlanningMasterSchedulesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesUpdate>>, TError,{id: string;data: NonReadonly<MasterScheduleFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesUpdate>>, TError,{id: string;data: NonReadonly<MasterScheduleFamily>}, TContext> => {

const mutationKey = ['v1PlanningMasterSchedulesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterSchedulesUpdate>>, {id: string;data: NonReadonly<MasterScheduleFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningMasterSchedulesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterSchedulesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterSchedulesUpdate>>>
    export type V1PlanningMasterSchedulesUpdateMutationBody = NonReadonly<MasterScheduleFamily>
    export type V1PlanningMasterSchedulesUpdateMutationError = unknown

    export const useV1PlanningMasterSchedulesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesUpdate>>, TError,{id: string;data: NonReadonly<MasterScheduleFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterSchedulesUpdate>>,
        TError,
        {id: string;data: NonReadonly<MasterScheduleFamily>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterSchedulesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningMasterSchedulesPartialUpdate = (
    id: string,
    patchedMasterScheduleFamily: NonReadonly<PatchedMasterScheduleFamily>,
 ) => {
      
      
      return customAxiosInstance<MasterScheduleFamily>(
      {url: `/api/v1/planning/master-schedules/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMasterScheduleFamily
    },
      );
    }
  


export const getV1PlanningMasterSchedulesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMasterScheduleFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMasterScheduleFamily>}, TContext> => {

const mutationKey = ['v1PlanningMasterSchedulesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterSchedulesPartialUpdate>>, {id: string;data: NonReadonly<PatchedMasterScheduleFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningMasterSchedulesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterSchedulesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterSchedulesPartialUpdate>>>
    export type V1PlanningMasterSchedulesPartialUpdateMutationBody = NonReadonly<PatchedMasterScheduleFamily>
    export type V1PlanningMasterSchedulesPartialUpdateMutationError = unknown

    export const useV1PlanningMasterSchedulesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMasterScheduleFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterSchedulesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedMasterScheduleFamily>},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterSchedulesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningMasterSchedulesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/planning/master-schedules/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1PlanningMasterSchedulesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PlanningMasterSchedulesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningMasterSchedulesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PlanningMasterSchedulesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningMasterSchedulesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMasterSchedulesDestroy>>>
    
    export type V1PlanningMasterSchedulesDestroyMutationError = unknown

    export const useV1PlanningMasterSchedulesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningMasterSchedulesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningMasterSchedulesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1PlanningMasterSchedulesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-093 Rule MRP-03: read-only. MrpRun/MrpRequirement فقط از طریق
اکشن run-mrp روی MasterScheduleRevisionViewSet تولید می‌شوند، هرگز
مستقیم از طریق این ViewSet نوشته نمی‌شوند.
 */
export const v1PlanningMrpRunsList = (
    params?: V1PlanningMrpRunsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedMrpRunList>(
      {url: `/api/v1/planning/mrp-runs/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1PlanningMrpRunsListQueryKey = (params?: V1PlanningMrpRunsListParams,) => {
    return [
    `/api/v1/planning/mrp-runs/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1PlanningMrpRunsListQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError = unknown>(params?: V1PlanningMrpRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningMrpRunsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningMrpRunsList>>> = ({ signal }) => v1PlanningMrpRunsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningMrpRunsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMrpRunsList>>>
export type V1PlanningMrpRunsListQueryError = unknown


export function useV1PlanningMrpRunsList<TData = Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError = unknown>(
 params: undefined |  V1PlanningMrpRunsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMrpRunsList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMrpRunsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMrpRunsList<TData = Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError = unknown>(
 params?: V1PlanningMrpRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMrpRunsList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMrpRunsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMrpRunsList<TData = Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError = unknown>(
 params?: V1PlanningMrpRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningMrpRunsList<TData = Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError = unknown>(
 params?: V1PlanningMrpRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningMrpRunsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-093 Rule MRP-03: read-only. MrpRun/MrpRequirement فقط از طریق
اکشن run-mrp روی MasterScheduleRevisionViewSet تولید می‌شوند، هرگز
مستقیم از طریق این ViewSet نوشته نمی‌شوند.
 */
export const v1PlanningMrpRunsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MrpRun>(
      {url: `/api/v1/planning/mrp-runs/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PlanningMrpRunsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/planning/mrp-runs/${id}/`
    ] as const;
    }

    
export const getV1PlanningMrpRunsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningMrpRunsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>> = ({ signal }) => v1PlanningMrpRunsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningMrpRunsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>>
export type V1PlanningMrpRunsRetrieveQueryError = unknown


export function useV1PlanningMrpRunsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMrpRunsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningMrpRunsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningMrpRunsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningMrpRunsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningMrpRunsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningPeriodsList = (
    params?: V1PlanningPeriodsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedPlanningPeriodList>(
      {url: `/api/v1/planning/periods/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1PlanningPeriodsListQueryKey = (params?: V1PlanningPeriodsListParams,) => {
    return [
    `/api/v1/planning/periods/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1PlanningPeriodsListQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError = unknown>(params?: V1PlanningPeriodsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningPeriodsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningPeriodsList>>> = ({ signal }) => v1PlanningPeriodsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningPeriodsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningPeriodsList>>>
export type V1PlanningPeriodsListQueryError = unknown


export function useV1PlanningPeriodsList<TData = Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError = unknown>(
 params: undefined |  V1PlanningPeriodsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningPeriodsList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningPeriodsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningPeriodsList<TData = Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError = unknown>(
 params?: V1PlanningPeriodsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningPeriodsList>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningPeriodsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningPeriodsList<TData = Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError = unknown>(
 params?: V1PlanningPeriodsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningPeriodsList<TData = Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError = unknown>(
 params?: V1PlanningPeriodsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningPeriodsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningPeriodsCreate = (
    planningPeriod: NonReadonly<PlanningPeriod>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PlanningPeriod>(
      {url: `/api/v1/planning/periods/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: planningPeriod, signal
    },
      );
    }
  


export const getV1PlanningPeriodsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsCreate>>, TError,{data: NonReadonly<PlanningPeriod>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsCreate>>, TError,{data: NonReadonly<PlanningPeriod>}, TContext> => {

const mutationKey = ['v1PlanningPeriodsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningPeriodsCreate>>, {data: NonReadonly<PlanningPeriod>}> = (props) => {
          const {data} = props ?? {};

          return  v1PlanningPeriodsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningPeriodsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningPeriodsCreate>>>
    export type V1PlanningPeriodsCreateMutationBody = NonReadonly<PlanningPeriod>
    export type V1PlanningPeriodsCreateMutationError = unknown

    export const useV1PlanningPeriodsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsCreate>>, TError,{data: NonReadonly<PlanningPeriod>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningPeriodsCreate>>,
        TError,
        {data: NonReadonly<PlanningPeriod>},
        TContext
      > => {

      const mutationOptions = getV1PlanningPeriodsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningPeriodsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PlanningPeriod>(
      {url: `/api/v1/planning/periods/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PlanningPeriodsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/planning/periods/${id}/`
    ] as const;
    }

    
export const getV1PlanningPeriodsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PlanningPeriodsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>> = ({ signal }) => v1PlanningPeriodsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PlanningPeriodsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>>
export type V1PlanningPeriodsRetrieveQueryError = unknown


export function useV1PlanningPeriodsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningPeriodsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PlanningPeriodsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PlanningPeriodsRetrieve<TData = Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PlanningPeriodsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PlanningPeriodsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningPeriodsUpdate = (
    id: string,
    planningPeriod: NonReadonly<PlanningPeriod>,
 ) => {
      
      
      return customAxiosInstance<PlanningPeriod>(
      {url: `/api/v1/planning/periods/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: planningPeriod
    },
      );
    }
  


export const getV1PlanningPeriodsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsUpdate>>, TError,{id: string;data: NonReadonly<PlanningPeriod>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsUpdate>>, TError,{id: string;data: NonReadonly<PlanningPeriod>}, TContext> => {

const mutationKey = ['v1PlanningPeriodsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningPeriodsUpdate>>, {id: string;data: NonReadonly<PlanningPeriod>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningPeriodsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningPeriodsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningPeriodsUpdate>>>
    export type V1PlanningPeriodsUpdateMutationBody = NonReadonly<PlanningPeriod>
    export type V1PlanningPeriodsUpdateMutationError = unknown

    export const useV1PlanningPeriodsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsUpdate>>, TError,{id: string;data: NonReadonly<PlanningPeriod>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningPeriodsUpdate>>,
        TError,
        {id: string;data: NonReadonly<PlanningPeriod>},
        TContext
      > => {

      const mutationOptions = getV1PlanningPeriodsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningPeriodsPartialUpdate = (
    id: string,
    patchedPlanningPeriod: NonReadonly<PatchedPlanningPeriod>,
 ) => {
      
      
      return customAxiosInstance<PlanningPeriod>(
      {url: `/api/v1/planning/periods/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPlanningPeriod
    },
      );
    }
  


export const getV1PlanningPeriodsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedPlanningPeriod>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedPlanningPeriod>}, TContext> => {

const mutationKey = ['v1PlanningPeriodsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningPeriodsPartialUpdate>>, {id: string;data: NonReadonly<PatchedPlanningPeriod>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PlanningPeriodsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningPeriodsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningPeriodsPartialUpdate>>>
    export type V1PlanningPeriodsPartialUpdateMutationBody = NonReadonly<PatchedPlanningPeriod>
    export type V1PlanningPeriodsPartialUpdateMutationError = unknown

    export const useV1PlanningPeriodsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedPlanningPeriod>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningPeriodsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedPlanningPeriod>},
        TContext
      > => {

      const mutationOptions = getV1PlanningPeriodsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1PlanningPeriodsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/planning/periods/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1PlanningPeriodsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PlanningPeriodsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PlanningPeriodsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PlanningPeriodsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PlanningPeriodsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1PlanningPeriodsDestroy>>>
    
    export type V1PlanningPeriodsDestroyMutationError = unknown

    export const useV1PlanningPeriodsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PlanningPeriodsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PlanningPeriodsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1PlanningPeriodsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Minimal fallback so this file is importable/testable in isolation.
 */
export const v1PrintingPrintFormatFamiliesList = (
    params?: V1PrintingPrintFormatFamiliesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedPrintFormatFamilyList>(
      {url: `/api/v1/printing/print-format-families/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1PrintingPrintFormatFamiliesListQueryKey = (params?: V1PrintingPrintFormatFamiliesListParams,) => {
    return [
    `/api/v1/printing/print-format-families/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1PrintingPrintFormatFamiliesListQueryOptions = <TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError = unknown>(params?: V1PrintingPrintFormatFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PrintingPrintFormatFamiliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>> = ({ signal }) => v1PrintingPrintFormatFamiliesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PrintingPrintFormatFamiliesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>>
export type V1PrintingPrintFormatFamiliesListQueryError = unknown


export function useV1PrintingPrintFormatFamiliesList<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError = unknown>(
 params: undefined |  V1PrintingPrintFormatFamiliesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingPrintFormatFamiliesList<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError = unknown>(
 params?: V1PrintingPrintFormatFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingPrintFormatFamiliesList<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError = unknown>(
 params?: V1PrintingPrintFormatFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PrintingPrintFormatFamiliesList<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError = unknown>(
 params?: V1PrintingPrintFormatFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PrintingPrintFormatFamiliesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Minimal fallback so this file is importable/testable in isolation.
 */
export const v1PrintingPrintFormatFamiliesCreate = (
    printFormatFamily: NonReadonly<PrintFormatFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PrintFormatFamily>(
      {url: `/api/v1/printing/print-format-families/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: printFormatFamily, signal
    },
      );
    }
  


export const getV1PrintingPrintFormatFamiliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesCreate>>, TError,{data: NonReadonly<PrintFormatFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesCreate>>, TError,{data: NonReadonly<PrintFormatFamily>}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatFamiliesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesCreate>>, {data: NonReadonly<PrintFormatFamily>}> = (props) => {
          const {data} = props ?? {};

          return  v1PrintingPrintFormatFamiliesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatFamiliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesCreate>>>
    export type V1PrintingPrintFormatFamiliesCreateMutationBody = NonReadonly<PrintFormatFamily>
    export type V1PrintingPrintFormatFamiliesCreateMutationError = unknown

    export const useV1PrintingPrintFormatFamiliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesCreate>>, TError,{data: NonReadonly<PrintFormatFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesCreate>>,
        TError,
        {data: NonReadonly<PrintFormatFamily>},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatFamiliesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Minimal fallback so this file is importable/testable in isolation.
 */
export const v1PrintingPrintFormatFamiliesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PrintFormatFamily>(
      {url: `/api/v1/printing/print-format-families/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PrintingPrintFormatFamiliesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/printing/print-format-families/${id}/`
    ] as const;
    }

    
export const getV1PrintingPrintFormatFamiliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PrintingPrintFormatFamiliesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>> = ({ signal }) => v1PrintingPrintFormatFamiliesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PrintingPrintFormatFamiliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>>
export type V1PrintingPrintFormatFamiliesRetrieveQueryError = unknown


export function useV1PrintingPrintFormatFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingPrintFormatFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingPrintFormatFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PrintingPrintFormatFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PrintingPrintFormatFamiliesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Minimal fallback so this file is importable/testable in isolation.
 */
export const v1PrintingPrintFormatFamiliesUpdate = (
    id: string,
    printFormatFamily: NonReadonly<PrintFormatFamily>,
 ) => {
      
      
      return customAxiosInstance<PrintFormatFamily>(
      {url: `/api/v1/printing/print-format-families/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: printFormatFamily
    },
      );
    }
  


export const getV1PrintingPrintFormatFamiliesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesUpdate>>, TError,{id: string;data: NonReadonly<PrintFormatFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesUpdate>>, TError,{id: string;data: NonReadonly<PrintFormatFamily>}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatFamiliesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesUpdate>>, {id: string;data: NonReadonly<PrintFormatFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PrintingPrintFormatFamiliesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatFamiliesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesUpdate>>>
    export type V1PrintingPrintFormatFamiliesUpdateMutationBody = NonReadonly<PrintFormatFamily>
    export type V1PrintingPrintFormatFamiliesUpdateMutationError = unknown

    export const useV1PrintingPrintFormatFamiliesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesUpdate>>, TError,{id: string;data: NonReadonly<PrintFormatFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesUpdate>>,
        TError,
        {id: string;data: NonReadonly<PrintFormatFamily>},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatFamiliesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Minimal fallback so this file is importable/testable in isolation.
 */
export const v1PrintingPrintFormatFamiliesPartialUpdate = (
    id: string,
    patchedPrintFormatFamily: NonReadonly<PatchedPrintFormatFamily>,
 ) => {
      
      
      return customAxiosInstance<PrintFormatFamily>(
      {url: `/api/v1/printing/print-format-families/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPrintFormatFamily
    },
      );
    }
  


export const getV1PrintingPrintFormatFamiliesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedPrintFormatFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedPrintFormatFamily>}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatFamiliesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesPartialUpdate>>, {id: string;data: NonReadonly<PatchedPrintFormatFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PrintingPrintFormatFamiliesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatFamiliesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesPartialUpdate>>>
    export type V1PrintingPrintFormatFamiliesPartialUpdateMutationBody = NonReadonly<PatchedPrintFormatFamily>
    export type V1PrintingPrintFormatFamiliesPartialUpdateMutationError = unknown

    export const useV1PrintingPrintFormatFamiliesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedPrintFormatFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedPrintFormatFamily>},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatFamiliesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Minimal fallback so this file is importable/testable in isolation.
 */
export const v1PrintingPrintFormatFamiliesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/printing/print-format-families/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1PrintingPrintFormatFamiliesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatFamiliesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PrintingPrintFormatFamiliesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatFamiliesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesDestroy>>>
    
    export type V1PrintingPrintFormatFamiliesDestroyMutationError = unknown

    export const useV1PrintingPrintFormatFamiliesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatFamiliesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatFamiliesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PrintingPrintFormatRevisionsList = (
    params?: V1PrintingPrintFormatRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedPrintFormatRevisionList>(
      {url: `/api/v1/printing/print-format-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1PrintingPrintFormatRevisionsListQueryKey = (params?: V1PrintingPrintFormatRevisionsListParams,) => {
    return [
    `/api/v1/printing/print-format-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1PrintingPrintFormatRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError = unknown>(params?: V1PrintingPrintFormatRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PrintingPrintFormatRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>> = ({ signal }) => v1PrintingPrintFormatRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PrintingPrintFormatRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>>
export type V1PrintingPrintFormatRevisionsListQueryError = unknown


export function useV1PrintingPrintFormatRevisionsList<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError = unknown>(
 params: undefined |  V1PrintingPrintFormatRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingPrintFormatRevisionsList<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError = unknown>(
 params?: V1PrintingPrintFormatRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingPrintFormatRevisionsList<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError = unknown>(
 params?: V1PrintingPrintFormatRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PrintingPrintFormatRevisionsList<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError = unknown>(
 params?: V1PrintingPrintFormatRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PrintingPrintFormatRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PrintingPrintFormatRevisionsCreate = (
    printFormatRevision: NonReadonly<PrintFormatRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PrintFormatRevision>(
      {url: `/api/v1/printing/print-format-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: printFormatRevision, signal
    },
      );
    }
  


export const getV1PrintingPrintFormatRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCreate>>, TError,{data: NonReadonly<PrintFormatRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCreate>>, TError,{data: NonReadonly<PrintFormatRevision>}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCreate>>, {data: NonReadonly<PrintFormatRevision>}> = (props) => {
          const {data} = props ?? {};

          return  v1PrintingPrintFormatRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCreate>>>
    export type V1PrintingPrintFormatRevisionsCreateMutationBody = NonReadonly<PrintFormatRevision>
    export type V1PrintingPrintFormatRevisionsCreateMutationError = unknown

    export const useV1PrintingPrintFormatRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCreate>>, TError,{data: NonReadonly<PrintFormatRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCreate>>,
        TError,
        {data: NonReadonly<PrintFormatRevision>},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PrintingPrintFormatRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PrintFormatRevision>(
      {url: `/api/v1/printing/print-format-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PrintingPrintFormatRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/printing/print-format-revisions/${id}/`
    ] as const;
    }

    
export const getV1PrintingPrintFormatRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PrintingPrintFormatRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>> = ({ signal }) => v1PrintingPrintFormatRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PrintingPrintFormatRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>>
export type V1PrintingPrintFormatRevisionsRetrieveQueryError = unknown


export function useV1PrintingPrintFormatRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingPrintFormatRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingPrintFormatRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PrintingPrintFormatRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PrintingPrintFormatRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PrintingPrintFormatRevisionsUpdate = (
    id: string,
    printFormatRevision: NonReadonly<PrintFormatRevision>,
 ) => {
      
      
      return customAxiosInstance<PrintFormatRevision>(
      {url: `/api/v1/printing/print-format-revisions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: printFormatRevision
    },
      );
    }
  


export const getV1PrintingPrintFormatRevisionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsUpdate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsUpdate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatRevisionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsUpdate>>, {id: string;data: NonReadonly<PrintFormatRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PrintingPrintFormatRevisionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatRevisionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsUpdate>>>
    export type V1PrintingPrintFormatRevisionsUpdateMutationBody = NonReadonly<PrintFormatRevision>
    export type V1PrintingPrintFormatRevisionsUpdateMutationError = unknown

    export const useV1PrintingPrintFormatRevisionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsUpdate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<PrintFormatRevision>},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatRevisionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PrintingPrintFormatRevisionsPartialUpdate = (
    id: string,
    patchedPrintFormatRevision: NonReadonly<PatchedPrintFormatRevision>,
 ) => {
      
      
      return customAxiosInstance<PrintFormatRevision>(
      {url: `/api/v1/printing/print-format-revisions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPrintFormatRevision
    },
      );
    }
  


export const getV1PrintingPrintFormatRevisionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedPrintFormatRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedPrintFormatRevision>}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatRevisionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedPrintFormatRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PrintingPrintFormatRevisionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPartialUpdate>>>
    export type V1PrintingPrintFormatRevisionsPartialUpdateMutationBody = NonReadonly<PatchedPrintFormatRevision>
    export type V1PrintingPrintFormatRevisionsPartialUpdateMutationError = unknown

    export const useV1PrintingPrintFormatRevisionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedPrintFormatRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedPrintFormatRevision>},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatRevisionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PrintingPrintFormatRevisionsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/printing/print-format-revisions/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1PrintingPrintFormatRevisionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatRevisionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1PrintingPrintFormatRevisionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatRevisionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsDestroy>>>
    
    export type V1PrintingPrintFormatRevisionsDestroyMutationError = unknown

    export const useV1PrintingPrintFormatRevisionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatRevisionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PrintingPrintFormatRevisionsCloneCreate = (
    id: string,
    printFormatRevision: NonReadonly<PrintFormatRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PrintFormatRevision>(
      {url: `/api/v1/printing/print-format-revisions/${id}/clone/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: printFormatRevision, signal
    },
      );
    }
  


export const getV1PrintingPrintFormatRevisionsCloneCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCloneCreate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCloneCreate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatRevisionsCloneCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCloneCreate>>, {id: string;data: NonReadonly<PrintFormatRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PrintingPrintFormatRevisionsCloneCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatRevisionsCloneCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCloneCreate>>>
    export type V1PrintingPrintFormatRevisionsCloneCreateMutationBody = NonReadonly<PrintFormatRevision>
    export type V1PrintingPrintFormatRevisionsCloneCreateMutationError = unknown

    export const useV1PrintingPrintFormatRevisionsCloneCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCloneCreate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsCloneCreate>>,
        TError,
        {id: string;data: NonReadonly<PrintFormatRevision>},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatRevisionsCloneCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PrintingPrintFormatRevisionsPublishCreate = (
    id: string,
    printFormatRevision: NonReadonly<PrintFormatRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PrintFormatRevision>(
      {url: `/api/v1/printing/print-format-revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: printFormatRevision, signal
    },
      );
    }
  


export const getV1PrintingPrintFormatRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPublishCreate>>, {id: string;data: NonReadonly<PrintFormatRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PrintingPrintFormatRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPublishCreate>>>
    export type V1PrintingPrintFormatRevisionsPublishCreateMutationBody = NonReadonly<PrintFormatRevision>
    export type V1PrintingPrintFormatRevisionsPublishCreateMutationError = unknown

    export const useV1PrintingPrintFormatRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<PrintFormatRevision>},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1PrintingPrintFormatRevisionsSetDefaultCreate = (
    id: string,
    printFormatRevision: NonReadonly<PrintFormatRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PrintFormatRevision>(
      {url: `/api/v1/printing/print-format-revisions/${id}/set-default/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: printFormatRevision, signal
    },
      );
    }
  


export const getV1PrintingPrintFormatRevisionsSetDefaultCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsSetDefaultCreate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsSetDefaultCreate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext> => {

const mutationKey = ['v1PrintingPrintFormatRevisionsSetDefaultCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsSetDefaultCreate>>, {id: string;data: NonReadonly<PrintFormatRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1PrintingPrintFormatRevisionsSetDefaultCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1PrintingPrintFormatRevisionsSetDefaultCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsSetDefaultCreate>>>
    export type V1PrintingPrintFormatRevisionsSetDefaultCreateMutationBody = NonReadonly<PrintFormatRevision>
    export type V1PrintingPrintFormatRevisionsSetDefaultCreateMutationError = unknown

    export const useV1PrintingPrintFormatRevisionsSetDefaultCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsSetDefaultCreate>>, TError,{id: string;data: NonReadonly<PrintFormatRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1PrintingPrintFormatRevisionsSetDefaultCreate>>,
        TError,
        {id: string;data: NonReadonly<PrintFormatRevision>},
        TContext
      > => {

      const mutationOptions = getV1PrintingPrintFormatRevisionsSetDefaultCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rule DPD-04 / AM-XXX — reads straight from shared.entity_search.registry.
 */
export const v1PrintingReportTypesRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/printing/report-types/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PrintingReportTypesRetrieveQueryKey = () => {
    return [
    `/api/v1/printing/report-types/`
    ] as const;
    }

    
export const getV1PrintingReportTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PrintingReportTypesRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>> = ({ signal }) => v1PrintingReportTypesRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PrintingReportTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>>
export type V1PrintingReportTypesRetrieveQueryError = unknown


export function useV1PrintingReportTypesRetrieve<TData = Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingReportTypesRetrieve<TData = Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingReportTypesRetrieve<TData = Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PrintingReportTypesRetrieve<TData = Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PrintingReportTypesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns real sample database data for a registered report_type.
 */
export const v1PrintingReportTypesSampleDataRetrieve = (
    reportType: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/printing/report-types/${reportType}/sample-data/`, method: 'GET', signal
    },
      );
    }
  



export const getV1PrintingReportTypesSampleDataRetrieveQueryKey = (reportType?: string,) => {
    return [
    `/api/v1/printing/report-types/${reportType}/sample-data/`
    ] as const;
    }

    
export const getV1PrintingReportTypesSampleDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError = unknown>(reportType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1PrintingReportTypesSampleDataRetrieveQueryKey(reportType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>> = ({ signal }) => v1PrintingReportTypesSampleDataRetrieve(reportType, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1PrintingReportTypesSampleDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>>
export type V1PrintingReportTypesSampleDataRetrieveQueryError = unknown


export function useV1PrintingReportTypesSampleDataRetrieve<TData = Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError = unknown>(
 reportType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingReportTypesSampleDataRetrieve<TData = Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError = unknown>(
 reportType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1PrintingReportTypesSampleDataRetrieve<TData = Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError = unknown>(
 reportType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1PrintingReportTypesSampleDataRetrieve<TData = Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError = unknown>(
 reportType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1PrintingReportTypesSampleDataRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1PrintingReportTypesSampleDataRetrieveQueryOptions(reportType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List BOM families for active tenant
 */
export const v1ProductionBomFamiliesList = (
    params?: V1ProductionBomFamiliesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedBomFamilyList>(
      {url: `/api/v1/production/bom-families/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionBomFamiliesListQueryKey = (params?: V1ProductionBomFamiliesListParams,) => {
    return [
    `/api/v1/production/bom-families/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionBomFamiliesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError = unknown>(params?: V1ProductionBomFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionBomFamiliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>> = ({ signal }) => v1ProductionBomFamiliesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionBomFamiliesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>>
export type V1ProductionBomFamiliesListQueryError = unknown


export function useV1ProductionBomFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError = unknown>(
 params: undefined |  V1ProductionBomFamiliesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError = unknown>(
 params?: V1ProductionBomFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError = unknown>(
 params?: V1ProductionBomFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List BOM families for active tenant
 */

export function useV1ProductionBomFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError = unknown>(
 params?: V1ProductionBomFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionBomFamiliesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a new BOM family
 */
export const v1ProductionBomFamiliesCreate = (
    bomFamily: NonReadonly<BomFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomFamily>(
      {url: `/api/v1/production/bom-families/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bomFamily, signal
    },
      );
    }
  


export const getV1ProductionBomFamiliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesCreate>>, TError,{data: NonReadonly<BomFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesCreate>>, TError,{data: NonReadonly<BomFamily>}, TContext> => {

const mutationKey = ['v1ProductionBomFamiliesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomFamiliesCreate>>, {data: NonReadonly<BomFamily>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionBomFamiliesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomFamiliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomFamiliesCreate>>>
    export type V1ProductionBomFamiliesCreateMutationBody = NonReadonly<BomFamily>
    export type V1ProductionBomFamiliesCreateMutationError = unknown

    /**
 * @summary Create a new BOM family
 */
export const useV1ProductionBomFamiliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesCreate>>, TError,{data: NonReadonly<BomFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomFamiliesCreate>>,
        TError,
        {data: NonReadonly<BomFamily>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomFamiliesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a BOM family by ID
 */
export const v1ProductionBomFamiliesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomFamily>(
      {url: `/api/v1/production/bom-families/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionBomFamiliesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/bom-families/${id}/`
    ] as const;
    }

    
export const getV1ProductionBomFamiliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionBomFamiliesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>> = ({ signal }) => v1ProductionBomFamiliesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionBomFamiliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>>
export type V1ProductionBomFamiliesRetrieveQueryError = unknown


export function useV1ProductionBomFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a BOM family by ID
 */

export function useV1ProductionBomFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionBomFamiliesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionBomFamiliesUpdate = (
    id: string,
    bomFamily: NonReadonly<BomFamily>,
 ) => {
      
      
      return customAxiosInstance<BomFamily>(
      {url: `/api/v1/production/bom-families/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bomFamily
    },
      );
    }
  


export const getV1ProductionBomFamiliesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesUpdate>>, TError,{id: string;data: NonReadonly<BomFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesUpdate>>, TError,{id: string;data: NonReadonly<BomFamily>}, TContext> => {

const mutationKey = ['v1ProductionBomFamiliesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomFamiliesUpdate>>, {id: string;data: NonReadonly<BomFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionBomFamiliesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomFamiliesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomFamiliesUpdate>>>
    export type V1ProductionBomFamiliesUpdateMutationBody = NonReadonly<BomFamily>
    export type V1ProductionBomFamiliesUpdateMutationError = unknown

    export const useV1ProductionBomFamiliesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesUpdate>>, TError,{id: string;data: NonReadonly<BomFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomFamiliesUpdate>>,
        TError,
        {id: string;data: NonReadonly<BomFamily>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomFamiliesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionBomFamiliesPartialUpdate = (
    id: string,
    patchedBomFamily: NonReadonly<PatchedBomFamily>,
 ) => {
      
      
      return customAxiosInstance<BomFamily>(
      {url: `/api/v1/production/bom-families/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedBomFamily
    },
      );
    }
  


export const getV1ProductionBomFamiliesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedBomFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedBomFamily>}, TContext> => {

const mutationKey = ['v1ProductionBomFamiliesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomFamiliesPartialUpdate>>, {id: string;data: NonReadonly<PatchedBomFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionBomFamiliesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomFamiliesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomFamiliesPartialUpdate>>>
    export type V1ProductionBomFamiliesPartialUpdateMutationBody = NonReadonly<PatchedBomFamily>
    export type V1ProductionBomFamiliesPartialUpdateMutationError = unknown

    export const useV1ProductionBomFamiliesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedBomFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomFamiliesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedBomFamily>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomFamiliesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionBomFamiliesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/bom-families/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionBomFamiliesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionBomFamiliesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomFamiliesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionBomFamiliesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomFamiliesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomFamiliesDestroy>>>
    
    export type V1ProductionBomFamiliesDestroyMutationError = unknown

    export const useV1ProductionBomFamiliesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomFamiliesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomFamiliesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomFamiliesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary List BOM items
 */
export const v1ProductionBomItemsList = (
    params?: V1ProductionBomItemsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedBomItemList>(
      {url: `/api/v1/production/bom-items/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionBomItemsListQueryKey = (params?: V1ProductionBomItemsListParams,) => {
    return [
    `/api/v1/production/bom-items/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionBomItemsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError = unknown>(params?: V1ProductionBomItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionBomItemsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionBomItemsList>>> = ({ signal }) => v1ProductionBomItemsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionBomItemsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomItemsList>>>
export type V1ProductionBomItemsListQueryError = unknown


export function useV1ProductionBomItemsList<TData = Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError = unknown>(
 params: undefined |  V1ProductionBomItemsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomItemsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomItemsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomItemsList<TData = Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError = unknown>(
 params?: V1ProductionBomItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomItemsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomItemsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomItemsList<TData = Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError = unknown>(
 params?: V1ProductionBomItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List BOM items
 */

export function useV1ProductionBomItemsList<TData = Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError = unknown>(
 params?: V1ProductionBomItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionBomItemsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Add a new item to a BOM revision
 */
export const v1ProductionBomItemsCreate = (
    bomItem: NonReadonly<BomItem>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomItem>(
      {url: `/api/v1/production/bom-items/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bomItem, signal
    },
      );
    }
  


export const getV1ProductionBomItemsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsCreate>>, TError,{data: NonReadonly<BomItem>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsCreate>>, TError,{data: NonReadonly<BomItem>}, TContext> => {

const mutationKey = ['v1ProductionBomItemsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomItemsCreate>>, {data: NonReadonly<BomItem>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionBomItemsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomItemsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomItemsCreate>>>
    export type V1ProductionBomItemsCreateMutationBody = NonReadonly<BomItem>
    export type V1ProductionBomItemsCreateMutationError = unknown

    /**
 * @summary Add a new item to a BOM revision
 */
export const useV1ProductionBomItemsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsCreate>>, TError,{data: NonReadonly<BomItem>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomItemsCreate>>,
        TError,
        {data: NonReadonly<BomItem>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomItemsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Retrieve a BOM item
 */
export const v1ProductionBomItemsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomItem>(
      {url: `/api/v1/production/bom-items/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionBomItemsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/bom-items/${id}/`
    ] as const;
    }

    
export const getV1ProductionBomItemsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionBomItemsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>> = ({ signal }) => v1ProductionBomItemsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionBomItemsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>>
export type V1ProductionBomItemsRetrieveQueryError = unknown


export function useV1ProductionBomItemsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomItemsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomItemsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a BOM item
 */

export function useV1ProductionBomItemsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomItemsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionBomItemsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Update a BOM item
 */
export const v1ProductionBomItemsUpdate = (
    id: string,
    bomItem: NonReadonly<BomItem>,
 ) => {
      
      
      return customAxiosInstance<BomItem>(
      {url: `/api/v1/production/bom-items/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bomItem
    },
      );
    }
  


export const getV1ProductionBomItemsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsUpdate>>, TError,{id: string;data: NonReadonly<BomItem>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsUpdate>>, TError,{id: string;data: NonReadonly<BomItem>}, TContext> => {

const mutationKey = ['v1ProductionBomItemsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomItemsUpdate>>, {id: string;data: NonReadonly<BomItem>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionBomItemsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomItemsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomItemsUpdate>>>
    export type V1ProductionBomItemsUpdateMutationBody = NonReadonly<BomItem>
    export type V1ProductionBomItemsUpdateMutationError = unknown

    /**
 * @summary Update a BOM item
 */
export const useV1ProductionBomItemsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsUpdate>>, TError,{id: string;data: NonReadonly<BomItem>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomItemsUpdate>>,
        TError,
        {id: string;data: NonReadonly<BomItem>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomItemsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Partially update a BOM item
 */
export const v1ProductionBomItemsPartialUpdate = (
    id: string,
    patchedBomItem: NonReadonly<PatchedBomItem>,
 ) => {
      
      
      return customAxiosInstance<BomItem>(
      {url: `/api/v1/production/bom-items/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedBomItem
    },
      );
    }
  


export const getV1ProductionBomItemsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedBomItem>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedBomItem>}, TContext> => {

const mutationKey = ['v1ProductionBomItemsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomItemsPartialUpdate>>, {id: string;data: NonReadonly<PatchedBomItem>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionBomItemsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomItemsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomItemsPartialUpdate>>>
    export type V1ProductionBomItemsPartialUpdateMutationBody = NonReadonly<PatchedBomItem>
    export type V1ProductionBomItemsPartialUpdateMutationError = unknown

    /**
 * @summary Partially update a BOM item
 */
export const useV1ProductionBomItemsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedBomItem>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomItemsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedBomItem>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomItemsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Remove an item from a BOM revision
 */
export const v1ProductionBomItemsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/bom-items/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionBomItemsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionBomItemsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomItemsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionBomItemsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomItemsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomItemsDestroy>>>
    
    export type V1ProductionBomItemsDestroyMutationError = unknown

    /**
 * @summary Remove an item from a BOM revision
 */
export const useV1ProductionBomItemsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomItemsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomItemsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomItemsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-101 / AM-011. Append-mostly: no PUT/PATCH/DELETE (ADR-046).
 * @summary List BOM-Operation allocations
 */
export const v1ProductionBomOperationAllocationsList = (
    params?: V1ProductionBomOperationAllocationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedBomOperationAllocationList>(
      {url: `/api/v1/production/bom-operation-allocations/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionBomOperationAllocationsListQueryKey = (params?: V1ProductionBomOperationAllocationsListParams,) => {
    return [
    `/api/v1/production/bom-operation-allocations/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionBomOperationAllocationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError = unknown>(params?: V1ProductionBomOperationAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionBomOperationAllocationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>> = ({ signal }) => v1ProductionBomOperationAllocationsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionBomOperationAllocationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>>
export type V1ProductionBomOperationAllocationsListQueryError = unknown


export function useV1ProductionBomOperationAllocationsList<TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError = unknown>(
 params: undefined |  V1ProductionBomOperationAllocationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomOperationAllocationsList<TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError = unknown>(
 params?: V1ProductionBomOperationAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomOperationAllocationsList<TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError = unknown>(
 params?: V1ProductionBomOperationAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List BOM-Operation allocations
 */

export function useV1ProductionBomOperationAllocationsList<TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError = unknown>(
 params?: V1ProductionBomOperationAllocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionBomOperationAllocationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-101 / AM-011. Append-mostly: no PUT/PATCH/DELETE (ADR-046).
 * @summary Allocate a BOM item to a routing operation
 */
export const v1ProductionBomOperationAllocationsCreate = (
    bomOperationAllocation: NonReadonly<BomOperationAllocation>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomOperationAllocation>(
      {url: `/api/v1/production/bom-operation-allocations/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bomOperationAllocation, signal
    },
      );
    }
  


export const getV1ProductionBomOperationAllocationsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsCreate>>, TError,{data: NonReadonly<BomOperationAllocation>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsCreate>>, TError,{data: NonReadonly<BomOperationAllocation>}, TContext> => {

const mutationKey = ['v1ProductionBomOperationAllocationsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsCreate>>, {data: NonReadonly<BomOperationAllocation>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionBomOperationAllocationsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomOperationAllocationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsCreate>>>
    export type V1ProductionBomOperationAllocationsCreateMutationBody = NonReadonly<BomOperationAllocation>
    export type V1ProductionBomOperationAllocationsCreateMutationError = unknown

    /**
 * @summary Allocate a BOM item to a routing operation
 */
export const useV1ProductionBomOperationAllocationsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsCreate>>, TError,{data: NonReadonly<BomOperationAllocation>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsCreate>>,
        TError,
        {data: NonReadonly<BomOperationAllocation>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomOperationAllocationsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-101 / AM-011. Append-mostly: no PUT/PATCH/DELETE (ADR-046).
 * @summary Retrieve a BOM-Operation allocation
 */
export const v1ProductionBomOperationAllocationsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomOperationAllocation>(
      {url: `/api/v1/production/bom-operation-allocations/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionBomOperationAllocationsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/bom-operation-allocations/${id}/`
    ] as const;
    }

    
export const getV1ProductionBomOperationAllocationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionBomOperationAllocationsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>> = ({ signal }) => v1ProductionBomOperationAllocationsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionBomOperationAllocationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>>
export type V1ProductionBomOperationAllocationsRetrieveQueryError = unknown


export function useV1ProductionBomOperationAllocationsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomOperationAllocationsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomOperationAllocationsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a BOM-Operation allocation
 */

export function useV1ProductionBomOperationAllocationsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionBomOperationAllocationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-101 / AM-011. Append-mostly: no PUT/PATCH/DELETE (ADR-046).
 * @summary Reactivate a previously deactivated allocation
 */
export const v1ProductionBomOperationAllocationsActivateCreate = (
    id: string,
    bomOperationAllocation: NonReadonly<BomOperationAllocation>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomOperationAllocation>(
      {url: `/api/v1/production/bom-operation-allocations/${id}/activate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bomOperationAllocation, signal
    },
      );
    }
  


export const getV1ProductionBomOperationAllocationsActivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsActivateCreate>>, TError,{id: string;data: NonReadonly<BomOperationAllocation>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsActivateCreate>>, TError,{id: string;data: NonReadonly<BomOperationAllocation>}, TContext> => {

const mutationKey = ['v1ProductionBomOperationAllocationsActivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsActivateCreate>>, {id: string;data: NonReadonly<BomOperationAllocation>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionBomOperationAllocationsActivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomOperationAllocationsActivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsActivateCreate>>>
    export type V1ProductionBomOperationAllocationsActivateCreateMutationBody = NonReadonly<BomOperationAllocation>
    export type V1ProductionBomOperationAllocationsActivateCreateMutationError = unknown

    /**
 * @summary Reactivate a previously deactivated allocation
 */
export const useV1ProductionBomOperationAllocationsActivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsActivateCreate>>, TError,{id: string;data: NonReadonly<BomOperationAllocation>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsActivateCreate>>,
        TError,
        {id: string;data: NonReadonly<BomOperationAllocation>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomOperationAllocationsActivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-101 / AM-011. Append-mostly: no PUT/PATCH/DELETE (ADR-046).
 * @summary Deactivate an allocation (soft — never hard-deleted, ADR-046)
 */
export const v1ProductionBomOperationAllocationsDeactivateCreate = (
    id: string,
    bomOperationAllocation: NonReadonly<BomOperationAllocation>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomOperationAllocation>(
      {url: `/api/v1/production/bom-operation-allocations/${id}/deactivate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bomOperationAllocation, signal
    },
      );
    }
  


export const getV1ProductionBomOperationAllocationsDeactivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsDeactivateCreate>>, TError,{id: string;data: NonReadonly<BomOperationAllocation>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsDeactivateCreate>>, TError,{id: string;data: NonReadonly<BomOperationAllocation>}, TContext> => {

const mutationKey = ['v1ProductionBomOperationAllocationsDeactivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsDeactivateCreate>>, {id: string;data: NonReadonly<BomOperationAllocation>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionBomOperationAllocationsDeactivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomOperationAllocationsDeactivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsDeactivateCreate>>>
    export type V1ProductionBomOperationAllocationsDeactivateCreateMutationBody = NonReadonly<BomOperationAllocation>
    export type V1ProductionBomOperationAllocationsDeactivateCreateMutationError = unknown

    /**
 * @summary Deactivate an allocation (soft — never hard-deleted, ADR-046)
 */
export const useV1ProductionBomOperationAllocationsDeactivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsDeactivateCreate>>, TError,{id: string;data: NonReadonly<BomOperationAllocation>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomOperationAllocationsDeactivateCreate>>,
        TError,
        {id: string;data: NonReadonly<BomOperationAllocation>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomOperationAllocationsDeactivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary List BOM revisions for active tenant
 */
export const v1ProductionBomRevisionsList = (
    params?: V1ProductionBomRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedBomRevisionList>(
      {url: `/api/v1/production/bom-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionBomRevisionsListQueryKey = (params?: V1ProductionBomRevisionsListParams,) => {
    return [
    `/api/v1/production/bom-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionBomRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError = unknown>(params?: V1ProductionBomRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionBomRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>> = ({ signal }) => v1ProductionBomRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionBomRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>>
export type V1ProductionBomRevisionsListQueryError = unknown


export function useV1ProductionBomRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError = unknown>(
 params: undefined |  V1ProductionBomRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError = unknown>(
 params?: V1ProductionBomRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError = unknown>(
 params?: V1ProductionBomRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List BOM revisions for active tenant
 */

export function useV1ProductionBomRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError = unknown>(
 params?: V1ProductionBomRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionBomRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Create a new draft BOM revision
 */
export const v1ProductionBomRevisionsCreate = (
    bomRevision: NonReadonly<BomRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomRevision>(
      {url: `/api/v1/production/bom-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bomRevision, signal
    },
      );
    }
  


export const getV1ProductionBomRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsCreate>>, TError,{data: NonReadonly<BomRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsCreate>>, TError,{data: NonReadonly<BomRevision>}, TContext> => {

const mutationKey = ['v1ProductionBomRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomRevisionsCreate>>, {data: NonReadonly<BomRevision>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionBomRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomRevisionsCreate>>>
    export type V1ProductionBomRevisionsCreateMutationBody = NonReadonly<BomRevision>
    export type V1ProductionBomRevisionsCreateMutationError = unknown

    /**
 * @summary Create a new draft BOM revision
 */
export const useV1ProductionBomRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsCreate>>, TError,{data: NonReadonly<BomRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomRevisionsCreate>>,
        TError,
        {data: NonReadonly<BomRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Retrieve a BOM revision by ID
 */
export const v1ProductionBomRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomRevision>(
      {url: `/api/v1/production/bom-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionBomRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/bom-revisions/${id}/`
    ] as const;
    }

    
export const getV1ProductionBomRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionBomRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>> = ({ signal }) => v1ProductionBomRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionBomRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>>
export type V1ProductionBomRevisionsRetrieveQueryError = unknown


export function useV1ProductionBomRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionBomRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a BOM revision by ID
 */

export function useV1ProductionBomRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionBomRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1ProductionBomRevisionsUpdate = (
    id: string,
    bomRevision: NonReadonly<BomRevision>,
 ) => {
      
      
      return customAxiosInstance<BomRevision>(
      {url: `/api/v1/production/bom-revisions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bomRevision
    },
      );
    }
  


export const getV1ProductionBomRevisionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsUpdate>>, TError,{id: string;data: NonReadonly<BomRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsUpdate>>, TError,{id: string;data: NonReadonly<BomRevision>}, TContext> => {

const mutationKey = ['v1ProductionBomRevisionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomRevisionsUpdate>>, {id: string;data: NonReadonly<BomRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionBomRevisionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomRevisionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomRevisionsUpdate>>>
    export type V1ProductionBomRevisionsUpdateMutationBody = NonReadonly<BomRevision>
    export type V1ProductionBomRevisionsUpdateMutationError = unknown

    export const useV1ProductionBomRevisionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsUpdate>>, TError,{id: string;data: NonReadonly<BomRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomRevisionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<BomRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomRevisionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1ProductionBomRevisionsPartialUpdate = (
    id: string,
    patchedBomRevision: NonReadonly<PatchedBomRevision>,
 ) => {
      
      
      return customAxiosInstance<BomRevision>(
      {url: `/api/v1/production/bom-revisions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedBomRevision
    },
      );
    }
  


export const getV1ProductionBomRevisionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedBomRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedBomRevision>}, TContext> => {

const mutationKey = ['v1ProductionBomRevisionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomRevisionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedBomRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionBomRevisionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomRevisionsPartialUpdate>>>
    export type V1ProductionBomRevisionsPartialUpdateMutationBody = NonReadonly<PatchedBomRevision>
    export type V1ProductionBomRevisionsPartialUpdateMutationError = unknown

    export const useV1ProductionBomRevisionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedBomRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomRevisionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedBomRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomRevisionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1ProductionBomRevisionsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/bom-revisions/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionBomRevisionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionBomRevisionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomRevisionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionBomRevisionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomRevisionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomRevisionsDestroy>>>
    
    export type V1ProductionBomRevisionsDestroyMutationError = unknown

    export const useV1ProductionBomRevisionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomRevisionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomRevisionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Publish a BOM revision (immutable afterward)
 */
export const v1ProductionBomRevisionsPublishCreate = (
    id: string,
    bomRevision: NonReadonly<BomRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BomRevision>(
      {url: `/api/v1/production/bom-revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bomRevision, signal
    },
      );
    }
  


export const getV1ProductionBomRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<BomRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<BomRevision>}, TContext> => {

const mutationKey = ['v1ProductionBomRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionBomRevisionsPublishCreate>>, {id: string;data: NonReadonly<BomRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionBomRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionBomRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionBomRevisionsPublishCreate>>>
    export type V1ProductionBomRevisionsPublishCreateMutationBody = NonReadonly<BomRevision>
    export type V1ProductionBomRevisionsPublishCreateMutationError = unknown

    /**
 * @summary Publish a BOM revision (immutable afterward)
 */
export const useV1ProductionBomRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionBomRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<BomRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionBomRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<BomRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionBomRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-015 Rule HLD-02: master data, distinct from DowntimeReasonCode.
 * @summary List hold reason codes
 */
export const v1ProductionHoldReasonCodesList = (
    params?: V1ProductionHoldReasonCodesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedHoldReasonCodeList>(
      {url: `/api/v1/production/hold-reason-codes/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionHoldReasonCodesListQueryKey = (params?: V1ProductionHoldReasonCodesListParams,) => {
    return [
    `/api/v1/production/hold-reason-codes/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionHoldReasonCodesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError = unknown>(params?: V1ProductionHoldReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionHoldReasonCodesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>> = ({ signal }) => v1ProductionHoldReasonCodesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionHoldReasonCodesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>>
export type V1ProductionHoldReasonCodesListQueryError = unknown


export function useV1ProductionHoldReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError = unknown>(
 params: undefined |  V1ProductionHoldReasonCodesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionHoldReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError = unknown>(
 params?: V1ProductionHoldReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionHoldReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError = unknown>(
 params?: V1ProductionHoldReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List hold reason codes
 */

export function useV1ProductionHoldReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError = unknown>(
 params?: V1ProductionHoldReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionHoldReasonCodesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-015 Rule HLD-02: master data, distinct from DowntimeReasonCode.
 * @summary Create a hold reason code
 */
export const v1ProductionHoldReasonCodesCreate = (
    holdReasonCode: NonReadonly<HoldReasonCode>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<HoldReasonCode>(
      {url: `/api/v1/production/hold-reason-codes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: holdReasonCode, signal
    },
      );
    }
  


export const getV1ProductionHoldReasonCodesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesCreate>>, TError,{data: NonReadonly<HoldReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesCreate>>, TError,{data: NonReadonly<HoldReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionHoldReasonCodesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesCreate>>, {data: NonReadonly<HoldReasonCode>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionHoldReasonCodesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionHoldReasonCodesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesCreate>>>
    export type V1ProductionHoldReasonCodesCreateMutationBody = NonReadonly<HoldReasonCode>
    export type V1ProductionHoldReasonCodesCreateMutationError = unknown

    /**
 * @summary Create a hold reason code
 */
export const useV1ProductionHoldReasonCodesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesCreate>>, TError,{data: NonReadonly<HoldReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionHoldReasonCodesCreate>>,
        TError,
        {data: NonReadonly<HoldReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionHoldReasonCodesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-015 Rule HLD-02: master data, distinct from DowntimeReasonCode.
 * @summary Retrieve a hold reason code
 */
export const v1ProductionHoldReasonCodesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<HoldReasonCode>(
      {url: `/api/v1/production/hold-reason-codes/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionHoldReasonCodesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/hold-reason-codes/${id}/`
    ] as const;
    }

    
export const getV1ProductionHoldReasonCodesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionHoldReasonCodesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>> = ({ signal }) => v1ProductionHoldReasonCodesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionHoldReasonCodesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>>
export type V1ProductionHoldReasonCodesRetrieveQueryError = unknown


export function useV1ProductionHoldReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionHoldReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionHoldReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a hold reason code
 */

export function useV1ProductionHoldReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionHoldReasonCodesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-015 Rule HLD-02: master data, distinct from DowntimeReasonCode.
 */
export const v1ProductionHoldReasonCodesUpdate = (
    id: string,
    holdReasonCode: NonReadonly<HoldReasonCode>,
 ) => {
      
      
      return customAxiosInstance<HoldReasonCode>(
      {url: `/api/v1/production/hold-reason-codes/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: holdReasonCode
    },
      );
    }
  


export const getV1ProductionHoldReasonCodesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesUpdate>>, TError,{id: string;data: NonReadonly<HoldReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesUpdate>>, TError,{id: string;data: NonReadonly<HoldReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionHoldReasonCodesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesUpdate>>, {id: string;data: NonReadonly<HoldReasonCode>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionHoldReasonCodesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionHoldReasonCodesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesUpdate>>>
    export type V1ProductionHoldReasonCodesUpdateMutationBody = NonReadonly<HoldReasonCode>
    export type V1ProductionHoldReasonCodesUpdateMutationError = unknown

    export const useV1ProductionHoldReasonCodesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesUpdate>>, TError,{id: string;data: NonReadonly<HoldReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionHoldReasonCodesUpdate>>,
        TError,
        {id: string;data: NonReadonly<HoldReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionHoldReasonCodesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-015 Rule HLD-02: master data, distinct from DowntimeReasonCode.
 */
export const v1ProductionHoldReasonCodesPartialUpdate = (
    id: string,
    patchedHoldReasonCode: NonReadonly<PatchedHoldReasonCode>,
 ) => {
      
      
      return customAxiosInstance<HoldReasonCode>(
      {url: `/api/v1/production/hold-reason-codes/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedHoldReasonCode
    },
      );
    }
  


export const getV1ProductionHoldReasonCodesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedHoldReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedHoldReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionHoldReasonCodesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesPartialUpdate>>, {id: string;data: NonReadonly<PatchedHoldReasonCode>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionHoldReasonCodesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionHoldReasonCodesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesPartialUpdate>>>
    export type V1ProductionHoldReasonCodesPartialUpdateMutationBody = NonReadonly<PatchedHoldReasonCode>
    export type V1ProductionHoldReasonCodesPartialUpdateMutationError = unknown

    export const useV1ProductionHoldReasonCodesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedHoldReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionHoldReasonCodesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedHoldReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionHoldReasonCodesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-015 Rule HLD-02: master data, distinct from DowntimeReasonCode.
 */
export const v1ProductionHoldReasonCodesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/hold-reason-codes/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionHoldReasonCodesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionHoldReasonCodesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionHoldReasonCodesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionHoldReasonCodesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesDestroy>>>
    
    export type V1ProductionHoldReasonCodesDestroyMutationError = unknown

    export const useV1ProductionHoldReasonCodesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionHoldReasonCodesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionHoldReasonCodesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionHoldReasonCodesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionLotFeedSessionsList = (
    params?: V1ProductionLotFeedSessionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkCenterLotFeedSessionList>(
      {url: `/api/v1/production/lot-feed-sessions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionLotFeedSessionsListQueryKey = (params?: V1ProductionLotFeedSessionsListParams,) => {
    return [
    `/api/v1/production/lot-feed-sessions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionLotFeedSessionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError = unknown>(params?: V1ProductionLotFeedSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionLotFeedSessionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>> = ({ signal }) => v1ProductionLotFeedSessionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionLotFeedSessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>>
export type V1ProductionLotFeedSessionsListQueryError = unknown


export function useV1ProductionLotFeedSessionsList<TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError = unknown>(
 params: undefined |  V1ProductionLotFeedSessionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionLotFeedSessionsList<TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError = unknown>(
 params?: V1ProductionLotFeedSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionLotFeedSessionsList<TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError = unknown>(
 params?: V1ProductionLotFeedSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionLotFeedSessionsList<TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError = unknown>(
 params?: V1ProductionLotFeedSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionLotFeedSessionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionLotFeedSessionsCreate = (
    workCenterLotFeedSession: NonReadonly<WorkCenterLotFeedSession>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkCenterLotFeedSession>(
      {url: `/api/v1/production/lot-feed-sessions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workCenterLotFeedSession, signal
    },
      );
    }
  


export const getV1ProductionLotFeedSessionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCreate>>, TError,{data: NonReadonly<WorkCenterLotFeedSession>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCreate>>, TError,{data: NonReadonly<WorkCenterLotFeedSession>}, TContext> => {

const mutationKey = ['v1ProductionLotFeedSessionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCreate>>, {data: NonReadonly<WorkCenterLotFeedSession>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionLotFeedSessionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionLotFeedSessionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCreate>>>
    export type V1ProductionLotFeedSessionsCreateMutationBody = NonReadonly<WorkCenterLotFeedSession>
    export type V1ProductionLotFeedSessionsCreateMutationError = unknown

    export const useV1ProductionLotFeedSessionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCreate>>, TError,{data: NonReadonly<WorkCenterLotFeedSession>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCreate>>,
        TError,
        {data: NonReadonly<WorkCenterLotFeedSession>},
        TContext
      > => {

      const mutationOptions = getV1ProductionLotFeedSessionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionLotFeedSessionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkCenterLotFeedSession>(
      {url: `/api/v1/production/lot-feed-sessions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionLotFeedSessionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/lot-feed-sessions/${id}/`
    ] as const;
    }

    
export const getV1ProductionLotFeedSessionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionLotFeedSessionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>> = ({ signal }) => v1ProductionLotFeedSessionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionLotFeedSessionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>>
export type V1ProductionLotFeedSessionsRetrieveQueryError = unknown


export function useV1ProductionLotFeedSessionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionLotFeedSessionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionLotFeedSessionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionLotFeedSessionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionLotFeedSessionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary بستن سشن تغذیهٔ پالت (Rule SN-04)
 */
export const v1ProductionLotFeedSessionsCloseCreate = (
    id: string,
    workCenterLotFeedSession: NonReadonly<WorkCenterLotFeedSession>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkCenterLotFeedSession>(
      {url: `/api/v1/production/lot-feed-sessions/${id}/close/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workCenterLotFeedSession, signal
    },
      );
    }
  


export const getV1ProductionLotFeedSessionsCloseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCloseCreate>>, TError,{id: string;data: NonReadonly<WorkCenterLotFeedSession>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCloseCreate>>, TError,{id: string;data: NonReadonly<WorkCenterLotFeedSession>}, TContext> => {

const mutationKey = ['v1ProductionLotFeedSessionsCloseCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCloseCreate>>, {id: string;data: NonReadonly<WorkCenterLotFeedSession>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionLotFeedSessionsCloseCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionLotFeedSessionsCloseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCloseCreate>>>
    export type V1ProductionLotFeedSessionsCloseCreateMutationBody = NonReadonly<WorkCenterLotFeedSession>
    export type V1ProductionLotFeedSessionsCloseCreateMutationError = unknown

    /**
 * @summary بستن سشن تغذیهٔ پالت (Rule SN-04)
 */
export const useV1ProductionLotFeedSessionsCloseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCloseCreate>>, TError,{id: string;data: NonReadonly<WorkCenterLotFeedSession>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionLotFeedSessionsCloseCreate>>,
        TError,
        {id: string;data: NonReadonly<WorkCenterLotFeedSession>},
        TContext
      > => {

      const mutationOptions = getV1ProductionLotFeedSessionsCloseCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List machines for active tenant
 */
export const v1ProductionMachinesList = (
    params?: V1ProductionMachinesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedMachineList>(
      {url: `/api/v1/production/machines/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionMachinesListQueryKey = (params?: V1ProductionMachinesListParams,) => {
    return [
    `/api/v1/production/machines/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionMachinesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError = unknown>(params?: V1ProductionMachinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionMachinesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionMachinesList>>> = ({ signal }) => v1ProductionMachinesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionMachinesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMachinesList>>>
export type V1ProductionMachinesListQueryError = unknown


export function useV1ProductionMachinesList<TData = Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError = unknown>(
 params: undefined |  V1ProductionMachinesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMachinesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMachinesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMachinesList<TData = Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError = unknown>(
 params?: V1ProductionMachinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMachinesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMachinesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMachinesList<TData = Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError = unknown>(
 params?: V1ProductionMachinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List machines for active tenant
 */

export function useV1ProductionMachinesList<TData = Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError = unknown>(
 params?: V1ProductionMachinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionMachinesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a new machine under a work center
 */
export const v1ProductionMachinesCreate = (
    machine: NonReadonly<Machine>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Machine>(
      {url: `/api/v1/production/machines/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: machine, signal
    },
      );
    }
  


export const getV1ProductionMachinesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesCreate>>, TError,{data: NonReadonly<Machine>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesCreate>>, TError,{data: NonReadonly<Machine>}, TContext> => {

const mutationKey = ['v1ProductionMachinesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionMachinesCreate>>, {data: NonReadonly<Machine>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionMachinesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionMachinesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMachinesCreate>>>
    export type V1ProductionMachinesCreateMutationBody = NonReadonly<Machine>
    export type V1ProductionMachinesCreateMutationError = unknown

    /**
 * @summary Create a new machine under a work center
 */
export const useV1ProductionMachinesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesCreate>>, TError,{data: NonReadonly<Machine>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionMachinesCreate>>,
        TError,
        {data: NonReadonly<Machine>},
        TContext
      > => {

      const mutationOptions = getV1ProductionMachinesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a machine by ID
 */
export const v1ProductionMachinesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Machine>(
      {url: `/api/v1/production/machines/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionMachinesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/machines/${id}/`
    ] as const;
    }

    
export const getV1ProductionMachinesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionMachinesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>> = ({ signal }) => v1ProductionMachinesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionMachinesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>>
export type V1ProductionMachinesRetrieveQueryError = unknown


export function useV1ProductionMachinesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMachinesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMachinesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a machine by ID
 */

export function useV1ProductionMachinesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMachinesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionMachinesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionMachinesUpdate = (
    id: string,
    machine: NonReadonly<Machine>,
 ) => {
      
      
      return customAxiosInstance<Machine>(
      {url: `/api/v1/production/machines/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: machine
    },
      );
    }
  


export const getV1ProductionMachinesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesUpdate>>, TError,{id: string;data: NonReadonly<Machine>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesUpdate>>, TError,{id: string;data: NonReadonly<Machine>}, TContext> => {

const mutationKey = ['v1ProductionMachinesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionMachinesUpdate>>, {id: string;data: NonReadonly<Machine>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionMachinesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionMachinesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMachinesUpdate>>>
    export type V1ProductionMachinesUpdateMutationBody = NonReadonly<Machine>
    export type V1ProductionMachinesUpdateMutationError = unknown

    export const useV1ProductionMachinesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesUpdate>>, TError,{id: string;data: NonReadonly<Machine>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionMachinesUpdate>>,
        TError,
        {id: string;data: NonReadonly<Machine>},
        TContext
      > => {

      const mutationOptions = getV1ProductionMachinesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionMachinesPartialUpdate = (
    id: string,
    patchedMachine: NonReadonly<PatchedMachine>,
 ) => {
      
      
      return customAxiosInstance<Machine>(
      {url: `/api/v1/production/machines/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMachine
    },
      );
    }
  


export const getV1ProductionMachinesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMachine>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMachine>}, TContext> => {

const mutationKey = ['v1ProductionMachinesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionMachinesPartialUpdate>>, {id: string;data: NonReadonly<PatchedMachine>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionMachinesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionMachinesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMachinesPartialUpdate>>>
    export type V1ProductionMachinesPartialUpdateMutationBody = NonReadonly<PatchedMachine>
    export type V1ProductionMachinesPartialUpdateMutationError = unknown

    export const useV1ProductionMachinesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedMachine>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionMachinesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedMachine>},
        TContext
      > => {

      const mutationOptions = getV1ProductionMachinesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionMachinesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/machines/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionMachinesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionMachinesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionMachinesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionMachinesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionMachinesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMachinesDestroy>>>
    
    export type V1ProductionMachinesDestroyMutationError = unknown

    export const useV1ProductionMachinesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMachinesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionMachinesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionMachinesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * استعلام موازنه موجودی ایستگاه (AM-033 بند ۲.۵).

فقط‌خواندنی. طبق قاعده BAL-01 عدم‌توازن در ایستگاه مانع عملیات نیست و تنها گزارش می‌شود.
 */
export const v1ProductionMaterialBalancesList = (
    params?: V1ProductionMaterialBalancesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialBalanceResult>(
      {url: `/api/v1/production/material-balances/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionMaterialBalancesListQueryKey = (params?: V1ProductionMaterialBalancesListParams,) => {
    return [
    `/api/v1/production/material-balances/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionMaterialBalancesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError = unknown>(params?: V1ProductionMaterialBalancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionMaterialBalancesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>> = ({ signal }) => v1ProductionMaterialBalancesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionMaterialBalancesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>>
export type V1ProductionMaterialBalancesListQueryError = unknown


export function useV1ProductionMaterialBalancesList<TData = Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError = unknown>(
 params: undefined |  V1ProductionMaterialBalancesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMaterialBalancesList<TData = Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError = unknown>(
 params?: V1ProductionMaterialBalancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMaterialBalancesList<TData = Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError = unknown>(
 params?: V1ProductionMaterialBalancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionMaterialBalancesList<TData = Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError = unknown>(
 params?: V1ProductionMaterialBalancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialBalancesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionMaterialBalancesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Trace Entity — append-only (ADR-046). No PUT/PATCH/DELETE.
 * @summary List material consumption records
 */
export const v1ProductionMaterialConsumptionRecordsList = (
    params?: V1ProductionMaterialConsumptionRecordsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedMaterialConsumptionRecordList>(
      {url: `/api/v1/production/material-consumption-records/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionMaterialConsumptionRecordsListQueryKey = (params?: V1ProductionMaterialConsumptionRecordsListParams,) => {
    return [
    `/api/v1/production/material-consumption-records/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionMaterialConsumptionRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError = unknown>(params?: V1ProductionMaterialConsumptionRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionMaterialConsumptionRecordsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>> = ({ signal }) => v1ProductionMaterialConsumptionRecordsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionMaterialConsumptionRecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>>
export type V1ProductionMaterialConsumptionRecordsListQueryError = unknown


export function useV1ProductionMaterialConsumptionRecordsList<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError = unknown>(
 params: undefined |  V1ProductionMaterialConsumptionRecordsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMaterialConsumptionRecordsList<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError = unknown>(
 params?: V1ProductionMaterialConsumptionRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMaterialConsumptionRecordsList<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError = unknown>(
 params?: V1ProductionMaterialConsumptionRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List material consumption records
 */

export function useV1ProductionMaterialConsumptionRecordsList<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError = unknown>(
 params?: V1ProductionMaterialConsumptionRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionMaterialConsumptionRecordsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Trace Entity — append-only (ADR-046). No PUT/PATCH/DELETE.
 * @summary Record actual material consumption for a work order
 */
export const v1ProductionMaterialConsumptionRecordsCreate = (
    materialConsumptionRecord: NonReadonly<MaterialConsumptionRecord>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialConsumptionRecord>(
      {url: `/api/v1/production/material-consumption-records/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: materialConsumptionRecord, signal
    },
      );
    }
  


export const getV1ProductionMaterialConsumptionRecordsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCreate>>, TError,{data: NonReadonly<MaterialConsumptionRecord>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCreate>>, TError,{data: NonReadonly<MaterialConsumptionRecord>}, TContext> => {

const mutationKey = ['v1ProductionMaterialConsumptionRecordsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCreate>>, {data: NonReadonly<MaterialConsumptionRecord>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionMaterialConsumptionRecordsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionMaterialConsumptionRecordsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCreate>>>
    export type V1ProductionMaterialConsumptionRecordsCreateMutationBody = NonReadonly<MaterialConsumptionRecord>
    export type V1ProductionMaterialConsumptionRecordsCreateMutationError = unknown

    /**
 * @summary Record actual material consumption for a work order
 */
export const useV1ProductionMaterialConsumptionRecordsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCreate>>, TError,{data: NonReadonly<MaterialConsumptionRecord>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCreate>>,
        TError,
        {data: NonReadonly<MaterialConsumptionRecord>},
        TContext
      > => {

      const mutationOptions = getV1ProductionMaterialConsumptionRecordsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Trace Entity — append-only (ADR-046). No PUT/PATCH/DELETE.
 * @summary Retrieve a consumption record
 */
export const v1ProductionMaterialConsumptionRecordsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialConsumptionRecord>(
      {url: `/api/v1/production/material-consumption-records/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionMaterialConsumptionRecordsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/material-consumption-records/${id}/`
    ] as const;
    }

    
export const getV1ProductionMaterialConsumptionRecordsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionMaterialConsumptionRecordsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>> = ({ signal }) => v1ProductionMaterialConsumptionRecordsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionMaterialConsumptionRecordsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>>
export type V1ProductionMaterialConsumptionRecordsRetrieveQueryError = unknown


export function useV1ProductionMaterialConsumptionRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMaterialConsumptionRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMaterialConsumptionRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a consumption record
 */

export function useV1ProductionMaterialConsumptionRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionMaterialConsumptionRecordsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Trace Entity — append-only (ADR-046). No PUT/PATCH/DELETE.
 * @summary Cumulative consumption per BOM item up to this work order's sequence (Rule BOA-03)
 */
export const v1ProductionMaterialConsumptionRecordsCumulativeRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<MaterialConsumptionRecord>(
      {url: `/api/v1/production/material-consumption-records/cumulative/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionMaterialConsumptionRecordsCumulativeRetrieveQueryKey = () => {
    return [
    `/api/v1/production/material-consumption-records/cumulative/`
    ] as const;
    }

    
export const getV1ProductionMaterialConsumptionRecordsCumulativeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionMaterialConsumptionRecordsCumulativeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>> = ({ signal }) => v1ProductionMaterialConsumptionRecordsCumulativeRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionMaterialConsumptionRecordsCumulativeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>>
export type V1ProductionMaterialConsumptionRecordsCumulativeRetrieveQueryError = unknown


export function useV1ProductionMaterialConsumptionRecordsCumulativeRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMaterialConsumptionRecordsCumulativeRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionMaterialConsumptionRecordsCumulativeRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Cumulative consumption per BOM item up to this work order's sequence (Rule BOA-03)
 */

export function useV1ProductionMaterialConsumptionRecordsCumulativeRetrieve<TData = Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionMaterialConsumptionRecordsCumulativeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionMaterialConsumptionRecordsCumulativeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-102 Phase 1: Expose AM-030 Material Source for Frontend.
 * @summary List AM-030 operation material sources
 */
export const v1ProductionOperationMaterialSourcesList = (
    params?: V1ProductionOperationMaterialSourcesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOperationMaterialSourceList>(
      {url: `/api/v1/production/operation-material-sources/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionOperationMaterialSourcesListQueryKey = (params?: V1ProductionOperationMaterialSourcesListParams,) => {
    return [
    `/api/v1/production/operation-material-sources/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionOperationMaterialSourcesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError = unknown>(params?: V1ProductionOperationMaterialSourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionOperationMaterialSourcesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>> = ({ signal }) => v1ProductionOperationMaterialSourcesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionOperationMaterialSourcesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>>
export type V1ProductionOperationMaterialSourcesListQueryError = unknown


export function useV1ProductionOperationMaterialSourcesList<TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError = unknown>(
 params: undefined |  V1ProductionOperationMaterialSourcesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionOperationMaterialSourcesList<TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError = unknown>(
 params?: V1ProductionOperationMaterialSourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionOperationMaterialSourcesList<TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError = unknown>(
 params?: V1ProductionOperationMaterialSourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List AM-030 operation material sources
 */

export function useV1ProductionOperationMaterialSourcesList<TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError = unknown>(
 params?: V1ProductionOperationMaterialSourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionOperationMaterialSourcesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-102 Phase 1: Expose AM-030 Material Source for Frontend.
 * @summary Link an allocation to an upstream operation
 */
export const v1ProductionOperationMaterialSourcesCreate = (
    operationMaterialSource: NonReadonly<OperationMaterialSource>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperationMaterialSource>(
      {url: `/api/v1/production/operation-material-sources/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: operationMaterialSource, signal
    },
      );
    }
  


export const getV1ProductionOperationMaterialSourcesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesCreate>>, TError,{data: NonReadonly<OperationMaterialSource>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesCreate>>, TError,{data: NonReadonly<OperationMaterialSource>}, TContext> => {

const mutationKey = ['v1ProductionOperationMaterialSourcesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesCreate>>, {data: NonReadonly<OperationMaterialSource>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionOperationMaterialSourcesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionOperationMaterialSourcesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesCreate>>>
    export type V1ProductionOperationMaterialSourcesCreateMutationBody = NonReadonly<OperationMaterialSource>
    export type V1ProductionOperationMaterialSourcesCreateMutationError = unknown

    /**
 * @summary Link an allocation to an upstream operation
 */
export const useV1ProductionOperationMaterialSourcesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesCreate>>, TError,{data: NonReadonly<OperationMaterialSource>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesCreate>>,
        TError,
        {data: NonReadonly<OperationMaterialSource>},
        TContext
      > => {

      const mutationOptions = getV1ProductionOperationMaterialSourcesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-102 Phase 1: Expose AM-030 Material Source for Frontend.
 * @summary Retrieve a material source link
 */
export const v1ProductionOperationMaterialSourcesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperationMaterialSource>(
      {url: `/api/v1/production/operation-material-sources/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionOperationMaterialSourcesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/operation-material-sources/${id}/`
    ] as const;
    }

    
export const getV1ProductionOperationMaterialSourcesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionOperationMaterialSourcesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>> = ({ signal }) => v1ProductionOperationMaterialSourcesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionOperationMaterialSourcesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>>
export type V1ProductionOperationMaterialSourcesRetrieveQueryError = unknown


export function useV1ProductionOperationMaterialSourcesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionOperationMaterialSourcesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionOperationMaterialSourcesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a material source link
 */

export function useV1ProductionOperationMaterialSourcesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionOperationMaterialSourcesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-102 Phase 1: Expose AM-030 Material Source for Frontend.
 * @summary Delete a material source link
 */
export const v1ProductionOperationMaterialSourcesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/operation-material-sources/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionOperationMaterialSourcesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionOperationMaterialSourcesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionOperationMaterialSourcesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionOperationMaterialSourcesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesDestroy>>>
    
    export type V1ProductionOperationMaterialSourcesDestroyMutationError = unknown

    /**
 * @summary Delete a material source link
 */
export const useV1ProductionOperationMaterialSourcesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionOperationMaterialSourcesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionOperationMaterialSourcesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List production lines for active tenant
 */
export const v1ProductionProductionLinesList = (
    params?: V1ProductionProductionLinesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedProductionLineList>(
      {url: `/api/v1/production/production-lines/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionProductionLinesListQueryKey = (params?: V1ProductionProductionLinesListParams,) => {
    return [
    `/api/v1/production/production-lines/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionProductionLinesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError = unknown>(params?: V1ProductionProductionLinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionProductionLinesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionProductionLinesList>>> = ({ signal }) => v1ProductionProductionLinesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionProductionLinesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionLinesList>>>
export type V1ProductionProductionLinesListQueryError = unknown


export function useV1ProductionProductionLinesList<TData = Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError = unknown>(
 params: undefined |  V1ProductionProductionLinesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionProductionLinesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionProductionLinesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionProductionLinesList<TData = Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError = unknown>(
 params?: V1ProductionProductionLinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionProductionLinesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionProductionLinesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionProductionLinesList<TData = Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError = unknown>(
 params?: V1ProductionProductionLinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List production lines for active tenant
 */

export function useV1ProductionProductionLinesList<TData = Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError = unknown>(
 params?: V1ProductionProductionLinesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionProductionLinesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a new production line
 */
export const v1ProductionProductionLinesCreate = (
    productionLine: NonReadonly<ProductionLine>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionLine>(
      {url: `/api/v1/production/production-lines/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productionLine, signal
    },
      );
    }
  


export const getV1ProductionProductionLinesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesCreate>>, TError,{data: NonReadonly<ProductionLine>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesCreate>>, TError,{data: NonReadonly<ProductionLine>}, TContext> => {

const mutationKey = ['v1ProductionProductionLinesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionLinesCreate>>, {data: NonReadonly<ProductionLine>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionProductionLinesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionLinesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionLinesCreate>>>
    export type V1ProductionProductionLinesCreateMutationBody = NonReadonly<ProductionLine>
    export type V1ProductionProductionLinesCreateMutationError = unknown

    /**
 * @summary Create a new production line
 */
export const useV1ProductionProductionLinesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesCreate>>, TError,{data: NonReadonly<ProductionLine>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionLinesCreate>>,
        TError,
        {data: NonReadonly<ProductionLine>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionLinesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a production line by ID
 */
export const v1ProductionProductionLinesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionLine>(
      {url: `/api/v1/production/production-lines/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionProductionLinesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/production-lines/${id}/`
    ] as const;
    }

    
export const getV1ProductionProductionLinesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionProductionLinesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>> = ({ signal }) => v1ProductionProductionLinesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionProductionLinesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>>
export type V1ProductionProductionLinesRetrieveQueryError = unknown


export function useV1ProductionProductionLinesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionProductionLinesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionProductionLinesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a production line by ID
 */

export function useV1ProductionProductionLinesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionProductionLinesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionProductionLinesUpdate = (
    id: string,
    productionLine: NonReadonly<ProductionLine>,
 ) => {
      
      
      return customAxiosInstance<ProductionLine>(
      {url: `/api/v1/production/production-lines/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productionLine
    },
      );
    }
  


export const getV1ProductionProductionLinesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesUpdate>>, TError,{id: string;data: NonReadonly<ProductionLine>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesUpdate>>, TError,{id: string;data: NonReadonly<ProductionLine>}, TContext> => {

const mutationKey = ['v1ProductionProductionLinesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionLinesUpdate>>, {id: string;data: NonReadonly<ProductionLine>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionLinesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionLinesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionLinesUpdate>>>
    export type V1ProductionProductionLinesUpdateMutationBody = NonReadonly<ProductionLine>
    export type V1ProductionProductionLinesUpdateMutationError = unknown

    export const useV1ProductionProductionLinesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesUpdate>>, TError,{id: string;data: NonReadonly<ProductionLine>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionLinesUpdate>>,
        TError,
        {id: string;data: NonReadonly<ProductionLine>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionLinesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionProductionLinesPartialUpdate = (
    id: string,
    patchedProductionLine: NonReadonly<PatchedProductionLine>,
 ) => {
      
      
      return customAxiosInstance<ProductionLine>(
      {url: `/api/v1/production/production-lines/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProductionLine
    },
      );
    }
  


export const getV1ProductionProductionLinesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedProductionLine>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedProductionLine>}, TContext> => {

const mutationKey = ['v1ProductionProductionLinesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionLinesPartialUpdate>>, {id: string;data: NonReadonly<PatchedProductionLine>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionLinesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionLinesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionLinesPartialUpdate>>>
    export type V1ProductionProductionLinesPartialUpdateMutationBody = NonReadonly<PatchedProductionLine>
    export type V1ProductionProductionLinesPartialUpdateMutationError = unknown

    export const useV1ProductionProductionLinesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedProductionLine>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionLinesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedProductionLine>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionLinesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionProductionLinesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/production-lines/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionProductionLinesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionProductionLinesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionLinesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionProductionLinesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionLinesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionLinesDestroy>>>
    
    export type V1ProductionProductionLinesDestroyMutationError = unknown

    export const useV1ProductionProductionLinesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionLinesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionLinesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionLinesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List production orders for active tenant
 */
export const v1ProductionProductionOrdersList = (
    params?: V1ProductionProductionOrdersListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedProductionOrderList>(
      {url: `/api/v1/production/production-orders/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionProductionOrdersListQueryKey = (params?: V1ProductionProductionOrdersListParams,) => {
    return [
    `/api/v1/production/production-orders/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionProductionOrdersListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError = unknown>(params?: V1ProductionProductionOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionProductionOrdersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>> = ({ signal }) => v1ProductionProductionOrdersList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionProductionOrdersListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>>
export type V1ProductionProductionOrdersListQueryError = unknown


export function useV1ProductionProductionOrdersList<TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError = unknown>(
 params: undefined |  V1ProductionProductionOrdersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionProductionOrdersList<TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError = unknown>(
 params?: V1ProductionProductionOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionProductionOrdersList<TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError = unknown>(
 params?: V1ProductionProductionOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List production orders for active tenant
 */

export function useV1ProductionProductionOrdersList<TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError = unknown>(
 params?: V1ProductionProductionOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionProductionOrdersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a new draft production order
 */
export const v1ProductionProductionOrdersCreate = (
    productionOrder: NonReadonly<ProductionOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productionOrder, signal
    },
      );
    }
  


export const getV1ProductionProductionOrdersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersCreate>>, TError,{data: NonReadonly<ProductionOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersCreate>>, TError,{data: NonReadonly<ProductionOrder>}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersCreate>>, {data: NonReadonly<ProductionOrder>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionProductionOrdersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersCreate>>>
    export type V1ProductionProductionOrdersCreateMutationBody = NonReadonly<ProductionOrder>
    export type V1ProductionProductionOrdersCreateMutationError = unknown

    /**
 * @summary Create a new draft production order
 */
export const useV1ProductionProductionOrdersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersCreate>>, TError,{data: NonReadonly<ProductionOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersCreate>>,
        TError,
        {data: NonReadonly<ProductionOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a production order by ID
 */
export const v1ProductionProductionOrdersRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionProductionOrdersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/production-orders/${id}/`
    ] as const;
    }

    
export const getV1ProductionProductionOrdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionProductionOrdersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>> = ({ signal }) => v1ProductionProductionOrdersRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionProductionOrdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>>
export type V1ProductionProductionOrdersRetrieveQueryError = unknown


export function useV1ProductionProductionOrdersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionProductionOrdersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionProductionOrdersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a production order by ID
 */

export function useV1ProductionProductionOrdersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionProductionOrdersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Update a production order
 */
export const v1ProductionProductionOrdersUpdate = (
    id: string,
    productionOrder: NonReadonly<ProductionOrder>,
 ) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productionOrder
    },
      );
    }
  


export const getV1ProductionProductionOrdersUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersUpdate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersUpdate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersUpdate>>, {id: string;data: NonReadonly<ProductionOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionOrdersUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersUpdate>>>
    export type V1ProductionProductionOrdersUpdateMutationBody = NonReadonly<ProductionOrder>
    export type V1ProductionProductionOrdersUpdateMutationError = unknown

    /**
 * @summary Update a production order
 */
export const useV1ProductionProductionOrdersUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersUpdate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersUpdate>>,
        TError,
        {id: string;data: NonReadonly<ProductionOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionProductionOrdersPartialUpdate = (
    id: string,
    patchedProductionOrder: NonReadonly<PatchedProductionOrder>,
 ) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProductionOrder
    },
      );
    }
  


export const getV1ProductionProductionOrdersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedProductionOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedProductionOrder>}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersPartialUpdate>>, {id: string;data: NonReadonly<PatchedProductionOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionOrdersPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersPartialUpdate>>>
    export type V1ProductionProductionOrdersPartialUpdateMutationBody = NonReadonly<PatchedProductionOrder>
    export type V1ProductionProductionOrdersPartialUpdateMutationError = unknown

    export const useV1ProductionProductionOrdersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedProductionOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedProductionOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionProductionOrdersDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/production-orders/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionProductionOrdersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionProductionOrdersDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersDestroy>>>
    
    export type V1ProductionProductionOrdersDestroyMutationError = unknown

    export const useV1ProductionProductionOrdersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Cancel a production order
 */
export const v1ProductionProductionOrdersCancelCreate = (
    id: string,
    productionOrder: NonReadonly<ProductionOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/cancel/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productionOrder, signal
    },
      );
    }
  


export const getV1ProductionProductionOrdersCancelCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersCancelCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersCancelCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersCancelCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersCancelCreate>>, {id: string;data: NonReadonly<ProductionOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionOrdersCancelCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersCancelCreate>>>
    export type V1ProductionProductionOrdersCancelCreateMutationBody = NonReadonly<ProductionOrder>
    export type V1ProductionProductionOrdersCancelCreateMutationError = unknown

    /**
 * @summary Cancel a production order
 */
export const useV1ProductionProductionOrdersCancelCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersCancelCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersCancelCreate>>,
        TError,
        {id: string;data: NonReadonly<ProductionOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersCancelCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Complete a production order
 */
export const v1ProductionProductionOrdersCompleteCreate = (
    id: string,
    productionOrder: NonReadonly<ProductionOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/complete/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productionOrder, signal
    },
      );
    }
  


export const getV1ProductionProductionOrdersCompleteCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersCompleteCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersCompleteCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersCompleteCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersCompleteCreate>>, {id: string;data: NonReadonly<ProductionOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionOrdersCompleteCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersCompleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersCompleteCreate>>>
    export type V1ProductionProductionOrdersCompleteCreateMutationBody = NonReadonly<ProductionOrder>
    export type V1ProductionProductionOrdersCompleteCreateMutationError = unknown

    /**
 * @summary Complete a production order
 */
export const useV1ProductionProductionOrdersCompleteCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersCompleteCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersCompleteCreate>>,
        TError,
        {id: string;data: NonReadonly<ProductionOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersCompleteCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Hold a production order
 */
export const v1ProductionProductionOrdersHoldCreate = (
    id: string,
    holdOrderRequest: HoldOrderRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/hold/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: holdOrderRequest, signal
    },
      );
    }
  


export const getV1ProductionProductionOrdersHoldCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersHoldCreate>>, TError,{id: string;data: HoldOrderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersHoldCreate>>, TError,{id: string;data: HoldOrderRequest}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersHoldCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersHoldCreate>>, {id: string;data: HoldOrderRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionOrdersHoldCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersHoldCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersHoldCreate>>>
    export type V1ProductionProductionOrdersHoldCreateMutationBody = HoldOrderRequest
    export type V1ProductionProductionOrdersHoldCreateMutationError = unknown

    /**
 * @summary Hold a production order
 */
export const useV1ProductionProductionOrdersHoldCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersHoldCreate>>, TError,{id: string;data: HoldOrderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersHoldCreate>>,
        TError,
        {id: string;data: HoldOrderRequest},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersHoldCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Release a production order
 */
export const v1ProductionProductionOrdersReleaseCreate = (
    id: string,
    productionOrder: NonReadonly<ProductionOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/release/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productionOrder, signal
    },
      );
    }
  


export const getV1ProductionProductionOrdersReleaseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersReleaseCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersReleaseCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersReleaseCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersReleaseCreate>>, {id: string;data: NonReadonly<ProductionOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionOrdersReleaseCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersReleaseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersReleaseCreate>>>
    export type V1ProductionProductionOrdersReleaseCreateMutationBody = NonReadonly<ProductionOrder>
    export type V1ProductionProductionOrdersReleaseCreateMutationError = unknown

    /**
 * @summary Release a production order
 */
export const useV1ProductionProductionOrdersReleaseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersReleaseCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersReleaseCreate>>,
        TError,
        {id: string;data: NonReadonly<ProductionOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersReleaseCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Resume a production order
 */
export const v1ProductionProductionOrdersResumeCreate = (
    id: string,
    productionOrder: NonReadonly<ProductionOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/resume/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productionOrder, signal
    },
      );
    }
  


export const getV1ProductionProductionOrdersResumeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersResumeCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersResumeCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersResumeCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersResumeCreate>>, {id: string;data: NonReadonly<ProductionOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionOrdersResumeCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersResumeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersResumeCreate>>>
    export type V1ProductionProductionOrdersResumeCreateMutationBody = NonReadonly<ProductionOrder>
    export type V1ProductionProductionOrdersResumeCreateMutationError = unknown

    /**
 * @summary Resume a production order
 */
export const useV1ProductionProductionOrdersResumeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersResumeCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersResumeCreate>>,
        TError,
        {id: string;data: NonReadonly<ProductionOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersResumeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Start a production order
 */
export const v1ProductionProductionOrdersStartCreate = (
    id: string,
    productionOrder: NonReadonly<ProductionOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/start/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productionOrder, signal
    },
      );
    }
  


export const getV1ProductionProductionOrdersStartCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersStartCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersStartCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersStartCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersStartCreate>>, {id: string;data: NonReadonly<ProductionOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionOrdersStartCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersStartCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersStartCreate>>>
    export type V1ProductionProductionOrdersStartCreateMutationBody = NonReadonly<ProductionOrder>
    export type V1ProductionProductionOrdersStartCreateMutationError = unknown

    /**
 * @summary Start a production order
 */
export const useV1ProductionProductionOrdersStartCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersStartCreate>>, TError,{id: string;data: NonReadonly<ProductionOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersStartCreate>>,
        TError,
        {id: string;data: NonReadonly<ProductionOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersStartCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Switch product: cancel this order, link the replacement
 */
export const v1ProductionProductionOrdersSwitchProductCreate = (
    id: string,
    switchProductRequest: SwitchProductRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ProductionOrder>(
      {url: `/api/v1/production/production-orders/${id}/switch-product/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: switchProductRequest, signal
    },
      );
    }
  


export const getV1ProductionProductionOrdersSwitchProductCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersSwitchProductCreate>>, TError,{id: string;data: SwitchProductRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersSwitchProductCreate>>, TError,{id: string;data: SwitchProductRequest}, TContext> => {

const mutationKey = ['v1ProductionProductionOrdersSwitchProductCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionProductionOrdersSwitchProductCreate>>, {id: string;data: SwitchProductRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionProductionOrdersSwitchProductCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionProductionOrdersSwitchProductCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionProductionOrdersSwitchProductCreate>>>
    export type V1ProductionProductionOrdersSwitchProductCreateMutationBody = SwitchProductRequest
    export type V1ProductionProductionOrdersSwitchProductCreateMutationError = unknown

    /**
 * @summary Switch product: cancel this order, link the replacement
 */
export const useV1ProductionProductionOrdersSwitchProductCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionProductionOrdersSwitchProductCreate>>, TError,{id: string;data: SwitchProductRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionProductionOrdersSwitchProductCreate>>,
        TError,
        {id: string;data: SwitchProductRequest},
        TContext
      > => {

      const mutationOptions = getV1ProductionProductionOrdersSwitchProductCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List routing families for active tenant
 */
export const v1ProductionRoutingFamiliesList = (
    params?: V1ProductionRoutingFamiliesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedRoutingFamilyList>(
      {url: `/api/v1/production/routing-families/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionRoutingFamiliesListQueryKey = (params?: V1ProductionRoutingFamiliesListParams,) => {
    return [
    `/api/v1/production/routing-families/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionRoutingFamiliesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError = unknown>(params?: V1ProductionRoutingFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingFamiliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>> = ({ signal }) => v1ProductionRoutingFamiliesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingFamiliesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>>
export type V1ProductionRoutingFamiliesListQueryError = unknown


export function useV1ProductionRoutingFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError = unknown>(
 params: undefined |  V1ProductionRoutingFamiliesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError = unknown>(
 params?: V1ProductionRoutingFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError = unknown>(
 params?: V1ProductionRoutingFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List routing families for active tenant
 */

export function useV1ProductionRoutingFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError = unknown>(
 params?: V1ProductionRoutingFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingFamiliesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a new routing family
 */
export const v1ProductionRoutingFamiliesCreate = (
    routingFamily: NonReadonly<RoutingFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingFamily>(
      {url: `/api/v1/production/routing-families/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: routingFamily, signal
    },
      );
    }
  


export const getV1ProductionRoutingFamiliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesCreate>>, TError,{data: NonReadonly<RoutingFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesCreate>>, TError,{data: NonReadonly<RoutingFamily>}, TContext> => {

const mutationKey = ['v1ProductionRoutingFamiliesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesCreate>>, {data: NonReadonly<RoutingFamily>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionRoutingFamiliesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingFamiliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesCreate>>>
    export type V1ProductionRoutingFamiliesCreateMutationBody = NonReadonly<RoutingFamily>
    export type V1ProductionRoutingFamiliesCreateMutationError = unknown

    /**
 * @summary Create a new routing family
 */
export const useV1ProductionRoutingFamiliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesCreate>>, TError,{data: NonReadonly<RoutingFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingFamiliesCreate>>,
        TError,
        {data: NonReadonly<RoutingFamily>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingFamiliesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a routing family by ID
 */
export const v1ProductionRoutingFamiliesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingFamily>(
      {url: `/api/v1/production/routing-families/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionRoutingFamiliesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/routing-families/${id}/`
    ] as const;
    }

    
export const getV1ProductionRoutingFamiliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingFamiliesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>> = ({ signal }) => v1ProductionRoutingFamiliesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingFamiliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>>
export type V1ProductionRoutingFamiliesRetrieveQueryError = unknown


export function useV1ProductionRoutingFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a routing family by ID
 */

export function useV1ProductionRoutingFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingFamiliesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionRoutingFamiliesUpdate = (
    id: string,
    routingFamily: NonReadonly<RoutingFamily>,
 ) => {
      
      
      return customAxiosInstance<RoutingFamily>(
      {url: `/api/v1/production/routing-families/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: routingFamily
    },
      );
    }
  


export const getV1ProductionRoutingFamiliesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesUpdate>>, TError,{id: string;data: NonReadonly<RoutingFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesUpdate>>, TError,{id: string;data: NonReadonly<RoutingFamily>}, TContext> => {

const mutationKey = ['v1ProductionRoutingFamiliesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesUpdate>>, {id: string;data: NonReadonly<RoutingFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingFamiliesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingFamiliesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesUpdate>>>
    export type V1ProductionRoutingFamiliesUpdateMutationBody = NonReadonly<RoutingFamily>
    export type V1ProductionRoutingFamiliesUpdateMutationError = unknown

    export const useV1ProductionRoutingFamiliesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesUpdate>>, TError,{id: string;data: NonReadonly<RoutingFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingFamiliesUpdate>>,
        TError,
        {id: string;data: NonReadonly<RoutingFamily>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingFamiliesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionRoutingFamiliesPartialUpdate = (
    id: string,
    patchedRoutingFamily: NonReadonly<PatchedRoutingFamily>,
 ) => {
      
      
      return customAxiosInstance<RoutingFamily>(
      {url: `/api/v1/production/routing-families/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRoutingFamily
    },
      );
    }
  


export const getV1ProductionRoutingFamiliesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingFamily>}, TContext> => {

const mutationKey = ['v1ProductionRoutingFamiliesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesPartialUpdate>>, {id: string;data: NonReadonly<PatchedRoutingFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingFamiliesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingFamiliesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesPartialUpdate>>>
    export type V1ProductionRoutingFamiliesPartialUpdateMutationBody = NonReadonly<PatchedRoutingFamily>
    export type V1ProductionRoutingFamiliesPartialUpdateMutationError = unknown

    export const useV1ProductionRoutingFamiliesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingFamiliesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedRoutingFamily>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingFamiliesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionRoutingFamiliesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/routing-families/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionRoutingFamiliesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionRoutingFamiliesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionRoutingFamiliesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingFamiliesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesDestroy>>>
    
    export type V1ProductionRoutingFamiliesDestroyMutationError = unknown

    export const useV1ProductionRoutingFamiliesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingFamiliesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingFamiliesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingFamiliesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-030: CRUD for the routing operation dependency graph.
Registered with DefaultRouter per project architectural constraint
("Never SimpleRouter — only DefaultRouter").
 */
export const v1ProductionRoutingOperationDependenciesList = (
    params?: V1ProductionRoutingOperationDependenciesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedRoutingOperationDependencyList>(
      {url: `/api/v1/production/routing-operation-dependencies/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionRoutingOperationDependenciesListQueryKey = (params?: V1ProductionRoutingOperationDependenciesListParams,) => {
    return [
    `/api/v1/production/routing-operation-dependencies/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionRoutingOperationDependenciesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError = unknown>(params?: V1ProductionRoutingOperationDependenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingOperationDependenciesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>> = ({ signal }) => v1ProductionRoutingOperationDependenciesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingOperationDependenciesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>>
export type V1ProductionRoutingOperationDependenciesListQueryError = unknown


export function useV1ProductionRoutingOperationDependenciesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError = unknown>(
 params: undefined |  V1ProductionRoutingOperationDependenciesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationDependenciesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError = unknown>(
 params?: V1ProductionRoutingOperationDependenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationDependenciesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError = unknown>(
 params?: V1ProductionRoutingOperationDependenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionRoutingOperationDependenciesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError = unknown>(
 params?: V1ProductionRoutingOperationDependenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingOperationDependenciesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-030: CRUD for the routing operation dependency graph.
Registered with DefaultRouter per project architectural constraint
("Never SimpleRouter — only DefaultRouter").
 */
export const v1ProductionRoutingOperationDependenciesCreate = (
    routingOperationDependency: NonReadonly<RoutingOperationDependency>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingOperationDependency>(
      {url: `/api/v1/production/routing-operation-dependencies/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: routingOperationDependency, signal
    },
      );
    }
  


export const getV1ProductionRoutingOperationDependenciesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesCreate>>, TError,{data: NonReadonly<RoutingOperationDependency>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesCreate>>, TError,{data: NonReadonly<RoutingOperationDependency>}, TContext> => {

const mutationKey = ['v1ProductionRoutingOperationDependenciesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesCreate>>, {data: NonReadonly<RoutingOperationDependency>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionRoutingOperationDependenciesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingOperationDependenciesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesCreate>>>
    export type V1ProductionRoutingOperationDependenciesCreateMutationBody = NonReadonly<RoutingOperationDependency>
    export type V1ProductionRoutingOperationDependenciesCreateMutationError = unknown

    export const useV1ProductionRoutingOperationDependenciesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesCreate>>, TError,{data: NonReadonly<RoutingOperationDependency>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesCreate>>,
        TError,
        {data: NonReadonly<RoutingOperationDependency>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingOperationDependenciesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-030: CRUD for the routing operation dependency graph.
Registered with DefaultRouter per project architectural constraint
("Never SimpleRouter — only DefaultRouter").
 */
export const v1ProductionRoutingOperationDependenciesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingOperationDependency>(
      {url: `/api/v1/production/routing-operation-dependencies/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionRoutingOperationDependenciesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/routing-operation-dependencies/${id}/`
    ] as const;
    }

    
export const getV1ProductionRoutingOperationDependenciesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingOperationDependenciesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>> = ({ signal }) => v1ProductionRoutingOperationDependenciesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingOperationDependenciesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>>
export type V1ProductionRoutingOperationDependenciesRetrieveQueryError = unknown


export function useV1ProductionRoutingOperationDependenciesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationDependenciesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationDependenciesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionRoutingOperationDependenciesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingOperationDependenciesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-030: CRUD for the routing operation dependency graph.
Registered with DefaultRouter per project architectural constraint
("Never SimpleRouter — only DefaultRouter").
 */
export const v1ProductionRoutingOperationDependenciesUpdate = (
    id: string,
    routingOperationDependency: NonReadonly<RoutingOperationDependency>,
 ) => {
      
      
      return customAxiosInstance<RoutingOperationDependency>(
      {url: `/api/v1/production/routing-operation-dependencies/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: routingOperationDependency
    },
      );
    }
  


export const getV1ProductionRoutingOperationDependenciesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesUpdate>>, TError,{id: string;data: NonReadonly<RoutingOperationDependency>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesUpdate>>, TError,{id: string;data: NonReadonly<RoutingOperationDependency>}, TContext> => {

const mutationKey = ['v1ProductionRoutingOperationDependenciesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesUpdate>>, {id: string;data: NonReadonly<RoutingOperationDependency>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingOperationDependenciesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingOperationDependenciesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesUpdate>>>
    export type V1ProductionRoutingOperationDependenciesUpdateMutationBody = NonReadonly<RoutingOperationDependency>
    export type V1ProductionRoutingOperationDependenciesUpdateMutationError = unknown

    export const useV1ProductionRoutingOperationDependenciesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesUpdate>>, TError,{id: string;data: NonReadonly<RoutingOperationDependency>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesUpdate>>,
        TError,
        {id: string;data: NonReadonly<RoutingOperationDependency>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingOperationDependenciesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-030: CRUD for the routing operation dependency graph.
Registered with DefaultRouter per project architectural constraint
("Never SimpleRouter — only DefaultRouter").
 */
export const v1ProductionRoutingOperationDependenciesPartialUpdate = (
    id: string,
    patchedRoutingOperationDependency: NonReadonly<PatchedRoutingOperationDependency>,
 ) => {
      
      
      return customAxiosInstance<RoutingOperationDependency>(
      {url: `/api/v1/production/routing-operation-dependencies/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRoutingOperationDependency
    },
      );
    }
  


export const getV1ProductionRoutingOperationDependenciesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingOperationDependency>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingOperationDependency>}, TContext> => {

const mutationKey = ['v1ProductionRoutingOperationDependenciesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesPartialUpdate>>, {id: string;data: NonReadonly<PatchedRoutingOperationDependency>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingOperationDependenciesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingOperationDependenciesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesPartialUpdate>>>
    export type V1ProductionRoutingOperationDependenciesPartialUpdateMutationBody = NonReadonly<PatchedRoutingOperationDependency>
    export type V1ProductionRoutingOperationDependenciesPartialUpdateMutationError = unknown

    export const useV1ProductionRoutingOperationDependenciesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingOperationDependency>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedRoutingOperationDependency>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingOperationDependenciesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-030: CRUD for the routing operation dependency graph.
Registered with DefaultRouter per project architectural constraint
("Never SimpleRouter — only DefaultRouter").
 */
export const v1ProductionRoutingOperationDependenciesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/routing-operation-dependencies/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionRoutingOperationDependenciesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionRoutingOperationDependenciesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionRoutingOperationDependenciesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingOperationDependenciesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesDestroy>>>
    
    export type V1ProductionRoutingOperationDependenciesDestroyMutationError = unknown

    export const useV1ProductionRoutingOperationDependenciesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingOperationDependenciesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingOperationDependenciesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary List routing operations
 */
export const v1ProductionRoutingOperationsList = (
    params?: V1ProductionRoutingOperationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedRoutingOperationList>(
      {url: `/api/v1/production/routing-operations/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionRoutingOperationsListQueryKey = (params?: V1ProductionRoutingOperationsListParams,) => {
    return [
    `/api/v1/production/routing-operations/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionRoutingOperationsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError = unknown>(params?: V1ProductionRoutingOperationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingOperationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>> = ({ signal }) => v1ProductionRoutingOperationsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingOperationsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>>
export type V1ProductionRoutingOperationsListQueryError = unknown


export function useV1ProductionRoutingOperationsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError = unknown>(
 params: undefined |  V1ProductionRoutingOperationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError = unknown>(
 params?: V1ProductionRoutingOperationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError = unknown>(
 params?: V1ProductionRoutingOperationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List routing operations
 */

export function useV1ProductionRoutingOperationsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError = unknown>(
 params?: V1ProductionRoutingOperationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingOperationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Add an operation to a routing revision
 */
export const v1ProductionRoutingOperationsCreate = (
    routingOperation: NonReadonly<RoutingOperation>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingOperation>(
      {url: `/api/v1/production/routing-operations/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: routingOperation, signal
    },
      );
    }
  


export const getV1ProductionRoutingOperationsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsCreate>>, TError,{data: NonReadonly<RoutingOperation>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsCreate>>, TError,{data: NonReadonly<RoutingOperation>}, TContext> => {

const mutationKey = ['v1ProductionRoutingOperationsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsCreate>>, {data: NonReadonly<RoutingOperation>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionRoutingOperationsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingOperationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsCreate>>>
    export type V1ProductionRoutingOperationsCreateMutationBody = NonReadonly<RoutingOperation>
    export type V1ProductionRoutingOperationsCreateMutationError = unknown

    /**
 * @summary Add an operation to a routing revision
 */
export const useV1ProductionRoutingOperationsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsCreate>>, TError,{data: NonReadonly<RoutingOperation>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingOperationsCreate>>,
        TError,
        {data: NonReadonly<RoutingOperation>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingOperationsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-030: read/update `upstream_join_type` on a RoutingOperation.
 */
export const v1ProductionRoutingOperationsJoinTypeList = (
    params?: V1ProductionRoutingOperationsJoinTypeListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedRoutingOperationJoinTypeList>(
      {url: `/api/v1/production/routing-operations-join-type/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionRoutingOperationsJoinTypeListQueryKey = (params?: V1ProductionRoutingOperationsJoinTypeListParams,) => {
    return [
    `/api/v1/production/routing-operations-join-type/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionRoutingOperationsJoinTypeListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError = unknown>(params?: V1ProductionRoutingOperationsJoinTypeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingOperationsJoinTypeListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>> = ({ signal }) => v1ProductionRoutingOperationsJoinTypeList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingOperationsJoinTypeListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>>
export type V1ProductionRoutingOperationsJoinTypeListQueryError = unknown


export function useV1ProductionRoutingOperationsJoinTypeList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError = unknown>(
 params: undefined |  V1ProductionRoutingOperationsJoinTypeListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsJoinTypeList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError = unknown>(
 params?: V1ProductionRoutingOperationsJoinTypeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsJoinTypeList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError = unknown>(
 params?: V1ProductionRoutingOperationsJoinTypeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionRoutingOperationsJoinTypeList<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError = unknown>(
 params?: V1ProductionRoutingOperationsJoinTypeListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingOperationsJoinTypeListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-030: read/update `upstream_join_type` on a RoutingOperation.
 */
export const v1ProductionRoutingOperationsJoinTypeRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingOperationJoinType>(
      {url: `/api/v1/production/routing-operations-join-type/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionRoutingOperationsJoinTypeRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/routing-operations-join-type/${id}/`
    ] as const;
    }

    
export const getV1ProductionRoutingOperationsJoinTypeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingOperationsJoinTypeRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>> = ({ signal }) => v1ProductionRoutingOperationsJoinTypeRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingOperationsJoinTypeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>>
export type V1ProductionRoutingOperationsJoinTypeRetrieveQueryError = unknown


export function useV1ProductionRoutingOperationsJoinTypeRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsJoinTypeRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsJoinTypeRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionRoutingOperationsJoinTypeRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingOperationsJoinTypeRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-030: read/update `upstream_join_type` on a RoutingOperation.
 */
export const v1ProductionRoutingOperationsJoinTypePartialUpdate = (
    id: string,
    patchedRoutingOperationJoinType: NonReadonly<PatchedRoutingOperationJoinType>,
 ) => {
      
      
      return customAxiosInstance<RoutingOperationJoinType>(
      {url: `/api/v1/production/routing-operations-join-type/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRoutingOperationJoinType
    },
      );
    }
  


export const getV1ProductionRoutingOperationsJoinTypePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypePartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingOperationJoinType>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypePartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingOperationJoinType>}, TContext> => {

const mutationKey = ['v1ProductionRoutingOperationsJoinTypePartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypePartialUpdate>>, {id: string;data: NonReadonly<PatchedRoutingOperationJoinType>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingOperationsJoinTypePartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingOperationsJoinTypePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypePartialUpdate>>>
    export type V1ProductionRoutingOperationsJoinTypePartialUpdateMutationBody = NonReadonly<PatchedRoutingOperationJoinType>
    export type V1ProductionRoutingOperationsJoinTypePartialUpdateMutationError = unknown

    export const useV1ProductionRoutingOperationsJoinTypePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypePartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingOperationJoinType>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypePartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedRoutingOperationJoinType>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingOperationsJoinTypePartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-030 §3.4 utility endpoint: given `completed_operation_ids` as a
repeated query param, returns whether this operation is ready to
start. Intended for manual/QA inspection and for the frontend
dependency-graph editor's "preview" mode — the authoritative
real-time decision during execution belongs to ADR-102's
Shopfloor Execution state machine, which calls
`services.readiness.is_ready_to_start` directly.
 */
export const v1ProductionRoutingOperationsJoinTypeReadinessRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingOperationJoinType>(
      {url: `/api/v1/production/routing-operations-join-type/${id}/readiness/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionRoutingOperationsJoinTypeReadinessRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/routing-operations-join-type/${id}/readiness/`
    ] as const;
    }

    
export const getV1ProductionRoutingOperationsJoinTypeReadinessRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingOperationsJoinTypeReadinessRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>> = ({ signal }) => v1ProductionRoutingOperationsJoinTypeReadinessRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingOperationsJoinTypeReadinessRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>>
export type V1ProductionRoutingOperationsJoinTypeReadinessRetrieveQueryError = unknown


export function useV1ProductionRoutingOperationsJoinTypeReadinessRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsJoinTypeReadinessRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsJoinTypeReadinessRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionRoutingOperationsJoinTypeReadinessRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsJoinTypeReadinessRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingOperationsJoinTypeReadinessRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Retrieve a routing operation
 */
export const v1ProductionRoutingOperationsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingOperation>(
      {url: `/api/v1/production/routing-operations/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionRoutingOperationsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/routing-operations/${id}/`
    ] as const;
    }

    
export const getV1ProductionRoutingOperationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingOperationsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>> = ({ signal }) => v1ProductionRoutingOperationsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingOperationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>>
export type V1ProductionRoutingOperationsRetrieveQueryError = unknown


export function useV1ProductionRoutingOperationsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingOperationsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a routing operation
 */

export function useV1ProductionRoutingOperationsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingOperationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Update a routing operation
 */
export const v1ProductionRoutingOperationsUpdate = (
    id: string,
    routingOperation: NonReadonly<RoutingOperation>,
 ) => {
      
      
      return customAxiosInstance<RoutingOperation>(
      {url: `/api/v1/production/routing-operations/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: routingOperation
    },
      );
    }
  


export const getV1ProductionRoutingOperationsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsUpdate>>, TError,{id: string;data: NonReadonly<RoutingOperation>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsUpdate>>, TError,{id: string;data: NonReadonly<RoutingOperation>}, TContext> => {

const mutationKey = ['v1ProductionRoutingOperationsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsUpdate>>, {id: string;data: NonReadonly<RoutingOperation>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingOperationsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingOperationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsUpdate>>>
    export type V1ProductionRoutingOperationsUpdateMutationBody = NonReadonly<RoutingOperation>
    export type V1ProductionRoutingOperationsUpdateMutationError = unknown

    /**
 * @summary Update a routing operation
 */
export const useV1ProductionRoutingOperationsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsUpdate>>, TError,{id: string;data: NonReadonly<RoutingOperation>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingOperationsUpdate>>,
        TError,
        {id: string;data: NonReadonly<RoutingOperation>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingOperationsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Partially update a routing operation
 */
export const v1ProductionRoutingOperationsPartialUpdate = (
    id: string,
    patchedRoutingOperation: NonReadonly<PatchedRoutingOperation>,
 ) => {
      
      
      return customAxiosInstance<RoutingOperation>(
      {url: `/api/v1/production/routing-operations/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRoutingOperation
    },
      );
    }
  


export const getV1ProductionRoutingOperationsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingOperation>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingOperation>}, TContext> => {

const mutationKey = ['v1ProductionRoutingOperationsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsPartialUpdate>>, {id: string;data: NonReadonly<PatchedRoutingOperation>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingOperationsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingOperationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsPartialUpdate>>>
    export type V1ProductionRoutingOperationsPartialUpdateMutationBody = NonReadonly<PatchedRoutingOperation>
    export type V1ProductionRoutingOperationsPartialUpdateMutationError = unknown

    /**
 * @summary Partially update a routing operation
 */
export const useV1ProductionRoutingOperationsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingOperation>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingOperationsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedRoutingOperation>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingOperationsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Remove an operation from a routing revision
 */
export const v1ProductionRoutingOperationsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/routing-operations/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionRoutingOperationsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionRoutingOperationsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingOperationsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionRoutingOperationsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingOperationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingOperationsDestroy>>>
    
    export type V1ProductionRoutingOperationsDestroyMutationError = unknown

    /**
 * @summary Remove an operation from a routing revision
 */
export const useV1ProductionRoutingOperationsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingOperationsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingOperationsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingOperationsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary List routing revisions for active tenant
 */
export const v1ProductionRoutingRevisionsList = (
    params?: V1ProductionRoutingRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedRoutingRevisionList>(
      {url: `/api/v1/production/routing-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionRoutingRevisionsListQueryKey = (params?: V1ProductionRoutingRevisionsListParams,) => {
    return [
    `/api/v1/production/routing-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionRoutingRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError = unknown>(params?: V1ProductionRoutingRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>> = ({ signal }) => v1ProductionRoutingRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>>
export type V1ProductionRoutingRevisionsListQueryError = unknown


export function useV1ProductionRoutingRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError = unknown>(
 params: undefined |  V1ProductionRoutingRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError = unknown>(
 params?: V1ProductionRoutingRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError = unknown>(
 params?: V1ProductionRoutingRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List routing revisions for active tenant
 */

export function useV1ProductionRoutingRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError = unknown>(
 params?: V1ProductionRoutingRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Create a new draft routing revision
 */
export const v1ProductionRoutingRevisionsCreate = (
    routingRevision: NonReadonly<RoutingRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingRevision>(
      {url: `/api/v1/production/routing-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: routingRevision, signal
    },
      );
    }
  


export const getV1ProductionRoutingRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsCreate>>, TError,{data: NonReadonly<RoutingRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsCreate>>, TError,{data: NonReadonly<RoutingRevision>}, TContext> => {

const mutationKey = ['v1ProductionRoutingRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsCreate>>, {data: NonReadonly<RoutingRevision>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionRoutingRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsCreate>>>
    export type V1ProductionRoutingRevisionsCreateMutationBody = NonReadonly<RoutingRevision>
    export type V1ProductionRoutingRevisionsCreateMutationError = unknown

    /**
 * @summary Create a new draft routing revision
 */
export const useV1ProductionRoutingRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsCreate>>, TError,{data: NonReadonly<RoutingRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingRevisionsCreate>>,
        TError,
        {data: NonReadonly<RoutingRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Retrieve a routing revision by ID
 */
export const v1ProductionRoutingRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingRevision>(
      {url: `/api/v1/production/routing-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionRoutingRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/routing-revisions/${id}/`
    ] as const;
    }

    
export const getV1ProductionRoutingRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>> = ({ signal }) => v1ProductionRoutingRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>>
export type V1ProductionRoutingRevisionsRetrieveQueryError = unknown


export function useV1ProductionRoutingRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a routing revision by ID
 */

export function useV1ProductionRoutingRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1ProductionRoutingRevisionsUpdate = (
    id: string,
    routingRevision: NonReadonly<RoutingRevision>,
 ) => {
      
      
      return customAxiosInstance<RoutingRevision>(
      {url: `/api/v1/production/routing-revisions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: routingRevision
    },
      );
    }
  


export const getV1ProductionRoutingRevisionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsUpdate>>, TError,{id: string;data: NonReadonly<RoutingRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsUpdate>>, TError,{id: string;data: NonReadonly<RoutingRevision>}, TContext> => {

const mutationKey = ['v1ProductionRoutingRevisionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsUpdate>>, {id: string;data: NonReadonly<RoutingRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingRevisionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingRevisionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsUpdate>>>
    export type V1ProductionRoutingRevisionsUpdateMutationBody = NonReadonly<RoutingRevision>
    export type V1ProductionRoutingRevisionsUpdateMutationError = unknown

    export const useV1ProductionRoutingRevisionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsUpdate>>, TError,{id: string;data: NonReadonly<RoutingRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingRevisionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<RoutingRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingRevisionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1ProductionRoutingRevisionsPartialUpdate = (
    id: string,
    patchedRoutingRevision: NonReadonly<PatchedRoutingRevision>,
 ) => {
      
      
      return customAxiosInstance<RoutingRevision>(
      {url: `/api/v1/production/routing-revisions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRoutingRevision
    },
      );
    }
  


export const getV1ProductionRoutingRevisionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingRevision>}, TContext> => {

const mutationKey = ['v1ProductionRoutingRevisionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedRoutingRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingRevisionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPartialUpdate>>>
    export type V1ProductionRoutingRevisionsPartialUpdateMutationBody = NonReadonly<PatchedRoutingRevision>
    export type V1ProductionRoutingRevisionsPartialUpdateMutationError = unknown

    export const useV1ProductionRoutingRevisionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoutingRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedRoutingRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingRevisionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1ProductionRoutingRevisionsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/routing-revisions/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionRoutingRevisionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionRoutingRevisionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionRoutingRevisionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingRevisionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsDestroy>>>
    
    export type V1ProductionRoutingRevisionsDestroyMutationError = unknown

    export const useV1ProductionRoutingRevisionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingRevisionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingRevisionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Publish a routing revision (immutable afterward)
 */
export const v1ProductionRoutingRevisionsPublishCreate = (
    id: string,
    routingRevision: NonReadonly<RoutingRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RoutingRevision>(
      {url: `/api/v1/production/routing-revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: routingRevision, signal
    },
      );
    }
  


export const getV1ProductionRoutingRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<RoutingRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<RoutingRevision>}, TContext> => {

const mutationKey = ['v1ProductionRoutingRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPublishCreate>>, {id: string;data: NonReadonly<RoutingRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPublishCreate>>>
    export type V1ProductionRoutingRevisionsPublishCreateMutationBody = NonReadonly<RoutingRevision>
    export type V1ProductionRoutingRevisionsPublishCreateMutationError = unknown

    /**
 * @summary Publish a routing revision (immutable afterward)
 */
export const useV1ProductionRoutingRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<RoutingRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<RoutingRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-028: مدیریت SOP در ماژول مهندسی Routing (نه Shopfloor).
 */
export const v1ProductionRoutingWorkInstructionFamiliesList = (
    params?: V1ProductionRoutingWorkInstructionFamiliesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkInstructionFamilyList>(
      {url: `/api/v1/production/routing/work-instruction-families/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionRoutingWorkInstructionFamiliesListQueryKey = (params?: V1ProductionRoutingWorkInstructionFamiliesListParams,) => {
    return [
    `/api/v1/production/routing/work-instruction-families/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionRoutingWorkInstructionFamiliesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError = unknown>(params?: V1ProductionRoutingWorkInstructionFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingWorkInstructionFamiliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>> = ({ signal }) => v1ProductionRoutingWorkInstructionFamiliesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingWorkInstructionFamiliesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>>
export type V1ProductionRoutingWorkInstructionFamiliesListQueryError = unknown


export function useV1ProductionRoutingWorkInstructionFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError = unknown>(
 params: undefined |  V1ProductionRoutingWorkInstructionFamiliesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingWorkInstructionFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError = unknown>(
 params?: V1ProductionRoutingWorkInstructionFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingWorkInstructionFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError = unknown>(
 params?: V1ProductionRoutingWorkInstructionFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionRoutingWorkInstructionFamiliesList<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError = unknown>(
 params?: V1ProductionRoutingWorkInstructionFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingWorkInstructionFamiliesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-028: مدیریت SOP در ماژول مهندسی Routing (نه Shopfloor).
 */
export const v1ProductionRoutingWorkInstructionFamiliesCreate = (
    workInstructionFamily: NonReadonly<WorkInstructionFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkInstructionFamily>(
      {url: `/api/v1/production/routing/work-instruction-families/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workInstructionFamily, signal
    },
      );
    }
  


export const getV1ProductionRoutingWorkInstructionFamiliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesCreate>>, TError,{data: NonReadonly<WorkInstructionFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesCreate>>, TError,{data: NonReadonly<WorkInstructionFamily>}, TContext> => {

const mutationKey = ['v1ProductionRoutingWorkInstructionFamiliesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesCreate>>, {data: NonReadonly<WorkInstructionFamily>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionRoutingWorkInstructionFamiliesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingWorkInstructionFamiliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesCreate>>>
    export type V1ProductionRoutingWorkInstructionFamiliesCreateMutationBody = NonReadonly<WorkInstructionFamily>
    export type V1ProductionRoutingWorkInstructionFamiliesCreateMutationError = unknown

    export const useV1ProductionRoutingWorkInstructionFamiliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesCreate>>, TError,{data: NonReadonly<WorkInstructionFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesCreate>>,
        TError,
        {data: NonReadonly<WorkInstructionFamily>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingWorkInstructionFamiliesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-028: مدیریت SOP در ماژول مهندسی Routing (نه Shopfloor).
 */
export const v1ProductionRoutingWorkInstructionFamiliesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkInstructionFamily>(
      {url: `/api/v1/production/routing/work-instruction-families/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionRoutingWorkInstructionFamiliesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/routing/work-instruction-families/${id}/`
    ] as const;
    }

    
export const getV1ProductionRoutingWorkInstructionFamiliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingWorkInstructionFamiliesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>> = ({ signal }) => v1ProductionRoutingWorkInstructionFamiliesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingWorkInstructionFamiliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>>
export type V1ProductionRoutingWorkInstructionFamiliesRetrieveQueryError = unknown


export function useV1ProductionRoutingWorkInstructionFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingWorkInstructionFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingWorkInstructionFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionRoutingWorkInstructionFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingWorkInstructionFamiliesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-028: مدیریت SOP در ماژول مهندسی Routing (نه Shopfloor).
 */
export const v1ProductionRoutingWorkInstructionFamiliesUpdate = (
    id: string,
    workInstructionFamily: NonReadonly<WorkInstructionFamily>,
 ) => {
      
      
      return customAxiosInstance<WorkInstructionFamily>(
      {url: `/api/v1/production/routing/work-instruction-families/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workInstructionFamily
    },
      );
    }
  


export const getV1ProductionRoutingWorkInstructionFamiliesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesUpdate>>, TError,{id: string;data: NonReadonly<WorkInstructionFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesUpdate>>, TError,{id: string;data: NonReadonly<WorkInstructionFamily>}, TContext> => {

const mutationKey = ['v1ProductionRoutingWorkInstructionFamiliesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesUpdate>>, {id: string;data: NonReadonly<WorkInstructionFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingWorkInstructionFamiliesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingWorkInstructionFamiliesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesUpdate>>>
    export type V1ProductionRoutingWorkInstructionFamiliesUpdateMutationBody = NonReadonly<WorkInstructionFamily>
    export type V1ProductionRoutingWorkInstructionFamiliesUpdateMutationError = unknown

    export const useV1ProductionRoutingWorkInstructionFamiliesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesUpdate>>, TError,{id: string;data: NonReadonly<WorkInstructionFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesUpdate>>,
        TError,
        {id: string;data: NonReadonly<WorkInstructionFamily>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingWorkInstructionFamiliesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-028: مدیریت SOP در ماژول مهندسی Routing (نه Shopfloor).
 */
export const v1ProductionRoutingWorkInstructionFamiliesPartialUpdate = (
    id: string,
    patchedWorkInstructionFamily: NonReadonly<PatchedWorkInstructionFamily>,
 ) => {
      
      
      return customAxiosInstance<WorkInstructionFamily>(
      {url: `/api/v1/production/routing/work-instruction-families/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWorkInstructionFamily
    },
      );
    }
  


export const getV1ProductionRoutingWorkInstructionFamiliesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkInstructionFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkInstructionFamily>}, TContext> => {

const mutationKey = ['v1ProductionRoutingWorkInstructionFamiliesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesPartialUpdate>>, {id: string;data: NonReadonly<PatchedWorkInstructionFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingWorkInstructionFamiliesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingWorkInstructionFamiliesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesPartialUpdate>>>
    export type V1ProductionRoutingWorkInstructionFamiliesPartialUpdateMutationBody = NonReadonly<PatchedWorkInstructionFamily>
    export type V1ProductionRoutingWorkInstructionFamiliesPartialUpdateMutationError = unknown

    export const useV1ProductionRoutingWorkInstructionFamiliesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkInstructionFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedWorkInstructionFamily>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingWorkInstructionFamiliesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-028: مدیریت SOP در ماژول مهندسی Routing (نه Shopfloor).
 */
export const v1ProductionRoutingWorkInstructionFamiliesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/routing/work-instruction-families/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionRoutingWorkInstructionFamiliesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionRoutingWorkInstructionFamiliesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionRoutingWorkInstructionFamiliesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingWorkInstructionFamiliesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesDestroy>>>
    
    export type V1ProductionRoutingWorkInstructionFamiliesDestroyMutationError = unknown

    export const useV1ProductionRoutingWorkInstructionFamiliesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionFamiliesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingWorkInstructionFamiliesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-028: ایجاد نسخهٔ Draft جدید + انتشار (publish).
 */
export const v1ProductionRoutingWorkInstructionRevisionsList = (
    params?: V1ProductionRoutingWorkInstructionRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkInstructionRevisionList>(
      {url: `/api/v1/production/routing/work-instruction-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionRoutingWorkInstructionRevisionsListQueryKey = (params?: V1ProductionRoutingWorkInstructionRevisionsListParams,) => {
    return [
    `/api/v1/production/routing/work-instruction-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionRoutingWorkInstructionRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError = unknown>(params?: V1ProductionRoutingWorkInstructionRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingWorkInstructionRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>> = ({ signal }) => v1ProductionRoutingWorkInstructionRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingWorkInstructionRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>>
export type V1ProductionRoutingWorkInstructionRevisionsListQueryError = unknown


export function useV1ProductionRoutingWorkInstructionRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError = unknown>(
 params: undefined |  V1ProductionRoutingWorkInstructionRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingWorkInstructionRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError = unknown>(
 params?: V1ProductionRoutingWorkInstructionRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingWorkInstructionRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError = unknown>(
 params?: V1ProductionRoutingWorkInstructionRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionRoutingWorkInstructionRevisionsList<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError = unknown>(
 params?: V1ProductionRoutingWorkInstructionRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingWorkInstructionRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-028: ایجاد نسخهٔ Draft جدید + انتشار (publish).
 */
export const v1ProductionRoutingWorkInstructionRevisionsCreate = (
    workInstructionRevision: NonReadonly<WorkInstructionRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkInstructionRevision>(
      {url: `/api/v1/production/routing/work-instruction-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workInstructionRevision, signal
    },
      );
    }
  


export const getV1ProductionRoutingWorkInstructionRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsCreate>>, TError,{data: NonReadonly<WorkInstructionRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsCreate>>, TError,{data: NonReadonly<WorkInstructionRevision>}, TContext> => {

const mutationKey = ['v1ProductionRoutingWorkInstructionRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsCreate>>, {data: NonReadonly<WorkInstructionRevision>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionRoutingWorkInstructionRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingWorkInstructionRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsCreate>>>
    export type V1ProductionRoutingWorkInstructionRevisionsCreateMutationBody = NonReadonly<WorkInstructionRevision>
    export type V1ProductionRoutingWorkInstructionRevisionsCreateMutationError = unknown

    export const useV1ProductionRoutingWorkInstructionRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsCreate>>, TError,{data: NonReadonly<WorkInstructionRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsCreate>>,
        TError,
        {data: NonReadonly<WorkInstructionRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingWorkInstructionRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-028: ایجاد نسخهٔ Draft جدید + انتشار (publish).
 */
export const v1ProductionRoutingWorkInstructionRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkInstructionRevision>(
      {url: `/api/v1/production/routing/work-instruction-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionRoutingWorkInstructionRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/routing/work-instruction-revisions/${id}/`
    ] as const;
    }

    
export const getV1ProductionRoutingWorkInstructionRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionRoutingWorkInstructionRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>> = ({ signal }) => v1ProductionRoutingWorkInstructionRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionRoutingWorkInstructionRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>>
export type V1ProductionRoutingWorkInstructionRevisionsRetrieveQueryError = unknown


export function useV1ProductionRoutingWorkInstructionRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingWorkInstructionRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionRoutingWorkInstructionRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionRoutingWorkInstructionRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionRoutingWorkInstructionRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-028: ایجاد نسخهٔ Draft جدید + انتشار (publish).
 */
export const v1ProductionRoutingWorkInstructionRevisionsUpdate = (
    id: string,
    workInstructionRevision: NonReadonly<WorkInstructionRevision>,
 ) => {
      
      
      return customAxiosInstance<WorkInstructionRevision>(
      {url: `/api/v1/production/routing/work-instruction-revisions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workInstructionRevision
    },
      );
    }
  


export const getV1ProductionRoutingWorkInstructionRevisionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsUpdate>>, TError,{id: string;data: NonReadonly<WorkInstructionRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsUpdate>>, TError,{id: string;data: NonReadonly<WorkInstructionRevision>}, TContext> => {

const mutationKey = ['v1ProductionRoutingWorkInstructionRevisionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsUpdate>>, {id: string;data: NonReadonly<WorkInstructionRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingWorkInstructionRevisionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingWorkInstructionRevisionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsUpdate>>>
    export type V1ProductionRoutingWorkInstructionRevisionsUpdateMutationBody = NonReadonly<WorkInstructionRevision>
    export type V1ProductionRoutingWorkInstructionRevisionsUpdateMutationError = unknown

    export const useV1ProductionRoutingWorkInstructionRevisionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsUpdate>>, TError,{id: string;data: NonReadonly<WorkInstructionRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<WorkInstructionRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingWorkInstructionRevisionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-028: ایجاد نسخهٔ Draft جدید + انتشار (publish).
 */
export const v1ProductionRoutingWorkInstructionRevisionsPartialUpdate = (
    id: string,
    patchedWorkInstructionRevision: NonReadonly<PatchedWorkInstructionRevision>,
 ) => {
      
      
      return customAxiosInstance<WorkInstructionRevision>(
      {url: `/api/v1/production/routing/work-instruction-revisions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWorkInstructionRevision
    },
      );
    }
  


export const getV1ProductionRoutingWorkInstructionRevisionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkInstructionRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkInstructionRevision>}, TContext> => {

const mutationKey = ['v1ProductionRoutingWorkInstructionRevisionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedWorkInstructionRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingWorkInstructionRevisionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingWorkInstructionRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPartialUpdate>>>
    export type V1ProductionRoutingWorkInstructionRevisionsPartialUpdateMutationBody = NonReadonly<PatchedWorkInstructionRevision>
    export type V1ProductionRoutingWorkInstructionRevisionsPartialUpdateMutationError = unknown

    export const useV1ProductionRoutingWorkInstructionRevisionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkInstructionRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedWorkInstructionRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingWorkInstructionRevisionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-028: ایجاد نسخهٔ Draft جدید + انتشار (publish).
 */
export const v1ProductionRoutingWorkInstructionRevisionsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/routing/work-instruction-revisions/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionRoutingWorkInstructionRevisionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionRoutingWorkInstructionRevisionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionRoutingWorkInstructionRevisionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingWorkInstructionRevisionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsDestroy>>>
    
    export type V1ProductionRoutingWorkInstructionRevisionsDestroyMutationError = unknown

    export const useV1ProductionRoutingWorkInstructionRevisionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingWorkInstructionRevisionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rule WI-01: نسخهٔ قبلی PUBLISHED (اگر هست) اتمیک SUPERSEDED می‌شود.
 */
export const v1ProductionRoutingWorkInstructionRevisionsPublishCreate = (
    id: string,
    workInstructionRevision: NonReadonly<WorkInstructionRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkInstructionRevision>(
      {url: `/api/v1/production/routing/work-instruction-revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workInstructionRevision, signal
    },
      );
    }
  


export const getV1ProductionRoutingWorkInstructionRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<WorkInstructionRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<WorkInstructionRevision>}, TContext> => {

const mutationKey = ['v1ProductionRoutingWorkInstructionRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPublishCreate>>, {id: string;data: NonReadonly<WorkInstructionRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionRoutingWorkInstructionRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionRoutingWorkInstructionRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPublishCreate>>>
    export type V1ProductionRoutingWorkInstructionRevisionsPublishCreateMutationBody = NonReadonly<WorkInstructionRevision>
    export type V1ProductionRoutingWorkInstructionRevisionsPublishCreateMutationError = unknown

    export const useV1ProductionRoutingWorkInstructionRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<WorkInstructionRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionRoutingWorkInstructionRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<WorkInstructionRevision>},
        TContext
      > => {

      const mutationOptions = getV1ProductionRoutingWorkInstructionRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List scrap reason codes
 */
export const v1ProductionScrapReasonCodesList = (
    params?: V1ProductionScrapReasonCodesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedScrapReasonCodeList>(
      {url: `/api/v1/production/scrap-reason-codes/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionScrapReasonCodesListQueryKey = (params?: V1ProductionScrapReasonCodesListParams,) => {
    return [
    `/api/v1/production/scrap-reason-codes/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionScrapReasonCodesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError = unknown>(params?: V1ProductionScrapReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionScrapReasonCodesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>> = ({ signal }) => v1ProductionScrapReasonCodesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionScrapReasonCodesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>>
export type V1ProductionScrapReasonCodesListQueryError = unknown


export function useV1ProductionScrapReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError = unknown>(
 params: undefined |  V1ProductionScrapReasonCodesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionScrapReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError = unknown>(
 params?: V1ProductionScrapReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionScrapReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError = unknown>(
 params?: V1ProductionScrapReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List scrap reason codes
 */

export function useV1ProductionScrapReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError = unknown>(
 params?: V1ProductionScrapReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionScrapReasonCodesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a scrap reason code
 */
export const v1ProductionScrapReasonCodesCreate = (
    scrapReasonCode: NonReadonly<ScrapReasonCode>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ScrapReasonCode>(
      {url: `/api/v1/production/scrap-reason-codes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scrapReasonCode, signal
    },
      );
    }
  


export const getV1ProductionScrapReasonCodesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesCreate>>, TError,{data: NonReadonly<ScrapReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesCreate>>, TError,{data: NonReadonly<ScrapReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionScrapReasonCodesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesCreate>>, {data: NonReadonly<ScrapReasonCode>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionScrapReasonCodesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionScrapReasonCodesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesCreate>>>
    export type V1ProductionScrapReasonCodesCreateMutationBody = NonReadonly<ScrapReasonCode>
    export type V1ProductionScrapReasonCodesCreateMutationError = unknown

    /**
 * @summary Create a scrap reason code
 */
export const useV1ProductionScrapReasonCodesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesCreate>>, TError,{data: NonReadonly<ScrapReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionScrapReasonCodesCreate>>,
        TError,
        {data: NonReadonly<ScrapReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionScrapReasonCodesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a scrap reason code
 */
export const v1ProductionScrapReasonCodesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ScrapReasonCode>(
      {url: `/api/v1/production/scrap-reason-codes/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionScrapReasonCodesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/scrap-reason-codes/${id}/`
    ] as const;
    }

    
export const getV1ProductionScrapReasonCodesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionScrapReasonCodesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>> = ({ signal }) => v1ProductionScrapReasonCodesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionScrapReasonCodesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>>
export type V1ProductionScrapReasonCodesRetrieveQueryError = unknown


export function useV1ProductionScrapReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionScrapReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionScrapReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a scrap reason code
 */

export function useV1ProductionScrapReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionScrapReasonCodesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionScrapReasonCodesUpdate = (
    id: string,
    scrapReasonCode: NonReadonly<ScrapReasonCode>,
 ) => {
      
      
      return customAxiosInstance<ScrapReasonCode>(
      {url: `/api/v1/production/scrap-reason-codes/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: scrapReasonCode
    },
      );
    }
  


export const getV1ProductionScrapReasonCodesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesUpdate>>, TError,{id: string;data: NonReadonly<ScrapReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesUpdate>>, TError,{id: string;data: NonReadonly<ScrapReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionScrapReasonCodesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesUpdate>>, {id: string;data: NonReadonly<ScrapReasonCode>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionScrapReasonCodesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionScrapReasonCodesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesUpdate>>>
    export type V1ProductionScrapReasonCodesUpdateMutationBody = NonReadonly<ScrapReasonCode>
    export type V1ProductionScrapReasonCodesUpdateMutationError = unknown

    export const useV1ProductionScrapReasonCodesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesUpdate>>, TError,{id: string;data: NonReadonly<ScrapReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionScrapReasonCodesUpdate>>,
        TError,
        {id: string;data: NonReadonly<ScrapReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionScrapReasonCodesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionScrapReasonCodesPartialUpdate = (
    id: string,
    patchedScrapReasonCode: NonReadonly<PatchedScrapReasonCode>,
 ) => {
      
      
      return customAxiosInstance<ScrapReasonCode>(
      {url: `/api/v1/production/scrap-reason-codes/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedScrapReasonCode
    },
      );
    }
  


export const getV1ProductionScrapReasonCodesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedScrapReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedScrapReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionScrapReasonCodesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesPartialUpdate>>, {id: string;data: NonReadonly<PatchedScrapReasonCode>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionScrapReasonCodesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionScrapReasonCodesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesPartialUpdate>>>
    export type V1ProductionScrapReasonCodesPartialUpdateMutationBody = NonReadonly<PatchedScrapReasonCode>
    export type V1ProductionScrapReasonCodesPartialUpdateMutationError = unknown

    export const useV1ProductionScrapReasonCodesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedScrapReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionScrapReasonCodesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedScrapReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionScrapReasonCodesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Reactivate a scrap reason code
 */
export const v1ProductionScrapReasonCodesActivateCreate = (
    id: string,
    scrapReasonCode: NonReadonly<ScrapReasonCode>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ScrapReasonCode>(
      {url: `/api/v1/production/scrap-reason-codes/${id}/activate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scrapReasonCode, signal
    },
      );
    }
  


export const getV1ProductionScrapReasonCodesActivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesActivateCreate>>, TError,{id: string;data: NonReadonly<ScrapReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesActivateCreate>>, TError,{id: string;data: NonReadonly<ScrapReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionScrapReasonCodesActivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesActivateCreate>>, {id: string;data: NonReadonly<ScrapReasonCode>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionScrapReasonCodesActivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionScrapReasonCodesActivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesActivateCreate>>>
    export type V1ProductionScrapReasonCodesActivateCreateMutationBody = NonReadonly<ScrapReasonCode>
    export type V1ProductionScrapReasonCodesActivateCreateMutationError = unknown

    /**
 * @summary Reactivate a scrap reason code
 */
export const useV1ProductionScrapReasonCodesActivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesActivateCreate>>, TError,{id: string;data: NonReadonly<ScrapReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionScrapReasonCodesActivateCreate>>,
        TError,
        {id: string;data: NonReadonly<ScrapReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionScrapReasonCodesActivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Deactivate a scrap reason code (soft, never deleted)
 */
export const v1ProductionScrapReasonCodesDeactivateCreate = (
    id: string,
    scrapReasonCode: NonReadonly<ScrapReasonCode>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ScrapReasonCode>(
      {url: `/api/v1/production/scrap-reason-codes/${id}/deactivate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scrapReasonCode, signal
    },
      );
    }
  


export const getV1ProductionScrapReasonCodesDeactivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesDeactivateCreate>>, TError,{id: string;data: NonReadonly<ScrapReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesDeactivateCreate>>, TError,{id: string;data: NonReadonly<ScrapReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionScrapReasonCodesDeactivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesDeactivateCreate>>, {id: string;data: NonReadonly<ScrapReasonCode>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionScrapReasonCodesDeactivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionScrapReasonCodesDeactivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesDeactivateCreate>>>
    export type V1ProductionScrapReasonCodesDeactivateCreateMutationBody = NonReadonly<ScrapReasonCode>
    export type V1ProductionScrapReasonCodesDeactivateCreateMutationError = unknown

    /**
 * @summary Deactivate a scrap reason code (soft, never deleted)
 */
export const useV1ProductionScrapReasonCodesDeactivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapReasonCodesDeactivateCreate>>, TError,{id: string;data: NonReadonly<ScrapReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionScrapReasonCodesDeactivateCreate>>,
        TError,
        {id: string;data: NonReadonly<ScrapReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionScrapReasonCodesDeactivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Trace Entity — append-only (ADR-046). No PUT/PATCH/DELETE.
 * @summary List scrap records
 */
export const v1ProductionScrapRecordsList = (
    params?: V1ProductionScrapRecordsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedScrapRecordList>(
      {url: `/api/v1/production/scrap-records/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionScrapRecordsListQueryKey = (params?: V1ProductionScrapRecordsListParams,) => {
    return [
    `/api/v1/production/scrap-records/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionScrapRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError = unknown>(params?: V1ProductionScrapRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionScrapRecordsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>> = ({ signal }) => v1ProductionScrapRecordsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionScrapRecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>>
export type V1ProductionScrapRecordsListQueryError = unknown


export function useV1ProductionScrapRecordsList<TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError = unknown>(
 params: undefined |  V1ProductionScrapRecordsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionScrapRecordsList<TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError = unknown>(
 params?: V1ProductionScrapRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionScrapRecordsList<TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError = unknown>(
 params?: V1ProductionScrapRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List scrap records
 */

export function useV1ProductionScrapRecordsList<TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError = unknown>(
 params?: V1ProductionScrapRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionScrapRecordsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Trace Entity — append-only (ADR-046). No PUT/PATCH/DELETE.
 * @summary Record scrap for a work order
 */
export const v1ProductionScrapRecordsCreate = (
    scrapRecord: NonReadonly<ScrapRecord>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ScrapRecord>(
      {url: `/api/v1/production/scrap-records/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scrapRecord, signal
    },
      );
    }
  


export const getV1ProductionScrapRecordsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsCreate>>, TError,{data: NonReadonly<ScrapRecord>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsCreate>>, TError,{data: NonReadonly<ScrapRecord>}, TContext> => {

const mutationKey = ['v1ProductionScrapRecordsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionScrapRecordsCreate>>, {data: NonReadonly<ScrapRecord>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionScrapRecordsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionScrapRecordsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapRecordsCreate>>>
    export type V1ProductionScrapRecordsCreateMutationBody = NonReadonly<ScrapRecord>
    export type V1ProductionScrapRecordsCreateMutationError = unknown

    /**
 * @summary Record scrap for a work order
 */
export const useV1ProductionScrapRecordsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsCreate>>, TError,{data: NonReadonly<ScrapRecord>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionScrapRecordsCreate>>,
        TError,
        {data: NonReadonly<ScrapRecord>},
        TContext
      > => {

      const mutationOptions = getV1ProductionScrapRecordsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Trace Entity — append-only (ADR-046). No PUT/PATCH/DELETE.
 * @summary Retrieve a scrap record
 */
export const v1ProductionScrapRecordsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ScrapRecord>(
      {url: `/api/v1/production/scrap-records/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionScrapRecordsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/scrap-records/${id}/`
    ] as const;
    }

    
export const getV1ProductionScrapRecordsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionScrapRecordsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>> = ({ signal }) => v1ProductionScrapRecordsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionScrapRecordsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>>
export type V1ProductionScrapRecordsRetrieveQueryError = unknown


export function useV1ProductionScrapRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionScrapRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionScrapRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a scrap record
 */

export function useV1ProductionScrapRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionScrapRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionScrapRecordsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * فقط خواندنی — این رکوردها همیشه خودکار توسط سرویس ساخته می‌شوند (Rule SN-05).
 */
export const v1ProductionSerialUnitLotLinksList = (
    params?: V1ProductionSerialUnitLotLinksListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedSerialUnitLotLinkList>(
      {url: `/api/v1/production/serial-unit-lot-links/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionSerialUnitLotLinksListQueryKey = (params?: V1ProductionSerialUnitLotLinksListParams,) => {
    return [
    `/api/v1/production/serial-unit-lot-links/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionSerialUnitLotLinksListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError = unknown>(params?: V1ProductionSerialUnitLotLinksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionSerialUnitLotLinksListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>> = ({ signal }) => v1ProductionSerialUnitLotLinksList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionSerialUnitLotLinksListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>>
export type V1ProductionSerialUnitLotLinksListQueryError = unknown


export function useV1ProductionSerialUnitLotLinksList<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError = unknown>(
 params: undefined |  V1ProductionSerialUnitLotLinksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitLotLinksList<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError = unknown>(
 params?: V1ProductionSerialUnitLotLinksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitLotLinksList<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError = unknown>(
 params?: V1ProductionSerialUnitLotLinksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionSerialUnitLotLinksList<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError = unknown>(
 params?: V1ProductionSerialUnitLotLinksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionSerialUnitLotLinksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * فقط خواندنی — این رکوردها همیشه خودکار توسط سرویس ساخته می‌شوند (Rule SN-05).
 */
export const v1ProductionSerialUnitLotLinksRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<SerialUnitLotLink>(
      {url: `/api/v1/production/serial-unit-lot-links/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionSerialUnitLotLinksRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/serial-unit-lot-links/${id}/`
    ] as const;
    }

    
export const getV1ProductionSerialUnitLotLinksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionSerialUnitLotLinksRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>> = ({ signal }) => v1ProductionSerialUnitLotLinksRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionSerialUnitLotLinksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>>
export type V1ProductionSerialUnitLotLinksRetrieveQueryError = unknown


export function useV1ProductionSerialUnitLotLinksRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitLotLinksRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitLotLinksRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionSerialUnitLotLinksRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitLotLinksRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionSerialUnitLotLinksRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-104. Create/link/trace all go through SerializationService — this
ViewSet never writes model fields directly (Trace Entity discipline).
 * @summary List serial units for active tenant
 */
export const v1ProductionSerialUnitsList = (
    params?: V1ProductionSerialUnitsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedSerialUnitList>(
      {url: `/api/v1/production/serial-units/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionSerialUnitsListQueryKey = (params?: V1ProductionSerialUnitsListParams,) => {
    return [
    `/api/v1/production/serial-units/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionSerialUnitsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError = unknown>(params?: V1ProductionSerialUnitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionSerialUnitsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>> = ({ signal }) => v1ProductionSerialUnitsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionSerialUnitsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>>
export type V1ProductionSerialUnitsListQueryError = unknown


export function useV1ProductionSerialUnitsList<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError = unknown>(
 params: undefined |  V1ProductionSerialUnitsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitsList<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError = unknown>(
 params?: V1ProductionSerialUnitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitsList<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError = unknown>(
 params?: V1ProductionSerialUnitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List serial units for active tenant
 */

export function useV1ProductionSerialUnitsList<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError = unknown>(
 params?: V1ProductionSerialUnitsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionSerialUnitsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-104. Create/link/trace all go through SerializationService — this
ViewSet never writes model fields directly (Trace Entity discipline).
 */
export const v1ProductionSerialUnitsCreate = (
    serialUnit: NonReadonly<SerialUnit>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<SerialUnit>(
      {url: `/api/v1/production/serial-units/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serialUnit, signal
    },
      );
    }
  


export const getV1ProductionSerialUnitsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsCreate>>, TError,{data: NonReadonly<SerialUnit>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsCreate>>, TError,{data: NonReadonly<SerialUnit>}, TContext> => {

const mutationKey = ['v1ProductionSerialUnitsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionSerialUnitsCreate>>, {data: NonReadonly<SerialUnit>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionSerialUnitsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionSerialUnitsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionSerialUnitsCreate>>>
    export type V1ProductionSerialUnitsCreateMutationBody = NonReadonly<SerialUnit>
    export type V1ProductionSerialUnitsCreateMutationError = unknown

    export const useV1ProductionSerialUnitsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsCreate>>, TError,{data: NonReadonly<SerialUnit>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionSerialUnitsCreate>>,
        TError,
        {data: NonReadonly<SerialUnit>},
        TContext
      > => {

      const mutationOptions = getV1ProductionSerialUnitsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-104. Create/link/trace all go through SerializationService — this
ViewSet never writes model fields directly (Trace Entity discipline).
 * @summary Retrieve a serial unit by ID
 */
export const v1ProductionSerialUnitsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<SerialUnit>(
      {url: `/api/v1/production/serial-units/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionSerialUnitsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/serial-units/${id}/`
    ] as const;
    }

    
export const getV1ProductionSerialUnitsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionSerialUnitsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>> = ({ signal }) => v1ProductionSerialUnitsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionSerialUnitsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>>
export type V1ProductionSerialUnitsRetrieveQueryError = unknown


export function useV1ProductionSerialUnitsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a serial unit by ID
 */

export function useV1ProductionSerialUnitsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionSerialUnitsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-104. Create/link/trace all go through SerializationService — this
ViewSet never writes model fields directly (Trace Entity discipline).
 * @summary ردیابی کامل یک واحد سریال‌دار (Rule SN-11)
 */
export const v1ProductionSerialUnitsTraceRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<SerialUnit>(
      {url: `/api/v1/production/serial-units/${id}/trace/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionSerialUnitsTraceRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/serial-units/${id}/trace/`
    ] as const;
    }

    
export const getV1ProductionSerialUnitsTraceRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionSerialUnitsTraceRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>> = ({ signal }) => v1ProductionSerialUnitsTraceRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionSerialUnitsTraceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>>
export type V1ProductionSerialUnitsTraceRetrieveQueryError = unknown


export function useV1ProductionSerialUnitsTraceRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitsTraceRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionSerialUnitsTraceRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary ردیابی کامل یک واحد سریال‌دار (Rule SN-11)
 */

export function useV1ProductionSerialUnitsTraceRetrieve<TData = Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsTraceRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionSerialUnitsTraceRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-104. Create/link/trace all go through SerializationService — this
ViewSet never writes model fields directly (Trace Entity discipline).
 * @summary پیوند یک واحد سریال‌دار به‌عنوان جزء یک واحد دیگر (Genealogy)
 */
export const v1ProductionSerialUnitsLinkComponentCreate = (
    serialUnitLinkComponent: SerialUnitLinkComponent,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<SerialUnit>(
      {url: `/api/v1/production/serial-units/link-component/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serialUnitLinkComponent, signal
    },
      );
    }
  


export const getV1ProductionSerialUnitsLinkComponentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsLinkComponentCreate>>, TError,{data: SerialUnitLinkComponent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsLinkComponentCreate>>, TError,{data: SerialUnitLinkComponent}, TContext> => {

const mutationKey = ['v1ProductionSerialUnitsLinkComponentCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionSerialUnitsLinkComponentCreate>>, {data: SerialUnitLinkComponent}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionSerialUnitsLinkComponentCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionSerialUnitsLinkComponentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionSerialUnitsLinkComponentCreate>>>
    export type V1ProductionSerialUnitsLinkComponentCreateMutationBody = SerialUnitLinkComponent
    export type V1ProductionSerialUnitsLinkComponentCreateMutationError = unknown

    /**
 * @summary پیوند یک واحد سریال‌دار به‌عنوان جزء یک واحد دیگر (Genealogy)
 */
export const useV1ProductionSerialUnitsLinkComponentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionSerialUnitsLinkComponentCreate>>, TError,{data: SerialUnitLinkComponent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionSerialUnitsLinkComponentCreate>>,
        TError,
        {data: SerialUnitLinkComponent},
        TContext
      > => {

      const mutationOptions = getV1ProductionSerialUnitsLinkComponentCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List downtime reason codes
 */
export const v1ProductionShopfloorDowntimeReasonCodesList = (
    params?: V1ProductionShopfloorDowntimeReasonCodesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedDowntimeReasonCodeList>(
      {url: `/api/v1/production/shopfloor/downtime-reason-codes/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorDowntimeReasonCodesListQueryKey = (params?: V1ProductionShopfloorDowntimeReasonCodesListParams,) => {
    return [
    `/api/v1/production/shopfloor/downtime-reason-codes/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorDowntimeReasonCodesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError = unknown>(params?: V1ProductionShopfloorDowntimeReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorDowntimeReasonCodesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>> = ({ signal }) => v1ProductionShopfloorDowntimeReasonCodesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorDowntimeReasonCodesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>>
export type V1ProductionShopfloorDowntimeReasonCodesListQueryError = unknown


export function useV1ProductionShopfloorDowntimeReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorDowntimeReasonCodesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorDowntimeReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError = unknown>(
 params?: V1ProductionShopfloorDowntimeReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorDowntimeReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError = unknown>(
 params?: V1ProductionShopfloorDowntimeReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List downtime reason codes
 */

export function useV1ProductionShopfloorDowntimeReasonCodesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError = unknown>(
 params?: V1ProductionShopfloorDowntimeReasonCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorDowntimeReasonCodesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a downtime reason code
 */
export const v1ProductionShopfloorDowntimeReasonCodesCreate = (
    downtimeReasonCode: NonReadonly<DowntimeReasonCode>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<DowntimeReasonCode>(
      {url: `/api/v1/production/shopfloor/downtime-reason-codes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: downtimeReasonCode, signal
    },
      );
    }
  


export const getV1ProductionShopfloorDowntimeReasonCodesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesCreate>>, TError,{data: NonReadonly<DowntimeReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesCreate>>, TError,{data: NonReadonly<DowntimeReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorDowntimeReasonCodesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesCreate>>, {data: NonReadonly<DowntimeReasonCode>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorDowntimeReasonCodesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorDowntimeReasonCodesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesCreate>>>
    export type V1ProductionShopfloorDowntimeReasonCodesCreateMutationBody = NonReadonly<DowntimeReasonCode>
    export type V1ProductionShopfloorDowntimeReasonCodesCreateMutationError = unknown

    /**
 * @summary Create a downtime reason code
 */
export const useV1ProductionShopfloorDowntimeReasonCodesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesCreate>>, TError,{data: NonReadonly<DowntimeReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesCreate>>,
        TError,
        {data: NonReadonly<DowntimeReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorDowntimeReasonCodesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a downtime reason code
 */
export const v1ProductionShopfloorDowntimeReasonCodesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<DowntimeReasonCode>(
      {url: `/api/v1/production/shopfloor/downtime-reason-codes/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorDowntimeReasonCodesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/downtime-reason-codes/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorDowntimeReasonCodesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorDowntimeReasonCodesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>> = ({ signal }) => v1ProductionShopfloorDowntimeReasonCodesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorDowntimeReasonCodesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>>
export type V1ProductionShopfloorDowntimeReasonCodesRetrieveQueryError = unknown


export function useV1ProductionShopfloorDowntimeReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorDowntimeReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorDowntimeReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a downtime reason code
 */

export function useV1ProductionShopfloorDowntimeReasonCodesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorDowntimeReasonCodesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorDowntimeReasonCodesUpdate = (
    id: string,
    downtimeReasonCode: NonReadonly<DowntimeReasonCode>,
 ) => {
      
      
      return customAxiosInstance<DowntimeReasonCode>(
      {url: `/api/v1/production/shopfloor/downtime-reason-codes/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: downtimeReasonCode
    },
      );
    }
  


export const getV1ProductionShopfloorDowntimeReasonCodesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesUpdate>>, TError,{id: string;data: NonReadonly<DowntimeReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesUpdate>>, TError,{id: string;data: NonReadonly<DowntimeReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorDowntimeReasonCodesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesUpdate>>, {id: string;data: NonReadonly<DowntimeReasonCode>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorDowntimeReasonCodesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorDowntimeReasonCodesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesUpdate>>>
    export type V1ProductionShopfloorDowntimeReasonCodesUpdateMutationBody = NonReadonly<DowntimeReasonCode>
    export type V1ProductionShopfloorDowntimeReasonCodesUpdateMutationError = unknown

    export const useV1ProductionShopfloorDowntimeReasonCodesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesUpdate>>, TError,{id: string;data: NonReadonly<DowntimeReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesUpdate>>,
        TError,
        {id: string;data: NonReadonly<DowntimeReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorDowntimeReasonCodesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorDowntimeReasonCodesPartialUpdate = (
    id: string,
    patchedDowntimeReasonCode: NonReadonly<PatchedDowntimeReasonCode>,
 ) => {
      
      
      return customAxiosInstance<DowntimeReasonCode>(
      {url: `/api/v1/production/shopfloor/downtime-reason-codes/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedDowntimeReasonCode
    },
      );
    }
  


export const getV1ProductionShopfloorDowntimeReasonCodesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedDowntimeReasonCode>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedDowntimeReasonCode>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorDowntimeReasonCodesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesPartialUpdate>>, {id: string;data: NonReadonly<PatchedDowntimeReasonCode>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorDowntimeReasonCodesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorDowntimeReasonCodesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesPartialUpdate>>>
    export type V1ProductionShopfloorDowntimeReasonCodesPartialUpdateMutationBody = NonReadonly<PatchedDowntimeReasonCode>
    export type V1ProductionShopfloorDowntimeReasonCodesPartialUpdateMutationError = unknown

    export const useV1ProductionShopfloorDowntimeReasonCodesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedDowntimeReasonCode>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedDowntimeReasonCode>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorDowntimeReasonCodesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorDowntimeReasonCodesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/downtime-reason-codes/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionShopfloorDowntimeReasonCodesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionShopfloorDowntimeReasonCodesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionShopfloorDowntimeReasonCodesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorDowntimeReasonCodesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesDestroy>>>
    
    export type V1ProductionShopfloorDowntimeReasonCodesDestroyMutationError = unknown

    export const useV1ProductionShopfloorDowntimeReasonCodesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeReasonCodesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorDowntimeReasonCodesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create/close go through the dedicated actions below (which call DowntimeService).
 * @summary List downtime records
 */
export const v1ProductionShopfloorDowntimeRecordsList = (
    params?: V1ProductionShopfloorDowntimeRecordsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedDowntimeRecordList>(
      {url: `/api/v1/production/shopfloor/downtime-records/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorDowntimeRecordsListQueryKey = (params?: V1ProductionShopfloorDowntimeRecordsListParams,) => {
    return [
    `/api/v1/production/shopfloor/downtime-records/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorDowntimeRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError = unknown>(params?: V1ProductionShopfloorDowntimeRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorDowntimeRecordsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>> = ({ signal }) => v1ProductionShopfloorDowntimeRecordsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorDowntimeRecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>>
export type V1ProductionShopfloorDowntimeRecordsListQueryError = unknown


export function useV1ProductionShopfloorDowntimeRecordsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorDowntimeRecordsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorDowntimeRecordsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError = unknown>(
 params?: V1ProductionShopfloorDowntimeRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorDowntimeRecordsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError = unknown>(
 params?: V1ProductionShopfloorDowntimeRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List downtime records
 */

export function useV1ProductionShopfloorDowntimeRecordsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError = unknown>(
 params?: V1ProductionShopfloorDowntimeRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorDowntimeRecordsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create/close go through the dedicated actions below (which call DowntimeService).
 * @summary Retrieve a downtime record
 */
export const v1ProductionShopfloorDowntimeRecordsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<DowntimeRecord>(
      {url: `/api/v1/production/shopfloor/downtime-records/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorDowntimeRecordsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/downtime-records/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorDowntimeRecordsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorDowntimeRecordsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>> = ({ signal }) => v1ProductionShopfloorDowntimeRecordsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorDowntimeRecordsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>>
export type V1ProductionShopfloorDowntimeRecordsRetrieveQueryError = unknown


export function useV1ProductionShopfloorDowntimeRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorDowntimeRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorDowntimeRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a downtime record
 */

export function useV1ProductionShopfloorDowntimeRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorDowntimeRecordsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create/close go through the dedicated actions below (which call DowntimeService).
 * @summary End a downtime record
 */
export const v1ProductionShopfloorDowntimeRecordsEndCreate = (
    id: string,
    downtimeRecord: NonReadonly<DowntimeRecord>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<DowntimeRecord>(
      {url: `/api/v1/production/shopfloor/downtime-records/${id}/end/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: downtimeRecord, signal
    },
      );
    }
  


export const getV1ProductionShopfloorDowntimeRecordsEndCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsEndCreate>>, TError,{id: string;data: NonReadonly<DowntimeRecord>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsEndCreate>>, TError,{id: string;data: NonReadonly<DowntimeRecord>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorDowntimeRecordsEndCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsEndCreate>>, {id: string;data: NonReadonly<DowntimeRecord>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorDowntimeRecordsEndCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorDowntimeRecordsEndCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsEndCreate>>>
    export type V1ProductionShopfloorDowntimeRecordsEndCreateMutationBody = NonReadonly<DowntimeRecord>
    export type V1ProductionShopfloorDowntimeRecordsEndCreateMutationError = unknown

    /**
 * @summary End a downtime record
 */
export const useV1ProductionShopfloorDowntimeRecordsEndCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsEndCreate>>, TError,{id: string;data: NonReadonly<DowntimeRecord>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsEndCreate>>,
        TError,
        {id: string;data: NonReadonly<DowntimeRecord>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorDowntimeRecordsEndCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create/close go through the dedicated actions below (which call DowntimeService).
 * @summary Start a downtime record
 */
export const v1ProductionShopfloorDowntimeRecordsStartCreate = (
    downtimeRecord: NonReadonly<DowntimeRecord>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<DowntimeRecord>(
      {url: `/api/v1/production/shopfloor/downtime-records/start/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: downtimeRecord, signal
    },
      );
    }
  


export const getV1ProductionShopfloorDowntimeRecordsStartCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsStartCreate>>, TError,{data: NonReadonly<DowntimeRecord>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsStartCreate>>, TError,{data: NonReadonly<DowntimeRecord>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorDowntimeRecordsStartCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsStartCreate>>, {data: NonReadonly<DowntimeRecord>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorDowntimeRecordsStartCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorDowntimeRecordsStartCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsStartCreate>>>
    export type V1ProductionShopfloorDowntimeRecordsStartCreateMutationBody = NonReadonly<DowntimeRecord>
    export type V1ProductionShopfloorDowntimeRecordsStartCreateMutationError = unknown

    /**
 * @summary Start a downtime record
 */
export const useV1ProductionShopfloorDowntimeRecordsStartCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsStartCreate>>, TError,{data: NonReadonly<DowntimeRecord>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorDowntimeRecordsStartCreate>>,
        TError,
        {data: NonReadonly<DowntimeRecord>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorDowntimeRecordsStartCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List leave requests
 */
export const v1ProductionShopfloorLeaveRequestsList = (
    params?: V1ProductionShopfloorLeaveRequestsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedLeaveRequestList>(
      {url: `/api/v1/production/shopfloor/leave-requests/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorLeaveRequestsListQueryKey = (params?: V1ProductionShopfloorLeaveRequestsListParams,) => {
    return [
    `/api/v1/production/shopfloor/leave-requests/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorLeaveRequestsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError = unknown>(params?: V1ProductionShopfloorLeaveRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorLeaveRequestsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>> = ({ signal }) => v1ProductionShopfloorLeaveRequestsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorLeaveRequestsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>>
export type V1ProductionShopfloorLeaveRequestsListQueryError = unknown


export function useV1ProductionShopfloorLeaveRequestsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorLeaveRequestsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorLeaveRequestsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError = unknown>(
 params?: V1ProductionShopfloorLeaveRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorLeaveRequestsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError = unknown>(
 params?: V1ProductionShopfloorLeaveRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List leave requests
 */

export function useV1ProductionShopfloorLeaveRequestsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError = unknown>(
 params?: V1ProductionShopfloorLeaveRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorLeaveRequestsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveRequestsCreate = (
    leaveRequest: NonReadonly<LeaveRequest>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LeaveRequest>(
      {url: `/api/v1/production/shopfloor/leave-requests/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: leaveRequest, signal
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveRequestsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsCreate>>, TError,{data: NonReadonly<LeaveRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsCreate>>, TError,{data: NonReadonly<LeaveRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveRequestsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsCreate>>, {data: NonReadonly<LeaveRequest>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorLeaveRequestsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveRequestsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsCreate>>>
    export type V1ProductionShopfloorLeaveRequestsCreateMutationBody = NonReadonly<LeaveRequest>
    export type V1ProductionShopfloorLeaveRequestsCreateMutationError = unknown

    export const useV1ProductionShopfloorLeaveRequestsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsCreate>>, TError,{data: NonReadonly<LeaveRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsCreate>>,
        TError,
        {data: NonReadonly<LeaveRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveRequestsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveRequestsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LeaveRequest>(
      {url: `/api/v1/production/shopfloor/leave-requests/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorLeaveRequestsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/leave-requests/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorLeaveRequestsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorLeaveRequestsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>> = ({ signal }) => v1ProductionShopfloorLeaveRequestsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorLeaveRequestsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>>
export type V1ProductionShopfloorLeaveRequestsRetrieveQueryError = unknown


export function useV1ProductionShopfloorLeaveRequestsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorLeaveRequestsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorLeaveRequestsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorLeaveRequestsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorLeaveRequestsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveRequestsUpdate = (
    id: string,
    leaveRequest: NonReadonly<LeaveRequest>,
 ) => {
      
      
      return customAxiosInstance<LeaveRequest>(
      {url: `/api/v1/production/shopfloor/leave-requests/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: leaveRequest
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveRequestsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsUpdate>>, TError,{id: string;data: NonReadonly<LeaveRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsUpdate>>, TError,{id: string;data: NonReadonly<LeaveRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveRequestsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsUpdate>>, {id: string;data: NonReadonly<LeaveRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorLeaveRequestsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveRequestsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsUpdate>>>
    export type V1ProductionShopfloorLeaveRequestsUpdateMutationBody = NonReadonly<LeaveRequest>
    export type V1ProductionShopfloorLeaveRequestsUpdateMutationError = unknown

    export const useV1ProductionShopfloorLeaveRequestsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsUpdate>>, TError,{id: string;data: NonReadonly<LeaveRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsUpdate>>,
        TError,
        {id: string;data: NonReadonly<LeaveRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveRequestsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveRequestsPartialUpdate = (
    id: string,
    patchedLeaveRequest: NonReadonly<PatchedLeaveRequest>,
 ) => {
      
      
      return customAxiosInstance<LeaveRequest>(
      {url: `/api/v1/production/shopfloor/leave-requests/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedLeaveRequest
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveRequestsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLeaveRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLeaveRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveRequestsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsPartialUpdate>>, {id: string;data: NonReadonly<PatchedLeaveRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorLeaveRequestsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveRequestsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsPartialUpdate>>>
    export type V1ProductionShopfloorLeaveRequestsPartialUpdateMutationBody = NonReadonly<PatchedLeaveRequest>
    export type V1ProductionShopfloorLeaveRequestsPartialUpdateMutationError = unknown

    export const useV1ProductionShopfloorLeaveRequestsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLeaveRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedLeaveRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveRequestsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveRequestsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/leave-requests/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveRequestsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveRequestsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionShopfloorLeaveRequestsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveRequestsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsDestroy>>>
    
    export type V1ProductionShopfloorLeaveRequestsDestroyMutationError = unknown

    export const useV1ProductionShopfloorLeaveRequestsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveRequestsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Approve a leave request
 */
export const v1ProductionShopfloorLeaveRequestsApproveCreate = (
    id: string,
    leaveRequest: NonReadonly<LeaveRequest>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LeaveRequest>(
      {url: `/api/v1/production/shopfloor/leave-requests/${id}/approve/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: leaveRequest, signal
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveRequestsApproveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsApproveCreate>>, TError,{id: string;data: NonReadonly<LeaveRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsApproveCreate>>, TError,{id: string;data: NonReadonly<LeaveRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveRequestsApproveCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsApproveCreate>>, {id: string;data: NonReadonly<LeaveRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorLeaveRequestsApproveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveRequestsApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsApproveCreate>>>
    export type V1ProductionShopfloorLeaveRequestsApproveCreateMutationBody = NonReadonly<LeaveRequest>
    export type V1ProductionShopfloorLeaveRequestsApproveCreateMutationError = unknown

    /**
 * @summary Approve a leave request
 */
export const useV1ProductionShopfloorLeaveRequestsApproveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsApproveCreate>>, TError,{id: string;data: NonReadonly<LeaveRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsApproveCreate>>,
        TError,
        {id: string;data: NonReadonly<LeaveRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveRequestsApproveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Reject a leave request
 */
export const v1ProductionShopfloorLeaveRequestsRejectCreate = (
    id: string,
    leaveRequest: NonReadonly<LeaveRequest>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LeaveRequest>(
      {url: `/api/v1/production/shopfloor/leave-requests/${id}/reject/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: leaveRequest, signal
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveRequestsRejectCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRejectCreate>>, TError,{id: string;data: NonReadonly<LeaveRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRejectCreate>>, TError,{id: string;data: NonReadonly<LeaveRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveRequestsRejectCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRejectCreate>>, {id: string;data: NonReadonly<LeaveRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorLeaveRequestsRejectCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveRequestsRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRejectCreate>>>
    export type V1ProductionShopfloorLeaveRequestsRejectCreateMutationBody = NonReadonly<LeaveRequest>
    export type V1ProductionShopfloorLeaveRequestsRejectCreateMutationError = unknown

    /**
 * @summary Reject a leave request
 */
export const useV1ProductionShopfloorLeaveRequestsRejectCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRejectCreate>>, TError,{id: string;data: NonReadonly<LeaveRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveRequestsRejectCreate>>,
        TError,
        {id: string;data: NonReadonly<LeaveRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveRequestsRejectCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List leave types
 */
export const v1ProductionShopfloorLeaveTypesList = (
    params?: V1ProductionShopfloorLeaveTypesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedLeaveTypeList>(
      {url: `/api/v1/production/shopfloor/leave-types/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorLeaveTypesListQueryKey = (params?: V1ProductionShopfloorLeaveTypesListParams,) => {
    return [
    `/api/v1/production/shopfloor/leave-types/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorLeaveTypesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError = unknown>(params?: V1ProductionShopfloorLeaveTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorLeaveTypesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>> = ({ signal }) => v1ProductionShopfloorLeaveTypesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorLeaveTypesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>>
export type V1ProductionShopfloorLeaveTypesListQueryError = unknown


export function useV1ProductionShopfloorLeaveTypesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorLeaveTypesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorLeaveTypesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError = unknown>(
 params?: V1ProductionShopfloorLeaveTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorLeaveTypesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError = unknown>(
 params?: V1ProductionShopfloorLeaveTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List leave types
 */

export function useV1ProductionShopfloorLeaveTypesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError = unknown>(
 params?: V1ProductionShopfloorLeaveTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorLeaveTypesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveTypesCreate = (
    leaveType: NonReadonly<LeaveType>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LeaveType>(
      {url: `/api/v1/production/shopfloor/leave-types/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: leaveType, signal
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveTypesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesCreate>>, TError,{data: NonReadonly<LeaveType>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesCreate>>, TError,{data: NonReadonly<LeaveType>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveTypesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesCreate>>, {data: NonReadonly<LeaveType>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorLeaveTypesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveTypesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesCreate>>>
    export type V1ProductionShopfloorLeaveTypesCreateMutationBody = NonReadonly<LeaveType>
    export type V1ProductionShopfloorLeaveTypesCreateMutationError = unknown

    export const useV1ProductionShopfloorLeaveTypesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesCreate>>, TError,{data: NonReadonly<LeaveType>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesCreate>>,
        TError,
        {data: NonReadonly<LeaveType>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveTypesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveTypesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LeaveType>(
      {url: `/api/v1/production/shopfloor/leave-types/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorLeaveTypesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/leave-types/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorLeaveTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorLeaveTypesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>> = ({ signal }) => v1ProductionShopfloorLeaveTypesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorLeaveTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>>
export type V1ProductionShopfloorLeaveTypesRetrieveQueryError = unknown


export function useV1ProductionShopfloorLeaveTypesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorLeaveTypesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorLeaveTypesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorLeaveTypesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorLeaveTypesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveTypesUpdate = (
    id: string,
    leaveType: NonReadonly<LeaveType>,
 ) => {
      
      
      return customAxiosInstance<LeaveType>(
      {url: `/api/v1/production/shopfloor/leave-types/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: leaveType
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveTypesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesUpdate>>, TError,{id: string;data: NonReadonly<LeaveType>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesUpdate>>, TError,{id: string;data: NonReadonly<LeaveType>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveTypesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesUpdate>>, {id: string;data: NonReadonly<LeaveType>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorLeaveTypesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveTypesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesUpdate>>>
    export type V1ProductionShopfloorLeaveTypesUpdateMutationBody = NonReadonly<LeaveType>
    export type V1ProductionShopfloorLeaveTypesUpdateMutationError = unknown

    export const useV1ProductionShopfloorLeaveTypesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesUpdate>>, TError,{id: string;data: NonReadonly<LeaveType>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesUpdate>>,
        TError,
        {id: string;data: NonReadonly<LeaveType>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveTypesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveTypesPartialUpdate = (
    id: string,
    patchedLeaveType: NonReadonly<PatchedLeaveType>,
 ) => {
      
      
      return customAxiosInstance<LeaveType>(
      {url: `/api/v1/production/shopfloor/leave-types/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedLeaveType
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveTypesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLeaveType>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLeaveType>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveTypesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesPartialUpdate>>, {id: string;data: NonReadonly<PatchedLeaveType>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorLeaveTypesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveTypesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesPartialUpdate>>>
    export type V1ProductionShopfloorLeaveTypesPartialUpdateMutationBody = NonReadonly<PatchedLeaveType>
    export type V1ProductionShopfloorLeaveTypesPartialUpdateMutationError = unknown

    export const useV1ProductionShopfloorLeaveTypesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedLeaveType>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedLeaveType>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveTypesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorLeaveTypesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/leave-types/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionShopfloorLeaveTypesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionShopfloorLeaveTypesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionShopfloorLeaveTypesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorLeaveTypesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesDestroy>>>
    
    export type V1ProductionShopfloorLeaveTypesDestroyMutationError = unknown

    export const useV1ProductionShopfloorLeaveTypesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorLeaveTypesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorLeaveTypesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List operator roster assignments
 */
export const v1ProductionShopfloorOperatorRosterAssignmentsList = (
    params?: V1ProductionShopfloorOperatorRosterAssignmentsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOperatorRosterAssignmentList>(
      {url: `/api/v1/production/shopfloor/operator-roster-assignments/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorOperatorRosterAssignmentsListQueryKey = (params?: V1ProductionShopfloorOperatorRosterAssignmentsListParams,) => {
    return [
    `/api/v1/production/shopfloor/operator-roster-assignments/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorOperatorRosterAssignmentsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError = unknown>(params?: V1ProductionShopfloorOperatorRosterAssignmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorOperatorRosterAssignmentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>> = ({ signal }) => v1ProductionShopfloorOperatorRosterAssignmentsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorOperatorRosterAssignmentsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>>
export type V1ProductionShopfloorOperatorRosterAssignmentsListQueryError = unknown


export function useV1ProductionShopfloorOperatorRosterAssignmentsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorOperatorRosterAssignmentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorRosterAssignmentsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError = unknown>(
 params?: V1ProductionShopfloorOperatorRosterAssignmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorRosterAssignmentsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError = unknown>(
 params?: V1ProductionShopfloorOperatorRosterAssignmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List operator roster assignments
 */

export function useV1ProductionShopfloorOperatorRosterAssignmentsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError = unknown>(
 params?: V1ProductionShopfloorOperatorRosterAssignmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorOperatorRosterAssignmentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Assign an operator to a roster for a period
 */
export const v1ProductionShopfloorOperatorRosterAssignmentsCreate = (
    operatorRosterAssignment: NonReadonly<OperatorRosterAssignment>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperatorRosterAssignment>(
      {url: `/api/v1/production/shopfloor/operator-roster-assignments/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: operatorRosterAssignment, signal
    },
      );
    }
  


export const getV1ProductionShopfloorOperatorRosterAssignmentsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsCreate>>, TError,{data: NonReadonly<OperatorRosterAssignment>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsCreate>>, TError,{data: NonReadonly<OperatorRosterAssignment>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorOperatorRosterAssignmentsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsCreate>>, {data: NonReadonly<OperatorRosterAssignment>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorOperatorRosterAssignmentsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorOperatorRosterAssignmentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsCreate>>>
    export type V1ProductionShopfloorOperatorRosterAssignmentsCreateMutationBody = NonReadonly<OperatorRosterAssignment>
    export type V1ProductionShopfloorOperatorRosterAssignmentsCreateMutationError = unknown

    /**
 * @summary Assign an operator to a roster for a period
 */
export const useV1ProductionShopfloorOperatorRosterAssignmentsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsCreate>>, TError,{data: NonReadonly<OperatorRosterAssignment>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsCreate>>,
        TError,
        {data: NonReadonly<OperatorRosterAssignment>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorOperatorRosterAssignmentsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorOperatorRosterAssignmentsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperatorRosterAssignment>(
      {url: `/api/v1/production/shopfloor/operator-roster-assignments/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorOperatorRosterAssignmentsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/operator-roster-assignments/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorOperatorRosterAssignmentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorOperatorRosterAssignmentsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>> = ({ signal }) => v1ProductionShopfloorOperatorRosterAssignmentsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorOperatorRosterAssignmentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>>
export type V1ProductionShopfloorOperatorRosterAssignmentsRetrieveQueryError = unknown


export function useV1ProductionShopfloorOperatorRosterAssignmentsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorRosterAssignmentsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorRosterAssignmentsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorOperatorRosterAssignmentsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorOperatorRosterAssignmentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorOperatorRosterAssignmentsUpdate = (
    id: string,
    operatorRosterAssignment: NonReadonly<OperatorRosterAssignment>,
 ) => {
      
      
      return customAxiosInstance<OperatorRosterAssignment>(
      {url: `/api/v1/production/shopfloor/operator-roster-assignments/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: operatorRosterAssignment
    },
      );
    }
  


export const getV1ProductionShopfloorOperatorRosterAssignmentsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsUpdate>>, TError,{id: string;data: NonReadonly<OperatorRosterAssignment>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsUpdate>>, TError,{id: string;data: NonReadonly<OperatorRosterAssignment>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorOperatorRosterAssignmentsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsUpdate>>, {id: string;data: NonReadonly<OperatorRosterAssignment>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorOperatorRosterAssignmentsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorOperatorRosterAssignmentsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsUpdate>>>
    export type V1ProductionShopfloorOperatorRosterAssignmentsUpdateMutationBody = NonReadonly<OperatorRosterAssignment>
    export type V1ProductionShopfloorOperatorRosterAssignmentsUpdateMutationError = unknown

    export const useV1ProductionShopfloorOperatorRosterAssignmentsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsUpdate>>, TError,{id: string;data: NonReadonly<OperatorRosterAssignment>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsUpdate>>,
        TError,
        {id: string;data: NonReadonly<OperatorRosterAssignment>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorOperatorRosterAssignmentsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate = (
    id: string,
    patchedOperatorRosterAssignment: NonReadonly<PatchedOperatorRosterAssignment>,
 ) => {
      
      
      return customAxiosInstance<OperatorRosterAssignment>(
      {url: `/api/v1/production/shopfloor/operator-roster-assignments/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedOperatorRosterAssignment
    },
      );
    }
  


export const getV1ProductionShopfloorOperatorRosterAssignmentsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOperatorRosterAssignment>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOperatorRosterAssignment>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate>>, {id: string;data: NonReadonly<PatchedOperatorRosterAssignment>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorOperatorRosterAssignmentsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate>>>
    export type V1ProductionShopfloorOperatorRosterAssignmentsPartialUpdateMutationBody = NonReadonly<PatchedOperatorRosterAssignment>
    export type V1ProductionShopfloorOperatorRosterAssignmentsPartialUpdateMutationError = unknown

    export const useV1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOperatorRosterAssignment>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedOperatorRosterAssignment>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorOperatorRosterAssignmentsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorOperatorRosterAssignmentsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/operator-roster-assignments/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionShopfloorOperatorRosterAssignmentsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionShopfloorOperatorRosterAssignmentsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionShopfloorOperatorRosterAssignmentsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorOperatorRosterAssignmentsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsDestroy>>>
    
    export type V1ProductionShopfloorOperatorRosterAssignmentsDestroyMutationError = unknown

    export const useV1ProductionShopfloorOperatorRosterAssignmentsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorOperatorRosterAssignmentsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Resolve the effective shift for an operator on a given date (Rule RES-01)
 */
export const v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperatorRosterAssignment>(
      {url: `/api/v1/production/shopfloor/operator-roster-assignments/resolve/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieveQueryKey = () => {
    return [
    `/api/v1/production/shopfloor/operator-roster-assignments/resolve/`
    ] as const;
    }

    
export const getV1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>> = ({ signal }) => v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>>
export type V1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieveQueryError = unknown


export function useV1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Resolve the effective shift for an operator on a given date (Rule RES-01)
 */

export function useV1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorOperatorRosterAssignmentsResolveRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Rule TRC-01: append-only. Records are created only via ShiftSwapService
or the (future) manual "single-day reassignment" action — never via a
bare POST here — to guarantee an approver/reason is always attached.
 * @summary List individual operator shift overrides (append-only)
 */
export const v1ProductionShopfloorOperatorShiftOverridesList = (
    params?: V1ProductionShopfloorOperatorShiftOverridesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOperatorShiftOverrideList>(
      {url: `/api/v1/production/shopfloor/operator-shift-overrides/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorOperatorShiftOverridesListQueryKey = (params?: V1ProductionShopfloorOperatorShiftOverridesListParams,) => {
    return [
    `/api/v1/production/shopfloor/operator-shift-overrides/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorOperatorShiftOverridesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError = unknown>(params?: V1ProductionShopfloorOperatorShiftOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorOperatorShiftOverridesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>> = ({ signal }) => v1ProductionShopfloorOperatorShiftOverridesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorOperatorShiftOverridesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>>
export type V1ProductionShopfloorOperatorShiftOverridesListQueryError = unknown


export function useV1ProductionShopfloorOperatorShiftOverridesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorOperatorShiftOverridesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorShiftOverridesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError = unknown>(
 params?: V1ProductionShopfloorOperatorShiftOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorShiftOverridesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError = unknown>(
 params?: V1ProductionShopfloorOperatorShiftOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List individual operator shift overrides (append-only)
 */

export function useV1ProductionShopfloorOperatorShiftOverridesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError = unknown>(
 params?: V1ProductionShopfloorOperatorShiftOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorOperatorShiftOverridesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Rule TRC-01: append-only. Records are created only via ShiftSwapService
or the (future) manual "single-day reassignment" action — never via a
bare POST here — to guarantee an approver/reason is always attached.
 */
export const v1ProductionShopfloorOperatorShiftOverridesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperatorShiftOverride>(
      {url: `/api/v1/production/shopfloor/operator-shift-overrides/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorOperatorShiftOverridesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/operator-shift-overrides/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorOperatorShiftOverridesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorOperatorShiftOverridesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>> = ({ signal }) => v1ProductionShopfloorOperatorShiftOverridesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorOperatorShiftOverridesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>>
export type V1ProductionShopfloorOperatorShiftOverridesRetrieveQueryError = unknown


export function useV1ProductionShopfloorOperatorShiftOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorShiftOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOperatorShiftOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorOperatorShiftOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOperatorShiftOverridesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorOperatorShiftOverridesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List ad-hoc overtime records (append-only)
 */
export const v1ProductionShopfloorOvertimeRecordsList = (
    params?: V1ProductionShopfloorOvertimeRecordsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOvertimeRecordList>(
      {url: `/api/v1/production/shopfloor/overtime-records/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorOvertimeRecordsListQueryKey = (params?: V1ProductionShopfloorOvertimeRecordsListParams,) => {
    return [
    `/api/v1/production/shopfloor/overtime-records/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorOvertimeRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError = unknown>(params?: V1ProductionShopfloorOvertimeRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorOvertimeRecordsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>> = ({ signal }) => v1ProductionShopfloorOvertimeRecordsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorOvertimeRecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>>
export type V1ProductionShopfloorOvertimeRecordsListQueryError = unknown


export function useV1ProductionShopfloorOvertimeRecordsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorOvertimeRecordsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOvertimeRecordsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError = unknown>(
 params?: V1ProductionShopfloorOvertimeRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOvertimeRecordsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError = unknown>(
 params?: V1ProductionShopfloorOvertimeRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List ad-hoc overtime records (append-only)
 */

export function useV1ProductionShopfloorOvertimeRecordsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError = unknown>(
 params?: V1ProductionShopfloorOvertimeRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorOvertimeRecordsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorOvertimeRecordsCreate = (
    overtimeRecord: NonReadonly<OvertimeRecord>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OvertimeRecord>(
      {url: `/api/v1/production/shopfloor/overtime-records/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: overtimeRecord, signal
    },
      );
    }
  


export const getV1ProductionShopfloorOvertimeRecordsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsCreate>>, TError,{data: NonReadonly<OvertimeRecord>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsCreate>>, TError,{data: NonReadonly<OvertimeRecord>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorOvertimeRecordsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsCreate>>, {data: NonReadonly<OvertimeRecord>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorOvertimeRecordsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorOvertimeRecordsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsCreate>>>
    export type V1ProductionShopfloorOvertimeRecordsCreateMutationBody = NonReadonly<OvertimeRecord>
    export type V1ProductionShopfloorOvertimeRecordsCreateMutationError = unknown

    export const useV1ProductionShopfloorOvertimeRecordsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsCreate>>, TError,{data: NonReadonly<OvertimeRecord>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsCreate>>,
        TError,
        {data: NonReadonly<OvertimeRecord>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorOvertimeRecordsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorOvertimeRecordsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OvertimeRecord>(
      {url: `/api/v1/production/shopfloor/overtime-records/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorOvertimeRecordsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/overtime-records/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorOvertimeRecordsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorOvertimeRecordsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>> = ({ signal }) => v1ProductionShopfloorOvertimeRecordsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorOvertimeRecordsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>>
export type V1ProductionShopfloorOvertimeRecordsRetrieveQueryError = unknown


export function useV1ProductionShopfloorOvertimeRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOvertimeRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorOvertimeRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorOvertimeRecordsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorOvertimeRecordsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorOvertimeRecordsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List roster days
 */
export const v1ProductionShopfloorRosterDaysList = (
    params?: V1ProductionShopfloorRosterDaysListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedRosterDayList>(
      {url: `/api/v1/production/shopfloor/roster-days/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorRosterDaysListQueryKey = (params?: V1ProductionShopfloorRosterDaysListParams,) => {
    return [
    `/api/v1/production/shopfloor/roster-days/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorRosterDaysListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError = unknown>(params?: V1ProductionShopfloorRosterDaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorRosterDaysListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>> = ({ signal }) => v1ProductionShopfloorRosterDaysList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorRosterDaysListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>>
export type V1ProductionShopfloorRosterDaysListQueryError = unknown


export function useV1ProductionShopfloorRosterDaysList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorRosterDaysListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorRosterDaysList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError = unknown>(
 params?: V1ProductionShopfloorRosterDaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorRosterDaysList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError = unknown>(
 params?: V1ProductionShopfloorRosterDaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List roster days
 */

export function useV1ProductionShopfloorRosterDaysList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError = unknown>(
 params?: V1ProductionShopfloorRosterDaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorRosterDaysListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Map a day_index to a shift template
 */
export const v1ProductionShopfloorRosterDaysCreate = (
    rosterDay: NonReadonly<RosterDay>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RosterDay>(
      {url: `/api/v1/production/shopfloor/roster-days/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rosterDay, signal
    },
      );
    }
  


export const getV1ProductionShopfloorRosterDaysCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysCreate>>, TError,{data: NonReadonly<RosterDay>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysCreate>>, TError,{data: NonReadonly<RosterDay>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorRosterDaysCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysCreate>>, {data: NonReadonly<RosterDay>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorRosterDaysCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorRosterDaysCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysCreate>>>
    export type V1ProductionShopfloorRosterDaysCreateMutationBody = NonReadonly<RosterDay>
    export type V1ProductionShopfloorRosterDaysCreateMutationError = unknown

    /**
 * @summary Map a day_index to a shift template
 */
export const useV1ProductionShopfloorRosterDaysCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysCreate>>, TError,{data: NonReadonly<RosterDay>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysCreate>>,
        TError,
        {data: NonReadonly<RosterDay>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorRosterDaysCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorRosterDaysRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<RosterDay>(
      {url: `/api/v1/production/shopfloor/roster-days/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorRosterDaysRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/roster-days/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorRosterDaysRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorRosterDaysRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>> = ({ signal }) => v1ProductionShopfloorRosterDaysRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorRosterDaysRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>>
export type V1ProductionShopfloorRosterDaysRetrieveQueryError = unknown


export function useV1ProductionShopfloorRosterDaysRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorRosterDaysRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorRosterDaysRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorRosterDaysRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorRosterDaysRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorRosterDaysUpdate = (
    id: string,
    rosterDay: NonReadonly<RosterDay>,
 ) => {
      
      
      return customAxiosInstance<RosterDay>(
      {url: `/api/v1/production/shopfloor/roster-days/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rosterDay
    },
      );
    }
  


export const getV1ProductionShopfloorRosterDaysUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysUpdate>>, TError,{id: string;data: NonReadonly<RosterDay>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysUpdate>>, TError,{id: string;data: NonReadonly<RosterDay>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorRosterDaysUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysUpdate>>, {id: string;data: NonReadonly<RosterDay>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorRosterDaysUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorRosterDaysUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysUpdate>>>
    export type V1ProductionShopfloorRosterDaysUpdateMutationBody = NonReadonly<RosterDay>
    export type V1ProductionShopfloorRosterDaysUpdateMutationError = unknown

    export const useV1ProductionShopfloorRosterDaysUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysUpdate>>, TError,{id: string;data: NonReadonly<RosterDay>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysUpdate>>,
        TError,
        {id: string;data: NonReadonly<RosterDay>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorRosterDaysUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorRosterDaysPartialUpdate = (
    id: string,
    patchedRosterDay: NonReadonly<PatchedRosterDay>,
 ) => {
      
      
      return customAxiosInstance<RosterDay>(
      {url: `/api/v1/production/shopfloor/roster-days/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRosterDay
    },
      );
    }
  


export const getV1ProductionShopfloorRosterDaysPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRosterDay>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRosterDay>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorRosterDaysPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysPartialUpdate>>, {id: string;data: NonReadonly<PatchedRosterDay>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorRosterDaysPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorRosterDaysPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysPartialUpdate>>>
    export type V1ProductionShopfloorRosterDaysPartialUpdateMutationBody = NonReadonly<PatchedRosterDay>
    export type V1ProductionShopfloorRosterDaysPartialUpdateMutationError = unknown

    export const useV1ProductionShopfloorRosterDaysPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRosterDay>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedRosterDay>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorRosterDaysPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorRosterDaysDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/roster-days/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionShopfloorRosterDaysDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionShopfloorRosterDaysDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionShopfloorRosterDaysDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorRosterDaysDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysDestroy>>>
    
    export type V1ProductionShopfloorRosterDaysDestroyMutationError = unknown

    export const useV1ProductionShopfloorRosterDaysDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorRosterDaysDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorRosterDaysDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List rosters (with their days)
 */
export const v1ProductionShopfloorRostersList = (
    params?: V1ProductionShopfloorRostersListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedRosterList>(
      {url: `/api/v1/production/shopfloor/rosters/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorRostersListQueryKey = (params?: V1ProductionShopfloorRostersListParams,) => {
    return [
    `/api/v1/production/shopfloor/rosters/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorRostersListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError = unknown>(params?: V1ProductionShopfloorRostersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorRostersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>> = ({ signal }) => v1ProductionShopfloorRostersList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorRostersListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>>
export type V1ProductionShopfloorRostersListQueryError = unknown


export function useV1ProductionShopfloorRostersList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorRostersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorRostersList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError = unknown>(
 params?: V1ProductionShopfloorRostersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorRostersList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError = unknown>(
 params?: V1ProductionShopfloorRostersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List rosters (with their days)
 */

export function useV1ProductionShopfloorRostersList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError = unknown>(
 params?: V1ProductionShopfloorRostersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorRostersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a roster
 */
export const v1ProductionShopfloorRostersCreate = (
    roster: NonReadonly<Roster>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Roster>(
      {url: `/api/v1/production/shopfloor/rosters/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: roster, signal
    },
      );
    }
  


export const getV1ProductionShopfloorRostersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersCreate>>, TError,{data: NonReadonly<Roster>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersCreate>>, TError,{data: NonReadonly<Roster>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorRostersCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRostersCreate>>, {data: NonReadonly<Roster>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorRostersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorRostersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRostersCreate>>>
    export type V1ProductionShopfloorRostersCreateMutationBody = NonReadonly<Roster>
    export type V1ProductionShopfloorRostersCreateMutationError = unknown

    /**
 * @summary Create a roster
 */
export const useV1ProductionShopfloorRostersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersCreate>>, TError,{data: NonReadonly<Roster>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorRostersCreate>>,
        TError,
        {data: NonReadonly<Roster>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorRostersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a roster
 */
export const v1ProductionShopfloorRostersRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Roster>(
      {url: `/api/v1/production/shopfloor/rosters/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorRostersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/rosters/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorRostersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorRostersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>> = ({ signal }) => v1ProductionShopfloorRostersRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorRostersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>>
export type V1ProductionShopfloorRostersRetrieveQueryError = unknown


export function useV1ProductionShopfloorRostersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorRostersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorRostersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a roster
 */

export function useV1ProductionShopfloorRostersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorRostersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorRostersUpdate = (
    id: string,
    roster: NonReadonly<Roster>,
 ) => {
      
      
      return customAxiosInstance<Roster>(
      {url: `/api/v1/production/shopfloor/rosters/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: roster
    },
      );
    }
  


export const getV1ProductionShopfloorRostersUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersUpdate>>, TError,{id: string;data: NonReadonly<Roster>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersUpdate>>, TError,{id: string;data: NonReadonly<Roster>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorRostersUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRostersUpdate>>, {id: string;data: NonReadonly<Roster>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorRostersUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorRostersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRostersUpdate>>>
    export type V1ProductionShopfloorRostersUpdateMutationBody = NonReadonly<Roster>
    export type V1ProductionShopfloorRostersUpdateMutationError = unknown

    export const useV1ProductionShopfloorRostersUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersUpdate>>, TError,{id: string;data: NonReadonly<Roster>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorRostersUpdate>>,
        TError,
        {id: string;data: NonReadonly<Roster>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorRostersUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorRostersPartialUpdate = (
    id: string,
    patchedRoster: NonReadonly<PatchedRoster>,
 ) => {
      
      
      return customAxiosInstance<Roster>(
      {url: `/api/v1/production/shopfloor/rosters/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRoster
    },
      );
    }
  


export const getV1ProductionShopfloorRostersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoster>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoster>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorRostersPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRostersPartialUpdate>>, {id: string;data: NonReadonly<PatchedRoster>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorRostersPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorRostersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRostersPartialUpdate>>>
    export type V1ProductionShopfloorRostersPartialUpdateMutationBody = NonReadonly<PatchedRoster>
    export type V1ProductionShopfloorRostersPartialUpdateMutationError = unknown

    export const useV1ProductionShopfloorRostersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedRoster>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorRostersPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedRoster>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorRostersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorRostersDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/rosters/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionShopfloorRostersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionShopfloorRostersDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorRostersDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionShopfloorRostersDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorRostersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorRostersDestroy>>>
    
    export type V1ProductionShopfloorRostersDestroyMutationError = unknown

    export const useV1ProductionShopfloorRostersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorRostersDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorRostersDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorRostersDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List shift boundary overrides
 */
export const v1ProductionShopfloorShiftBoundaryOverridesList = (
    params?: V1ProductionShopfloorShiftBoundaryOverridesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedShiftBoundaryOverrideList>(
      {url: `/api/v1/production/shopfloor/shift-boundary-overrides/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorShiftBoundaryOverridesListQueryKey = (params?: V1ProductionShopfloorShiftBoundaryOverridesListParams,) => {
    return [
    `/api/v1/production/shopfloor/shift-boundary-overrides/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorShiftBoundaryOverridesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError = unknown>(params?: V1ProductionShopfloorShiftBoundaryOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorShiftBoundaryOverridesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>> = ({ signal }) => v1ProductionShopfloorShiftBoundaryOverridesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorShiftBoundaryOverridesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>>
export type V1ProductionShopfloorShiftBoundaryOverridesListQueryError = unknown


export function useV1ProductionShopfloorShiftBoundaryOverridesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorShiftBoundaryOverridesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftBoundaryOverridesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError = unknown>(
 params?: V1ProductionShopfloorShiftBoundaryOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftBoundaryOverridesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError = unknown>(
 params?: V1ProductionShopfloorShiftBoundaryOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List shift boundary overrides
 */

export function useV1ProductionShopfloorShiftBoundaryOverridesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError = unknown>(
 params?: V1ProductionShopfloorShiftBoundaryOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorShiftBoundaryOverridesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftBoundaryOverridesCreate = (
    shiftBoundaryOverride: NonReadonly<ShiftBoundaryOverride>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ShiftBoundaryOverride>(
      {url: `/api/v1/production/shopfloor/shift-boundary-overrides/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shiftBoundaryOverride, signal
    },
      );
    }
  


export const getV1ProductionShopfloorShiftBoundaryOverridesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesCreate>>, TError,{data: NonReadonly<ShiftBoundaryOverride>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesCreate>>, TError,{data: NonReadonly<ShiftBoundaryOverride>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftBoundaryOverridesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesCreate>>, {data: NonReadonly<ShiftBoundaryOverride>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorShiftBoundaryOverridesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftBoundaryOverridesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesCreate>>>
    export type V1ProductionShopfloorShiftBoundaryOverridesCreateMutationBody = NonReadonly<ShiftBoundaryOverride>
    export type V1ProductionShopfloorShiftBoundaryOverridesCreateMutationError = unknown

    export const useV1ProductionShopfloorShiftBoundaryOverridesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesCreate>>, TError,{data: NonReadonly<ShiftBoundaryOverride>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesCreate>>,
        TError,
        {data: NonReadonly<ShiftBoundaryOverride>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftBoundaryOverridesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftBoundaryOverridesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ShiftBoundaryOverride>(
      {url: `/api/v1/production/shopfloor/shift-boundary-overrides/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorShiftBoundaryOverridesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/shift-boundary-overrides/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorShiftBoundaryOverridesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorShiftBoundaryOverridesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>> = ({ signal }) => v1ProductionShopfloorShiftBoundaryOverridesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorShiftBoundaryOverridesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>>
export type V1ProductionShopfloorShiftBoundaryOverridesRetrieveQueryError = unknown


export function useV1ProductionShopfloorShiftBoundaryOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftBoundaryOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftBoundaryOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorShiftBoundaryOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorShiftBoundaryOverridesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftBoundaryOverridesUpdate = (
    id: string,
    shiftBoundaryOverride: NonReadonly<ShiftBoundaryOverride>,
 ) => {
      
      
      return customAxiosInstance<ShiftBoundaryOverride>(
      {url: `/api/v1/production/shopfloor/shift-boundary-overrides/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: shiftBoundaryOverride
    },
      );
    }
  


export const getV1ProductionShopfloorShiftBoundaryOverridesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesUpdate>>, TError,{id: string;data: NonReadonly<ShiftBoundaryOverride>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesUpdate>>, TError,{id: string;data: NonReadonly<ShiftBoundaryOverride>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftBoundaryOverridesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesUpdate>>, {id: string;data: NonReadonly<ShiftBoundaryOverride>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorShiftBoundaryOverridesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftBoundaryOverridesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesUpdate>>>
    export type V1ProductionShopfloorShiftBoundaryOverridesUpdateMutationBody = NonReadonly<ShiftBoundaryOverride>
    export type V1ProductionShopfloorShiftBoundaryOverridesUpdateMutationError = unknown

    export const useV1ProductionShopfloorShiftBoundaryOverridesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesUpdate>>, TError,{id: string;data: NonReadonly<ShiftBoundaryOverride>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesUpdate>>,
        TError,
        {id: string;data: NonReadonly<ShiftBoundaryOverride>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftBoundaryOverridesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftBoundaryOverridesPartialUpdate = (
    id: string,
    patchedShiftBoundaryOverride: NonReadonly<PatchedShiftBoundaryOverride>,
 ) => {
      
      
      return customAxiosInstance<ShiftBoundaryOverride>(
      {url: `/api/v1/production/shopfloor/shift-boundary-overrides/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedShiftBoundaryOverride
    },
      );
    }
  


export const getV1ProductionShopfloorShiftBoundaryOverridesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedShiftBoundaryOverride>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedShiftBoundaryOverride>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftBoundaryOverridesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesPartialUpdate>>, {id: string;data: NonReadonly<PatchedShiftBoundaryOverride>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorShiftBoundaryOverridesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftBoundaryOverridesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesPartialUpdate>>>
    export type V1ProductionShopfloorShiftBoundaryOverridesPartialUpdateMutationBody = NonReadonly<PatchedShiftBoundaryOverride>
    export type V1ProductionShopfloorShiftBoundaryOverridesPartialUpdateMutationError = unknown

    export const useV1ProductionShopfloorShiftBoundaryOverridesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedShiftBoundaryOverride>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedShiftBoundaryOverride>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftBoundaryOverridesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftBoundaryOverridesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/shift-boundary-overrides/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionShopfloorShiftBoundaryOverridesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftBoundaryOverridesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionShopfloorShiftBoundaryOverridesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftBoundaryOverridesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesDestroy>>>
    
    export type V1ProductionShopfloorShiftBoundaryOverridesDestroyMutationError = unknown

    export const useV1ProductionShopfloorShiftBoundaryOverridesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftBoundaryOverridesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftBoundaryOverridesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List shift swap requests
 */
export const v1ProductionShopfloorShiftSwapRequestsList = (
    params?: V1ProductionShopfloorShiftSwapRequestsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedShiftSwapRequestList>(
      {url: `/api/v1/production/shopfloor/shift-swap-requests/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorShiftSwapRequestsListQueryKey = (params?: V1ProductionShopfloorShiftSwapRequestsListParams,) => {
    return [
    `/api/v1/production/shopfloor/shift-swap-requests/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorShiftSwapRequestsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError = unknown>(params?: V1ProductionShopfloorShiftSwapRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorShiftSwapRequestsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>> = ({ signal }) => v1ProductionShopfloorShiftSwapRequestsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorShiftSwapRequestsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>>
export type V1ProductionShopfloorShiftSwapRequestsListQueryError = unknown


export function useV1ProductionShopfloorShiftSwapRequestsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorShiftSwapRequestsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftSwapRequestsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError = unknown>(
 params?: V1ProductionShopfloorShiftSwapRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftSwapRequestsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError = unknown>(
 params?: V1ProductionShopfloorShiftSwapRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List shift swap requests
 */

export function useV1ProductionShopfloorShiftSwapRequestsList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError = unknown>(
 params?: V1ProductionShopfloorShiftSwapRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorShiftSwapRequestsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftSwapRequestsCreate = (
    shiftSwapRequest: NonReadonly<ShiftSwapRequest>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ShiftSwapRequest>(
      {url: `/api/v1/production/shopfloor/shift-swap-requests/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shiftSwapRequest, signal
    },
      );
    }
  


export const getV1ProductionShopfloorShiftSwapRequestsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsCreate>>, TError,{data: NonReadonly<ShiftSwapRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsCreate>>, TError,{data: NonReadonly<ShiftSwapRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftSwapRequestsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsCreate>>, {data: NonReadonly<ShiftSwapRequest>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorShiftSwapRequestsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftSwapRequestsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsCreate>>>
    export type V1ProductionShopfloorShiftSwapRequestsCreateMutationBody = NonReadonly<ShiftSwapRequest>
    export type V1ProductionShopfloorShiftSwapRequestsCreateMutationError = unknown

    export const useV1ProductionShopfloorShiftSwapRequestsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsCreate>>, TError,{data: NonReadonly<ShiftSwapRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsCreate>>,
        TError,
        {data: NonReadonly<ShiftSwapRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftSwapRequestsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftSwapRequestsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ShiftSwapRequest>(
      {url: `/api/v1/production/shopfloor/shift-swap-requests/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorShiftSwapRequestsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/shift-swap-requests/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorShiftSwapRequestsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorShiftSwapRequestsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>> = ({ signal }) => v1ProductionShopfloorShiftSwapRequestsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorShiftSwapRequestsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>>
export type V1ProductionShopfloorShiftSwapRequestsRetrieveQueryError = unknown


export function useV1ProductionShopfloorShiftSwapRequestsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftSwapRequestsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftSwapRequestsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorShiftSwapRequestsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorShiftSwapRequestsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftSwapRequestsUpdate = (
    id: string,
    shiftSwapRequest: NonReadonly<ShiftSwapRequest>,
 ) => {
      
      
      return customAxiosInstance<ShiftSwapRequest>(
      {url: `/api/v1/production/shopfloor/shift-swap-requests/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: shiftSwapRequest
    },
      );
    }
  


export const getV1ProductionShopfloorShiftSwapRequestsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsUpdate>>, TError,{id: string;data: NonReadonly<ShiftSwapRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsUpdate>>, TError,{id: string;data: NonReadonly<ShiftSwapRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftSwapRequestsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsUpdate>>, {id: string;data: NonReadonly<ShiftSwapRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorShiftSwapRequestsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftSwapRequestsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsUpdate>>>
    export type V1ProductionShopfloorShiftSwapRequestsUpdateMutationBody = NonReadonly<ShiftSwapRequest>
    export type V1ProductionShopfloorShiftSwapRequestsUpdateMutationError = unknown

    export const useV1ProductionShopfloorShiftSwapRequestsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsUpdate>>, TError,{id: string;data: NonReadonly<ShiftSwapRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsUpdate>>,
        TError,
        {id: string;data: NonReadonly<ShiftSwapRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftSwapRequestsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftSwapRequestsPartialUpdate = (
    id: string,
    patchedShiftSwapRequest: NonReadonly<PatchedShiftSwapRequest>,
 ) => {
      
      
      return customAxiosInstance<ShiftSwapRequest>(
      {url: `/api/v1/production/shopfloor/shift-swap-requests/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedShiftSwapRequest
    },
      );
    }
  


export const getV1ProductionShopfloorShiftSwapRequestsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedShiftSwapRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedShiftSwapRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftSwapRequestsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsPartialUpdate>>, {id: string;data: NonReadonly<PatchedShiftSwapRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorShiftSwapRequestsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftSwapRequestsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsPartialUpdate>>>
    export type V1ProductionShopfloorShiftSwapRequestsPartialUpdateMutationBody = NonReadonly<PatchedShiftSwapRequest>
    export type V1ProductionShopfloorShiftSwapRequestsPartialUpdateMutationError = unknown

    export const useV1ProductionShopfloorShiftSwapRequestsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedShiftSwapRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedShiftSwapRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftSwapRequestsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftSwapRequestsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/shift-swap-requests/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionShopfloorShiftSwapRequestsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftSwapRequestsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionShopfloorShiftSwapRequestsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftSwapRequestsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsDestroy>>>
    
    export type V1ProductionShopfloorShiftSwapRequestsDestroyMutationError = unknown

    export const useV1ProductionShopfloorShiftSwapRequestsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftSwapRequestsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Approve a shift swap (generates the two OperatorShiftOverride records)
 */
export const v1ProductionShopfloorShiftSwapRequestsApproveCreate = (
    id: string,
    shiftSwapRequest: NonReadonly<ShiftSwapRequest>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ShiftSwapRequest>(
      {url: `/api/v1/production/shopfloor/shift-swap-requests/${id}/approve/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shiftSwapRequest, signal
    },
      );
    }
  


export const getV1ProductionShopfloorShiftSwapRequestsApproveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsApproveCreate>>, TError,{id: string;data: NonReadonly<ShiftSwapRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsApproveCreate>>, TError,{id: string;data: NonReadonly<ShiftSwapRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftSwapRequestsApproveCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsApproveCreate>>, {id: string;data: NonReadonly<ShiftSwapRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorShiftSwapRequestsApproveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftSwapRequestsApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsApproveCreate>>>
    export type V1ProductionShopfloorShiftSwapRequestsApproveCreateMutationBody = NonReadonly<ShiftSwapRequest>
    export type V1ProductionShopfloorShiftSwapRequestsApproveCreateMutationError = unknown

    /**
 * @summary Approve a shift swap (generates the two OperatorShiftOverride records)
 */
export const useV1ProductionShopfloorShiftSwapRequestsApproveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsApproveCreate>>, TError,{id: string;data: NonReadonly<ShiftSwapRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsApproveCreate>>,
        TError,
        {id: string;data: NonReadonly<ShiftSwapRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftSwapRequestsApproveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Reject a shift swap
 */
export const v1ProductionShopfloorShiftSwapRequestsRejectCreate = (
    id: string,
    shiftSwapRequest: NonReadonly<ShiftSwapRequest>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ShiftSwapRequest>(
      {url: `/api/v1/production/shopfloor/shift-swap-requests/${id}/reject/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shiftSwapRequest, signal
    },
      );
    }
  


export const getV1ProductionShopfloorShiftSwapRequestsRejectCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRejectCreate>>, TError,{id: string;data: NonReadonly<ShiftSwapRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRejectCreate>>, TError,{id: string;data: NonReadonly<ShiftSwapRequest>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftSwapRequestsRejectCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRejectCreate>>, {id: string;data: NonReadonly<ShiftSwapRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorShiftSwapRequestsRejectCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftSwapRequestsRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRejectCreate>>>
    export type V1ProductionShopfloorShiftSwapRequestsRejectCreateMutationBody = NonReadonly<ShiftSwapRequest>
    export type V1ProductionShopfloorShiftSwapRequestsRejectCreateMutationError = unknown

    /**
 * @summary Reject a shift swap
 */
export const useV1ProductionShopfloorShiftSwapRequestsRejectCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRejectCreate>>, TError,{id: string;data: NonReadonly<ShiftSwapRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftSwapRequestsRejectCreate>>,
        TError,
        {id: string;data: NonReadonly<ShiftSwapRequest>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftSwapRequestsRejectCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List shift templates
 */
export const v1ProductionShopfloorShiftTemplatesList = (
    params?: V1ProductionShopfloorShiftTemplatesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedShiftTemplateList>(
      {url: `/api/v1/production/shopfloor/shift-templates/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorShiftTemplatesListQueryKey = (params?: V1ProductionShopfloorShiftTemplatesListParams,) => {
    return [
    `/api/v1/production/shopfloor/shift-templates/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorShiftTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError = unknown>(params?: V1ProductionShopfloorShiftTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorShiftTemplatesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>> = ({ signal }) => v1ProductionShopfloorShiftTemplatesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorShiftTemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>>
export type V1ProductionShopfloorShiftTemplatesListQueryError = unknown


export function useV1ProductionShopfloorShiftTemplatesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError = unknown>(
 params: undefined |  V1ProductionShopfloorShiftTemplatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftTemplatesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError = unknown>(
 params?: V1ProductionShopfloorShiftTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftTemplatesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError = unknown>(
 params?: V1ProductionShopfloorShiftTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List shift templates
 */

export function useV1ProductionShopfloorShiftTemplatesList<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError = unknown>(
 params?: V1ProductionShopfloorShiftTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorShiftTemplatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a shift template
 */
export const v1ProductionShopfloorShiftTemplatesCreate = (
    shiftTemplate: NonReadonly<ShiftTemplate>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ShiftTemplate>(
      {url: `/api/v1/production/shopfloor/shift-templates/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shiftTemplate, signal
    },
      );
    }
  


export const getV1ProductionShopfloorShiftTemplatesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesCreate>>, TError,{data: NonReadonly<ShiftTemplate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesCreate>>, TError,{data: NonReadonly<ShiftTemplate>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftTemplatesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesCreate>>, {data: NonReadonly<ShiftTemplate>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShopfloorShiftTemplatesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftTemplatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesCreate>>>
    export type V1ProductionShopfloorShiftTemplatesCreateMutationBody = NonReadonly<ShiftTemplate>
    export type V1ProductionShopfloorShiftTemplatesCreateMutationError = unknown

    /**
 * @summary Create a shift template
 */
export const useV1ProductionShopfloorShiftTemplatesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesCreate>>, TError,{data: NonReadonly<ShiftTemplate>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesCreate>>,
        TError,
        {data: NonReadonly<ShiftTemplate>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftTemplatesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a shift template
 */
export const v1ProductionShopfloorShiftTemplatesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ShiftTemplate>(
      {url: `/api/v1/production/shopfloor/shift-templates/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorShiftTemplatesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shopfloor/shift-templates/${id}/`
    ] as const;
    }

    
export const getV1ProductionShopfloorShiftTemplatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorShiftTemplatesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>> = ({ signal }) => v1ProductionShopfloorShiftTemplatesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorShiftTemplatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>>
export type V1ProductionShopfloorShiftTemplatesRetrieveQueryError = unknown


export function useV1ProductionShopfloorShiftTemplatesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftTemplatesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorShiftTemplatesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a shift template
 */

export function useV1ProductionShopfloorShiftTemplatesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorShiftTemplatesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftTemplatesUpdate = (
    id: string,
    shiftTemplate: NonReadonly<ShiftTemplate>,
 ) => {
      
      
      return customAxiosInstance<ShiftTemplate>(
      {url: `/api/v1/production/shopfloor/shift-templates/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: shiftTemplate
    },
      );
    }
  


export const getV1ProductionShopfloorShiftTemplatesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesUpdate>>, TError,{id: string;data: NonReadonly<ShiftTemplate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesUpdate>>, TError,{id: string;data: NonReadonly<ShiftTemplate>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftTemplatesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesUpdate>>, {id: string;data: NonReadonly<ShiftTemplate>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorShiftTemplatesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftTemplatesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesUpdate>>>
    export type V1ProductionShopfloorShiftTemplatesUpdateMutationBody = NonReadonly<ShiftTemplate>
    export type V1ProductionShopfloorShiftTemplatesUpdateMutationError = unknown

    export const useV1ProductionShopfloorShiftTemplatesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesUpdate>>, TError,{id: string;data: NonReadonly<ShiftTemplate>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesUpdate>>,
        TError,
        {id: string;data: NonReadonly<ShiftTemplate>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftTemplatesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftTemplatesPartialUpdate = (
    id: string,
    patchedShiftTemplate: NonReadonly<PatchedShiftTemplate>,
 ) => {
      
      
      return customAxiosInstance<ShiftTemplate>(
      {url: `/api/v1/production/shopfloor/shift-templates/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedShiftTemplate
    },
      );
    }
  


export const getV1ProductionShopfloorShiftTemplatesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedShiftTemplate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedShiftTemplate>}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftTemplatesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesPartialUpdate>>, {id: string;data: NonReadonly<PatchedShiftTemplate>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShopfloorShiftTemplatesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftTemplatesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesPartialUpdate>>>
    export type V1ProductionShopfloorShiftTemplatesPartialUpdateMutationBody = NonReadonly<PatchedShiftTemplate>
    export type V1ProductionShopfloorShiftTemplatesPartialUpdateMutationError = unknown

    export const useV1ProductionShopfloorShiftTemplatesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedShiftTemplate>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedShiftTemplate>},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftTemplatesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionShopfloorShiftTemplatesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/shift-templates/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionShopfloorShiftTemplatesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionShopfloorShiftTemplatesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionShopfloorShiftTemplatesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShopfloorShiftTemplatesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesDestroy>>>
    
    export type V1ProductionShopfloorShiftTemplatesDestroyMutationError = unknown

    export const useV1ProductionShopfloorShiftTemplatesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShopfloorShiftTemplatesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionShopfloorShiftTemplatesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-028: اندپوینت‌های Read-Only هوشمند — بدون create/update/destroy.

این ViewSet هیچ queryset پیش‌فرضی expose نمی‌کند (فقط اکشن‌های سفارشی
زیر) چون منطق آن ذاتاً context-aware است، نه لیست خام یک مدل.
 */
export const v1ProductionShopfloorWorkInstructionsRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/work-instructions/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorWorkInstructionsRetrieveQueryKey = () => {
    return [
    `/api/v1/production/shopfloor/work-instructions/`
    ] as const;
    }

    
export const getV1ProductionShopfloorWorkInstructionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorWorkInstructionsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>> = ({ signal }) => v1ProductionShopfloorWorkInstructionsRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorWorkInstructionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>>
export type V1ProductionShopfloorWorkInstructionsRetrieveQueryError = unknown


export function useV1ProductionShopfloorWorkInstructionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorWorkInstructionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorWorkInstructionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorWorkInstructionsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorWorkInstructionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-028 §2.2 — دستورالعمل ایستگاه(های) فعلیِ کاربر لاگین‌شده (اپراتور).
 */
export const v1ProductionShopfloorWorkInstructionsActiveRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/work-instructions/active/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShopfloorWorkInstructionsActiveRetrieveQueryKey = () => {
    return [
    `/api/v1/production/shopfloor/work-instructions/active/`
    ] as const;
    }

    
export const getV1ProductionShopfloorWorkInstructionsActiveRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorWorkInstructionsActiveRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>> = ({ signal }) => v1ProductionShopfloorWorkInstructionsActiveRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorWorkInstructionsActiveRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>>
export type V1ProductionShopfloorWorkInstructionsActiveRetrieveQueryError = unknown


export function useV1ProductionShopfloorWorkInstructionsActiveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorWorkInstructionsActiveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorWorkInstructionsActiveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorWorkInstructionsActiveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsActiveRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorWorkInstructionsActiveRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-028 §2.3 — دستورالعمل تمام ایستگاه‌های یک خط تولید (سرپرست/مدیر).
 */
export const v1ProductionShopfloorWorkInstructionsForLineRetrieve = (
    params: V1ProductionShopfloorWorkInstructionsForLineRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/shopfloor/work-instructions/for_line/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShopfloorWorkInstructionsForLineRetrieveQueryKey = (params?: V1ProductionShopfloorWorkInstructionsForLineRetrieveParams,) => {
    return [
    `/api/v1/production/shopfloor/work-instructions/for_line/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShopfloorWorkInstructionsForLineRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError = unknown>(params: V1ProductionShopfloorWorkInstructionsForLineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShopfloorWorkInstructionsForLineRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>> = ({ signal }) => v1ProductionShopfloorWorkInstructionsForLineRetrieve(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShopfloorWorkInstructionsForLineRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>>
export type V1ProductionShopfloorWorkInstructionsForLineRetrieveQueryError = unknown


export function useV1ProductionShopfloorWorkInstructionsForLineRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError = unknown>(
 params: V1ProductionShopfloorWorkInstructionsForLineRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorWorkInstructionsForLineRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError = unknown>(
 params: V1ProductionShopfloorWorkInstructionsForLineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShopfloorWorkInstructionsForLineRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError = unknown>(
 params: V1ProductionShopfloorWorkInstructionsForLineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShopfloorWorkInstructionsForLineRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError = unknown>(
 params: V1ProductionShopfloorWorkInstructionsForLineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShopfloorWorkInstructionsForLineRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShopfloorWorkInstructionsForLineRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-102 Phase B (revised) — originally documented as ADR-105, folded
into ADR-102 by AM-017 (documentation/numbering merge only; no model
or behavior change). Tenant scoping follows TenantScopedViewMixin.
 */
export const v1ProductionShortageHoldsList = (
    params?: V1ProductionShortageHoldsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkOrderShortageHoldList>(
      {url: `/api/v1/production/shortage-holds/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionShortageHoldsListQueryKey = (params?: V1ProductionShortageHoldsListParams,) => {
    return [
    `/api/v1/production/shortage-holds/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionShortageHoldsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError = unknown>(params?: V1ProductionShortageHoldsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShortageHoldsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>> = ({ signal }) => v1ProductionShortageHoldsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShortageHoldsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>>
export type V1ProductionShortageHoldsListQueryError = unknown


export function useV1ProductionShortageHoldsList<TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError = unknown>(
 params: undefined |  V1ProductionShortageHoldsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShortageHoldsList<TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError = unknown>(
 params?: V1ProductionShortageHoldsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShortageHoldsList<TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError = unknown>(
 params?: V1ProductionShortageHoldsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShortageHoldsList<TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError = unknown>(
 params?: V1ProductionShortageHoldsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShortageHoldsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-102 Phase B (revised) — originally documented as ADR-105, folded
into ADR-102 by AM-017 (documentation/numbering merge only; no model
or behavior change). Tenant scoping follows TenantScopedViewMixin.
 */
export const v1ProductionShortageHoldsCreate = (
    workOrderShortageHoldCreate: WorkOrderShortageHoldCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrderShortageHoldCreate>(
      {url: `/api/v1/production/shortage-holds/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workOrderShortageHoldCreate, signal
    },
      );
    }
  


export const getV1ProductionShortageHoldsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsCreate>>, TError,{data: WorkOrderShortageHoldCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsCreate>>, TError,{data: WorkOrderShortageHoldCreate}, TContext> => {

const mutationKey = ['v1ProductionShortageHoldsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShortageHoldsCreate>>, {data: WorkOrderShortageHoldCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionShortageHoldsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShortageHoldsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShortageHoldsCreate>>>
    export type V1ProductionShortageHoldsCreateMutationBody = WorkOrderShortageHoldCreate
    export type V1ProductionShortageHoldsCreateMutationError = unknown

    export const useV1ProductionShortageHoldsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsCreate>>, TError,{data: WorkOrderShortageHoldCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShortageHoldsCreate>>,
        TError,
        {data: WorkOrderShortageHoldCreate},
        TContext
      > => {

      const mutationOptions = getV1ProductionShortageHoldsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-102 Phase B (revised) — originally documented as ADR-105, folded
into ADR-102 by AM-017 (documentation/numbering merge only; no model
or behavior change). Tenant scoping follows TenantScopedViewMixin.
 */
export const v1ProductionShortageHoldsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrderShortageHold>(
      {url: `/api/v1/production/shortage-holds/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionShortageHoldsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/shortage-holds/${id}/`
    ] as const;
    }

    
export const getV1ProductionShortageHoldsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionShortageHoldsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>> = ({ signal }) => v1ProductionShortageHoldsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionShortageHoldsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>>
export type V1ProductionShortageHoldsRetrieveQueryError = unknown


export function useV1ProductionShortageHoldsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShortageHoldsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionShortageHoldsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionShortageHoldsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionShortageHoldsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-102 Phase B (revised) — originally documented as ADR-105, folded
into ADR-102 by AM-017 (documentation/numbering merge only; no model
or behavior change). Tenant scoping follows TenantScopedViewMixin.
 */
export const v1ProductionShortageHoldsQcApproveCreate = (
    id: string,
    qcApproval: QcApproval,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrderShortageHold>(
      {url: `/api/v1/production/shortage-holds/${id}/qc-approve/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: qcApproval, signal
    },
      );
    }
  


export const getV1ProductionShortageHoldsQcApproveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsQcApproveCreate>>, TError,{id: string;data: QcApproval}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsQcApproveCreate>>, TError,{id: string;data: QcApproval}, TContext> => {

const mutationKey = ['v1ProductionShortageHoldsQcApproveCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShortageHoldsQcApproveCreate>>, {id: string;data: QcApproval}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShortageHoldsQcApproveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShortageHoldsQcApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShortageHoldsQcApproveCreate>>>
    export type V1ProductionShortageHoldsQcApproveCreateMutationBody = QcApproval
    export type V1ProductionShortageHoldsQcApproveCreateMutationError = unknown

    export const useV1ProductionShortageHoldsQcApproveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsQcApproveCreate>>, TError,{id: string;data: QcApproval}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShortageHoldsQcApproveCreate>>,
        TError,
        {id: string;data: QcApproval},
        TContext
      > => {

      const mutationOptions = getV1ProductionShortageHoldsQcApproveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-102 Phase B (revised) — originally documented as ADR-105, folded
into ADR-102 by AM-017 (documentation/numbering merge only; no model
or behavior change). Tenant scoping follows TenantScopedViewMixin.
 */
export const v1ProductionShortageHoldsResumeCreate = (
    id: string,
    resume: Resume,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrderShortageHold>(
      {url: `/api/v1/production/shortage-holds/${id}/resume/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resume, signal
    },
      );
    }
  


export const getV1ProductionShortageHoldsResumeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsResumeCreate>>, TError,{id: string;data: Resume}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsResumeCreate>>, TError,{id: string;data: Resume}, TContext> => {

const mutationKey = ['v1ProductionShortageHoldsResumeCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionShortageHoldsResumeCreate>>, {id: string;data: Resume}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionShortageHoldsResumeCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionShortageHoldsResumeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionShortageHoldsResumeCreate>>>
    export type V1ProductionShortageHoldsResumeCreateMutationBody = Resume
    export type V1ProductionShortageHoldsResumeCreateMutationError = unknown

    export const useV1ProductionShortageHoldsResumeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionShortageHoldsResumeCreate>>, TError,{id: string;data: Resume}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionShortageHoldsResumeCreate>>,
        TError,
        {id: string;data: Resume},
        TContext
      > => {

      const mutationOptions = getV1ProductionShortageHoldsResumeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List operator station/machine assignments
 */
export const v1ProductionStationAssignmentOperatorStationAssignmentsList = (
    params?: V1ProductionStationAssignmentOperatorStationAssignmentsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOperatorStationAssignmentList>(
      {url: `/api/v1/production/station-assignment/operator-station-assignments/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionStationAssignmentOperatorStationAssignmentsListQueryKey = (params?: V1ProductionStationAssignmentOperatorStationAssignmentsListParams,) => {
    return [
    `/api/v1/production/station-assignment/operator-station-assignments/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionStationAssignmentOperatorStationAssignmentsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError = unknown>(params?: V1ProductionStationAssignmentOperatorStationAssignmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionStationAssignmentOperatorStationAssignmentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>> = ({ signal }) => v1ProductionStationAssignmentOperatorStationAssignmentsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionStationAssignmentOperatorStationAssignmentsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>>
export type V1ProductionStationAssignmentOperatorStationAssignmentsListQueryError = unknown


export function useV1ProductionStationAssignmentOperatorStationAssignmentsList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError = unknown>(
 params: undefined |  V1ProductionStationAssignmentOperatorStationAssignmentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationAssignmentsList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError = unknown>(
 params?: V1ProductionStationAssignmentOperatorStationAssignmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationAssignmentsList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError = unknown>(
 params?: V1ProductionStationAssignmentOperatorStationAssignmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List operator station/machine assignments
 */

export function useV1ProductionStationAssignmentOperatorStationAssignmentsList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError = unknown>(
 params?: V1ProductionStationAssignmentOperatorStationAssignmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionStationAssignmentOperatorStationAssignmentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationAssignmentsCreate = (
    operatorStationAssignment: NonReadonly<OperatorStationAssignment>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperatorStationAssignment>(
      {url: `/api/v1/production/station-assignment/operator-station-assignments/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: operatorStationAssignment, signal
    },
      );
    }
  


export const getV1ProductionStationAssignmentOperatorStationAssignmentsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsCreate>>, TError,{data: NonReadonly<OperatorStationAssignment>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsCreate>>, TError,{data: NonReadonly<OperatorStationAssignment>}, TContext> => {

const mutationKey = ['v1ProductionStationAssignmentOperatorStationAssignmentsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsCreate>>, {data: NonReadonly<OperatorStationAssignment>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionStationAssignmentOperatorStationAssignmentsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionStationAssignmentOperatorStationAssignmentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsCreate>>>
    export type V1ProductionStationAssignmentOperatorStationAssignmentsCreateMutationBody = NonReadonly<OperatorStationAssignment>
    export type V1ProductionStationAssignmentOperatorStationAssignmentsCreateMutationError = unknown

    export const useV1ProductionStationAssignmentOperatorStationAssignmentsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsCreate>>, TError,{data: NonReadonly<OperatorStationAssignment>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsCreate>>,
        TError,
        {data: NonReadonly<OperatorStationAssignment>},
        TContext
      > => {

      const mutationOptions = getV1ProductionStationAssignmentOperatorStationAssignmentsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperatorStationAssignment>(
      {url: `/api/v1/production/station-assignment/operator-station-assignments/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionStationAssignmentOperatorStationAssignmentsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/station-assignment/operator-station-assignments/${id}/`
    ] as const;
    }

    
export const getV1ProductionStationAssignmentOperatorStationAssignmentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionStationAssignmentOperatorStationAssignmentsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>> = ({ signal }) => v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionStationAssignmentOperatorStationAssignmentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>>
export type V1ProductionStationAssignmentOperatorStationAssignmentsRetrieveQueryError = unknown


export function useV1ProductionStationAssignmentOperatorStationAssignmentsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationAssignmentsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationAssignmentsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionStationAssignmentOperatorStationAssignmentsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionStationAssignmentOperatorStationAssignmentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationAssignmentsUpdate = (
    id: string,
    operatorStationAssignment: NonReadonly<OperatorStationAssignment>,
 ) => {
      
      
      return customAxiosInstance<OperatorStationAssignment>(
      {url: `/api/v1/production/station-assignment/operator-station-assignments/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: operatorStationAssignment
    },
      );
    }
  


export const getV1ProductionStationAssignmentOperatorStationAssignmentsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsUpdate>>, TError,{id: string;data: NonReadonly<OperatorStationAssignment>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsUpdate>>, TError,{id: string;data: NonReadonly<OperatorStationAssignment>}, TContext> => {

const mutationKey = ['v1ProductionStationAssignmentOperatorStationAssignmentsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsUpdate>>, {id: string;data: NonReadonly<OperatorStationAssignment>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionStationAssignmentOperatorStationAssignmentsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionStationAssignmentOperatorStationAssignmentsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsUpdate>>>
    export type V1ProductionStationAssignmentOperatorStationAssignmentsUpdateMutationBody = NonReadonly<OperatorStationAssignment>
    export type V1ProductionStationAssignmentOperatorStationAssignmentsUpdateMutationError = unknown

    export const useV1ProductionStationAssignmentOperatorStationAssignmentsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsUpdate>>, TError,{id: string;data: NonReadonly<OperatorStationAssignment>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsUpdate>>,
        TError,
        {id: string;data: NonReadonly<OperatorStationAssignment>},
        TContext
      > => {

      const mutationOptions = getV1ProductionStationAssignmentOperatorStationAssignmentsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate = (
    id: string,
    patchedOperatorStationAssignment: NonReadonly<PatchedOperatorStationAssignment>,
 ) => {
      
      
      return customAxiosInstance<OperatorStationAssignment>(
      {url: `/api/v1/production/station-assignment/operator-station-assignments/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedOperatorStationAssignment
    },
      );
    }
  


export const getV1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOperatorStationAssignment>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOperatorStationAssignment>}, TContext> => {

const mutationKey = ['v1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate>>, {id: string;data: NonReadonly<PatchedOperatorStationAssignment>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate>>>
    export type V1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdateMutationBody = NonReadonly<PatchedOperatorStationAssignment>
    export type V1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdateMutationError = unknown

    export const useV1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOperatorStationAssignment>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedOperatorStationAssignment>},
        TContext
      > => {

      const mutationOptions = getV1ProductionStationAssignmentOperatorStationAssignmentsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationAssignmentsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/station-assignment/operator-station-assignments/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionStationAssignmentOperatorStationAssignmentsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionStationAssignmentOperatorStationAssignmentsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionStationAssignmentOperatorStationAssignmentsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionStationAssignmentOperatorStationAssignmentsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsDestroy>>>
    
    export type V1ProductionStationAssignmentOperatorStationAssignmentsDestroyMutationError = unknown

    export const useV1ProductionStationAssignmentOperatorStationAssignmentsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionStationAssignmentOperatorStationAssignmentsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Resolve active station(s)/machine(s) for an operator at a given date/time (Rule OSA-01/OSA-02)
 */
export const v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperatorStationAssignment>(
      {url: `/api/v1/production/station-assignment/operator-station-assignments/resolve/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieveQueryKey = () => {
    return [
    `/api/v1/production/station-assignment/operator-station-assignments/resolve/`
    ] as const;
    }

    
export const getV1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>> = ({ signal }) => v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>>
export type V1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieveQueryError = unknown


export function useV1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Resolve active station(s)/machine(s) for an operator at a given date/time (Rule OSA-01/OSA-02)
 */

export function useV1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionStationAssignmentOperatorStationAssignmentsResolveRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List rotation slots for a rotational assignment
 */
export const v1ProductionStationAssignmentOperatorStationRotationSlotsList = (
    params?: V1ProductionStationAssignmentOperatorStationRotationSlotsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedOperatorStationRotationSlotList>(
      {url: `/api/v1/production/station-assignment/operator-station-rotation-slots/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionStationAssignmentOperatorStationRotationSlotsListQueryKey = (params?: V1ProductionStationAssignmentOperatorStationRotationSlotsListParams,) => {
    return [
    `/api/v1/production/station-assignment/operator-station-rotation-slots/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionStationAssignmentOperatorStationRotationSlotsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError = unknown>(params?: V1ProductionStationAssignmentOperatorStationRotationSlotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionStationAssignmentOperatorStationRotationSlotsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>> = ({ signal }) => v1ProductionStationAssignmentOperatorStationRotationSlotsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionStationAssignmentOperatorStationRotationSlotsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>>
export type V1ProductionStationAssignmentOperatorStationRotationSlotsListQueryError = unknown


export function useV1ProductionStationAssignmentOperatorStationRotationSlotsList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError = unknown>(
 params: undefined |  V1ProductionStationAssignmentOperatorStationRotationSlotsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationRotationSlotsList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError = unknown>(
 params?: V1ProductionStationAssignmentOperatorStationRotationSlotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationRotationSlotsList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError = unknown>(
 params?: V1ProductionStationAssignmentOperatorStationRotationSlotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List rotation slots for a rotational assignment
 */

export function useV1ProductionStationAssignmentOperatorStationRotationSlotsList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError = unknown>(
 params?: V1ProductionStationAssignmentOperatorStationRotationSlotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionStationAssignmentOperatorStationRotationSlotsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationRotationSlotsCreate = (
    operatorStationRotationSlot: NonReadonly<OperatorStationRotationSlot>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperatorStationRotationSlot>(
      {url: `/api/v1/production/station-assignment/operator-station-rotation-slots/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: operatorStationRotationSlot, signal
    },
      );
    }
  


export const getV1ProductionStationAssignmentOperatorStationRotationSlotsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsCreate>>, TError,{data: NonReadonly<OperatorStationRotationSlot>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsCreate>>, TError,{data: NonReadonly<OperatorStationRotationSlot>}, TContext> => {

const mutationKey = ['v1ProductionStationAssignmentOperatorStationRotationSlotsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsCreate>>, {data: NonReadonly<OperatorStationRotationSlot>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionStationAssignmentOperatorStationRotationSlotsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionStationAssignmentOperatorStationRotationSlotsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsCreate>>>
    export type V1ProductionStationAssignmentOperatorStationRotationSlotsCreateMutationBody = NonReadonly<OperatorStationRotationSlot>
    export type V1ProductionStationAssignmentOperatorStationRotationSlotsCreateMutationError = unknown

    export const useV1ProductionStationAssignmentOperatorStationRotationSlotsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsCreate>>, TError,{data: NonReadonly<OperatorStationRotationSlot>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsCreate>>,
        TError,
        {data: NonReadonly<OperatorStationRotationSlot>},
        TContext
      > => {

      const mutationOptions = getV1ProductionStationAssignmentOperatorStationRotationSlotsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<OperatorStationRotationSlot>(
      {url: `/api/v1/production/station-assignment/operator-station-rotation-slots/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionStationAssignmentOperatorStationRotationSlotsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/station-assignment/operator-station-rotation-slots/${id}/`
    ] as const;
    }

    
export const getV1ProductionStationAssignmentOperatorStationRotationSlotsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionStationAssignmentOperatorStationRotationSlotsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>> = ({ signal }) => v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionStationAssignmentOperatorStationRotationSlotsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>>
export type V1ProductionStationAssignmentOperatorStationRotationSlotsRetrieveQueryError = unknown


export function useV1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionStationAssignmentOperatorStationRotationSlotsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationRotationSlotsUpdate = (
    id: string,
    operatorStationRotationSlot: NonReadonly<OperatorStationRotationSlot>,
 ) => {
      
      
      return customAxiosInstance<OperatorStationRotationSlot>(
      {url: `/api/v1/production/station-assignment/operator-station-rotation-slots/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: operatorStationRotationSlot
    },
      );
    }
  


export const getV1ProductionStationAssignmentOperatorStationRotationSlotsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsUpdate>>, TError,{id: string;data: NonReadonly<OperatorStationRotationSlot>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsUpdate>>, TError,{id: string;data: NonReadonly<OperatorStationRotationSlot>}, TContext> => {

const mutationKey = ['v1ProductionStationAssignmentOperatorStationRotationSlotsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsUpdate>>, {id: string;data: NonReadonly<OperatorStationRotationSlot>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionStationAssignmentOperatorStationRotationSlotsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionStationAssignmentOperatorStationRotationSlotsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsUpdate>>>
    export type V1ProductionStationAssignmentOperatorStationRotationSlotsUpdateMutationBody = NonReadonly<OperatorStationRotationSlot>
    export type V1ProductionStationAssignmentOperatorStationRotationSlotsUpdateMutationError = unknown

    export const useV1ProductionStationAssignmentOperatorStationRotationSlotsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsUpdate>>, TError,{id: string;data: NonReadonly<OperatorStationRotationSlot>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsUpdate>>,
        TError,
        {id: string;data: NonReadonly<OperatorStationRotationSlot>},
        TContext
      > => {

      const mutationOptions = getV1ProductionStationAssignmentOperatorStationRotationSlotsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate = (
    id: string,
    patchedOperatorStationRotationSlot: NonReadonly<PatchedOperatorStationRotationSlot>,
 ) => {
      
      
      return customAxiosInstance<OperatorStationRotationSlot>(
      {url: `/api/v1/production/station-assignment/operator-station-rotation-slots/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedOperatorStationRotationSlot
    },
      );
    }
  


export const getV1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOperatorStationRotationSlot>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOperatorStationRotationSlot>}, TContext> => {

const mutationKey = ['v1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate>>, {id: string;data: NonReadonly<PatchedOperatorStationRotationSlot>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate>>>
    export type V1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdateMutationBody = NonReadonly<PatchedOperatorStationRotationSlot>
    export type V1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdateMutationError = unknown

    export const useV1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedOperatorStationRotationSlot>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedOperatorStationRotationSlot>},
        TContext
      > => {

      const mutationOptions = getV1ProductionStationAssignmentOperatorStationRotationSlotsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentOperatorStationRotationSlotsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/station-assignment/operator-station-rotation-slots/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionStationAssignmentOperatorStationRotationSlotsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionStationAssignmentOperatorStationRotationSlotsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionStationAssignmentOperatorStationRotationSlotsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionStationAssignmentOperatorStationRotationSlotsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsDestroy>>>
    
    export type V1ProductionStationAssignmentOperatorStationRotationSlotsDestroyMutationError = unknown

    export const useV1ProductionStationAssignmentOperatorStationRotationSlotsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionStationAssignmentOperatorStationRotationSlotsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionStationAssignmentOperatorStationRotationSlotsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List station assignment overrides (append-only)
 */
export const v1ProductionStationAssignmentStationAssignmentOverridesList = (
    params?: V1ProductionStationAssignmentStationAssignmentOverridesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedStationAssignmentOverrideList>(
      {url: `/api/v1/production/station-assignment/station-assignment-overrides/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionStationAssignmentStationAssignmentOverridesListQueryKey = (params?: V1ProductionStationAssignmentStationAssignmentOverridesListParams,) => {
    return [
    `/api/v1/production/station-assignment/station-assignment-overrides/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionStationAssignmentStationAssignmentOverridesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError = unknown>(params?: V1ProductionStationAssignmentStationAssignmentOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionStationAssignmentStationAssignmentOverridesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>> = ({ signal }) => v1ProductionStationAssignmentStationAssignmentOverridesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionStationAssignmentStationAssignmentOverridesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>>
export type V1ProductionStationAssignmentStationAssignmentOverridesListQueryError = unknown


export function useV1ProductionStationAssignmentStationAssignmentOverridesList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError = unknown>(
 params: undefined |  V1ProductionStationAssignmentStationAssignmentOverridesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentStationAssignmentOverridesList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError = unknown>(
 params?: V1ProductionStationAssignmentStationAssignmentOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentStationAssignmentOverridesList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError = unknown>(
 params?: V1ProductionStationAssignmentStationAssignmentOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List station assignment overrides (append-only)
 */

export function useV1ProductionStationAssignmentStationAssignmentOverridesList<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError = unknown>(
 params?: V1ProductionStationAssignmentStationAssignmentOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionStationAssignmentStationAssignmentOverridesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentStationAssignmentOverridesCreate = (
    stationAssignmentOverride: NonReadonly<StationAssignmentOverride>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StationAssignmentOverride>(
      {url: `/api/v1/production/station-assignment/station-assignment-overrides/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stationAssignmentOverride, signal
    },
      );
    }
  


export const getV1ProductionStationAssignmentStationAssignmentOverridesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesCreate>>, TError,{data: NonReadonly<StationAssignmentOverride>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesCreate>>, TError,{data: NonReadonly<StationAssignmentOverride>}, TContext> => {

const mutationKey = ['v1ProductionStationAssignmentStationAssignmentOverridesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesCreate>>, {data: NonReadonly<StationAssignmentOverride>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionStationAssignmentStationAssignmentOverridesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionStationAssignmentStationAssignmentOverridesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesCreate>>>
    export type V1ProductionStationAssignmentStationAssignmentOverridesCreateMutationBody = NonReadonly<StationAssignmentOverride>
    export type V1ProductionStationAssignmentStationAssignmentOverridesCreateMutationError = unknown

    export const useV1ProductionStationAssignmentStationAssignmentOverridesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesCreate>>, TError,{data: NonReadonly<StationAssignmentOverride>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesCreate>>,
        TError,
        {data: NonReadonly<StationAssignmentOverride>},
        TContext
      > => {

      const mutationOptions = getV1ProductionStationAssignmentStationAssignmentOverridesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionStationAssignmentStationAssignmentOverridesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<StationAssignmentOverride>(
      {url: `/api/v1/production/station-assignment/station-assignment-overrides/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionStationAssignmentStationAssignmentOverridesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/station-assignment/station-assignment-overrides/${id}/`
    ] as const;
    }

    
export const getV1ProductionStationAssignmentStationAssignmentOverridesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionStationAssignmentStationAssignmentOverridesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>> = ({ signal }) => v1ProductionStationAssignmentStationAssignmentOverridesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionStationAssignmentStationAssignmentOverridesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>>
export type V1ProductionStationAssignmentStationAssignmentOverridesRetrieveQueryError = unknown


export function useV1ProductionStationAssignmentStationAssignmentOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentStationAssignmentOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionStationAssignmentStationAssignmentOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionStationAssignmentStationAssignmentOverridesRetrieve<TData = Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionStationAssignmentStationAssignmentOverridesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionStationAssignmentStationAssignmentOverridesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * مجموعه ویوهای عملیات تجمیعی مصرف کارگاه (AM-033 بند ۴).

درگاه‌ها:
- POST /api/v1/production/unified-consumption-action/
  دریافت سفارش‌کار و خطوط مصرف؛ ثبت همزمان رکوردهای مصرف، ضایعات و آغاز گردش‌کار QC.
- GET /api/v1/production/unified-consumption-action/backflush-suggestions/
  محاسبه و بازگرداندن پیشنهادات مصرف بر اساس مقدار تولید واقعی.
 */
export const v1ProductionUnifiedConsumptionActionRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/unified-consumption-action/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionUnifiedConsumptionActionRetrieveQueryKey = () => {
    return [
    `/api/v1/production/unified-consumption-action/`
    ] as const;
    }

    
export const getV1ProductionUnifiedConsumptionActionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionUnifiedConsumptionActionRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>> = ({ signal }) => v1ProductionUnifiedConsumptionActionRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionUnifiedConsumptionActionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>>
export type V1ProductionUnifiedConsumptionActionRetrieveQueryError = unknown


export function useV1ProductionUnifiedConsumptionActionRetrieve<TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionUnifiedConsumptionActionRetrieve<TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionUnifiedConsumptionActionRetrieve<TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionUnifiedConsumptionActionRetrieve<TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionUnifiedConsumptionActionRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * مجموعه ویوهای عملیات تجمیعی مصرف کارگاه (AM-033 بند ۴).

درگاه‌ها:
- POST /api/v1/production/unified-consumption-action/
  دریافت سفارش‌کار و خطوط مصرف؛ ثبت همزمان رکوردهای مصرف، ضایعات و آغاز گردش‌کار QC.
- GET /api/v1/production/unified-consumption-action/backflush-suggestions/
  محاسبه و بازگرداندن پیشنهادات مصرف بر اساس مقدار تولید واقعی.
 */
export const v1ProductionUnifiedConsumptionActionCreate = (
    unifiedConsumptionActionInput: UnifiedConsumptionActionInput,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<UnifiedConsumptionLineResult[]>(
      {url: `/api/v1/production/unified-consumption-action/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unifiedConsumptionActionInput, signal
    },
      );
    }
  


export const getV1ProductionUnifiedConsumptionActionCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionCreate>>, TError,{data: UnifiedConsumptionActionInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionCreate>>, TError,{data: UnifiedConsumptionActionInput}, TContext> => {

const mutationKey = ['v1ProductionUnifiedConsumptionActionCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionCreate>>, {data: UnifiedConsumptionActionInput}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionUnifiedConsumptionActionCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionUnifiedConsumptionActionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionCreate>>>
    export type V1ProductionUnifiedConsumptionActionCreateMutationBody = UnifiedConsumptionActionInput
    export type V1ProductionUnifiedConsumptionActionCreateMutationError = unknown

    export const useV1ProductionUnifiedConsumptionActionCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionCreate>>, TError,{data: UnifiedConsumptionActionInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionCreate>>,
        TError,
        {data: UnifiedConsumptionActionInput},
        TContext
      > => {

      const mutationOptions = getV1ProductionUnifiedConsumptionActionCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * مجموعه ویوهای عملیات تجمیعی مصرف کارگاه (AM-033 بند ۴).

درگاه‌ها:
- POST /api/v1/production/unified-consumption-action/
  دریافت سفارش‌کار و خطوط مصرف؛ ثبت همزمان رکوردهای مصرف، ضایعات و آغاز گردش‌کار QC.
- GET /api/v1/production/unified-consumption-action/backflush-suggestions/
  محاسبه و بازگرداندن پیشنهادات مصرف بر اساس مقدار تولید واقعی.
 */
export const v1ProductionUnifiedConsumptionActionBackflushSuggestionsList = (
    params: V1ProductionUnifiedConsumptionActionBackflushSuggestionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<BackflushSuggestionResult[]>(
      {url: `/api/v1/production/unified-consumption-action/backflush-suggestions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionUnifiedConsumptionActionBackflushSuggestionsListQueryKey = (params?: V1ProductionUnifiedConsumptionActionBackflushSuggestionsListParams,) => {
    return [
    `/api/v1/production/unified-consumption-action/backflush-suggestions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionUnifiedConsumptionActionBackflushSuggestionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError = unknown>(params: V1ProductionUnifiedConsumptionActionBackflushSuggestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionUnifiedConsumptionActionBackflushSuggestionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>> = ({ signal }) => v1ProductionUnifiedConsumptionActionBackflushSuggestionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionUnifiedConsumptionActionBackflushSuggestionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>>
export type V1ProductionUnifiedConsumptionActionBackflushSuggestionsListQueryError = unknown


export function useV1ProductionUnifiedConsumptionActionBackflushSuggestionsList<TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError = unknown>(
 params: V1ProductionUnifiedConsumptionActionBackflushSuggestionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionUnifiedConsumptionActionBackflushSuggestionsList<TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError = unknown>(
 params: V1ProductionUnifiedConsumptionActionBackflushSuggestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionUnifiedConsumptionActionBackflushSuggestionsList<TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError = unknown>(
 params: V1ProductionUnifiedConsumptionActionBackflushSuggestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ProductionUnifiedConsumptionActionBackflushSuggestionsList<TData = Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError = unknown>(
 params: V1ProductionUnifiedConsumptionActionBackflushSuggestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionUnifiedConsumptionActionBackflushSuggestionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionUnifiedConsumptionActionBackflushSuggestionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List work centers for active tenant
 */
export const v1ProductionWorkCentersList = (
    params?: V1ProductionWorkCentersListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkCenterList>(
      {url: `/api/v1/production/work-centers/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionWorkCentersListQueryKey = (params?: V1ProductionWorkCentersListParams,) => {
    return [
    `/api/v1/production/work-centers/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionWorkCentersListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError = unknown>(params?: V1ProductionWorkCentersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionWorkCentersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionWorkCentersList>>> = ({ signal }) => v1ProductionWorkCentersList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionWorkCentersListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkCentersList>>>
export type V1ProductionWorkCentersListQueryError = unknown


export function useV1ProductionWorkCentersList<TData = Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError = unknown>(
 params: undefined |  V1ProductionWorkCentersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionWorkCentersList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionWorkCentersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionWorkCentersList<TData = Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError = unknown>(
 params?: V1ProductionWorkCentersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionWorkCentersList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionWorkCentersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionWorkCentersList<TData = Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError = unknown>(
 params?: V1ProductionWorkCentersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List work centers for active tenant
 */

export function useV1ProductionWorkCentersList<TData = Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError = unknown>(
 params?: V1ProductionWorkCentersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionWorkCentersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Create a new work center
 */
export const v1ProductionWorkCentersCreate = (
    workCenter: NonReadonly<WorkCenter>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkCenter>(
      {url: `/api/v1/production/work-centers/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workCenter, signal
    },
      );
    }
  


export const getV1ProductionWorkCentersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersCreate>>, TError,{data: NonReadonly<WorkCenter>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersCreate>>, TError,{data: NonReadonly<WorkCenter>}, TContext> => {

const mutationKey = ['v1ProductionWorkCentersCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkCentersCreate>>, {data: NonReadonly<WorkCenter>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionWorkCentersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkCentersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkCentersCreate>>>
    export type V1ProductionWorkCentersCreateMutationBody = NonReadonly<WorkCenter>
    export type V1ProductionWorkCentersCreateMutationError = unknown

    /**
 * @summary Create a new work center
 */
export const useV1ProductionWorkCentersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersCreate>>, TError,{data: NonReadonly<WorkCenter>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkCentersCreate>>,
        TError,
        {data: NonReadonly<WorkCenter>},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkCentersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a work center by ID
 */
export const v1ProductionWorkCentersRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkCenter>(
      {url: `/api/v1/production/work-centers/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionWorkCentersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/work-centers/${id}/`
    ] as const;
    }

    
export const getV1ProductionWorkCentersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionWorkCentersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>> = ({ signal }) => v1ProductionWorkCentersRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionWorkCentersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>>
export type V1ProductionWorkCentersRetrieveQueryError = unknown


export function useV1ProductionWorkCentersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionWorkCentersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionWorkCentersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a work center by ID
 */

export function useV1ProductionWorkCentersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionWorkCentersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionWorkCentersUpdate = (
    id: string,
    workCenter: NonReadonly<WorkCenter>,
 ) => {
      
      
      return customAxiosInstance<WorkCenter>(
      {url: `/api/v1/production/work-centers/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workCenter
    },
      );
    }
  


export const getV1ProductionWorkCentersUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersUpdate>>, TError,{id: string;data: NonReadonly<WorkCenter>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersUpdate>>, TError,{id: string;data: NonReadonly<WorkCenter>}, TContext> => {

const mutationKey = ['v1ProductionWorkCentersUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkCentersUpdate>>, {id: string;data: NonReadonly<WorkCenter>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionWorkCentersUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkCentersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkCentersUpdate>>>
    export type V1ProductionWorkCentersUpdateMutationBody = NonReadonly<WorkCenter>
    export type V1ProductionWorkCentersUpdateMutationError = unknown

    export const useV1ProductionWorkCentersUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersUpdate>>, TError,{id: string;data: NonReadonly<WorkCenter>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkCentersUpdate>>,
        TError,
        {id: string;data: NonReadonly<WorkCenter>},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkCentersUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionWorkCentersPartialUpdate = (
    id: string,
    patchedWorkCenter: NonReadonly<PatchedWorkCenter>,
 ) => {
      
      
      return customAxiosInstance<WorkCenter>(
      {url: `/api/v1/production/work-centers/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWorkCenter
    },
      );
    }
  


export const getV1ProductionWorkCentersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkCenter>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkCenter>}, TContext> => {

const mutationKey = ['v1ProductionWorkCentersPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkCentersPartialUpdate>>, {id: string;data: NonReadonly<PatchedWorkCenter>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionWorkCentersPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkCentersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkCentersPartialUpdate>>>
    export type V1ProductionWorkCentersPartialUpdateMutationBody = NonReadonly<PatchedWorkCenter>
    export type V1ProductionWorkCentersPartialUpdateMutationError = unknown

    export const useV1ProductionWorkCentersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkCenter>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkCentersPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedWorkCenter>},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkCentersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionWorkCentersDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/work-centers/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionWorkCentersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionWorkCentersDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkCentersDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionWorkCentersDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkCentersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkCentersDestroy>>>
    
    export type V1ProductionWorkCentersDestroyMutationError = unknown

    export const useV1ProductionWorkCentersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkCentersDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkCentersDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkCentersDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary List work orders for active tenant
 */
export const v1ProductionWorkOrdersList = (
    params?: V1ProductionWorkOrdersListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkOrderList>(
      {url: `/api/v1/production/work-orders/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ProductionWorkOrdersListQueryKey = (params?: V1ProductionWorkOrdersListParams,) => {
    return [
    `/api/v1/production/work-orders/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ProductionWorkOrdersListQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError = unknown>(params?: V1ProductionWorkOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionWorkOrdersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>> = ({ signal }) => v1ProductionWorkOrdersList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionWorkOrdersListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>>
export type V1ProductionWorkOrdersListQueryError = unknown


export function useV1ProductionWorkOrdersList<TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError = unknown>(
 params: undefined |  V1ProductionWorkOrdersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionWorkOrdersList<TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError = unknown>(
 params?: V1ProductionWorkOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionWorkOrdersList<TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError = unknown>(
 params?: V1ProductionWorkOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List work orders for active tenant
 */

export function useV1ProductionWorkOrdersList<TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError = unknown>(
 params?: V1ProductionWorkOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionWorkOrdersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionWorkOrdersCreate = (
    workOrder: NonReadonly<WorkOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrder>(
      {url: `/api/v1/production/work-orders/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workOrder, signal
    },
      );
    }
  


export const getV1ProductionWorkOrdersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersCreate>>, TError,{data: NonReadonly<WorkOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersCreate>>, TError,{data: NonReadonly<WorkOrder>}, TContext> => {

const mutationKey = ['v1ProductionWorkOrdersCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersCreate>>, {data: NonReadonly<WorkOrder>}> = (props) => {
          const {data} = props ?? {};

          return  v1ProductionWorkOrdersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkOrdersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersCreate>>>
    export type V1ProductionWorkOrdersCreateMutationBody = NonReadonly<WorkOrder>
    export type V1ProductionWorkOrdersCreateMutationError = unknown

    export const useV1ProductionWorkOrdersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersCreate>>, TError,{data: NonReadonly<WorkOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkOrdersCreate>>,
        TError,
        {data: NonReadonly<WorkOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkOrdersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Retrieve a work order by ID
 */
export const v1ProductionWorkOrdersRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrder>(
      {url: `/api/v1/production/work-orders/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ProductionWorkOrdersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/production/work-orders/${id}/`
    ] as const;
    }

    
export const getV1ProductionWorkOrdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ProductionWorkOrdersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>> = ({ signal }) => v1ProductionWorkOrdersRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ProductionWorkOrdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>>
export type V1ProductionWorkOrdersRetrieveQueryError = unknown


export function useV1ProductionWorkOrdersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionWorkOrdersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ProductionWorkOrdersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a work order by ID
 */

export function useV1ProductionWorkOrdersRetrieve<TData = Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ProductionWorkOrdersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Update a work order
 */
export const v1ProductionWorkOrdersUpdate = (
    id: string,
    workOrder: NonReadonly<WorkOrder>,
 ) => {
      
      
      return customAxiosInstance<WorkOrder>(
      {url: `/api/v1/production/work-orders/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workOrder
    },
      );
    }
  


export const getV1ProductionWorkOrdersUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersUpdate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersUpdate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext> => {

const mutationKey = ['v1ProductionWorkOrdersUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersUpdate>>, {id: string;data: NonReadonly<WorkOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionWorkOrdersUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkOrdersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersUpdate>>>
    export type V1ProductionWorkOrdersUpdateMutationBody = NonReadonly<WorkOrder>
    export type V1ProductionWorkOrdersUpdateMutationError = unknown

    /**
 * @summary Update a work order
 */
export const useV1ProductionWorkOrdersUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersUpdate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkOrdersUpdate>>,
        TError,
        {id: string;data: NonReadonly<WorkOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkOrdersUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionWorkOrdersPartialUpdate = (
    id: string,
    patchedWorkOrder: NonReadonly<PatchedWorkOrder>,
 ) => {
      
      
      return customAxiosInstance<WorkOrder>(
      {url: `/api/v1/production/work-orders/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWorkOrder
    },
      );
    }
  


export const getV1ProductionWorkOrdersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkOrder>}, TContext> => {

const mutationKey = ['v1ProductionWorkOrdersPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersPartialUpdate>>, {id: string;data: NonReadonly<PatchedWorkOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionWorkOrdersPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkOrdersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersPartialUpdate>>>
    export type V1ProductionWorkOrdersPartialUpdateMutationBody = NonReadonly<PatchedWorkOrder>
    export type V1ProductionWorkOrdersPartialUpdateMutationError = unknown

    export const useV1ProductionWorkOrdersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkOrdersPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedWorkOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkOrdersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 */
export const v1ProductionWorkOrdersDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/production/work-orders/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ProductionWorkOrdersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ProductionWorkOrdersDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ProductionWorkOrdersDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkOrdersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersDestroy>>>
    
    export type V1ProductionWorkOrdersDestroyMutationError = unknown

    export const useV1ProductionWorkOrdersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkOrdersDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkOrdersDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Cancel a work order
 */
export const v1ProductionWorkOrdersCancelCreate = (
    id: string,
    workOrder: NonReadonly<WorkOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrder>(
      {url: `/api/v1/production/work-orders/${id}/cancel/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workOrder, signal
    },
      );
    }
  


export const getV1ProductionWorkOrdersCancelCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersCancelCreate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersCancelCreate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext> => {

const mutationKey = ['v1ProductionWorkOrdersCancelCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersCancelCreate>>, {id: string;data: NonReadonly<WorkOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionWorkOrdersCancelCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkOrdersCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersCancelCreate>>>
    export type V1ProductionWorkOrdersCancelCreateMutationBody = NonReadonly<WorkOrder>
    export type V1ProductionWorkOrdersCancelCreateMutationError = unknown

    /**
 * @summary Cancel a work order
 */
export const useV1ProductionWorkOrdersCancelCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersCancelCreate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkOrdersCancelCreate>>,
        TError,
        {id: string;data: NonReadonly<WorkOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkOrdersCancelCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Complete a work order
 */
export const v1ProductionWorkOrdersCompleteCreate = (
    id: string,
    workOrder: NonReadonly<WorkOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrder>(
      {url: `/api/v1/production/work-orders/${id}/complete/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workOrder, signal
    },
      );
    }
  


export const getV1ProductionWorkOrdersCompleteCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersCompleteCreate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersCompleteCreate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext> => {

const mutationKey = ['v1ProductionWorkOrdersCompleteCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersCompleteCreate>>, {id: string;data: NonReadonly<WorkOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionWorkOrdersCompleteCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkOrdersCompleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersCompleteCreate>>>
    export type V1ProductionWorkOrdersCompleteCreateMutationBody = NonReadonly<WorkOrder>
    export type V1ProductionWorkOrdersCompleteCreateMutationError = unknown

    /**
 * @summary Complete a work order
 */
export const useV1ProductionWorkOrdersCompleteCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersCompleteCreate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkOrdersCompleteCreate>>,
        TError,
        {id: string;data: NonReadonly<WorkOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkOrdersCompleteCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Pause a work order
 */
export const v1ProductionWorkOrdersPauseCreate = (
    id: string,
    pauseWorkOrderRequest: PauseWorkOrderRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrder>(
      {url: `/api/v1/production/work-orders/${id}/pause/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pauseWorkOrderRequest, signal
    },
      );
    }
  


export const getV1ProductionWorkOrdersPauseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersPauseCreate>>, TError,{id: string;data: PauseWorkOrderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersPauseCreate>>, TError,{id: string;data: PauseWorkOrderRequest}, TContext> => {

const mutationKey = ['v1ProductionWorkOrdersPauseCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersPauseCreate>>, {id: string;data: PauseWorkOrderRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionWorkOrdersPauseCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkOrdersPauseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersPauseCreate>>>
    export type V1ProductionWorkOrdersPauseCreateMutationBody = PauseWorkOrderRequest
    export type V1ProductionWorkOrdersPauseCreateMutationError = unknown

    /**
 * @summary Pause a work order
 */
export const useV1ProductionWorkOrdersPauseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersPauseCreate>>, TError,{id: string;data: PauseWorkOrderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkOrdersPauseCreate>>,
        TError,
        {id: string;data: PauseWorkOrderRequest},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkOrdersPauseCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Resume a paused work order
 */
export const v1ProductionWorkOrdersResumeCreate = (
    id: string,
    workOrder: NonReadonly<WorkOrder>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrder>(
      {url: `/api/v1/production/work-orders/${id}/resume/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workOrder, signal
    },
      );
    }
  


export const getV1ProductionWorkOrdersResumeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersResumeCreate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersResumeCreate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext> => {

const mutationKey = ['v1ProductionWorkOrdersResumeCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersResumeCreate>>, {id: string;data: NonReadonly<WorkOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionWorkOrdersResumeCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkOrdersResumeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersResumeCreate>>>
    export type V1ProductionWorkOrdersResumeCreateMutationBody = NonReadonly<WorkOrder>
    export type V1ProductionWorkOrdersResumeCreateMutationError = unknown

    /**
 * @summary Resume a paused work order
 */
export const useV1ProductionWorkOrdersResumeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersResumeCreate>>, TError,{id: string;data: NonReadonly<WorkOrder>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkOrdersResumeCreate>>,
        TError,
        {id: string;data: NonReadonly<WorkOrder>},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkOrdersResumeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Inventory ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.
 * @summary Start a work order
 */
export const v1ProductionWorkOrdersStartCreate = (
    id: string,
    startWorkOrderRequest: StartWorkOrderRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkOrder>(
      {url: `/api/v1/production/work-orders/${id}/start/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startWorkOrderRequest, signal
    },
      );
    }
  


export const getV1ProductionWorkOrdersStartCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersStartCreate>>, TError,{id: string;data: StartWorkOrderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersStartCreate>>, TError,{id: string;data: StartWorkOrderRequest}, TContext> => {

const mutationKey = ['v1ProductionWorkOrdersStartCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ProductionWorkOrdersStartCreate>>, {id: string;data: StartWorkOrderRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ProductionWorkOrdersStartCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ProductionWorkOrdersStartCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ProductionWorkOrdersStartCreate>>>
    export type V1ProductionWorkOrdersStartCreateMutationBody = StartWorkOrderRequest
    export type V1ProductionWorkOrdersStartCreateMutationError = unknown

    /**
 * @summary Start a work order
 */
export const useV1ProductionWorkOrdersStartCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ProductionWorkOrdersStartCreate>>, TError,{id: string;data: StartWorkOrderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ProductionWorkOrdersStartCreate>>,
        TError,
        {id: string;data: StartWorkOrderRequest},
        TContext
      > => {

      const mutationOptions = getV1ProductionWorkOrdersStartCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-056 Rule QM-01: CRUD for QualityCheckFamily.
Tenant-scoped: tenant_id injected from request context.

AM-008: added PATCH (name, is_active only — "code" is explicitly
rejected on update, see partial_update() below). Still no PUT/DELETE
— full replacement or hard delete were never requested and would
conflict with ADR-046 Hard-Delete-Prohibited regardless.
 * @summary List quality check families
 */
export const v1QualityCheckFamiliesList = (
    params?: V1QualityCheckFamiliesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedQualityCheckFamilyList>(
      {url: `/api/v1/quality-check-families/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1QualityCheckFamiliesListQueryKey = (params?: V1QualityCheckFamiliesListParams,) => {
    return [
    `/api/v1/quality-check-families/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1QualityCheckFamiliesListQueryOptions = <TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError = unknown>(params?: V1QualityCheckFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QualityCheckFamiliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>> = ({ signal }) => v1QualityCheckFamiliesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1QualityCheckFamiliesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>>
export type V1QualityCheckFamiliesListQueryError = unknown


export function useV1QualityCheckFamiliesList<TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError = unknown>(
 params: undefined |  V1QualityCheckFamiliesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityCheckFamiliesList<TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError = unknown>(
 params?: V1QualityCheckFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityCheckFamiliesList<TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError = unknown>(
 params?: V1QualityCheckFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List quality check families
 */

export function useV1QualityCheckFamiliesList<TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError = unknown>(
 params?: V1QualityCheckFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1QualityCheckFamiliesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-056 Rule QM-01: CRUD for QualityCheckFamily.
Tenant-scoped: tenant_id injected from request context.

AM-008: added PATCH (name, is_active only — "code" is explicitly
rejected on update, see partial_update() below). Still no PUT/DELETE
— full replacement or hard delete were never requested and would
conflict with ADR-046 Hard-Delete-Prohibited regardless.
 * @summary Create a quality check family
 */
export const v1QualityCheckFamiliesCreate = (
    qualityCheckFamily: NonReadonly<QualityCheckFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<QualityCheckFamily>(
      {url: `/api/v1/quality-check-families/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: qualityCheckFamily, signal
    },
      );
    }
  


export const getV1QualityCheckFamiliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesCreate>>, TError,{data: NonReadonly<QualityCheckFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesCreate>>, TError,{data: NonReadonly<QualityCheckFamily>}, TContext> => {

const mutationKey = ['v1QualityCheckFamiliesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QualityCheckFamiliesCreate>>, {data: NonReadonly<QualityCheckFamily>}> = (props) => {
          const {data} = props ?? {};

          return  v1QualityCheckFamiliesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1QualityCheckFamiliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QualityCheckFamiliesCreate>>>
    export type V1QualityCheckFamiliesCreateMutationBody = NonReadonly<QualityCheckFamily>
    export type V1QualityCheckFamiliesCreateMutationError = unknown

    /**
 * @summary Create a quality check family
 */
export const useV1QualityCheckFamiliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesCreate>>, TError,{data: NonReadonly<QualityCheckFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QualityCheckFamiliesCreate>>,
        TError,
        {data: NonReadonly<QualityCheckFamily>},
        TContext
      > => {

      const mutationOptions = getV1QualityCheckFamiliesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-056 Rule QM-01: CRUD for QualityCheckFamily.
Tenant-scoped: tenant_id injected from request context.

AM-008: added PATCH (name, is_active only — "code" is explicitly
rejected on update, see partial_update() below). Still no PUT/DELETE
— full replacement or hard delete were never requested and would
conflict with ADR-046 Hard-Delete-Prohibited regardless.
 */
export const v1QualityCheckFamiliesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<QualityCheckFamily>(
      {url: `/api/v1/quality-check-families/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1QualityCheckFamiliesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/quality-check-families/${id}/`
    ] as const;
    }

    
export const getV1QualityCheckFamiliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QualityCheckFamiliesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>> = ({ signal }) => v1QualityCheckFamiliesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1QualityCheckFamiliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>>
export type V1QualityCheckFamiliesRetrieveQueryError = unknown


export function useV1QualityCheckFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityCheckFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityCheckFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1QualityCheckFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1QualityCheckFamiliesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-008 Rule QC-08-01: only "name" and "is_active" are editable.
"code" is explicitly rejected (400), not silently dropped — a
client that thinks it changed the code and gets a 200 back with
the old code, no explanation, is worse than an explicit error.
 * @summary Update a quality check family's name/active state
 */
export const v1QualityCheckFamiliesPartialUpdate = (
    id: string,
    patchedQualityCheckFamily: NonReadonly<PatchedQualityCheckFamily>,
 ) => {
      
      
      return customAxiosInstance<QualityCheckFamily>(
      {url: `/api/v1/quality-check-families/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedQualityCheckFamily
    },
      );
    }
  


export const getV1QualityCheckFamiliesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedQualityCheckFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedQualityCheckFamily>}, TContext> => {

const mutationKey = ['v1QualityCheckFamiliesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QualityCheckFamiliesPartialUpdate>>, {id: string;data: NonReadonly<PatchedQualityCheckFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1QualityCheckFamiliesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1QualityCheckFamiliesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QualityCheckFamiliesPartialUpdate>>>
    export type V1QualityCheckFamiliesPartialUpdateMutationBody = NonReadonly<PatchedQualityCheckFamily>
    export type V1QualityCheckFamiliesPartialUpdateMutationError = unknown

    /**
 * @summary Update a quality check family's name/active state
 */
export const useV1QualityCheckFamiliesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedQualityCheckFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QualityCheckFamiliesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedQualityCheckFamily>},
        TContext
      > => {

      const mutationOptions = getV1QualityCheckFamiliesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-056 Rule QM-02 / AM-007 / AM-008.

- POST   /quality-check-revisions/                       create (status=DRAFT)
- GET    /quality-check-revisions/                        list
- GET    /quality-check-revisions/{id}/                    retrieve
- PATCH  /quality-check-revisions/{id}/                    AM-008: edit name/description/is_active — DRAFT + not_required only
- POST   /quality-check-revisions/{id}/submit_for_approval/

PUT/DELETE remain unsupported at every lifecycle stage. PATCH is now
supported but gated by BOTH status and approval_state (see
partial_update() — the model's own clean() only ever checked status,
which is not enough once a revision can be "pending" while still
status=draft; AM-008 §1a/§3 has the full reasoning).
 * @summary List quality check revisions
 */
export const v1QualityCheckRevisionsList = (
    params?: V1QualityCheckRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedQualityCheckRevisionList>(
      {url: `/api/v1/quality-check-revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1QualityCheckRevisionsListQueryKey = (params?: V1QualityCheckRevisionsListParams,) => {
    return [
    `/api/v1/quality-check-revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1QualityCheckRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError = unknown>(params?: V1QualityCheckRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QualityCheckRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>> = ({ signal }) => v1QualityCheckRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1QualityCheckRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>>
export type V1QualityCheckRevisionsListQueryError = unknown


export function useV1QualityCheckRevisionsList<TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError = unknown>(
 params: undefined |  V1QualityCheckRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityCheckRevisionsList<TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError = unknown>(
 params?: V1QualityCheckRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityCheckRevisionsList<TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError = unknown>(
 params?: V1QualityCheckRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List quality check revisions
 */

export function useV1QualityCheckRevisionsList<TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError = unknown>(
 params?: V1QualityCheckRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1QualityCheckRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a DRAFT revision under an existing QualityCheckFamily.
revision_no is auto-assigned as (max existing revision_no for this
family) + 1 — mirrors the convention used across every other
Family+Revision domain in this codebase (Material, BOM, Routing).
 * @summary Create a draft quality check revision
 */
export const v1QualityCheckRevisionsCreate = (
    qualityCheckRevision: NonReadonly<QualityCheckRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<QualityCheckRevision>(
      {url: `/api/v1/quality-check-revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: qualityCheckRevision, signal
    },
      );
    }
  


export const getV1QualityCheckRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsCreate>>, TError,{data: NonReadonly<QualityCheckRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsCreate>>, TError,{data: NonReadonly<QualityCheckRevision>}, TContext> => {

const mutationKey = ['v1QualityCheckRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QualityCheckRevisionsCreate>>, {data: NonReadonly<QualityCheckRevision>}> = (props) => {
          const {data} = props ?? {};

          return  v1QualityCheckRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1QualityCheckRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QualityCheckRevisionsCreate>>>
    export type V1QualityCheckRevisionsCreateMutationBody = NonReadonly<QualityCheckRevision>
    export type V1QualityCheckRevisionsCreateMutationError = unknown

    /**
 * @summary Create a draft quality check revision
 */
export const useV1QualityCheckRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsCreate>>, TError,{data: NonReadonly<QualityCheckRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QualityCheckRevisionsCreate>>,
        TError,
        {data: NonReadonly<QualityCheckRevision>},
        TContext
      > => {

      const mutationOptions = getV1QualityCheckRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-056 Rule QM-02 / AM-007 / AM-008.

- POST   /quality-check-revisions/                       create (status=DRAFT)
- GET    /quality-check-revisions/                        list
- GET    /quality-check-revisions/{id}/                    retrieve
- PATCH  /quality-check-revisions/{id}/                    AM-008: edit name/description/is_active — DRAFT + not_required only
- POST   /quality-check-revisions/{id}/submit_for_approval/

PUT/DELETE remain unsupported at every lifecycle stage. PATCH is now
supported but gated by BOTH status and approval_state (see
partial_update() — the model's own clean() only ever checked status,
which is not enough once a revision can be "pending" while still
status=draft; AM-008 §1a/§3 has the full reasoning).
 */
export const v1QualityCheckRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<QualityCheckRevision>(
      {url: `/api/v1/quality-check-revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1QualityCheckRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/quality-check-revisions/${id}/`
    ] as const;
    }

    
export const getV1QualityCheckRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QualityCheckRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>> = ({ signal }) => v1QualityCheckRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1QualityCheckRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>>
export type V1QualityCheckRevisionsRetrieveQueryError = unknown


export function useV1QualityCheckRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityCheckRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityCheckRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1QualityCheckRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1QualityCheckRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-008 Rule QC-08-02: editable ONLY when status=DRAFT AND
approval_state=not_required. The second condition is not
redundant with the first — a revision can be status=draft while
approval_state=pending (submitted, awaiting the workflow gate's
outcome). QualityCheckRevision.clean() alone does not catch that
case (it only checks status==PUBLISHED); this explicit check is
what actually prevents editing content out from under a reviewer
mid-approval.
 * @summary Edit a draft quality check revision
 */
export const v1QualityCheckRevisionsPartialUpdate = (
    id: string,
    patchedQualityCheckRevision: NonReadonly<PatchedQualityCheckRevision>,
 ) => {
      
      
      return customAxiosInstance<QualityCheckRevision>(
      {url: `/api/v1/quality-check-revisions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedQualityCheckRevision
    },
      );
    }
  


export const getV1QualityCheckRevisionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedQualityCheckRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedQualityCheckRevision>}, TContext> => {

const mutationKey = ['v1QualityCheckRevisionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QualityCheckRevisionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedQualityCheckRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1QualityCheckRevisionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1QualityCheckRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QualityCheckRevisionsPartialUpdate>>>
    export type V1QualityCheckRevisionsPartialUpdateMutationBody = NonReadonly<PatchedQualityCheckRevision>
    export type V1QualityCheckRevisionsPartialUpdateMutationError = unknown

    /**
 * @summary Edit a draft quality check revision
 */
export const useV1QualityCheckRevisionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedQualityCheckRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QualityCheckRevisionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedQualityCheckRevision>},
        TContext
      > => {

      const mutationOptions = getV1QualityCheckRevisionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-056 Rule QM-02 / AM-007 / AM-008.

- POST   /quality-check-revisions/                       create (status=DRAFT)
- GET    /quality-check-revisions/                        list
- GET    /quality-check-revisions/{id}/                    retrieve
- PATCH  /quality-check-revisions/{id}/                    AM-008: edit name/description/is_active — DRAFT + not_required only
- POST   /quality-check-revisions/{id}/submit_for_approval/

PUT/DELETE remain unsupported at every lifecycle stage. PATCH is now
supported but gated by BOTH status and approval_state (see
partial_update() — the model's own clean() only ever checked status,
which is not enough once a revision can be "pending" while still
status=draft; AM-008 §1a/§3 has the full reasoning).
 * @summary Submit a draft revision for workflow-gated approval
 */
export const v1QualityCheckRevisionsSubmitForApprovalCreate = (
    id: string,
    qualityCheckSubmitApproval: QualityCheckSubmitApproval,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<QualityCheckRevision>(
      {url: `/api/v1/quality-check-revisions/${id}/submit_for_approval/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: qualityCheckSubmitApproval, signal
    },
      );
    }
  


export const getV1QualityCheckRevisionsSubmitForApprovalCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsSubmitForApprovalCreate>>, TError,{id: string;data: QualityCheckSubmitApproval}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsSubmitForApprovalCreate>>, TError,{id: string;data: QualityCheckSubmitApproval}, TContext> => {

const mutationKey = ['v1QualityCheckRevisionsSubmitForApprovalCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QualityCheckRevisionsSubmitForApprovalCreate>>, {id: string;data: QualityCheckSubmitApproval}> = (props) => {
          const {id,data} = props ?? {};

          return  v1QualityCheckRevisionsSubmitForApprovalCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1QualityCheckRevisionsSubmitForApprovalCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QualityCheckRevisionsSubmitForApprovalCreate>>>
    export type V1QualityCheckRevisionsSubmitForApprovalCreateMutationBody = QualityCheckSubmitApproval
    export type V1QualityCheckRevisionsSubmitForApprovalCreateMutationError = unknown

    /**
 * @summary Submit a draft revision for workflow-gated approval
 */
export const useV1QualityCheckRevisionsSubmitForApprovalCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityCheckRevisionsSubmitForApprovalCreate>>, TError,{id: string;data: QualityCheckSubmitApproval}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QualityCheckRevisionsSubmitForApprovalCreate>>,
        TError,
        {id: string;data: QualityCheckSubmitApproval},
        TContext
      > => {

      const mutationOptions = getV1QualityCheckRevisionsSubmitForApprovalCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * GET /api/v1/quality/lots/{lot_id}/release-status/
استعلام وضعیت کیفی فعلی و تاریخچه تصمیمات پالت توسط کاربران دارای مجوز quality.view.
رعایت کامل RBAC مرکزی پلتفرم و استفاده از IsPermitted.
 */
export const v1QualityLotsReleaseStatusRetrieve = (
    lotId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<LotCurrentReleaseStatus>(
      {url: `/api/v1/quality/lots/${lotId}/release-status/`, method: 'GET', signal
    },
      );
    }
  



export const getV1QualityLotsReleaseStatusRetrieveQueryKey = (lotId?: string,) => {
    return [
    `/api/v1/quality/lots/${lotId}/release-status/`
    ] as const;
    }

    
export const getV1QualityLotsReleaseStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError = unknown>(lotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1QualityLotsReleaseStatusRetrieveQueryKey(lotId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>> = ({ signal }) => v1QualityLotsReleaseStatusRetrieve(lotId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(lotId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1QualityLotsReleaseStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>>
export type V1QualityLotsReleaseStatusRetrieveQueryError = unknown


export function useV1QualityLotsReleaseStatusRetrieve<TData = Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError = unknown>(
 lotId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityLotsReleaseStatusRetrieve<TData = Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError = unknown>(
 lotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1QualityLotsReleaseStatusRetrieve<TData = Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError = unknown>(
 lotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1QualityLotsReleaseStatusRetrieve<TData = Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError = unknown>(
 lotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1QualityLotsReleaseStatusRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1QualityLotsReleaseStatusRetrieveQueryOptions(lotId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * POST /api/v1/quality/release-decisions/ (AM-042 §2.3)
ثبت تصمیم کیفی جدید برای پالت توسط پرسنل دارای مجوز quality.manage.
رعایت کامل RBAC مرکزی پلتفرم و استفاده از IsPermitted.
 */
export const v1QualityReleaseDecisionsCreate = (
    releaseDecisionCreate: ReleaseDecisionCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ReleaseDecisionOutput>(
      {url: `/api/v1/quality/release-decisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: releaseDecisionCreate, signal
    },
      );
    }
  


export const getV1QualityReleaseDecisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityReleaseDecisionsCreate>>, TError,{data: ReleaseDecisionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1QualityReleaseDecisionsCreate>>, TError,{data: ReleaseDecisionCreate}, TContext> => {

const mutationKey = ['v1QualityReleaseDecisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1QualityReleaseDecisionsCreate>>, {data: ReleaseDecisionCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1QualityReleaseDecisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1QualityReleaseDecisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1QualityReleaseDecisionsCreate>>>
    export type V1QualityReleaseDecisionsCreateMutationBody = ReleaseDecisionCreate
    export type V1QualityReleaseDecisionsCreateMutationError = unknown

    export const useV1QualityReleaseDecisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1QualityReleaseDecisionsCreate>>, TError,{data: ReleaseDecisionCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1QualityReleaseDecisionsCreate>>,
        TError,
        {data: ReleaseDecisionCreate},
        TContext
      > => {

      const mutationOptions = getV1QualityReleaseDecisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-042 §2.3 API: ReleaseDecision (Append-Only Trace).
پرمیشن‌ها مطابق سند AM-042: quality.manage برای POST و quality.view برای GET (List, Retrieve).
 * @summary List quality release decisions (read-only)
 */
export const v1ReleaseDecisionsRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/release-decisions/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ReleaseDecisionsRetrieveQueryKey = () => {
    return [
    `/api/v1/release-decisions/`
    ] as const;
    }

    
export const getV1ReleaseDecisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReleaseDecisionsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>> = ({ signal }) => v1ReleaseDecisionsRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ReleaseDecisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>>
export type V1ReleaseDecisionsRetrieveQueryError = unknown


export function useV1ReleaseDecisionsRetrieve<TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReleaseDecisionsRetrieve<TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReleaseDecisionsRetrieve<TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List quality release decisions (read-only)
 */

export function useV1ReleaseDecisionsRetrieve<TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ReleaseDecisionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * AM-042 §2.3 API: ReleaseDecision (Append-Only Trace).
پرمیشن‌ها مطابق سند AM-042: quality.manage برای POST و quality.view برای GET (List, Retrieve).
 * @summary Record a new release decision for a lot
 */
export const v1ReleaseDecisionsCreate = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/release-decisions/`, method: 'POST', signal
    },
      );
    }
  


export const getV1ReleaseDecisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsCreate>>, TError,void, TContext> => {

const mutationKey = ['v1ReleaseDecisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ReleaseDecisionsCreate>>, void> = () => {
          

          return  v1ReleaseDecisionsCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ReleaseDecisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ReleaseDecisionsCreate>>>
    
    export type V1ReleaseDecisionsCreateMutationError = unknown

    /**
 * @summary Record a new release decision for a lot
 */
export const useV1ReleaseDecisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsCreate>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ReleaseDecisionsCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getV1ReleaseDecisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AM-042 §2.3 API: ReleaseDecision (Append-Only Trace).
پرمیشن‌ها مطابق سند AM-042: quality.manage برای POST و quality.view برای GET (List, Retrieve).
 * @summary Retrieve a quality release decision (read-only)
 */
export const v1ReleaseDecisionsRetrieve2 = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/release-decisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ReleaseDecisionsRetrieve2QueryKey = (id?: string,) => {
    return [
    `/api/v1/release-decisions/${id}/`
    ] as const;
    }

    
export const getV1ReleaseDecisionsRetrieve2QueryOptions = <TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReleaseDecisionsRetrieve2QueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>> = ({ signal }) => v1ReleaseDecisionsRetrieve2(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ReleaseDecisionsRetrieve2QueryResult = NonNullable<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>>
export type V1ReleaseDecisionsRetrieve2QueryError = unknown


export function useV1ReleaseDecisionsRetrieve2<TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>,
          TError,
          Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReleaseDecisionsRetrieve2<TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>,
          TError,
          Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReleaseDecisionsRetrieve2<TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a quality release decision (read-only)
 */

export function useV1ReleaseDecisionsRetrieve2<TData = Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReleaseDecisionsRetrieve2>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ReleaseDecisionsRetrieve2QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Reporting ViewSets.
Local copy per ADR-058 domain isolation — no cross-domain imports
(مشابه apps.quality.api.mixins، apps.workflow.api.mixins، ...).
 */
export const v1ReportingDefinitionsList = (
    params?: V1ReportingDefinitionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedReportDefinitionList>(
      {url: `/api/v1/reporting/definitions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1ReportingDefinitionsListQueryKey = (params?: V1ReportingDefinitionsListParams,) => {
    return [
    `/api/v1/reporting/definitions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1ReportingDefinitionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError = unknown>(params?: V1ReportingDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingDefinitionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingDefinitionsList>>> = ({ signal }) => v1ReportingDefinitionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ReportingDefinitionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingDefinitionsList>>>
export type V1ReportingDefinitionsListQueryError = unknown


export function useV1ReportingDefinitionsList<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError = unknown>(
 params: undefined |  V1ReportingDefinitionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingDefinitionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingDefinitionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReportingDefinitionsList<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError = unknown>(
 params?: V1ReportingDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingDefinitionsList>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingDefinitionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReportingDefinitionsList<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError = unknown>(
 params?: V1ReportingDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ReportingDefinitionsList<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError = unknown>(
 params?: V1ReportingDefinitionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ReportingDefinitionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Reporting ViewSets.
Local copy per ADR-058 domain isolation — no cross-domain imports
(مشابه apps.quality.api.mixins، apps.workflow.api.mixins، ...).
 */
export const v1ReportingDefinitionsCreate = (
    reportDefinition: NonReadonly<ReportDefinition>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ReportDefinition>(
      {url: `/api/v1/reporting/definitions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportDefinition, signal
    },
      );
    }
  


export const getV1ReportingDefinitionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsCreate>>, TError,{data: NonReadonly<ReportDefinition>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsCreate>>, TError,{data: NonReadonly<ReportDefinition>}, TContext> => {

const mutationKey = ['v1ReportingDefinitionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ReportingDefinitionsCreate>>, {data: NonReadonly<ReportDefinition>}> = (props) => {
          const {data} = props ?? {};

          return  v1ReportingDefinitionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ReportingDefinitionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ReportingDefinitionsCreate>>>
    export type V1ReportingDefinitionsCreateMutationBody = NonReadonly<ReportDefinition>
    export type V1ReportingDefinitionsCreateMutationError = unknown

    export const useV1ReportingDefinitionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsCreate>>, TError,{data: NonReadonly<ReportDefinition>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ReportingDefinitionsCreate>>,
        TError,
        {data: NonReadonly<ReportDefinition>},
        TContext
      > => {

      const mutationOptions = getV1ReportingDefinitionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Reporting ViewSets.
Local copy per ADR-058 domain isolation — no cross-domain imports
(مشابه apps.quality.api.mixins، apps.workflow.api.mixins، ...).
 */
export const v1ReportingDefinitionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ReportDefinition>(
      {url: `/api/v1/reporting/definitions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ReportingDefinitionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/reporting/definitions/${id}/`
    ] as const;
    }

    
export const getV1ReportingDefinitionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingDefinitionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>> = ({ signal }) => v1ReportingDefinitionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ReportingDefinitionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>>
export type V1ReportingDefinitionsRetrieveQueryError = unknown


export function useV1ReportingDefinitionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReportingDefinitionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReportingDefinitionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ReportingDefinitionsRetrieve<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ReportingDefinitionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Reporting ViewSets.
Local copy per ADR-058 domain isolation — no cross-domain imports
(مشابه apps.quality.api.mixins، apps.workflow.api.mixins، ...).
 */
export const v1ReportingDefinitionsUpdate = (
    id: string,
    reportDefinition: NonReadonly<ReportDefinition>,
 ) => {
      
      
      return customAxiosInstance<ReportDefinition>(
      {url: `/api/v1/reporting/definitions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: reportDefinition
    },
      );
    }
  


export const getV1ReportingDefinitionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsUpdate>>, TError,{id: string;data: NonReadonly<ReportDefinition>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsUpdate>>, TError,{id: string;data: NonReadonly<ReportDefinition>}, TContext> => {

const mutationKey = ['v1ReportingDefinitionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ReportingDefinitionsUpdate>>, {id: string;data: NonReadonly<ReportDefinition>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ReportingDefinitionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ReportingDefinitionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ReportingDefinitionsUpdate>>>
    export type V1ReportingDefinitionsUpdateMutationBody = NonReadonly<ReportDefinition>
    export type V1ReportingDefinitionsUpdateMutationError = unknown

    export const useV1ReportingDefinitionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsUpdate>>, TError,{id: string;data: NonReadonly<ReportDefinition>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ReportingDefinitionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<ReportDefinition>},
        TContext
      > => {

      const mutationOptions = getV1ReportingDefinitionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Reporting ViewSets.
Local copy per ADR-058 domain isolation — no cross-domain imports
(مشابه apps.quality.api.mixins، apps.workflow.api.mixins، ...).
 */
export const v1ReportingDefinitionsPartialUpdate = (
    id: string,
    patchedReportDefinition: NonReadonly<PatchedReportDefinition>,
 ) => {
      
      
      return customAxiosInstance<ReportDefinition>(
      {url: `/api/v1/reporting/definitions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedReportDefinition
    },
      );
    }
  


export const getV1ReportingDefinitionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedReportDefinition>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedReportDefinition>}, TContext> => {

const mutationKey = ['v1ReportingDefinitionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ReportingDefinitionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedReportDefinition>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1ReportingDefinitionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ReportingDefinitionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ReportingDefinitionsPartialUpdate>>>
    export type V1ReportingDefinitionsPartialUpdateMutationBody = NonReadonly<PatchedReportDefinition>
    export type V1ReportingDefinitionsPartialUpdateMutationError = unknown

    export const useV1ReportingDefinitionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedReportDefinition>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ReportingDefinitionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedReportDefinition>},
        TContext
      > => {

      const mutationOptions = getV1ReportingDefinitionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Reporting ViewSets.
Local copy per ADR-058 domain isolation — no cross-domain imports
(مشابه apps.quality.api.mixins، apps.workflow.api.mixins، ...).
 */
export const v1ReportingDefinitionsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/reporting/definitions/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1ReportingDefinitionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1ReportingDefinitionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ReportingDefinitionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1ReportingDefinitionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ReportingDefinitionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1ReportingDefinitionsDestroy>>>
    
    export type V1ReportingDefinitionsDestroyMutationError = unknown

    export const useV1ReportingDefinitionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ReportingDefinitionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1ReportingDefinitionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rule RPT-06: preview صفحه‌بندی‌شده، synchronous، با سقف ردیف.
 */
export const v1ReportingDefinitionsExecuteCreate = (
    id: string,
    params?: V1ReportingDefinitionsExecuteCreateParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ReportDefinition>(
      {url: `/api/v1/reporting/definitions/${id}/execute/`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getV1ReportingDefinitionsExecuteCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsExecuteCreate>>, TError,{id: string;params?: V1ReportingDefinitionsExecuteCreateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsExecuteCreate>>, TError,{id: string;params?: V1ReportingDefinitionsExecuteCreateParams}, TContext> => {

const mutationKey = ['v1ReportingDefinitionsExecuteCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1ReportingDefinitionsExecuteCreate>>, {id: string;params?: V1ReportingDefinitionsExecuteCreateParams}> = (props) => {
          const {id,params} = props ?? {};

          return  v1ReportingDefinitionsExecuteCreate(id,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1ReportingDefinitionsExecuteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1ReportingDefinitionsExecuteCreate>>>
    
    export type V1ReportingDefinitionsExecuteCreateMutationError = unknown

    export const useV1ReportingDefinitionsExecuteCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsExecuteCreate>>, TError,{id: string;params?: V1ReportingDefinitionsExecuteCreateParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1ReportingDefinitionsExecuteCreate>>,
        TError,
        {id: string;params?: V1ReportingDefinitionsExecuteCreateParams},
        TContext
      > => {

      const mutationOptions = getV1ReportingDefinitionsExecuteCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rule RPT-07: خروجی CSV، بدون pagination، با همان سقف ردیف.
 */
export const v1ReportingDefinitionsExportRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ReportDefinition>(
      {url: `/api/v1/reporting/definitions/${id}/export/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ReportingDefinitionsExportRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/reporting/definitions/${id}/export/`
    ] as const;
    }

    
export const getV1ReportingDefinitionsExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingDefinitionsExportRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>> = ({ signal }) => v1ReportingDefinitionsExportRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ReportingDefinitionsExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>>
export type V1ReportingDefinitionsExportRetrieveQueryError = unknown


export function useV1ReportingDefinitionsExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReportingDefinitionsExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReportingDefinitionsExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ReportingDefinitionsExportRetrieve<TData = Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingDefinitionsExportRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ReportingDefinitionsExportRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET /api/reporting/sources/
Rule RPT-01/RPT-08: فقط metadata رجیستری را expose می‌کند تا فرانت
بتواند فرم ساخت گزارش را بسازد. خودِ داده هرگز از این endpoint
برنمی‌گردد.
 */
export const v1ReportingSourcesList = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ReportSourceField[]>(
      {url: `/api/v1/reporting/sources/`, method: 'GET', signal
    },
      );
    }
  



export const getV1ReportingSourcesListQueryKey = () => {
    return [
    `/api/v1/reporting/sources/`
    ] as const;
    }

    
export const getV1ReportingSourcesListQueryOptions = <TData = Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1ReportingSourcesListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1ReportingSourcesList>>> = ({ signal }) => v1ReportingSourcesList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1ReportingSourcesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1ReportingSourcesList>>>
export type V1ReportingSourcesListQueryError = unknown


export function useV1ReportingSourcesList<TData = Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingSourcesList>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingSourcesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReportingSourcesList<TData = Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1ReportingSourcesList>>,
          TError,
          Awaited<ReturnType<typeof v1ReportingSourcesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1ReportingSourcesList<TData = Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1ReportingSourcesList<TData = Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1ReportingSourcesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1ReportingSourcesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-089 GES-02.
GET /api/v1/shared/entity-search/?model=inventory.materialrevision&q=PLT-10
 */
export const v1SharedEntitySearchRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/shared/entity-search/`, method: 'GET', signal
    },
      );
    }
  



export const getV1SharedEntitySearchRetrieveQueryKey = () => {
    return [
    `/api/v1/shared/entity-search/`
    ] as const;
    }

    
export const getV1SharedEntitySearchRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SharedEntitySearchRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>> = ({ signal }) => v1SharedEntitySearchRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1SharedEntitySearchRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>>
export type V1SharedEntitySearchRetrieveQueryError = unknown


export function useV1SharedEntitySearchRetrieve<TData = Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1SharedEntitySearchRetrieve<TData = Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1SharedEntitySearchRetrieve<TData = Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1SharedEntitySearchRetrieve<TData = Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1SharedEntitySearchRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET /api/v1/shared/entity-search/detail/?model=inventory.materialrevision&id=uuid
Returns full object details including generic custom_fields mapping for Form Auto-Fill.
 */
export const v1SharedEntitySearchDetailRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/shared/entity-search/detail/`, method: 'GET', signal
    },
      );
    }
  



export const getV1SharedEntitySearchDetailRetrieveQueryKey = () => {
    return [
    `/api/v1/shared/entity-search/detail/`
    ] as const;
    }

    
export const getV1SharedEntitySearchDetailRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1SharedEntitySearchDetailRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>> = ({ signal }) => v1SharedEntitySearchDetailRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1SharedEntitySearchDetailRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>>
export type V1SharedEntitySearchDetailRetrieveQueryError = unknown


export function useV1SharedEntitySearchDetailRetrieve<TData = Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1SharedEntitySearchDetailRetrieve<TData = Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1SharedEntitySearchDetailRetrieve<TData = Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1SharedEntitySearchDetailRetrieve<TData = Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1SharedEntitySearchDetailRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1SharedEntitySearchDetailRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet for Tenant management (System Administration level).
 * @summary List all tenants
 */
export const v1TenantsList = (
    params?: V1TenantsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedTenantListList>(
      {url: `/api/v1/tenants/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1TenantsListQueryKey = (params?: V1TenantsListParams,) => {
    return [
    `/api/v1/tenants/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1TenantsListQueryOptions = <TData = Awaited<ReturnType<typeof v1TenantsList>>, TError = unknown>(params?: V1TenantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1TenantsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1TenantsList>>> = ({ signal }) => v1TenantsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1TenantsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1TenantsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1TenantsList>>>
export type V1TenantsListQueryError = unknown


export function useV1TenantsList<TData = Awaited<ReturnType<typeof v1TenantsList>>, TError = unknown>(
 params: undefined |  V1TenantsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1TenantsList>>,
          TError,
          Awaited<ReturnType<typeof v1TenantsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1TenantsList<TData = Awaited<ReturnType<typeof v1TenantsList>>, TError = unknown>(
 params?: V1TenantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1TenantsList>>,
          TError,
          Awaited<ReturnType<typeof v1TenantsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1TenantsList<TData = Awaited<ReturnType<typeof v1TenantsList>>, TError = unknown>(
 params?: V1TenantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all tenants
 */

export function useV1TenantsList<TData = Awaited<ReturnType<typeof v1TenantsList>>, TError = unknown>(
 params?: V1TenantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1TenantsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet for Tenant management (System Administration level).
 * @summary Create and provision a new tenant
 */
export const v1TenantsCreate = (
    tenantCreate: TenantCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantCreate, signal
    },
      );
    }
  


export const getV1TenantsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsCreate>>, TError,{data: TenantCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsCreate>>, TError,{data: TenantCreate}, TContext> => {

const mutationKey = ['v1TenantsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsCreate>>, {data: TenantCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1TenantsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsCreate>>>
    export type V1TenantsCreateMutationBody = TenantCreate
    export type V1TenantsCreateMutationError = unknown

    /**
 * @summary Create and provision a new tenant
 */
export const useV1TenantsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsCreate>>, TError,{data: TenantCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsCreate>>,
        TError,
        {data: TenantCreate},
        TContext
      > => {

      const mutationOptions = getV1TenantsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Tenant management (System Administration level).
 * @summary Retrieve a tenant by ID
 */
export const v1TenantsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1TenantsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/tenants/${id}/`
    ] as const;
    }

    
export const getV1TenantsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1TenantsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1TenantsRetrieve>>> = ({ signal }) => v1TenantsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1TenantsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1TenantsRetrieve>>>
export type V1TenantsRetrieveQueryError = unknown


export function useV1TenantsRetrieve<TData = Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1TenantsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1TenantsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1TenantsRetrieve<TData = Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1TenantsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1TenantsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1TenantsRetrieve<TData = Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a tenant by ID
 */

export function useV1TenantsRetrieve<TData = Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1TenantsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1TenantsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet for Tenant management (System Administration level).
 */
export const v1TenantsUpdate = (
    id: string,
    tenantDetail: NonReadonly<TenantDetail>,
 ) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tenantDetail
    },
      );
    }
  


export const getV1TenantsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsUpdate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsUpdate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext> => {

const mutationKey = ['v1TenantsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsUpdate>>, {id: string;data: NonReadonly<TenantDetail>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1TenantsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsUpdate>>>
    export type V1TenantsUpdateMutationBody = NonReadonly<TenantDetail>
    export type V1TenantsUpdateMutationError = unknown

    export const useV1TenantsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsUpdate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsUpdate>>,
        TError,
        {id: string;data: NonReadonly<TenantDetail>},
        TContext
      > => {

      const mutationOptions = getV1TenantsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Tenant management (System Administration level).
 */
export const v1TenantsPartialUpdate = (
    id: string,
    patchedTenantDetail: NonReadonly<PatchedTenantDetail>,
 ) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedTenantDetail
    },
      );
    }
  


export const getV1TenantsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedTenantDetail>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedTenantDetail>}, TContext> => {

const mutationKey = ['v1TenantsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsPartialUpdate>>, {id: string;data: NonReadonly<PatchedTenantDetail>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1TenantsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsPartialUpdate>>>
    export type V1TenantsPartialUpdateMutationBody = NonReadonly<PatchedTenantDetail>
    export type V1TenantsPartialUpdateMutationError = unknown

    export const useV1TenantsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedTenantDetail>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedTenantDetail>},
        TContext
      > => {

      const mutationOptions = getV1TenantsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Tenant management (System Administration level).
 */
export const v1TenantsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/tenants/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1TenantsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1TenantsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1TenantsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsDestroy>>>
    
    export type V1TenantsDestroyMutationError = unknown

    export const useV1TenantsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1TenantsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Tenant management (System Administration level).
 * @summary Activate a tenant
 */
export const v1TenantsActivateCreate = (
    id: string,
    tenantDetail: NonReadonly<TenantDetail>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/${id}/activate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantDetail, signal
    },
      );
    }
  


export const getV1TenantsActivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsActivateCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsActivateCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext> => {

const mutationKey = ['v1TenantsActivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsActivateCreate>>, {id: string;data: NonReadonly<TenantDetail>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1TenantsActivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsActivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsActivateCreate>>>
    export type V1TenantsActivateCreateMutationBody = NonReadonly<TenantDetail>
    export type V1TenantsActivateCreateMutationError = unknown

    /**
 * @summary Activate a tenant
 */
export const useV1TenantsActivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsActivateCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsActivateCreate>>,
        TError,
        {id: string;data: NonReadonly<TenantDetail>},
        TContext
      > => {

      const mutationOptions = getV1TenantsActivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Tenant management (System Administration level).
 * @summary Archive a tenant
 */
export const v1TenantsArchiveCreate = (
    id: string,
    tenantDetail: NonReadonly<TenantDetail>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/${id}/archive/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantDetail, signal
    },
      );
    }
  


export const getV1TenantsArchiveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsArchiveCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsArchiveCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext> => {

const mutationKey = ['v1TenantsArchiveCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsArchiveCreate>>, {id: string;data: NonReadonly<TenantDetail>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1TenantsArchiveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsArchiveCreate>>>
    export type V1TenantsArchiveCreateMutationBody = NonReadonly<TenantDetail>
    export type V1TenantsArchiveCreateMutationError = unknown

    /**
 * @summary Archive a tenant
 */
export const useV1TenantsArchiveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsArchiveCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsArchiveCreate>>,
        TError,
        {id: string;data: NonReadonly<TenantDetail>},
        TContext
      > => {

      const mutationOptions = getV1TenantsArchiveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Tenant management (System Administration level).
 * @summary End deployment phase for a tenant
 */
export const v1TenantsEndDeploymentPhaseCreate = (
    id: string,
    tenantDetail: NonReadonly<TenantDetail>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/${id}/end-deployment-phase/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantDetail, signal
    },
      );
    }
  


export const getV1TenantsEndDeploymentPhaseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsEndDeploymentPhaseCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsEndDeploymentPhaseCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext> => {

const mutationKey = ['v1TenantsEndDeploymentPhaseCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsEndDeploymentPhaseCreate>>, {id: string;data: NonReadonly<TenantDetail>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1TenantsEndDeploymentPhaseCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsEndDeploymentPhaseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsEndDeploymentPhaseCreate>>>
    export type V1TenantsEndDeploymentPhaseCreateMutationBody = NonReadonly<TenantDetail>
    export type V1TenantsEndDeploymentPhaseCreateMutationError = unknown

    /**
 * @summary End deployment phase for a tenant
 */
export const useV1TenantsEndDeploymentPhaseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsEndDeploymentPhaseCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsEndDeploymentPhaseCreate>>,
        TError,
        {id: string;data: NonReadonly<TenantDetail>},
        TContext
      > => {

      const mutationOptions = getV1TenantsEndDeploymentPhaseCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Tenant management (System Administration level).
 * @summary Reactivate a tenant
 */
export const v1TenantsReactivateCreate = (
    id: string,
    tenantDetail: NonReadonly<TenantDetail>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/${id}/reactivate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantDetail, signal
    },
      );
    }
  


export const getV1TenantsReactivateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsReactivateCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsReactivateCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext> => {

const mutationKey = ['v1TenantsReactivateCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsReactivateCreate>>, {id: string;data: NonReadonly<TenantDetail>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1TenantsReactivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsReactivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsReactivateCreate>>>
    export type V1TenantsReactivateCreateMutationBody = NonReadonly<TenantDetail>
    export type V1TenantsReactivateCreateMutationError = unknown

    /**
 * @summary Reactivate a tenant
 */
export const useV1TenantsReactivateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsReactivateCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsReactivateCreate>>,
        TError,
        {id: string;data: NonReadonly<TenantDetail>},
        TContext
      > => {

      const mutationOptions = getV1TenantsReactivateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Tenant management (System Administration level).
 * @summary Start deployment phase for a tenant
 */
export const v1TenantsStartDeploymentPhaseCreate = (
    id: string,
    tenantDetail: NonReadonly<TenantDetail>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/${id}/start-deployment-phase/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantDetail, signal
    },
      );
    }
  


export const getV1TenantsStartDeploymentPhaseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsStartDeploymentPhaseCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsStartDeploymentPhaseCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext> => {

const mutationKey = ['v1TenantsStartDeploymentPhaseCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsStartDeploymentPhaseCreate>>, {id: string;data: NonReadonly<TenantDetail>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1TenantsStartDeploymentPhaseCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsStartDeploymentPhaseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsStartDeploymentPhaseCreate>>>
    export type V1TenantsStartDeploymentPhaseCreateMutationBody = NonReadonly<TenantDetail>
    export type V1TenantsStartDeploymentPhaseCreateMutationError = unknown

    /**
 * @summary Start deployment phase for a tenant
 */
export const useV1TenantsStartDeploymentPhaseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsStartDeploymentPhaseCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsStartDeploymentPhaseCreate>>,
        TError,
        {id: string;data: NonReadonly<TenantDetail>},
        TContext
      > => {

      const mutationOptions = getV1TenantsStartDeploymentPhaseCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet for Tenant management (System Administration level).
 * @summary Suspend a tenant
 */
export const v1TenantsSuspendCreate = (
    id: string,
    tenantDetail: NonReadonly<TenantDetail>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<TenantDetail>(
      {url: `/api/v1/tenants/${id}/suspend/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantDetail, signal
    },
      );
    }
  


export const getV1TenantsSuspendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsSuspendCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1TenantsSuspendCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext> => {

const mutationKey = ['v1TenantsSuspendCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1TenantsSuspendCreate>>, {id: string;data: NonReadonly<TenantDetail>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1TenantsSuspendCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1TenantsSuspendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1TenantsSuspendCreate>>>
    export type V1TenantsSuspendCreateMutationBody = NonReadonly<TenantDetail>
    export type V1TenantsSuspendCreateMutationError = unknown

    /**
 * @summary Suspend a tenant
 */
export const useV1TenantsSuspendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1TenantsSuspendCreate>>, TError,{id: string;data: NonReadonly<TenantDetail>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1TenantsSuspendCreate>>,
        TError,
        {id: string;data: NonReadonly<TenantDetail>},
        TContext
      > => {

      const mutationOptions = getV1TenantsSuspendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet اصلی مدیریت کاربران، پسورد و دسترسی‌ها (AM-026).
 */
export const v1UsersList = (
    params?: V1UsersListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedUserList>(
      {url: `/api/v1/users/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1UsersListQueryKey = (params?: V1UsersListParams,) => {
    return [
    `/api/v1/users/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1UsersListQueryOptions = <TData = Awaited<ReturnType<typeof v1UsersList>>, TError = unknown>(params?: V1UsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1UsersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1UsersList>>> = ({ signal }) => v1UsersList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1UsersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1UsersListQueryResult = NonNullable<Awaited<ReturnType<typeof v1UsersList>>>
export type V1UsersListQueryError = unknown


export function useV1UsersList<TData = Awaited<ReturnType<typeof v1UsersList>>, TError = unknown>(
 params: undefined |  V1UsersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersList>>,
          TError,
          Awaited<ReturnType<typeof v1UsersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersList<TData = Awaited<ReturnType<typeof v1UsersList>>, TError = unknown>(
 params?: V1UsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersList>>,
          TError,
          Awaited<ReturnType<typeof v1UsersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersList<TData = Awaited<ReturnType<typeof v1UsersList>>, TError = unknown>(
 params?: V1UsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1UsersList<TData = Awaited<ReturnType<typeof v1UsersList>>, TError = unknown>(
 params?: V1UsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1UsersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet اصلی مدیریت کاربران، پسورد و دسترسی‌ها (AM-026).
 */
export const v1UsersCreate = (
    user: NonReadonly<User>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<User>(
      {url: `/api/v1/users/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: user, signal
    },
      );
    }
  


export const getV1UsersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersCreate>>, TError,{data: NonReadonly<User>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1UsersCreate>>, TError,{data: NonReadonly<User>}, TContext> => {

const mutationKey = ['v1UsersCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1UsersCreate>>, {data: NonReadonly<User>}> = (props) => {
          const {data} = props ?? {};

          return  v1UsersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1UsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1UsersCreate>>>
    export type V1UsersCreateMutationBody = NonReadonly<User>
    export type V1UsersCreateMutationError = unknown

    export const useV1UsersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersCreate>>, TError,{data: NonReadonly<User>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1UsersCreate>>,
        TError,
        {data: NonReadonly<User>},
        TContext
      > => {

      const mutationOptions = getV1UsersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet اصلی مدیریت کاربران، پسورد و دسترسی‌ها (AM-026).
 */
export const v1UsersRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<User>(
      {url: `/api/v1/users/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1UsersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/users/${id}/`
    ] as const;
    }

    
export const getV1UsersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1UsersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1UsersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1UsersRetrieve>>> = ({ signal }) => v1UsersRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1UsersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1UsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1UsersRetrieve>>>
export type V1UsersRetrieveQueryError = unknown


export function useV1UsersRetrieve<TData = Awaited<ReturnType<typeof v1UsersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1UsersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersRetrieve<TData = Awaited<ReturnType<typeof v1UsersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1UsersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersRetrieve<TData = Awaited<ReturnType<typeof v1UsersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1UsersRetrieve<TData = Awaited<ReturnType<typeof v1UsersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1UsersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ViewSet اصلی مدیریت کاربران، پسورد و دسترسی‌ها (AM-026).
 */
export const v1UsersUpdate = (
    id: string,
    user: NonReadonly<User>,
 ) => {
      
      
      return customAxiosInstance<User>(
      {url: `/api/v1/users/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: user
    },
      );
    }
  


export const getV1UsersUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersUpdate>>, TError,{id: string;data: NonReadonly<User>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1UsersUpdate>>, TError,{id: string;data: NonReadonly<User>}, TContext> => {

const mutationKey = ['v1UsersUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1UsersUpdate>>, {id: string;data: NonReadonly<User>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1UsersUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1UsersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1UsersUpdate>>>
    export type V1UsersUpdateMutationBody = NonReadonly<User>
    export type V1UsersUpdateMutationError = unknown

    export const useV1UsersUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersUpdate>>, TError,{id: string;data: NonReadonly<User>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1UsersUpdate>>,
        TError,
        {id: string;data: NonReadonly<User>},
        TContext
      > => {

      const mutationOptions = getV1UsersUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet اصلی مدیریت کاربران، پسورد و دسترسی‌ها (AM-026).
 */
export const v1UsersPartialUpdate = (
    id: string,
    patchedUser: NonReadonly<PatchedUser>,
 ) => {
      
      
      return customAxiosInstance<User>(
      {url: `/api/v1/users/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedUser
    },
      );
    }
  


export const getV1UsersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedUser>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1UsersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedUser>}, TContext> => {

const mutationKey = ['v1UsersPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1UsersPartialUpdate>>, {id: string;data: NonReadonly<PatchedUser>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1UsersPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1UsersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1UsersPartialUpdate>>>
    export type V1UsersPartialUpdateMutationBody = NonReadonly<PatchedUser>
    export type V1UsersPartialUpdateMutationError = unknown

    export const useV1UsersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedUser>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1UsersPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedUser>},
        TContext
      > => {

      const mutationOptions = getV1UsersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ViewSet اصلی مدیریت کاربران، پسورد و دسترسی‌ها (AM-026).
 */
export const v1UsersDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/users/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1UsersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1UsersDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1UsersDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1UsersDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1UsersDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1UsersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1UsersDestroy>>>
    
    export type V1UsersDestroyMutationError = unknown

    export const useV1UsersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1UsersDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1UsersDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rule RBAC-03.
GET -> کاتالوگ + دسترسی مؤثر.
POST -> جایگزینی کامل Overrideها.
نیازمند users.manage.
 */
export const v1UsersPermissionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<User>(
      {url: `/api/v1/users/${id}/permissions/`, method: 'GET', signal
    },
      );
    }
  



export const getV1UsersPermissionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/users/${id}/permissions/`
    ] as const;
    }

    
export const getV1UsersPermissionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1UsersPermissionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>> = ({ signal }) => v1UsersPermissionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1UsersPermissionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>>
export type V1UsersPermissionsRetrieveQueryError = unknown


export function useV1UsersPermissionsRetrieve<TData = Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersPermissionsRetrieve<TData = Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersPermissionsRetrieve<TData = Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1UsersPermissionsRetrieve<TData = Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersPermissionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1UsersPermissionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Rule RBAC-03.
GET -> کاتالوگ + دسترسی مؤثر.
POST -> جایگزینی کامل Overrideها.
نیازمند users.manage.
 */
export const v1UsersPermissionsCreate = (
    id: string,
    user: NonReadonly<User>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<User>(
      {url: `/api/v1/users/${id}/permissions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: user, signal
    },
      );
    }
  


export const getV1UsersPermissionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersPermissionsCreate>>, TError,{id: string;data: NonReadonly<User>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1UsersPermissionsCreate>>, TError,{id: string;data: NonReadonly<User>}, TContext> => {

const mutationKey = ['v1UsersPermissionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1UsersPermissionsCreate>>, {id: string;data: NonReadonly<User>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1UsersPermissionsCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1UsersPermissionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1UsersPermissionsCreate>>>
    export type V1UsersPermissionsCreateMutationBody = NonReadonly<User>
    export type V1UsersPermissionsCreateMutationError = unknown

    export const useV1UsersPermissionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersPermissionsCreate>>, TError,{id: string;data: NonReadonly<User>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1UsersPermissionsCreate>>,
        TError,
        {id: string;data: NonReadonly<User>},
        TContext
      > => {

      const mutationOptions = getV1UsersPermissionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rule PWD-02/PWD-03 — ریست پسورد توسط مدیر.
نیازمند users.manage (ثبت‌شده در DEFAULT_ACTION_PERMISSION_SUFFIX).
 */
export const v1UsersResetPasswordCreate = (
    id: string,
    user: NonReadonly<User>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<User>(
      {url: `/api/v1/users/${id}/reset-password/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: user, signal
    },
      );
    }
  


export const getV1UsersResetPasswordCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersResetPasswordCreate>>, TError,{id: string;data: NonReadonly<User>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1UsersResetPasswordCreate>>, TError,{id: string;data: NonReadonly<User>}, TContext> => {

const mutationKey = ['v1UsersResetPasswordCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1UsersResetPasswordCreate>>, {id: string;data: NonReadonly<User>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1UsersResetPasswordCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1UsersResetPasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1UsersResetPasswordCreate>>>
    export type V1UsersResetPasswordCreateMutationBody = NonReadonly<User>
    export type V1UsersResetPasswordCreateMutationError = unknown

    export const useV1UsersResetPasswordCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersResetPasswordCreate>>, TError,{id: string;data: NonReadonly<User>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1UsersResetPasswordCreate>>,
        TError,
        {id: string;data: NonReadonly<User>},
        TContext
      > => {

      const mutationOptions = getV1UsersResetPasswordCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * نمونه ویو برای تست دسترسی ادمین.
 */
export const v1UsersAdminTestRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/users/admin-test/`, method: 'GET', signal
    },
      );
    }
  



export const getV1UsersAdminTestRetrieveQueryKey = () => {
    return [
    `/api/v1/users/admin-test/`
    ] as const;
    }

    
export const getV1UsersAdminTestRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1UsersAdminTestRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>> = ({ signal }) => v1UsersAdminTestRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1UsersAdminTestRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>>
export type V1UsersAdminTestRetrieveQueryError = unknown


export function useV1UsersAdminTestRetrieve<TData = Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersAdminTestRetrieve<TData = Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersAdminTestRetrieve<TData = Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1UsersAdminTestRetrieve<TData = Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersAdminTestRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1UsersAdminTestRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * لیست و ایجاد کاربران فعال تنانت کنونی جهت استفاده در فرانت‌اند.
 */
export const v1UsersListRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/users/list/`, method: 'GET', signal
    },
      );
    }
  



export const getV1UsersListRetrieveQueryKey = () => {
    return [
    `/api/v1/users/list/`
    ] as const;
    }

    
export const getV1UsersListRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1UsersListRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1UsersListRetrieve>>> = ({ signal }) => v1UsersListRetrieve(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1UsersListRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1UsersListRetrieve>>>
export type V1UsersListRetrieveQueryError = unknown


export function useV1UsersListRetrieve<TData = Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersListRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1UsersListRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersListRetrieve<TData = Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1UsersListRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1UsersListRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1UsersListRetrieve<TData = Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useV1UsersListRetrieve<TData = Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1UsersListRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1UsersListRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * لیست و ایجاد کاربران فعال تنانت کنونی جهت استفاده در فرانت‌اند.
 */
export const v1UsersListCreate = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/users/list/`, method: 'POST', signal
    },
      );
    }
  


export const getV1UsersListCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersListCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1UsersListCreate>>, TError,void, TContext> => {

const mutationKey = ['v1UsersListCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1UsersListCreate>>, void> = () => {
          

          return  v1UsersListCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1UsersListCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1UsersListCreate>>>
    
    export type V1UsersListCreateMutationError = unknown

    export const useV1UsersListCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersListCreate>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1UsersListCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getV1UsersListCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rule PWD-01 — تغییر پسورد خود کاربر.
 */
export const v1UsersMeChangePasswordCreate = (
    user: NonReadonly<User>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<User>(
      {url: `/api/v1/users/me/change-password/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: user, signal
    },
      );
    }
  


export const getV1UsersMeChangePasswordCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersMeChangePasswordCreate>>, TError,{data: NonReadonly<User>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1UsersMeChangePasswordCreate>>, TError,{data: NonReadonly<User>}, TContext> => {

const mutationKey = ['v1UsersMeChangePasswordCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1UsersMeChangePasswordCreate>>, {data: NonReadonly<User>}> = (props) => {
          const {data} = props ?? {};

          return  v1UsersMeChangePasswordCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1UsersMeChangePasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1UsersMeChangePasswordCreate>>>
    export type V1UsersMeChangePasswordCreateMutationBody = NonReadonly<User>
    export type V1UsersMeChangePasswordCreateMutationError = unknown

    export const useV1UsersMeChangePasswordCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1UsersMeChangePasswordCreate>>, TError,{data: NonReadonly<User>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1UsersMeChangePasswordCreate>>,
        TError,
        {data: NonReadonly<User>},
        TContext
      > => {

      const mutationOptions = getV1UsersMeChangePasswordCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary List workflow families for active tenant
 */
export const v1WorkflowFamiliesList = (
    params?: V1WorkflowFamiliesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkflowFamilyList>(
      {url: `/api/v1/workflow/families/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1WorkflowFamiliesListQueryKey = (params?: V1WorkflowFamiliesListParams,) => {
    return [
    `/api/v1/workflow/families/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1WorkflowFamiliesListQueryOptions = <TData = Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError = unknown>(params?: V1WorkflowFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1WorkflowFamiliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1WorkflowFamiliesList>>> = ({ signal }) => v1WorkflowFamiliesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1WorkflowFamiliesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowFamiliesList>>>
export type V1WorkflowFamiliesListQueryError = unknown


export function useV1WorkflowFamiliesList<TData = Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError = unknown>(
 params: undefined |  V1WorkflowFamiliesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowFamiliesList<TData = Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError = unknown>(
 params?: V1WorkflowFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowFamiliesList>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowFamiliesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowFamiliesList<TData = Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError = unknown>(
 params?: V1WorkflowFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List workflow families for active tenant
 */

export function useV1WorkflowFamiliesList<TData = Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError = unknown>(
 params?: V1WorkflowFamiliesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1WorkflowFamiliesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary Create a new workflow family
 */
export const v1WorkflowFamiliesCreate = (
    workflowFamily: NonReadonly<WorkflowFamily>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowFamily>(
      {url: `/api/v1/workflow/families/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowFamily, signal
    },
      );
    }
  


export const getV1WorkflowFamiliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesCreate>>, TError,{data: NonReadonly<WorkflowFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesCreate>>, TError,{data: NonReadonly<WorkflowFamily>}, TContext> => {

const mutationKey = ['v1WorkflowFamiliesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowFamiliesCreate>>, {data: NonReadonly<WorkflowFamily>}> = (props) => {
          const {data} = props ?? {};

          return  v1WorkflowFamiliesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowFamiliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowFamiliesCreate>>>
    export type V1WorkflowFamiliesCreateMutationBody = NonReadonly<WorkflowFamily>
    export type V1WorkflowFamiliesCreateMutationError = unknown

    /**
 * @summary Create a new workflow family
 */
export const useV1WorkflowFamiliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesCreate>>, TError,{data: NonReadonly<WorkflowFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowFamiliesCreate>>,
        TError,
        {data: NonReadonly<WorkflowFamily>},
        TContext
      > => {

      const mutationOptions = getV1WorkflowFamiliesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary Retrieve a workflow family by ID
 */
export const v1WorkflowFamiliesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowFamily>(
      {url: `/api/v1/workflow/families/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1WorkflowFamiliesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/workflow/families/${id}/`
    ] as const;
    }

    
export const getV1WorkflowFamiliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1WorkflowFamiliesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>> = ({ signal }) => v1WorkflowFamiliesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1WorkflowFamiliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>>
export type V1WorkflowFamiliesRetrieveQueryError = unknown


export function useV1WorkflowFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a workflow family by ID
 */

export function useV1WorkflowFamiliesRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1WorkflowFamiliesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 */
export const v1WorkflowFamiliesUpdate = (
    id: string,
    workflowFamily: NonReadonly<WorkflowFamily>,
 ) => {
      
      
      return customAxiosInstance<WorkflowFamily>(
      {url: `/api/v1/workflow/families/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workflowFamily
    },
      );
    }
  


export const getV1WorkflowFamiliesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesUpdate>>, TError,{id: string;data: NonReadonly<WorkflowFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesUpdate>>, TError,{id: string;data: NonReadonly<WorkflowFamily>}, TContext> => {

const mutationKey = ['v1WorkflowFamiliesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowFamiliesUpdate>>, {id: string;data: NonReadonly<WorkflowFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1WorkflowFamiliesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowFamiliesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowFamiliesUpdate>>>
    export type V1WorkflowFamiliesUpdateMutationBody = NonReadonly<WorkflowFamily>
    export type V1WorkflowFamiliesUpdateMutationError = unknown

    export const useV1WorkflowFamiliesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesUpdate>>, TError,{id: string;data: NonReadonly<WorkflowFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowFamiliesUpdate>>,
        TError,
        {id: string;data: NonReadonly<WorkflowFamily>},
        TContext
      > => {

      const mutationOptions = getV1WorkflowFamiliesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 */
export const v1WorkflowFamiliesPartialUpdate = (
    id: string,
    patchedWorkflowFamily: NonReadonly<PatchedWorkflowFamily>,
 ) => {
      
      
      return customAxiosInstance<WorkflowFamily>(
      {url: `/api/v1/workflow/families/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWorkflowFamily
    },
      );
    }
  


export const getV1WorkflowFamiliesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkflowFamily>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkflowFamily>}, TContext> => {

const mutationKey = ['v1WorkflowFamiliesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowFamiliesPartialUpdate>>, {id: string;data: NonReadonly<PatchedWorkflowFamily>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1WorkflowFamiliesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowFamiliesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowFamiliesPartialUpdate>>>
    export type V1WorkflowFamiliesPartialUpdateMutationBody = NonReadonly<PatchedWorkflowFamily>
    export type V1WorkflowFamiliesPartialUpdateMutationError = unknown

    export const useV1WorkflowFamiliesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkflowFamily>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowFamiliesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedWorkflowFamily>},
        TContext
      > => {

      const mutationOptions = getV1WorkflowFamiliesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 */
export const v1WorkflowFamiliesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/workflow/families/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1WorkflowFamiliesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1WorkflowFamiliesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowFamiliesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1WorkflowFamiliesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowFamiliesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowFamiliesDestroy>>>
    
    export type V1WorkflowFamiliesDestroyMutationError = unknown

    export const useV1WorkflowFamiliesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowFamiliesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1WorkflowFamiliesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary Lock a workflow family
 */
export const v1WorkflowFamiliesLockCreate = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowFamily>(
      {url: `/api/v1/workflow/families/${id}/lock/`, method: 'POST', signal
    },
      );
    }
  


export const getV1WorkflowFamiliesLockCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesLockCreate>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesLockCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1WorkflowFamiliesLockCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowFamiliesLockCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1WorkflowFamiliesLockCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowFamiliesLockCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowFamiliesLockCreate>>>
    
    export type V1WorkflowFamiliesLockCreateMutationError = unknown

    /**
 * @summary Lock a workflow family
 */
export const useV1WorkflowFamiliesLockCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesLockCreate>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowFamiliesLockCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1WorkflowFamiliesLockCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary Unlock a workflow family
 */
export const v1WorkflowFamiliesUnlockCreate = (
    id: string,
    workflowFamilyUnlockBody: WorkflowFamilyUnlockBody,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowFamily>(
      {url: `/api/v1/workflow/families/${id}/unlock/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowFamilyUnlockBody, signal
    },
      );
    }
  


export const getV1WorkflowFamiliesUnlockCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesUnlockCreate>>, TError,{id: string;data: WorkflowFamilyUnlockBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesUnlockCreate>>, TError,{id: string;data: WorkflowFamilyUnlockBody}, TContext> => {

const mutationKey = ['v1WorkflowFamiliesUnlockCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowFamiliesUnlockCreate>>, {id: string;data: WorkflowFamilyUnlockBody}> = (props) => {
          const {id,data} = props ?? {};

          return  v1WorkflowFamiliesUnlockCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowFamiliesUnlockCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowFamiliesUnlockCreate>>>
    export type V1WorkflowFamiliesUnlockCreateMutationBody = WorkflowFamilyUnlockBody
    export type V1WorkflowFamiliesUnlockCreateMutationError = unknown

    /**
 * @summary Unlock a workflow family
 */
export const useV1WorkflowFamiliesUnlockCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowFamiliesUnlockCreate>>, TError,{id: string;data: WorkflowFamilyUnlockBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowFamiliesUnlockCreate>>,
        TError,
        {id: string;data: WorkflowFamilyUnlockBody},
        TContext
      > => {

      const mutationOptions = getV1WorkflowFamiliesUnlockCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary List workflow instances for active tenant
 */
export const v1WorkflowInstancesList = (
    params?: V1WorkflowInstancesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkflowInstanceList>(
      {url: `/api/v1/workflow/instances/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1WorkflowInstancesListQueryKey = (params?: V1WorkflowInstancesListParams,) => {
    return [
    `/api/v1/workflow/instances/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1WorkflowInstancesListQueryOptions = <TData = Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError = unknown>(params?: V1WorkflowInstancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1WorkflowInstancesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1WorkflowInstancesList>>> = ({ signal }) => v1WorkflowInstancesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1WorkflowInstancesListQueryResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowInstancesList>>>
export type V1WorkflowInstancesListQueryError = unknown


export function useV1WorkflowInstancesList<TData = Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError = unknown>(
 params: undefined |  V1WorkflowInstancesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowInstancesList>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowInstancesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowInstancesList<TData = Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError = unknown>(
 params?: V1WorkflowInstancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowInstancesList>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowInstancesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowInstancesList<TData = Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError = unknown>(
 params?: V1WorkflowInstancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List workflow instances for active tenant
 */

export function useV1WorkflowInstancesList<TData = Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError = unknown>(
 params?: V1WorkflowInstancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1WorkflowInstancesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary Start a new workflow instance
 */
export const v1WorkflowInstancesCreate = (
    workflowInstanceCreate: WorkflowInstanceCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowInstanceCreate>(
      {url: `/api/v1/workflow/instances/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowInstanceCreate, signal
    },
      );
    }
  


export const getV1WorkflowInstancesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesCreate>>, TError,{data: WorkflowInstanceCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesCreate>>, TError,{data: WorkflowInstanceCreate}, TContext> => {

const mutationKey = ['v1WorkflowInstancesCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowInstancesCreate>>, {data: WorkflowInstanceCreate}> = (props) => {
          const {data} = props ?? {};

          return  v1WorkflowInstancesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowInstancesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowInstancesCreate>>>
    export type V1WorkflowInstancesCreateMutationBody = WorkflowInstanceCreate
    export type V1WorkflowInstancesCreateMutationError = unknown

    /**
 * @summary Start a new workflow instance
 */
export const useV1WorkflowInstancesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesCreate>>, TError,{data: WorkflowInstanceCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowInstancesCreate>>,
        TError,
        {data: WorkflowInstanceCreate},
        TContext
      > => {

      const mutationOptions = getV1WorkflowInstancesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary Retrieve a workflow instance by ID
 */
export const v1WorkflowInstancesRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowInstance>(
      {url: `/api/v1/workflow/instances/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1WorkflowInstancesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/workflow/instances/${id}/`
    ] as const;
    }

    
export const getV1WorkflowInstancesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1WorkflowInstancesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>> = ({ signal }) => v1WorkflowInstancesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1WorkflowInstancesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>>
export type V1WorkflowInstancesRetrieveQueryError = unknown


export function useV1WorkflowInstancesRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowInstancesRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowInstancesRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a workflow instance by ID
 */

export function useV1WorkflowInstancesRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowInstancesRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1WorkflowInstancesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 */
export const v1WorkflowInstancesUpdate = (
    id: string,
    workflowInstance: NonReadonly<WorkflowInstance>,
 ) => {
      
      
      return customAxiosInstance<WorkflowInstance>(
      {url: `/api/v1/workflow/instances/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workflowInstance
    },
      );
    }
  


export const getV1WorkflowInstancesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesUpdate>>, TError,{id: string;data: NonReadonly<WorkflowInstance>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesUpdate>>, TError,{id: string;data: NonReadonly<WorkflowInstance>}, TContext> => {

const mutationKey = ['v1WorkflowInstancesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowInstancesUpdate>>, {id: string;data: NonReadonly<WorkflowInstance>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1WorkflowInstancesUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowInstancesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowInstancesUpdate>>>
    export type V1WorkflowInstancesUpdateMutationBody = NonReadonly<WorkflowInstance>
    export type V1WorkflowInstancesUpdateMutationError = unknown

    export const useV1WorkflowInstancesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesUpdate>>, TError,{id: string;data: NonReadonly<WorkflowInstance>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowInstancesUpdate>>,
        TError,
        {id: string;data: NonReadonly<WorkflowInstance>},
        TContext
      > => {

      const mutationOptions = getV1WorkflowInstancesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 */
export const v1WorkflowInstancesPartialUpdate = (
    id: string,
    patchedWorkflowInstance: NonReadonly<PatchedWorkflowInstance>,
 ) => {
      
      
      return customAxiosInstance<WorkflowInstance>(
      {url: `/api/v1/workflow/instances/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWorkflowInstance
    },
      );
    }
  


export const getV1WorkflowInstancesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkflowInstance>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkflowInstance>}, TContext> => {

const mutationKey = ['v1WorkflowInstancesPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowInstancesPartialUpdate>>, {id: string;data: NonReadonly<PatchedWorkflowInstance>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1WorkflowInstancesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowInstancesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowInstancesPartialUpdate>>>
    export type V1WorkflowInstancesPartialUpdateMutationBody = NonReadonly<PatchedWorkflowInstance>
    export type V1WorkflowInstancesPartialUpdateMutationError = unknown

    export const useV1WorkflowInstancesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkflowInstance>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowInstancesPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedWorkflowInstance>},
        TContext
      > => {

      const mutationOptions = getV1WorkflowInstancesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 */
export const v1WorkflowInstancesDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/workflow/instances/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1WorkflowInstancesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1WorkflowInstancesDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowInstancesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1WorkflowInstancesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowInstancesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowInstancesDestroy>>>
    
    export type V1WorkflowInstancesDestroyMutationError = unknown

    export const useV1WorkflowInstancesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowInstancesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1WorkflowInstancesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary Approve a pending workflow instance
 */
export const v1WorkflowInstancesApproveCreate = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowInstance>(
      {url: `/api/v1/workflow/instances/${id}/approve/`, method: 'POST', signal
    },
      );
    }
  


export const getV1WorkflowInstancesApproveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesApproveCreate>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesApproveCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1WorkflowInstancesApproveCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowInstancesApproveCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1WorkflowInstancesApproveCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowInstancesApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowInstancesApproveCreate>>>
    
    export type V1WorkflowInstancesApproveCreateMutationError = unknown

    /**
 * @summary Approve a pending workflow instance
 */
export const useV1WorkflowInstancesApproveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesApproveCreate>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowInstancesApproveCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1WorkflowInstancesApproveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shared tenant resolution logic for Workflow ViewSets.
Mirrors shared.tenant.views.organization_views.OrganizationViewSet pattern.

Local copy per ADR-058 domain isolation — no cross-domain imports.
 * @summary Reject a pending workflow instance
 */
export const v1WorkflowInstancesRejectCreate = (
    id: string,
    workflowRejectBody: WorkflowRejectBody,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowInstance>(
      {url: `/api/v1/workflow/instances/${id}/reject/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowRejectBody, signal
    },
      );
    }
  


export const getV1WorkflowInstancesRejectCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesRejectCreate>>, TError,{id: string;data: WorkflowRejectBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesRejectCreate>>, TError,{id: string;data: WorkflowRejectBody}, TContext> => {

const mutationKey = ['v1WorkflowInstancesRejectCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowInstancesRejectCreate>>, {id: string;data: WorkflowRejectBody}> = (props) => {
          const {id,data} = props ?? {};

          return  v1WorkflowInstancesRejectCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowInstancesRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowInstancesRejectCreate>>>
    export type V1WorkflowInstancesRejectCreateMutationBody = WorkflowRejectBody
    export type V1WorkflowInstancesRejectCreateMutationError = unknown

    /**
 * @summary Reject a pending workflow instance
 */
export const useV1WorkflowInstancesRejectCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowInstancesRejectCreate>>, TError,{id: string;data: WorkflowRejectBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowInstancesRejectCreate>>,
        TError,
        {id: string;data: WorkflowRejectBody},
        TContext
      > => {

      const mutationOptions = getV1WorkflowInstancesRejectCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary List workflow revisions for active tenant
 */
export const v1WorkflowRevisionsList = (
    params?: V1WorkflowRevisionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedWorkflowRevisionList>(
      {url: `/api/v1/workflow/revisions/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getV1WorkflowRevisionsListQueryKey = (params?: V1WorkflowRevisionsListParams,) => {
    return [
    `/api/v1/workflow/revisions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getV1WorkflowRevisionsListQueryOptions = <TData = Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError = unknown>(params?: V1WorkflowRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1WorkflowRevisionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1WorkflowRevisionsList>>> = ({ signal }) => v1WorkflowRevisionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1WorkflowRevisionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowRevisionsList>>>
export type V1WorkflowRevisionsListQueryError = unknown


export function useV1WorkflowRevisionsList<TData = Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError = unknown>(
 params: undefined |  V1WorkflowRevisionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowRevisionsList<TData = Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError = unknown>(
 params?: V1WorkflowRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowRevisionsList>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowRevisionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowRevisionsList<TData = Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError = unknown>(
 params?: V1WorkflowRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List workflow revisions for active tenant
 */

export function useV1WorkflowRevisionsList<TData = Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError = unknown>(
 params?: V1WorkflowRevisionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1WorkflowRevisionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Create a new draft workflow revision
 */
export const v1WorkflowRevisionsCreate = (
    workflowRevision: NonReadonly<WorkflowRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowRevision>(
      {url: `/api/v1/workflow/revisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowRevision, signal
    },
      );
    }
  


export const getV1WorkflowRevisionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsCreate>>, TError,{data: NonReadonly<WorkflowRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsCreate>>, TError,{data: NonReadonly<WorkflowRevision>}, TContext> => {

const mutationKey = ['v1WorkflowRevisionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowRevisionsCreate>>, {data: NonReadonly<WorkflowRevision>}> = (props) => {
          const {data} = props ?? {};

          return  v1WorkflowRevisionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowRevisionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowRevisionsCreate>>>
    export type V1WorkflowRevisionsCreateMutationBody = NonReadonly<WorkflowRevision>
    export type V1WorkflowRevisionsCreateMutationError = unknown

    /**
 * @summary Create a new draft workflow revision
 */
export const useV1WorkflowRevisionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsCreate>>, TError,{data: NonReadonly<WorkflowRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowRevisionsCreate>>,
        TError,
        {data: NonReadonly<WorkflowRevision>},
        TContext
      > => {

      const mutationOptions = getV1WorkflowRevisionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Retrieve a workflow revision by ID
 */
export const v1WorkflowRevisionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowRevision>(
      {url: `/api/v1/workflow/revisions/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getV1WorkflowRevisionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/workflow/revisions/${id}/`
    ] as const;
    }

    
export const getV1WorkflowRevisionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1WorkflowRevisionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>> = ({ signal }) => v1WorkflowRevisionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type V1WorkflowRevisionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>>
export type V1WorkflowRevisionsRetrieveQueryError = unknown


export function useV1WorkflowRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useV1WorkflowRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Retrieve a workflow revision by ID
 */

export function useV1WorkflowRevisionsRetrieve<TData = Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getV1WorkflowRevisionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1WorkflowRevisionsUpdate = (
    id: string,
    workflowRevision: NonReadonly<WorkflowRevision>,
 ) => {
      
      
      return customAxiosInstance<WorkflowRevision>(
      {url: `/api/v1/workflow/revisions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workflowRevision
    },
      );
    }
  


export const getV1WorkflowRevisionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsUpdate>>, TError,{id: string;data: NonReadonly<WorkflowRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsUpdate>>, TError,{id: string;data: NonReadonly<WorkflowRevision>}, TContext> => {

const mutationKey = ['v1WorkflowRevisionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowRevisionsUpdate>>, {id: string;data: NonReadonly<WorkflowRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1WorkflowRevisionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowRevisionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowRevisionsUpdate>>>
    export type V1WorkflowRevisionsUpdateMutationBody = NonReadonly<WorkflowRevision>
    export type V1WorkflowRevisionsUpdateMutationError = unknown

    export const useV1WorkflowRevisionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsUpdate>>, TError,{id: string;data: NonReadonly<WorkflowRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowRevisionsUpdate>>,
        TError,
        {id: string;data: NonReadonly<WorkflowRevision>},
        TContext
      > => {

      const mutationOptions = getV1WorkflowRevisionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1WorkflowRevisionsPartialUpdate = (
    id: string,
    patchedWorkflowRevision: NonReadonly<PatchedWorkflowRevision>,
 ) => {
      
      
      return customAxiosInstance<WorkflowRevision>(
      {url: `/api/v1/workflow/revisions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWorkflowRevision
    },
      );
    }
  


export const getV1WorkflowRevisionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkflowRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkflowRevision>}, TContext> => {

const mutationKey = ['v1WorkflowRevisionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowRevisionsPartialUpdate>>, {id: string;data: NonReadonly<PatchedWorkflowRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1WorkflowRevisionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowRevisionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowRevisionsPartialUpdate>>>
    export type V1WorkflowRevisionsPartialUpdateMutationBody = NonReadonly<PatchedWorkflowRevision>
    export type V1WorkflowRevisionsPartialUpdateMutationError = unknown

    export const useV1WorkflowRevisionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedWorkflowRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowRevisionsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedWorkflowRevision>},
        TContext
      > => {

      const mutationOptions = getV1WorkflowRevisionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 */
export const v1WorkflowRevisionsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/v1/workflow/revisions/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getV1WorkflowRevisionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['v1WorkflowRevisionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowRevisionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  v1WorkflowRevisionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowRevisionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowRevisionsDestroy>>>
    
    export type V1WorkflowRevisionsDestroyMutationError = unknown

    export const useV1WorkflowRevisionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowRevisionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getV1WorkflowRevisionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Calls ``instance.full_clean()`` before every update so that
``Model.clean()`` immutability guards are enforced at the API layer.

This mixin belongs in ``shared.backbone.api`` because the requirement is
structural and affects every domain that uses the Family/Revision pattern
(ADR-047, ADR-054, ADR-055, ADR-056, ADR-060).
 * @summary Publish a workflow revision (immutable afterward)
 */
export const v1WorkflowRevisionsPublishCreate = (
    id: string,
    workflowRevision: NonReadonly<WorkflowRevision>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<WorkflowRevision>(
      {url: `/api/v1/workflow/revisions/${id}/publish/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowRevision, signal
    },
      );
    }
  


export const getV1WorkflowRevisionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<WorkflowRevision>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<WorkflowRevision>}, TContext> => {

const mutationKey = ['v1WorkflowRevisionsPublishCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1WorkflowRevisionsPublishCreate>>, {id: string;data: NonReadonly<WorkflowRevision>}> = (props) => {
          const {id,data} = props ?? {};

          return  v1WorkflowRevisionsPublishCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V1WorkflowRevisionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v1WorkflowRevisionsPublishCreate>>>
    export type V1WorkflowRevisionsPublishCreateMutationBody = NonReadonly<WorkflowRevision>
    export type V1WorkflowRevisionsPublishCreateMutationError = unknown

    /**
 * @summary Publish a workflow revision (immutable afterward)
 */
export const useV1WorkflowRevisionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1WorkflowRevisionsPublishCreate>>, TError,{id: string;data: NonReadonly<WorkflowRevision>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1WorkflowRevisionsPublishCreate>>,
        TError,
        {id: string;data: NonReadonly<WorkflowRevision>},
        TContext
      > => {

      const mutationOptions = getV1WorkflowRevisionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    